
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ipg0f", function(module, exports) {
/* markdownModePlugin.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $hTKp4 = parcelRequire("hTKp4");


var $eiA8Z = parcelRequire("eiA8Z");


var $1S4f7 = parcelRequire("1S4f7");


var $4Chin = parcelRequire("4Chin");

var $cPCP8 = parcelRequire("cPCP8");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");





var $ks2lK = parcelRequire("ks2lK");

const $f77ee1d521b258ad$export$160e35dbff8be862 = new (0, $ks2lK.PluginKey)('markdownMode');


const $eeb551b796465707$var$isMac = typeof navigator !== 'undefined' && new RegExp('Mac', 'iu').test(navigator.userAgentData?.platform ?? navigator.platform);
const $eeb551b796465707$export$2fa7e76a57ca53b0 = (e)=>{
    const modifierMatch = $eeb551b796465707$var$isMac ? e.metaKey && !e.ctrlKey : e.ctrlKey && !e.metaKey;
    return modifierMatch && !e.altKey && !e.shiftKey && e.code === 'KeyE';
};
/**
 * Selector matching the wrapping container that holds both the ProseMirror
 * editor DOM and any plugin-rendered content (e.g. the markdown source view
 * mounted via `PluginSlot`). Defined in
 * `editor-core/src/ui/Appearance/FullPage/FullPageContentArea.tsx` as
 * `EDITOR_CONTAINER`.
 */ const $eeb551b796465707$var$EDITOR_CONTAINER_SELECTOR = '[data-editor-container="true"]';
const $eeb551b796465707$export$f3fcac9ec039b10c = (editorView)=>{
    const activeElement = (0, $hTKp4.getDocument)()?.activeElement ?? null;
    // No active element / focus on body — fall through and allow toggle.
    // `document.body` is reported as `activeElement` in browsers when nothing
    // else is focused; treat that the same as "no focus".
    const hasMeaningfulFocus = activeElement !== null && activeElement !== (0, $hTKp4.getDocument)()?.body && activeElement !== (0, $hTKp4.getDocument)()?.documentElement;
    if (!hasMeaningfulFocus) return true;
    if (editorView.dom.contains(activeElement)) return true;
    const ourContainer = typeof editorView.dom.closest === 'function' ? editorView.dom.closest($eeb551b796465707$var$EDITOR_CONTAINER_SELECTOR) : null;
    if (ourContainer && ourContainer.contains(activeElement)) return true;
    // Multi-editor safety: if focus is inside SOME OTHER editor container,
    // only that editor should respond — not this one.
    const focusedContainer = typeof activeElement.closest === 'function' ? activeElement.closest($eeb551b796465707$var$EDITOR_CONTAINER_SELECTOR) : null;
    if (focusedContainer && focusedContainer !== ourContainer) return false;
    // Focus is outside any editor container (e.g. a popup, side panel, an
    // unrelated input). Allow the toggle so the shortcut works from "anywhere
    // on the page" — in particular right after clicking the view-mode toggle
    // button, which moves focus out of the editor.
    return true;
};
const $eeb551b796465707$export$ed529ff4eb54147f = (api, getEditorView)=>{
    return (e)=>{
        if (!$eeb551b796465707$export$2fa7e76a57ca53b0(e)) return;
        const editorView = getEditorView();
        if (!editorView || editorView.isDestroyed) return;
        // Multi-editor guard: if focus is inside a DIFFERENT editor, only that
        // one should toggle. When focus is outside any editor (e.g. body, a
        // popup, a button) we still toggle so the shortcut works "anywhere on
        // the page", including immediately after the user clicked the toggle
        // button (which moves focus out of the editor).
        if (!$eeb551b796465707$export$f3fcac9ec039b10c(editorView)) return;
        const pluginState = (0, $f77ee1d521b258ad$export$160e35dbff8be862).getState(editorView.state);
        if (!pluginState?.isMarkdownMode) return;
        const currentView = pluginState.view ?? 'preview';
        // Only syntax and preview participate in the runtime toggle cycle.
        // Any other value is treated as non-toggleable.
        if (currentView !== 'syntax' && currentView !== 'preview') return;
        e.preventDefault();
        // Cycle through available views. When split view is enabled in the
        // future, add 'split-view' to this array.
        const viewCycle = [
            'preview',
            'syntax'
        ];
        const currentIndex = viewCycle.indexOf(currentView);
        const nextView = viewCycle[(currentIndex + 1) % viewCycle.length];
        api?.markdownMode?.actions.setView(nextView);
    };
};



/**
 * @file source-view-utils.ts
 *
 * Foundation utilities for interacting with the CodeMirror 6 source view in
 * markdown mode. Provides two layers:
 *
 *  1. **Context queries** - pure functions over `EditorState` that use the
 *     Lezer syntax tree to answer semantic questions about the current cursor
 *     position / selection (e.g. "is the cursor inside a code block?").
 *
 *  2. **Syntax primitive factories** - functions that return `SourceViewCommand`
 *     values (the standard CM6 command signature) for common markdown text
 *     transformations (e.g. wrapping a selection in `**...**`).
 *
 * These utilities are the shared foundation that toolbar-contributing plugins
 * compose into their own `SourceViewCommand` implementations. All CM6 and
 * Lezer knowledge is centralised here so individual plugins remain ignorant of
 * CodeMirror internals.
 *
 * No React or side-effect imports - this module is pure logic and is safe to
 * import in any context.
 */ 
var $hugED = parcelRequire("hugED");


var $59nWR = parcelRequire("59nWR");


var $5oQvt = parcelRequire("5oQvt");

const $c8eb22a0108df7ae$export$2d73244c2182ac32 = Object.fromEntries((0, $hugED.markdownLanguage).parser.nodeSet.types.map((t)=>[
        t.name,
        t.name
    ]));
// ---------------------------------------------------------------------------
// Internal helpers
// ---------------------------------------------------------------------------
/**
 * Walk the Lezer syntax tree upward from `pos`, returning the names of every
 * ancestor node (inclusive of the node at `pos`).
 */ function $c8eb22a0108df7ae$var$ancestorNames(state, pos) {
    const names = [];
    let node = (0, $59nWR.syntaxTree)(state).resolveInner(pos, 1);
    while(node.parent){
        names.push(node.type.name);
        node = node.parent;
    }
    return names;
}
/**
 * Return true if any ancestor node at `pos` has one of the given type names.
 */ function $c8eb22a0108df7ae$var$hasAncestor(state, pos, ...typeNames) {
    const names = new Set(typeNames);
    let node = (0, $59nWR.syntaxTree)(state).resolveInner(pos, 1);
    while(node.parent){
        if (names.has(node.type.name)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * Return true if any Lezer node overlapping [from, to] has one of the given
 * type names. Uses syntaxTree.iterate() for an exact answer - no sampling.
 */ function $c8eb22a0108df7ae$var$rangeOverlapsNodes(state, from, to, ...typeNames) {
    const names = new Set(typeNames);
    let found = false;
    (0, $59nWR.syntaxTree)(state).iterate({
        from: from,
        to: to,
        enter (node) {
            if (names.has(node.type.name)) {
                found = true;
                return false; // stop iteration early
            }
        }
    });
    return found;
}
/** Canonical wrap syntax for each inline format (used for toggle-on). */ const $c8eb22a0108df7ae$var$INLINE_FORMAT_SYNTAX = {
    bold: '**',
    italic: '*',
    inlineCode: '`',
    strikethrough: '~~'
};
/** Lezer node type for each inline format (used for toggle-off detection). */ const $c8eb22a0108df7ae$var$INLINE_FORMAT_NODE_TYPE = {
    bold: 'StrongEmphasis',
    italic: 'Emphasis',
    inlineCode: 'InlineCode',
    strikethrough: 'Strikethrough'
};
/**
 * The Lezer node types that represent "code contexts" - positions where inline
 * markdown formatting (bold, italic, etc.) is meaningless or invalid.
 */ const $c8eb22a0108df7ae$var$CODE_CONTEXT_NODES = [
    'FencedCode',
    'CodeBlock',
    'InlineCode',
    'CodeText',
    'CodeInfo'
];
function $c8eb22a0108df7ae$export$340f88d26d8d1507(state) {
    const { head: head } = state.selection.main;
    return $c8eb22a0108df7ae$var$hasAncestor(state, head, ...$c8eb22a0108df7ae$var$CODE_CONTEXT_NODES);
}
function $c8eb22a0108df7ae$export$59eae5fcd69a8ca2(state) {
    const { from: from, to: to } = state.selection.main;
    // For a collapsed cursor, use the ancestor walk (faster).
    if (from === to) return $c8eb22a0108df7ae$var$hasAncestor(state, from, ...$c8eb22a0108df7ae$var$CODE_CONTEXT_NODES);
    return $c8eb22a0108df7ae$var$rangeOverlapsNodes(state, from, to, ...$c8eb22a0108df7ae$var$CODE_CONTEXT_NODES);
}
function $c8eb22a0108df7ae$var$isSelectionInBlockCodeContext(state) {
    const { from: from, to: to } = state.selection.main;
    if (from === to) return $c8eb22a0108df7ae$var$hasAncestor(state, from, $c8eb22a0108df7ae$export$2d73244c2182ac32.FencedCode, $c8eb22a0108df7ae$export$2d73244c2182ac32.CodeBlock);
    return $c8eb22a0108df7ae$var$rangeOverlapsNodes(state, from, to, $c8eb22a0108df7ae$export$2d73244c2182ac32.FencedCode, $c8eb22a0108df7ae$export$2d73244c2182ac32.CodeBlock);
}
function $c8eb22a0108df7ae$export$8970a27599376db5(state) {
    const { head: head } = state.selection.main;
    return $c8eb22a0108df7ae$var$hasAncestor(state, head, $c8eb22a0108df7ae$export$2d73244c2182ac32.URL);
}
function $c8eb22a0108df7ae$export$bd3fd8da835721f8(state) {
    return !$c8eb22a0108df7ae$export$340f88d26d8d1507(state) && !$c8eb22a0108df7ae$export$8970a27599376db5(state);
}
function $c8eb22a0108df7ae$export$753a775122b7b63b(state, lezerNodeType) {
    const { head: head } = state.selection.main;
    return $c8eb22a0108df7ae$var$hasAncestor(state, head, lezerNodeType);
}
function $c8eb22a0108df7ae$export$8e72f433f86285(state) {
    // Helper: extract heading level from a list of ancestor node names.
    function levelFromNames(names) {
        for (const name of names){
            const atx = name.match(/^ATXHeading(\d)$/u);
            if (atx) return parseInt(atx[1], 10);
            const setext = name.match(/^SetextHeading(\d)$/u);
            if (setext) return parseInt(setext[1], 10);
        }
        return null;
    }
    const { head: head } = state.selection.main;
    // First try the cursor position directly.
    const direct = levelFromNames($c8eb22a0108df7ae$var$ancestorNames(state, head));
    if (direct !== null) return direct;
    // When the cursor is at the very end of a line (on the \n character),
    // Lezer places it outside the ATXHeading node boundary. Fall back to
    // the last character of the line to detect the heading correctly.
    const line = state.doc.lineAt(head);
    if (head === line.to && line.to > line.from) return levelFromNames($c8eb22a0108df7ae$var$ancestorNames(state, line.to - 1));
    return null;
}
/**
 * Returns true if the primary selection head is inside `typeName`, including
 * the common CM6 edge case where the cursor sits at the end of a non-empty
 * line and Lezer resolves it onto the trailing newline outside the node.
 */ function $c8eb22a0108df7ae$var$isAtCursorOrLineEnd(state, typeName) {
    const { head: head } = state.selection.main;
    if ($c8eb22a0108df7ae$var$hasAncestor(state, head, typeName)) return true;
    const line = state.doc.lineAt(head);
    return head === line.to && line.to > line.from && $c8eb22a0108df7ae$var$hasAncestor(state, line.to - 1, typeName);
}
function $c8eb22a0108df7ae$export$8533b10fb9ecef78(state) {
    return $c8eb22a0108df7ae$var$isAtCursorOrLineEnd(state, $c8eb22a0108df7ae$export$2d73244c2182ac32.Blockquote);
}
function $c8eb22a0108df7ae$export$857ab4b4af2c663a(state) {
    return $c8eb22a0108df7ae$var$isAtCursorOrLineEnd(state, $c8eb22a0108df7ae$export$2d73244c2182ac32.BulletList);
}
function $c8eb22a0108df7ae$export$bcf034afbca8b7b1(state) {
    return $c8eb22a0108df7ae$var$isAtCursorOrLineEnd(state, $c8eb22a0108df7ae$export$2d73244c2182ac32.OrderedList);
}
function $c8eb22a0108df7ae$export$2ee0ef920e12bb1f(state) {
    return $c8eb22a0108df7ae$var$isAtCursorOrLineEnd(state, $c8eb22a0108df7ae$export$2d73244c2182ac32.Task) || $c8eb22a0108df7ae$var$isAtCursorOrLineEnd(state, $c8eb22a0108df7ae$export$2d73244c2182ac32.TaskMarker);
}
function $c8eb22a0108df7ae$export$b777e8b4e40fe375(state, format) {
    return $c8eb22a0108df7ae$export$753a775122b7b63b(state, $c8eb22a0108df7ae$var$INLINE_FORMAT_NODE_TYPE[format]);
}
function $c8eb22a0108df7ae$export$5069c0cb22ba97e6(state) {
    return {
        boldActive: $c8eb22a0108df7ae$export$b777e8b4e40fe375(state, 'bold'),
        italicActive: $c8eb22a0108df7ae$export$b777e8b4e40fe375(state, 'italic'),
        codeActive: $c8eb22a0108df7ae$export$b777e8b4e40fe375(state, 'inlineCode'),
        strikeActive: $c8eb22a0108df7ae$export$b777e8b4e40fe375(state, 'strikethrough'),
        inlineFormattingAvailable: $c8eb22a0108df7ae$export$bd3fd8da835721f8(state)
    };
}
function $c8eb22a0108df7ae$export$96bc0c55bfc3ec38(state) {
    const { head: head } = state.selection.main;
    return {
        headingLevel: $c8eb22a0108df7ae$export$8e72f433f86285(state),
        inBlockquote: $c8eb22a0108df7ae$export$8533b10fb9ecef78(state),
        inCodeBlock: $c8eb22a0108df7ae$var$hasAncestor(state, head, $c8eb22a0108df7ae$export$2d73244c2182ac32.FencedCode, $c8eb22a0108df7ae$export$2d73244c2182ac32.CodeBlock)
    };
}
function $c8eb22a0108df7ae$export$19f8516089a6ae9b(state) {
    const inTaskList = $c8eb22a0108df7ae$export$2ee0ef920e12bb1f(state);
    return {
        inBulletList: !inTaskList && $c8eb22a0108df7ae$export$857ab4b4af2c663a(state),
        inOrderedList: !inTaskList && $c8eb22a0108df7ae$export$bcf034afbca8b7b1(state),
        inTaskList: inTaskList
    };
}
// ---------------------------------------------------------------------------
// Syntax primitive factories - return SourceViewCommand values
// ---------------------------------------------------------------------------
/**
 * The Lezer mark node types used to delimit inline formatting. These are the
 * nodes whose text we remove when toggling off a format.
 */ const $c8eb22a0108df7ae$var$INLINE_MARK_NODE_TYPES = new Set([
    $c8eb22a0108df7ae$export$2d73244c2182ac32.EmphasisMark,
    $c8eb22a0108df7ae$export$2d73244c2182ac32.StrikethroughMark,
    $c8eb22a0108df7ae$export$2d73244c2182ac32.CodeMark
]);
/**
 * Find the innermost enclosing Lezer node of `nodeType` at `pos`, then return
 * the positions of its opening and closing mark child nodes. Returns null if
 * no such node is found or if the marks cannot be located.
 */ function $c8eb22a0108df7ae$var$findEnclosingMarkPositions(state, pos, nodeType) {
    let node = (0, $59nWR.syntaxTree)(state).resolveInner(pos, 1);
    while(node.parent && node.type.name !== nodeType)node = node.parent;
    if (node.type.name !== nodeType) return null;
    let openMark = node.firstChild;
    while(openMark && !$c8eb22a0108df7ae$var$INLINE_MARK_NODE_TYPES.has(openMark.type.name))openMark = openMark.nextSibling;
    let closeMark = node.lastChild;
    while(closeMark && !$c8eb22a0108df7ae$var$INLINE_MARK_NODE_TYPES.has(closeMark.type.name))closeMark = closeMark.prevSibling;
    if (!openMark || !closeMark || openMark === closeMark) return null;
    return {
        openFrom: openMark.from,
        openTo: openMark.to,
        closeFrom: closeMark.from,
        closeTo: closeMark.to
    };
}
function $c8eb22a0108df7ae$export$a43514489bd58733(format) {
    return (view)=>{
        const { state: state } = view;
        const syntax = $c8eb22a0108df7ae$var$INLINE_FORMAT_SYNTAX[format];
        const lezerNodeType = $c8eb22a0108df7ae$var$INLINE_FORMAT_NODE_TYPE[format];
        if (format !== 'inlineCode' && ($c8eb22a0108df7ae$export$59eae5fcd69a8ca2(state) || $c8eb22a0108df7ae$export$8970a27599376db5(state))) return false;
        const range = state.selection.main;
        const { from: from, to: to } = range;
        // Toggle off via Lezer tree - variant-agnostic, handles combined marks.
        const marks = $c8eb22a0108df7ae$var$findEnclosingMarkPositions(state, range.head, lezerNodeType);
        if (marks) {
            const { openFrom: openFrom, openTo: openTo, closeFrom: closeFrom, closeTo: closeTo } = marks;
            const changes = [
                {
                    from: openFrom,
                    to: openTo,
                    insert: ''
                },
                {
                    from: closeFrom,
                    to: closeTo,
                    insert: ''
                }
            ];
            const changeSet = state.changes(changes);
            const mappedSelection = (0, $5oQvt.EditorSelection).create(state.selection.ranges.map((range)=>range.map(changeSet, 1)), state.selection.mainIndex);
            view.dispatch(state.update({
                changes: changes,
                selection: mappedSelection
            }));
            return true;
        }
        // No selection - insert pair and place cursor between.
        if (range.empty) {
            view.dispatch(state.update({
                changes: {
                    from: from,
                    insert: syntax + syntax
                },
                selection: {
                    anchor: from + syntax.length
                }
            }));
            return true;
        }
        // Toggle on - wrap selection.
        view.dispatch(state.update({
            changes: [
                {
                    from: from,
                    insert: syntax
                },
                {
                    from: to,
                    insert: syntax
                }
            ],
            selection: {
                anchor: from + syntax.length,
                head: to + syntax.length
            }
        }));
        return true;
    };
}
function $c8eb22a0108df7ae$export$f3072de57f1b974a(prefix) {
    return (view)=>{
        const { state: state } = view;
        const { from: from, to: to } = state.selection.main;
        if ($c8eb22a0108df7ae$var$isSelectionInBlockCodeContext(state)) return false;
        const doc = state.doc;
        const firstLine = doc.lineAt(from);
        const lastLine = doc.lineAt(to === from ? from : to - 1);
        const allHavePrefix = Array.from({
            length: lastLine.number - firstLine.number + 1
        }, (_, i)=>doc.line(firstLine.number + i)).every((line)=>line.text.startsWith(prefix));
        const changes = [];
        for(let n = firstLine.number; n <= lastLine.number; n++){
            const line = doc.line(n);
            if (allHavePrefix) changes.push({
                from: line.from,
                to: line.from + prefix.length,
                insert: ''
            });
            else if (!line.text.startsWith(prefix)) {
                if (line.text === '' && n === firstLine.number && n === lastLine.number) {
                    // Inserting a list/quote prefix on a blank line between paragraphs.
                    // Without a trailing blank line, the next paragraph would be parsed
                    // as a lazy continuation of this list item by CommonMark. Insert
                    // a blank line after the prefix to keep the blocks separate.
                    const nextLine = n < doc.lines ? doc.line(n + 1) : null;
                    if (nextLine && nextLine.text !== '') changes.push({
                        from: line.from,
                        insert: prefix + '\n'
                    });
                    else changes.push({
                        from: line.from,
                        insert: prefix
                    });
                } else changes.push({
                    from: line.from,
                    insert: prefix
                });
            }
        }
        const changeSet = state.changes(changes);
        // Map the selection through the changes. Use assoc=1 so that positions
        // that coincide with an insertion point (e.g. cursor at col 0 when we
        // insert a prefix there) are moved forward rather than left behind.
        const mappedSelection = (0, $5oQvt.EditorSelection).create(state.selection.ranges.map((range)=>range.map(changeSet, 1)), state.selection.mainIndex);
        const tr = state.update({
            changes: changes,
            selection: mappedSelection
        });
        view.dispatch(tr);
        return true;
    };
}
function $c8eb22a0108df7ae$export$f27293a683e57637() {
    return (view)=>{
        const { state: state } = view;
        const { from: from, to: to } = state.selection.main;
        if ($c8eb22a0108df7ae$var$isSelectionInBlockCodeContext(state)) return false;
        const doc = state.doc;
        const firstLine = doc.lineAt(from);
        const lastLine = doc.lineAt(to === from ? from : to - 1);
        const taskPrefixPattern = /^(\s*)(?:[-*+]|\d+\.)\s+\[[ xX]\]\s+/u;
        const listPrefixPattern = /^(\s*)(?:[-*+]|\d+\.)\s+/u;
        const lines = Array.from({
            length: lastLine.number - firstLine.number + 1
        }, (_, i)=>doc.line(firstLine.number + i));
        const allHaveTaskPrefix = lines.every((line)=>taskPrefixPattern.test(line.text));
        const changes = [];
        for (const line of lines){
            const taskMatch = line.text.match(taskPrefixPattern);
            if (allHaveTaskPrefix && taskMatch) {
                changes.push({
                    from: line.from + taskMatch[1].length,
                    to: line.from + taskMatch[0].length,
                    insert: ''
                });
                continue;
            }
            if (taskMatch) continue;
            const listMatch = line.text.match(listPrefixPattern);
            if (listMatch) {
                changes.push({
                    from: line.from + listMatch[1].length,
                    to: line.from + listMatch[0].length,
                    insert: '- [ ] '
                });
                continue;
            }
            const indentation = line.text.match(/^\s*/u)?.[0] ?? '';
            if (line.text === '' && line.number === firstLine.number && line.number === lastLine.number) {
                const nextLine = line.number < doc.lines ? doc.line(line.number + 1) : null;
                changes.push({
                    from: line.from,
                    insert: nextLine && nextLine.text !== '' ? '- [ ] \n' : '- [ ] '
                });
            } else changes.push({
                from: line.from + indentation.length,
                insert: '- [ ] '
            });
        }
        const changeSet = state.changes(changes);
        const mappedSelection = (0, $5oQvt.EditorSelection).create(state.selection.ranges.map((range)=>range.map(changeSet, 1)), state.selection.mainIndex);
        view.dispatch(state.update({
            changes: changes,
            selection: mappedSelection
        }));
        return true;
    };
}
function $c8eb22a0108df7ae$export$fdf2c1c8534e927b(level) {
    return (view)=>{
        const { state: state } = view;
        const { head: head } = state.selection.main;
        if ($c8eb22a0108df7ae$var$hasAncestor(state, head, $c8eb22a0108df7ae$export$2d73244c2182ac32.FencedCode, $c8eb22a0108df7ae$export$2d73244c2182ac32.CodeBlock)) return false;
        const line = state.doc.lineAt(head);
        const text = line.text;
        const existingMatch = text.match(/^(#{1,6}) /u);
        const targetPrefix = '#'.repeat(level) + ' ';
        const existingHeadingLevel = $c8eb22a0108df7ae$export$8e72f433f86285(state);
        if (existingMatch) {
            const existingPrefix = existingMatch[0];
            if (existingPrefix === targetPrefix) view.dispatch(state.update({
                changes: {
                    from: line.from,
                    to: line.from + existingPrefix.length,
                    insert: ''
                }
            }));
            else view.dispatch(state.update({
                changes: {
                    from: line.from,
                    to: line.from + existingPrefix.length,
                    insert: targetPrefix
                }
            }));
        } else if (existingHeadingLevel !== null) return false;
        else view.dispatch(state.update({
            changes: {
                from: line.from,
                insert: targetPrefix
            }
        }));
        return true;
    };
}
function $c8eb22a0108df7ae$export$3b2204dc19d35ba4() {
    return (view)=>{
        const { state: state } = view;
        const { from: from, to: to } = state.selection.main;
        if ($c8eb22a0108df7ae$var$hasAncestor(state, from, $c8eb22a0108df7ae$export$2d73244c2182ac32.FencedCode)) {
            let node = (0, $59nWR.syntaxTree)(state).resolveInner(from, 1);
            while(node.parent && node.type.name !== $c8eb22a0108df7ae$export$2d73244c2182ac32.FencedCode)node = node.parent;
            if (node.type.name === $c8eb22a0108df7ae$export$2d73244c2182ac32.FencedCode) {
                const fenceText = state.doc.sliceString(node.from, node.to);
                const openFenceEnd = fenceText.indexOf('\n');
                const closeFenceStart = fenceText.lastIndexOf('\n');
                if (openFenceEnd !== -1) {
                    const inner = fenceText.slice(openFenceEnd + 1, closeFenceStart);
                    view.dispatch(state.update({
                        changes: {
                            from: node.from,
                            to: node.to,
                            insert: inner
                        }
                    }));
                    return true;
                }
            }
        }
        if ($c8eb22a0108df7ae$var$isSelectionInBlockCodeContext(state)) return false;
        const doc = state.doc;
        const firstLine = doc.lineAt(from);
        const lastLine = doc.lineAt(to === from ? from : to - 1);
        const selectedText = doc.sliceString(firstLine.from, lastLine.to);
        view.dispatch(state.update({
            changes: {
                from: firstLine.from,
                to: lastLine.to,
                insert: '```\n' + selectedText + '\n```'
            },
            selection: {
                anchor: firstLine.from + 4
            }
        }));
        return true;
    };
}
const $c8eb22a0108df7ae$export$b850a936f66192a3 = $c8eb22a0108df7ae$export$a43514489bd58733('bold');
const $c8eb22a0108df7ae$export$227b5ef404be9031 = $c8eb22a0108df7ae$export$a43514489bd58733('italic');
const $c8eb22a0108df7ae$export$e7d955a85cfe503c = $c8eb22a0108df7ae$export$a43514489bd58733('inlineCode');
const $c8eb22a0108df7ae$export$a46d65f808b4881d = $c8eb22a0108df7ae$export$a43514489bd58733('strikethrough');
const $c8eb22a0108df7ae$export$2cd68375ac1e5429 = $c8eb22a0108df7ae$export$f3072de57f1b974a('> ');
const $c8eb22a0108df7ae$export$71c898cbdfd51c6e = $c8eb22a0108df7ae$export$f3072de57f1b974a('* ');
const $c8eb22a0108df7ae$export$744c9722bde8c6b3 = $c8eb22a0108df7ae$export$f3072de57f1b974a('1. ');
const $c8eb22a0108df7ae$export$49b8416aa3f9522a = $c8eb22a0108df7ae$export$f27293a683e57637();
const $c8eb22a0108df7ae$export$4e0d444e5782abea = $c8eb22a0108df7ae$export$fdf2c1c8534e927b(1);
const $c8eb22a0108df7ae$export$b8d734de6aecb0a3 = $c8eb22a0108df7ae$export$fdf2c1c8534e927b(2);
const $c8eb22a0108df7ae$export$df05910f74b29e0 = $c8eb22a0108df7ae$export$fdf2c1c8534e927b(3);
const $c8eb22a0108df7ae$export$ca48da5fbbd68542 = $c8eb22a0108df7ae$export$fdf2c1c8534e927b(4);
const $c8eb22a0108df7ae$export$1335885ed6c2d3ac = $c8eb22a0108df7ae$export$fdf2c1c8534e927b(5);
const $c8eb22a0108df7ae$export$8381ca7ddcf8db0d = $c8eb22a0108df7ae$export$fdf2c1c8534e927b(6);
const $c8eb22a0108df7ae$export$b420bd8551521778 = $c8eb22a0108df7ae$export$3b2204dc19d35ba4();


/**
 * MarkdownModeContentComponent — orchestration surface for the markdown-mode
 * plugin's `contentComponent` slot.
 *
 * This component is mounted by the editor's `contentComponent` mechanism and
 * is rendered as a sibling to the ProseMirror `editorDOMElement` inside
 * `FullPageContentArea`. It owns:
 *
 *  1. **Snapshot** — reads the current ADF doc from the live ProseMirror view
 *     when the user transitions away from preview.
 *  2. **Dispatch tap** — installs a `dispatchTransaction` tap on the live
 *     ProseMirror view to push debounced `liveAdfDoc` updates to the source
 *     and preview views.
 *  3. **Source view rendering** — mounts `MarkdownSourceView` when
 *     `view === 'syntax'`, seeded from the snapshot and fed live updates.
 *  4. **Writeback** — pushes source-view edits back into the ProseMirror
 *     editor via `replaceWith` + `replaceDocument` meta (collab-safe).
 *  5. **Preview rendering** — delegates to a consumer-supplied
 *     `previewComponent` when `view === 'split-view'`.
 *
 * The current view (`syntax | preview | split-view`) lives in this plugin's
 * ProseMirror state (`markdownModePluginKey`); the wrapper that renders this
 * component reads it via `useSharedPluginStateSelector` and passes it down
 * as `currentView`.
 */ 





/**
 * Applies annotation mark character ranges to a ProseMirror document.
 *
 * This is the inverse of `extractAnnotationRanges`. Given:
 *   - A PM document parsed from clean markdown (no annotation syntax)
 *   - The markdown string that was parsed
 *   - An array of { id, from, to } annotation ranges (character offsets into markdown)
 *
 * It returns a new PM document where each text node overlapping with an
 * annotation range carries the corresponding annotation mark.
 *
 * This is used on commit in the markdown source view: the user has edited
 * clean markdown, CM6 has tracked the annotation ranges through their edits
 * (via DecorationSet.map()), and we now need to write the PM document back
 * with annotation marks re-applied at the (possibly shifted) positions.
 *
 * Overlap handling
 * ----------------
 * Multiple annotation marks with different IDs can overlap (the same text can
 * carry two different inline comments). ProseMirror's `tr.addMark()` removes
 * any existing mark of the same type before adding a new one — which would
 * cause later annotations to erase earlier ones in the overlap region.
 *
 * To handle this correctly, we build the document by reconstructing text nodes
 * directly: we compute all the markdown character boundaries where annotation
 * membership changes (sorted unique boundaries of all ranges), then create one
 * text node per sub-span with the correct set of annotation marks.
 */ /**
 * Escape a raw PM text string the same way `mdast-util-to-markdown` does, so
 * we can search for it in the serialized markdown when a direct `indexOf` fails.
 *
 * Mirrors the identical helper in `extractAnnotationRanges.ts` — kept local
 * here to avoid a circular dependency between the two files.
 */ function $084c25d885898a33$var$escapedForMarkdown(text) {
    return text.replace(/[*_`[\\\]]/gu, (ch)=>`\\${ch}`);
}
function $084c25d885898a33$export$65bdd44f71145a33(doc, markdown, annotations) {
    if (annotations.length === 0) return doc;
    const schema = doc.type.schema;
    const annotationMarkType = schema.marks.annotation;
    // If the schema doesn't have an annotation mark, return unchanged.
    if (!annotationMarkType) return doc;
    // Filter to valid, in-bounds annotations only.
    const valid = annotations.filter((a)=>a.from >= 0 && a.to <= markdown.length && a.from < a.to);
    if (valid.length === 0) return doc;
    /**
	 * Given a markdown character range [mdFrom, mdTo), return the set of
	 * annotation marks that should be applied to it.
	 */ function marksForMdRange(mdFrom, mdTo) {
        const marks = [];
        for (const ann of valid)if (ann.from < mdTo && ann.to > mdFrom) marks.push(annotationMarkType.create({
            id: ann.id,
            annotationType: 'inlineComment'
        }));
        return marks;
    }
    /**
	 * Split a text node's content into sub-spans at annotation boundaries, and
	 * create new PM text nodes with the correct marks for each sub-span.
	 *
	 * @param text - The text content of the node.
	 * @param existingMarks - Any non-annotation marks already on the node.
	 * @param mdFrom - The markdown character offset of the start of this text.
	 * @returns An array of PM text nodes (may be a single node if no annotations
	 *   overlap this text, or multiple if the annotation boundaries split it).
	 *
	 * Splitting is always performed regardless of whether the text node already
	 * carries formatting marks (em, strong, code, etc.). This is safe because
	 * convertInlineChildren in mdast-util-from-pm merges adjacent text nodes with
	 * identical non-annotation marks before serialization — e.g.
	 * ["b"(strong), "old"(strong+ann)] serializes as "**bold**", not "**b****old**".
	 */ function splitTextNode(text, existingMarks, mdFrom) {
        const mdTo = mdFrom + text.length;
        // Split at annotation boundaries.
        const boundaries = new Set();
        boundaries.add(mdFrom);
        boundaries.add(mdTo);
        for (const ann of valid){
            if (ann.from > mdFrom && ann.from < mdTo) boundaries.add(ann.from);
            if (ann.to > mdFrom && ann.to < mdTo) boundaries.add(ann.to);
        }
        const sortedBoundaries = [
            ...boundaries
        ].sort((a, b)=>a - b);
        // If there are only two boundaries (start and end), no splits needed.
        // Just apply the correct marks to the whole node.
        if (sortedBoundaries.length === 2) {
            const annMarks = marksForMdRange(mdFrom, mdTo);
            const allMarks = schema.marks.annotation ? [
                ...existingMarks.filter((m)=>m.type.name !== 'annotation'),
                ...annMarks
            ] : existingMarks;
            return [
                schema.text(text, allMarks)
            ];
        }
        // Multiple sub-spans — create one text node per sub-span.
        const nodes = [];
        for(let i = 0; i < sortedBoundaries.length - 1; i++){
            const spanMdFrom = sortedBoundaries[i];
            const spanMdTo = sortedBoundaries[i + 1];
            const spanText = text.slice(spanMdFrom - mdFrom, spanMdTo - mdFrom);
            if (!spanText) continue;
            const annMarks = marksForMdRange(spanMdFrom, spanMdTo);
            const allMarks = [
                ...existingMarks.filter((m)=>m.type.name !== 'annotation'),
                ...annMarks
            ];
            nodes.push(schema.text(spanText, allMarks));
        }
        return nodes;
    }
    // Walk the PM document and rebuild it with annotation marks applied.
    // We track the markdown offset as we encounter text nodes (same
    // forward-search strategy as extractAnnotationRanges).
    let searchFrom = 0;
    function rebuildChildren(parent) {
        const result = [];
        parent.forEach((child)=>{
            if (child.isText && child.text) {
                const text = child.text;
                let mdIdx = markdown.indexOf(text, searchFrom);
                let matchLength = text.length;
                if (mdIdx === -1) {
                    // The serializer may have escaped special characters (e.g. `*` → `\*`),
                    // making the raw PM text no longer a direct substring. Retry with the
                    // escaped form as a fallback — mirrors the same logic in extractAnnotationRanges.
                    const escaped = $084c25d885898a33$var$escapedForMarkdown(text);
                    if (escaped !== text) {
                        mdIdx = markdown.indexOf(escaped, searchFrom);
                        if (mdIdx !== -1) matchLength = escaped.length;
                    }
                }
                if (mdIdx === -1) {
                    // Still not found — skip without advancing searchFrom, same as
                    // extractAnnotationRanges does for untranslatable nodes.
                    result.push(child);
                    return;
                }
                const nodes = splitTextNode(text, child.marks, mdIdx);
                searchFrom = mdIdx + matchLength;
                result.push(...nodes);
            } else if (child.isLeaf) result.push(child);
            else {
                const newChildren = rebuildChildren(child);
                try {
                    result.push(schema.nodes[child.type.name].createChecked(child.attrs, newChildren, child.marks));
                } catch  {
                    // If createChecked fails (e.g. content constraint violation), fall back.
                    result.push(child);
                }
            }
        });
        return result;
    }
    // Rebuild top-level (doc) children.
    const topChildren = rebuildChildren(doc);
    return schema.nodes[doc.type.name].createChecked(doc.attrs, topChildren, doc.marks);
}


/**
 * Pure helpers for converting between ADF (ProseMirror) docs and markdown
 * source. Used by `MarkdownSourceView` to populate its textarea on mount and
 * to round-trip the user's edits back to ADF on unmount.
 *
 * Both functions are intentionally side-effect free and React-free so they can
 * be unit-tested in isolation. Errors from the markdown parser are *thrown* —
 * `markdownToAdf` is a "throws on parse error" boundary; the calling component
 * is responsible for catching and surfacing them.
 *
 * Ticket: https://hello.jira.atlassian.cloud/browse/EDITOR-6558
 */ /**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $3bfe62e1276fb0cc$var$emptyOptions = {};
function $3bfe62e1276fb0cc$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $3bfe62e1276fb0cc$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $3bfe62e1276fb0cc$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $3bfe62e1276fb0cc$var$one(value, includeImageAlt, includeHtml) {
    if ($3bfe62e1276fb0cc$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $3bfe62e1276fb0cc$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $3bfe62e1276fb0cc$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $3bfe62e1276fb0cc$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $3bfe62e1276fb0cc$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $3bfe62e1276fb0cc$var$node(value) {
    return Boolean(value && typeof value === 'object');
}




/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ 
var $eFJVr = parcelRequire("eFJVr");


var $cJwEn = parcelRequire("cJwEn");


var $b0aSX = parcelRequire("b0aSX");


var $3qp16 = parcelRequire("3qp16");

function $d490b642f549a9be$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $eFJVr.compile)(options)((0, $b0aSX.postprocess)((0, $cJwEn.parse)(options).document().write((0, $3qp16.preprocess)()(value, encoding, true))));
}



var $2JNc8 = parcelRequire("2JNc8");


var $26Ync = parcelRequire("26Ync");




const $0b56131e225d9ff8$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $0b56131e225d9ff8$export$a0fb664af7d0cc44(value) {
    return value.replace($0b56131e225d9ff8$var$characterEscapeOrReference, $0b56131e225d9ff8$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $0b56131e225d9ff8$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $2JNc8.decodeNumericCharacterReference)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $26Ync.decodeNamedCharacterReference)($2) || $0;
}



var $kxETH = parcelRequire("kxETH");




/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $0ac4c77e3d86609a$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $0ac4c77e3d86609a$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $0ac4c77e3d86609a$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $0ac4c77e3d86609a$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $0ac4c77e3d86609a$var$point(point) {
    return $0ac4c77e3d86609a$var$index(point && point.line) + ':' + $0ac4c77e3d86609a$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $0ac4c77e3d86609a$var$position(pos) {
    return $0ac4c77e3d86609a$var$point(pos && pos.start) + '-' + $0ac4c77e3d86609a$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $0ac4c77e3d86609a$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


const $a2d866d1a57b6a8e$var$own = {}.hasOwnProperty;
function $a2d866d1a57b6a8e$export$d744d789c09bfde6(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return $a2d866d1a57b6a8e$var$compiler(options)((0, $b0aSX.postprocess)((0, $cJwEn.parse)(options).document().write((0, $3qp16.preprocess)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $a2d866d1a57b6a8e$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $a2d866d1a57b6a8e$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($a2d866d1a57b6a8e$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $a2d866d1a57b6a8e$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $a2d866d1a57b6a8e$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $a2d866d1a57b6a8e$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $a2d866d1a57b6a8e$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $0ac4c77e3d86609a$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $a2d866d1a57b6a8e$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $a2d866d1a57b6a8e$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $3bfe62e1276fb0cc$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $kxETH.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $a2d866d1a57b6a8e$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $a2d866d1a57b6a8e$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $a2d866d1a57b6a8e$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $0b56131e225d9ff8$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $kxETH.normalizeIdentifier)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $kxETH.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $2JNc8.decodeNumericCharacterReference)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $26Ync.decodeNamedCharacterReference)(data);
            value = result;
        }
        const tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        const tail = this.stack.pop();
        tail.position.end = $a2d866d1a57b6a8e$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $a2d866d1a57b6a8e$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $a2d866d1a57b6a8e$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $a2d866d1a57b6a8e$var$configure(combined, value);
        else $a2d866d1a57b6a8e$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $a2d866d1a57b6a8e$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($a2d866d1a57b6a8e$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $a2d866d1a57b6a8e$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $0ac4c77e3d86609a$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $0ac4c77e3d86609a$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $0ac4c77e3d86609a$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $a41cbcc025bac23c$var$constructsWithoutStrikethrough = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
$a41cbcc025bac23c$var$handleDelete.peek = $a41cbcc025bac23c$var$peekDelete;
function $a41cbcc025bac23c$export$34d64e709dd0b9bb() {
    return {
        canContainEols: [
            'delete'
        ],
        enter: {
            strikethrough: $a41cbcc025bac23c$var$enterStrikethrough
        },
        exit: {
            strikethrough: $a41cbcc025bac23c$var$exitStrikethrough
        }
    };
}
function $a41cbcc025bac23c$export$1632835bd2c84956() {
    return {
        unsafe: [
            {
                character: '~',
                inConstruct: 'phrasing',
                notInConstruct: $a41cbcc025bac23c$var$constructsWithoutStrikethrough
            }
        ],
        handlers: {
            delete: $a41cbcc025bac23c$var$handleDelete
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a41cbcc025bac23c$var$enterStrikethrough(token) {
    this.enter({
        type: 'delete',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a41cbcc025bac23c$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $a41cbcc025bac23c$var$handleDelete(node, _, state, info) {
    const tracker = state.createTracker(info);
    const exit = state.enter('strikethrough');
    let value = tracker.move('~~');
    value += state.containerPhrasing(node, {
        ...tracker.current(),
        before: value,
        after: '~'
    });
    value += tracker.move('~~');
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $a41cbcc025bac23c$var$peekDelete() {
    return '~';
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */ function $49c6ebd220c6e9c2$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $49c6ebd220c6e9c2$export$411ce8e5a71e3069() {}
function $49c6ebd220c6e9c2$export$dcb8b3f0e2de7e49() {}
function $49c6ebd220c6e9c2$export$565e9d9bd6b6e0d4() {}


/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|Array<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */ /**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {Array<Array<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */ function $bd9af20191ee876e$export$cdb7288612c4f3d6(table, options = {}) {
    const align = (options.align || []).concat();
    const stringLength = options.stringLength || $bd9af20191ee876e$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $bd9af20191ee876e$var$serialize(table[rowIndex][columnIndex]);
            if (options.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === 'object' && 'length' in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $bd9af20191ee876e$var$toAlignment(align[columnIndex]);
    else {
        const code = $bd9af20191ee876e$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = '';
        let after = '';
        if (code === 99 /* `c` */ ) {
            before = ':';
            after = ':';
        } else if (code === 108 /* `l` */ ) before = ':';
        else if (code === 114 /* `r` */ ) after = ':';
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = options.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + '-'.repeat(size) + after;
        if (options.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || '';
            let before = '';
            let after = '';
            if (options.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = ' '.repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = ' '.repeat(size / 2 + 0.5);
                        after = ' '.repeat(size / 2 - 0.5);
                    } else {
                        before = ' '.repeat(size / 2);
                        after = before;
                    }
                } else after = ' '.repeat(size);
            }
            if (options.delimiterStart !== false && !columnIndex) line.push('|');
            if (options.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(options.alignDelimiters === false && cell === '') && (options.delimiterStart !== false || columnIndex)) line.push(' ');
            if (options.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (options.alignDelimiters !== false) line.push(after);
            if (options.padding !== false) line.push(' ');
            if (options.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push('|');
        }
        lines.push(options.delimiterEnd === false ? line.join('').replace(/ +$/, '') : line.join(''));
    }
    return lines.join('\n');
}
/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */ function $bd9af20191ee876e$var$serialize(value) {
    return value === null || value === undefined ? '' : String(value);
}
/**
 * @param {string} value
 * @returns {number}
 */ function $bd9af20191ee876e$var$defaultStringLength(value) {
    return value.length;
}
/**
 * @param {string|null|undefined} value
 * @returns {number}
 */ function $bd9af20191ee876e$var$toAlignment(value) {
    const code = typeof value === 'string' ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


/**
 * @import {Blockquote, Parents} from 'mdast'
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $189de2611cc048ef$export$67dc04e652a298ca(node, _, state, info) {
    const exit = state.enter('blockquote');
    const tracker = state.createTracker(info);
    tracker.move('> ');
    tracker.shift(2);
    const value = state.indentLines(state.containerFlow(node, tracker.current()), $189de2611cc048ef$var$map);
    exit();
    return value;
}
/** @type {Map} */ function $189de2611cc048ef$var$map(line, _, blank) {
    return '>' + (blank ? '' : ' ') + line;
}


/**
 * @import {Break, Parents} from 'mdast'
 * @import {Info, State} from 'mdast-util-to-markdown'
 */ /**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $a349916310745a86$export$78221a09424368d(stack, pattern) {
    return $a349916310745a86$var$listInScope(stack, pattern.inConstruct, true) && !$a349916310745a86$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $a349916310745a86$var$listInScope(stack, list, none) {
    if (typeof list === 'string') list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $5c89ac4dcd2b0d29$export$371da9dd35aba193(_, _1, state, info) {
    let index = -1;
    while(++index < state.unsafe.length){
        // If we can’t put eols in this construct (setext headings, tables), use a
        // space instead.
        if (state.unsafe[index].character === '\n' && (0, $a349916310745a86$export$78221a09424368d)(state.stack, state.unsafe[index])) return /[ \t]/.test(info.before) ? '' : ' ';
    }
    return '\\\n';
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {Code, Parents} from 'mdast'
 */ /**
 * Get the count of the longest repeating streak of `character` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} character
 *   Single character to look for.
 * @returns {number}
 *   Count of most frequent adjacent `character`s in `value`.
 */ function $68ce6fdd46f5a4a5$export$711675ff42d864f2(value, character) {
    const source = String(value);
    let index = source.indexOf(character);
    let expected = index;
    let count = 0;
    let max = 0;
    if (typeof character !== 'string' || character.length !== 1) throw new Error('Expected character');
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + 1;
        index = source.indexOf(character, expected);
    }
    return max;
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Code} from 'mdast'
 */ /**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */ function $3abff2cebb74e7e4$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(state.options.fences === false && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value));
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */ function $bd4674373d2f4943$export$7487ee7cbb2e2919(state) {
    const marker = state.options.fence || '`';
    if (marker !== '`' && marker !== '~') throw new Error('Cannot serialize code with `' + marker + '` for `options.fence`, expected `` ` `` or `~`');
    return marker;
}


function $1be2581f07caf707$export$6565f9f03506010b(node, _, state, info) {
    const marker = (0, $bd4674373d2f4943$export$7487ee7cbb2e2919)(state);
    const raw = node.value || '';
    const suffix = marker === '`' ? 'GraveAccent' : 'Tilde';
    if ((0, $3abff2cebb74e7e4$export$8c0df78a8cad9f4b)(node, state)) {
        const exit = state.enter('codeIndented');
        const value = state.indentLines(raw, $1be2581f07caf707$var$map);
        exit();
        return value;
    }
    const tracker = state.createTracker(info);
    const sequence = marker.repeat(Math.max((0, $68ce6fdd46f5a4a5$export$711675ff42d864f2)(raw, marker) + 1, 3));
    const exit = state.enter('codeFenced');
    let value = tracker.move(sequence);
    if (node.lang) {
        const subexit = state.enter(`codeFencedLang${suffix}`);
        value += tracker.move(state.safe(node.lang, {
            before: value,
            after: ' ',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    if (node.lang && node.meta) {
        const subexit = state.enter(`codeFencedMeta${suffix}`);
        value += tracker.move(' ');
        value += tracker.move(state.safe(node.meta, {
            before: value,
            after: '\n',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    value += tracker.move('\n');
    if (raw) value += tracker.move(raw + '\n');
    value += tracker.move(sequence);
    exit();
    return value;
}
/** @type {Map} */ function $1be2581f07caf707$var$map(line, _, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Definition, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */ function $6e9576fb96656521$export$7aeba63896b2719(state) {
    const marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error('Cannot serialize title with `' + marker + '` for `options.quote`, expected `"`, or `\'`');
    return marker;
}


function $85e48424475fc186$export$69f215ed977cdb73(node, _, state, info) {
    const quote = (0, $6e9576fb96656521$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('definition');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    value += tracker.move(state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move(']: ');
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : '\n',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Emphasis, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */ function $772c061f6d40e286$export$f967eb786dea04e7(state) {
    const marker = state.options.emphasis || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize emphasis with `' + marker + '` for `options.emphasis`, expected `*`, or `_`');
    return marker;
}


/**
 * Encode a code point as a character reference.
 *
 * @param {number} code
 *   Code point to encode.
 * @returns {string}
 *   Encoded character reference.
 */ function $5992f65195685991$export$5810cf1e579e9d5b(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


/**
 * @import {EncodeSides} from '../types.js'
 */ 
var $daFoX = parcelRequire("daFoX");

function $4df61b556c309f65$export$b444be54825dd0b6(outside, inside, marker) {
    const outsideKind = (0, $daFoX.classifyCharacter)(outside);
    const insideKind = (0, $daFoX.classifyCharacter)(inside);
    // Letter outside:
    if (outsideKind === undefined) return insideKind === undefined ? // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    marker === '_' ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: true
    };
    // Whitespace outside:
    if (outsideKind === 1) return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    };
    // Punctuation outside:
    return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: false
    } : {
        inside: false,
        outside: false
    };
}


$aa85e9ea1bdfde42$export$bef81ba411953b51.peek = $aa85e9ea1bdfde42$var$emphasisPeek;
function $aa85e9ea1bdfde42$export$bef81ba411953b51(node, _, state, info) {
    const marker = (0, $772c061f6d40e286$export$f967eb786dea04e7)(state);
    const exit = state.enter('emphasis');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker);
    let between = tracker.move(state.containerPhrasing(node, {
        after: marker,
        before: before,
        ...tracker.current()
    }));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $4df61b556c309f65$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $5992f65195685991$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $4df61b556c309f65$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $5992f65195685991$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $aa85e9ea1bdfde42$var$emphasisPeek(_, _1, state) {
    return state.options.emphasis || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Heading, Parents} from 'mdast'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Heading} from 'mdast'
 */ 
var $72j6x = parcelRequire("72j6x");
/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 


function $59ac58d8ab94c25f$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $72j6x.visitParents)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



function $8f4380e3d2d5e11a$export$78863676235adfbc(node, state) {
    let literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $59ac58d8ab94c25f$export$bf638b60ea8b89b7)(node, function(node) {
        if ('value' in node && /\r?\n|\r/.test(node.value) || node.type === 'break') {
            literalWithBreak = true;
            return 0, $72j6x.EXIT;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $3bfe62e1276fb0cc$export$f84e8e69fd4488a5)(node) && (state.options.setext || literalWithBreak));
}


function $ef8031370ca37913$export$46e4a324ac90507f(node, _, state, info) {
    const rank = Math.max(Math.min(6, node.depth || 1), 1);
    const tracker = state.createTracker(info);
    if ((0, $8f4380e3d2d5e11a$export$78863676235adfbc)(node, state)) {
        const exit = state.enter('headingSetext');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...tracker.current(),
            before: '\n',
            after: '\n'
        });
        subexit();
        exit();
        return value + '\n' + (rank === 1 ? '=' : '-').repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf('\r'), value.lastIndexOf('\n')) + 1));
    }
    const sequence = '#'.repeat(rank);
    const exit = state.enter('headingAtx');
    const subexit = state.enter('phrasing');
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + ' ');
    let value = state.containerPhrasing(node, {
        before: '# ',
        after: '\n',
        ...tracker.current()
    });
    if (/^[\t ]/.test(value)) // To do: what effect has the character reference on tracking?
    value = (0, $5992f65195685991$export$5810cf1e579e9d5b)(value.charCodeAt(0)) + value.slice(1);
    value = value ? sequence + ' ' + value : sequence;
    if (state.options.closeAtx) value += ' ' + sequence;
    subexit();
    exit();
    return value;
}


/**
 * @import {Html} from 'mdast'
 */ $4ac251886dd789db$export$c0bb0b647f701bb5.peek = $4ac251886dd789db$var$htmlPeek;
function $4ac251886dd789db$export$c0bb0b647f701bb5(node) {
    return node.value || '';
}
/**
 * @returns {string}
 */ function $4ac251886dd789db$var$htmlPeek() {
    return '<';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Image, Parents} from 'mdast'
 */ 
$f0727908ca4f11be$export$5c452ff88e35e47d.peek = $f0727908ca4f11be$var$imagePeek;
function $f0727908ca4f11be$export$5c452ff88e35e47d(node, _, state, info) {
    const quote = (0, $6e9576fb96656521$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('image');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    value += tracker.move(state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @returns {string}
 */ function $f0727908ca4f11be$var$imagePeek() {
    return '!';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {ImageReference, Parents} from 'mdast'
 */ $2d7bed644e50e610$export$f281796f6bc3b8db.peek = $2d7bed644e50e610$var$imageReferencePeek;
function $2d7bed644e50e610$export$f281796f6bc3b8db(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('imageReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    const alt = state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(alt + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !alt || alt !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $2d7bed644e50e610$var$imageReferencePeek() {
    return '!';
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {InlineCode, Parents} from 'mdast'
 */ $9642dfed6522030c$export$91b9bee19a0d8569.peek = $9642dfed6522030c$var$inlineCodePeek;
function $9642dfed6522030c$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || '';
    let sequence = '`';
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value))sequence += '`';
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = ' ' + value + ' ';
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $9642dfed6522030c$var$inlineCodePeek() {
    return '`';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Link, Parents} from 'mdast'
 * @import {Exit} from '../types.js'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Link} from 'mdast'
 */ 
function $25dfdf8aefb6a8cd$export$74cae3045e3179ed(node, state) {
    const raw = (0, $3bfe62e1276fb0cc$export$f84e8e69fd4488a5)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s a no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === 'text' && // And if the url is the same as the content…
    (raw === node.url || 'mailto:' + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}


$85f59b955fedc11b$export$9c30223ca0a664fb.peek = $85f59b955fedc11b$var$linkPeek;
function $85f59b955fedc11b$export$9c30223ca0a664fb(node, _, state, info) {
    const quote = (0, $6e9576fb96656521$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const tracker = state.createTracker(info);
    /** @type {Exit} */ let exit;
    /** @type {Exit} */ let subexit;
    if ((0, $25dfdf8aefb6a8cd$export$74cae3045e3179ed)(node, state)) {
        // Hide the fact that we’re in phrasing, because escapes don’t work.
        const stack = state.stack;
        state.stack = [];
        exit = state.enter('autolink');
        let value = tracker.move('<');
        value += tracker.move(state.containerPhrasing(node, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
        exit();
        state.stack = stack;
        return value;
    }
    exit = state.enter('link');
    subexit = state.enter('label');
    let value = tracker.move('[');
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: '](',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */ function $85f59b955fedc11b$var$linkPeek(node, _, state) {
    return (0, $25dfdf8aefb6a8cd$export$74cae3045e3179ed)(node, state) ? '<' : '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {LinkReference, Parents} from 'mdast'
 */ $ff8f4a53245769f9$export$e6c469b1b7b2bc6a.peek = $ff8f4a53245769f9$var$linkReferencePeek;
function $ff8f4a53245769f9$export$e6c469b1b7b2bc6a(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('linkReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    const text = state.containerPhrasing(node, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(text + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !text || text !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $ff8f4a53245769f9$var$linkReferencePeek() {
    return '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {List, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $05e099439f6ef8f9$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || '*';
    if (marker !== '*' && marker !== '+' && marker !== '-') throw new Error('Cannot serialize items with `' + marker + '` for `options.bullet`, expected `*`, `+`, or `-`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ 
function $b845233e28f326a7$export$e6803bf0889262a1(state) {
    const bullet = (0, $05e099439f6ef8f9$export$7425517207a4d0ae)(state);
    const bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === '*' ? '-' : '*';
    if (bulletOther !== '*' && bulletOther !== '+' && bulletOther !== '-') throw new Error('Cannot serialize items with `' + bulletOther + '` for `options.bulletOther`, expected `*`, `+`, or `-`');
    if (bulletOther === bullet) throw new Error('Expected `bullet` (`' + bullet + '`) and `bulletOther` (`' + bulletOther + '`) to be different');
    return bulletOther;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */ function $5690713c68123629$export$98d522b78eddc19b(state) {
    const marker = state.options.bulletOrdered || '.';
    if (marker !== '.' && marker !== ')') throw new Error('Cannot serialize items with `' + marker + '` for `options.bulletOrdered`, expected `.` or `)`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */ function $b95c754325860627$export$d8d533ef24dba866(state) {
    const marker = state.options.rule || '*';
    if (marker !== '*' && marker !== '-' && marker !== '_') throw new Error('Cannot serialize rules with `' + marker + '` for `options.rule`, expected `*`, `-`, or `_`');
    return marker;
}


function $085efd7d0dbbb220$export$8837f4fc672e936d(node, parent, state, info) {
    const exit = state.enter('list');
    const bulletCurrent = state.bulletCurrent;
    /** @type {string} */ let bullet = node.ordered ? (0, $5690713c68123629$export$98d522b78eddc19b)(state) : (0, $05e099439f6ef8f9$export$7425517207a4d0ae)(state);
    /** @type {string} */ const bulletOther = node.ordered ? bullet === '.' ? ')' : '.' : (0, $b845233e28f326a7$export$e6803bf0889262a1)(state);
    let useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
    if (!node.ordered) {
        const firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === '*' || bullet === '-') && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === 'list' && state.stack[state.stack.length - 2] === 'listItem' && state.stack[state.stack.length - 3] === 'list' && state.stack[state.stack.length - 4] === 'listItem' && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $b95c754325860627$export$d8d533ef24dba866)(state) === bullet && firstListItem) {
            let index = -1;
            while(++index < node.children.length){
                const item = node.children[index];
                if (item && item.type === 'listItem' && item.children && item.children[0] && item.children[0].type === 'thematicBreak') {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    const value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {ListItem, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $ba523898a1d1a58e$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || 'one';
    if (style !== 'tab' && style !== 'one' && style !== 'mixed') throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
    return style;
}


function $32922853a9a5faae$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $ba523898a1d1a58e$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $05e099439f6ef8f9$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === 'list' && parent.ordered) bullet = (typeof parent.start === 'number' && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.type === 'list' && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + ' '.repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter('listItem');
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? '' : ' '.repeat(size)) + line;
        return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line;
    }
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Paragraph, Parents} from 'mdast'
 */ /**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $b4851e8aa52ae01e$export$9c206ddddb32a9b(node, _, state, info) {
    const exit = state.enter('paragraph');
    const subexit = state.enter('phrasing');
    const value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Root} from 'mdast'
 */ /**
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */ 
var $eydDE = parcelRequire("eydDE");

const $1e0216f4131e190d$export$444c9dec66a6f08c = /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */ (0, $eydDE.convert)([
    'break',
    'delete',
    'emphasis',
    // To do: next major: removed since footnotes were added to GFM.
    'footnote',
    'footnoteReference',
    'image',
    'imageReference',
    'inlineCode',
    // Enabled by `mdast-util-math`:
    'inlineMath',
    'link',
    'linkReference',
    // Enabled by `mdast-util-mdx`:
    'mdxJsxTextElement',
    // Enabled by `mdast-util-mdx`:
    'mdxTextExpression',
    'strong',
    'text',
    // Enabled by `mdast-util-directive`:
    'textDirective'
]);


function $ac7e9703e35bd2d4$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    const hasPhrasing = node.children.some(function(d) {
        return (0, $1e0216f4131e190d$export$444c9dec66a6f08c)(d);
    });
    const container = hasPhrasing ? state.containerPhrasing : state.containerFlow;
    return container.call(state, node, info);
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Strong} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */ function $320abb20a6eb8775$export$b7ce17905d66a6c3(state) {
    const marker = state.options.strong || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize strong with `' + marker + '` for `options.strong`, expected `*`, or `_`');
    return marker;
}




$a91dcc76ddc85487$export$59ae2c325a998f89.peek = $a91dcc76ddc85487$var$strongPeek;
function $a91dcc76ddc85487$export$59ae2c325a998f89(node, _, state, info) {
    const marker = (0, $320abb20a6eb8775$export$b7ce17905d66a6c3)(state);
    const exit = state.enter('strong');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker + marker);
    let between = tracker.move(state.containerPhrasing(node, {
        after: marker,
        before: before,
        ...tracker.current()
    }));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $4df61b556c309f65$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $5992f65195685991$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $4df61b556c309f65$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $5992f65195685991$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker + marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $a91dcc76ddc85487$var$strongPeek(_, _1, state) {
    return state.options.strong || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Text} from 'mdast'
 */ /**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $1b8da66ea2146135$export$6f093cfa640b7166(node, _, state, info) {
    return state.safe(node.value, info);
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Parents, ThematicBreak} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */ function $c774a54caae64f25$export$72f02155834d89c4(state) {
    const repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error('Cannot serialize rules with repetition `' + repetition + '` for `options.ruleRepetition`, expected `3` or more');
    return repetition;
}



function $ce5fc5c907d2cb43$export$ba7b13e047416c03(_, _1, state) {
    const value = ((0, $b95c754325860627$export$d8d533ef24dba866)(state) + (state.options.ruleSpaces ? ' ' : '')).repeat((0, $c774a54caae64f25$export$72f02155834d89c4)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}


const $1dd28883d8b6efc1$export$8f34ce051745d39e = {
    blockquote: $189de2611cc048ef$export$67dc04e652a298ca,
    break: (0, $5c89ac4dcd2b0d29$export$371da9dd35aba193),
    code: $1be2581f07caf707$export$6565f9f03506010b,
    definition: $85e48424475fc186$export$69f215ed977cdb73,
    emphasis: $aa85e9ea1bdfde42$export$bef81ba411953b51,
    hardBreak: $5c89ac4dcd2b0d29$export$371da9dd35aba193,
    heading: $ef8031370ca37913$export$46e4a324ac90507f,
    html: $4ac251886dd789db$export$c0bb0b647f701bb5,
    image: $f0727908ca4f11be$export$5c452ff88e35e47d,
    imageReference: $2d7bed644e50e610$export$f281796f6bc3b8db,
    inlineCode: $9642dfed6522030c$export$91b9bee19a0d8569,
    link: $85f59b955fedc11b$export$9c30223ca0a664fb,
    linkReference: $ff8f4a53245769f9$export$e6c469b1b7b2bc6a,
    list: $085efd7d0dbbb220$export$8837f4fc672e936d,
    listItem: $32922853a9a5faae$export$76c7e83ecc9cdf05,
    paragraph: $b4851e8aa52ae01e$export$9c206ddddb32a9b,
    root: $ac7e9703e35bd2d4$export$e8e78c978b129247,
    strong: $a91dcc76ddc85487$export$59ae2c325a998f89,
    text: $1b8da66ea2146135$export$6f093cfa640b7166,
    thematicBreak: $ce5fc5c907d2cb43$export$ba7b13e047416c03
};


function $3bff305c903a5854$export$8bd0ec8ecf6adb7d() {
    return {
        enter: {
            table: $3bff305c903a5854$var$enterTable,
            tableData: $3bff305c903a5854$var$enterCell,
            tableHeader: $3bff305c903a5854$var$enterCell,
            tableRow: $3bff305c903a5854$var$enterRow
        },
        exit: {
            codeText: $3bff305c903a5854$var$exitCodeText,
            table: $3bff305c903a5854$var$exitTable,
            tableData: $3bff305c903a5854$var$exit,
            tableHeader: $3bff305c903a5854$var$exit,
            tableRow: $3bff305c903a5854$var$exit
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3bff305c903a5854$var$enterTable(token) {
    const align = token._align;
    (0, $49c6ebd220c6e9c2$export$dcb8b3f0e2de7e49)(align, 'expected `_align` on table');
    this.enter({
        type: 'table',
        align: align.map(function(d) {
            return d === 'none' ? null : d;
        }),
        children: []
    }, token);
    this.data.inTable = true;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3bff305c903a5854$var$exitTable(token) {
    this.exit(token);
    this.data.inTable = undefined;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3bff305c903a5854$var$enterRow(token) {
    this.enter({
        type: 'tableRow',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3bff305c903a5854$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3bff305c903a5854$var$enterCell(token) {
    this.enter({
        type: 'tableCell',
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $3bff305c903a5854$var$exitCodeText(token) {
    let value = this.resume();
    if (this.data.inTable) value = value.replace(/\\([\\|])/g, $3bff305c903a5854$var$replace);
    const node = this.stack[this.stack.length - 1];
    (0, $49c6ebd220c6e9c2$export$dcb8b3f0e2de7e49)(node.type === 'inlineCode');
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $3bff305c903a5854$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}
function $3bff305c903a5854$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? ' ' : '|';
    return {
        unsafe: [
            {
                character: '\r',
                inConstruct: 'tableCell'
            },
            {
                character: '\n',
                inConstruct: 'tableCell'
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: '|',
                after: '[\t :-]'
            },
            // A pipe in a cell must be encoded.
            {
                character: '|',
                inConstruct: 'tableCell'
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ':',
                after: '-'
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            inlineCode: inlineCodeWithTable,
            table: handleTable,
            tableCell: handleTableCell,
            tableRow: handleTableRow
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, state, info) {
        return serializeData(handleTableAsData(node, state, info), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, state, info) {
        const row = handleTableRowAsData(node, state, info);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf('\n'));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, state, info) {
        const exit = state.enter('tableCell');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...info,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $bd9af20191ee876e$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = state.enter('table');
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], state, info);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableRowAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = state.enter('tableRow');
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, state, info);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, state) {
        let value = (0, $1dd28883d8b6efc1$export$8f34ce051745d39e).inlineCode(node, parent, state);
        if (state.stack.includes('tableCell')) value = value.replace(/\|/g, '\\$&');
        return value;
    }
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 

function $b4ef0b4c77ef6a57$export$a427a608608b215f() {
    return {
        exit: {
            taskListCheckValueChecked: $b4ef0b4c77ef6a57$var$exitCheck,
            taskListCheckValueUnchecked: $b4ef0b4c77ef6a57$var$exitCheck,
            paragraph: $b4ef0b4c77ef6a57$var$exitParagraphWithTaskListItem
        }
    };
}
function $b4ef0b4c77ef6a57$export$9975722e7e834b78() {
    return {
        unsafe: [
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            listItem: $b4ef0b4c77ef6a57$var$listItemWithTaskListItem
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $b4ef0b4c77ef6a57$var$exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    const node = this.stack[this.stack.length - 2];
    (0, $49c6ebd220c6e9c2$export$dcb8b3f0e2de7e49)(node.type === 'listItem');
    node.checked = token.type === 'taskListCheckValueChecked';
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $b4ef0b4c77ef6a57$var$exitParagraphWithTaskListItem(token) {
    const parent = this.stack[this.stack.length - 2];
    if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean') {
        const node = this.stack[this.stack.length - 1];
        (0, $49c6ebd220c6e9c2$export$dcb8b3f0e2de7e49)(node.type === 'paragraph');
        const head = node.children[0];
        if (head && head.type === 'text') {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === 'paragraph') {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === 'number') {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $b4ef0b4c77ef6a57$var$listItemWithTaskListItem(node, parent, state, info) {
    const head = node.children[0];
    const checkable = typeof node.checked === 'boolean' && head && head.type === 'paragraph';
    const checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
    const tracker = state.createTracker(info);
    if (checkable) tracker.move(checkbox);
    let value = (0, $1dd28883d8b6efc1$export$8f34ce051745d39e).listItem(node, parent, state, {
        ...info,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


/**
 * @import {Options} from 'micromark-extension-gfm-strikethrough'
 * @import {Event, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 
var $7v7jT = parcelRequire("7v7jT");





var $fQmC6 = parcelRequire("fQmC6");

function $8e04031d12c492e0$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        name: 'strikethrough',
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = 'strikethroughSequence';
                events[open][1].type = 'strikethroughSequence';
                /** @type {Token} */ const strikethrough = {
                    type: 'strikethrough',
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: 'strikethroughText',
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        'enter',
                        strikethrough,
                        context
                    ],
                    [
                        'enter',
                        events[open][1],
                        context
                    ],
                    [
                        'exit',
                        events[open][1],
                        context
                    ],
                    [
                        'enter',
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $7v7jT.splice)(nextEvents, nextEvents.length, 0, (0, $fQmC6.resolveAll)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $7v7jT.splice)(nextEvents, nextEvents.length, 0, [
                    [
                        'exit',
                        text,
                        context
                    ],
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        strikethrough,
                        context
                    ]
                ]);
                (0, $7v7jT.splice)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === 'strikethroughSequenceTemporary') events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter('strikethroughSequenceTemporary');
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $daFoX.classifyCharacter)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit('strikethroughSequenceTemporary');
            const after = (0, $daFoX.classifyCharacter)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}


/**
 * @import {Event, Extension, Point, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 
var $2q899 = parcelRequire("2q899");


var $4b5zd = parcelRequire("4b5zd");

/**
 * @import {Event} from 'micromark-util-types'
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $acb31fb29b6b63f6$export$9348908dd4518b4a {
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */ add(index, remove, add) {
        $acb31fb29b6b63f6$var$addImplementation(this, index, remove, add);
    }
    // To do: add this when moving to `micromark`.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {undefined}
    //  */
    // addBefore(index, remove, add) {
    //   addImplementation(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */ consume(events) {
        this.map.sort(function(a, b) {
            return a[0] - b[0];
        });
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push(events.slice());
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            for (const element of slice)events.push(element);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */ function $acb31fb29b6b63f6$var$addImplementation(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used by tables, use when moving to micromark.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @import {Event} from 'micromark-util-types'
 */ /**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */ function $c56aa18500579fa3$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === 'enter') // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === 'tableContent') align.push(events[index + 1][1].type === 'tableDelimiterMarker' ? 'left' : 'none');
            } else if (event[1].type === 'tableContent') {
                if (events[index - 1][1].type === 'tableDelimiterMarker') {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right';
                }
            } else if (event[1].type === 'tableDelimiterRow') break;
        } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') inDelimiterRow = true;
        index += 1;
    }
    return align;
}


function $5490715e401c0d53$export$e36cebda627bf2dd() {
    return {
        flow: {
            null: {
                name: 'table',
                tokenize: $5490715e401c0d53$var$tokenizeTable,
                resolveAll: $5490715e401c0d53$var$resolveTable
            }
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5490715e401c0d53$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter('tableHead');
        effects.enter('tableRow');
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit('tableRow');
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $4b5zd.markdownSpace)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $2q899.factorySpace)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $4b5zd.markdownLineEndingOrSpace)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter('tableDelimiterRow');
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $4b5zd.markdownSpace)(code)) return (0, $2q899.factorySpace)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $4b5zd.markdownSpace)(code)) return (0, $2q899.factorySpace)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter('tableDelimiterFiller');
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit('tableDelimiterFiller');
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit('tableDelimiterFiller');
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $4b5zd.markdownSpace)(code)) return (0, $2q899.factorySpace)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit('tableDelimiterRow');
            effects.exit('tableHead');
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter('tableRow');
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return bodyRowBreak;
        }
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit('tableRow');
            return ok(code);
        }
        if ((0, $4b5zd.markdownSpace)(code)) return (0, $2q899.factorySpace)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $4b5zd.markdownLineEndingOrSpace)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ function $5490715e401c0d53$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $acb31fb29b6b63f6$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === 'enter') {
            // Start of head.
            if (token.type === 'tableHead') {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $5490715e401c0d53$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: 'table',
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        'enter',
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: 'tableBody',
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            'enter',
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $5490715e401c0d53$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === 'tableCellDivider') {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $5490715e401c0d53$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === 'tableHead') {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $5490715e401c0d53$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $5490715e401c0d53$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) cell[3] = index;
    }
    if (lastTableEnd !== 0) $5490715e401c0d53$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === 'enter' && event[1].type === 'table') event[1]._align = (0, $c56aa18500579fa3$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $5490715e401c0d53$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? 'tableHeader' : rowKind === 2 ? 'tableDelimiter' : 'tableData';
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = 'tableContent';
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $5490715e401c0d53$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $5490715e401c0d53$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            'enter',
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $5490715e401c0d53$var$getPoint(context.events, range[2]);
        const relatedEnd = $5490715e401c0d53$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                'enter',
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                'exit',
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $5490715e401c0d53$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $5490715e401c0d53$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $5490715e401c0d53$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            'exit',
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        'exit',
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */ function $5490715e401c0d53$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === 'enter' ? 'start' : 'end';
    return event[1][side];
}


/**
 * @import {Extension, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 





const $78c447656c76a7de$var$tasklistCheck = {
    name: 'tasklistCheck',
    tokenize: $78c447656c76a7de$var$tokenizeTasklistCheck
};
function $78c447656c76a7de$export$2912e8b2802475ff() {
    return {
        text: {
            [91]: $78c447656c76a7de$var$tasklistCheck
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $78c447656c76a7de$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter('taskListCheck');
        effects.enter('taskListCheckMarker');
        effects.consume(code);
        effects.exit('taskListCheckMarker');
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $4b5zd.markdownLineEndingOrSpace)(code)) {
            effects.enter('taskListCheckValueUnchecked');
            effects.consume(code);
            effects.exit('taskListCheckValueUnchecked');
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter('taskListCheckValueChecked');
            effects.consume(code);
            effects.exit('taskListCheckValueChecked');
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter('taskListCheckMarker');
            effects.consume(code);
            effects.exit('taskListCheckMarker');
            effects.exit('taskListCheck');
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $4b5zd.markdownLineEnding)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $4b5zd.markdownSpace)(code)) return effects.check({
            tokenize: $78c447656c76a7de$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $78c447656c76a7de$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $2q899.factorySpace)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}





/**
 * @import {Info, Join, Options, SafeConfig, State} from 'mdast-util-to-markdown'
 * @import {Nodes} from 'mdast'
 * @import {Enter, FlowParents, PhrasingParents, TrackFields} from './types.js'
 */ /**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $8a9f9aad604403eb$var$own = {}.hasOwnProperty;
function $8a9f9aad604403eb$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $8a9f9aad604403eb$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $8a9f9aad604403eb$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}


/**
 * @import {Options, State} from './types.js'
 */ const $64bc31b6b64620ad$var$own = {}.hasOwnProperty;
function $64bc31b6b64620ad$export$8d21e34596265fa2(base, extension) {
    let index = -1;
    /** @type {keyof Options} */ let key;
    // First do subextensions.
    if (extension.extensions) while(++index < extension.extensions.length)$64bc31b6b64620ad$export$8d21e34596265fa2(base, extension.extensions[index]);
    for(key in extension)if ($64bc31b6b64620ad$var$own.call(extension, key)) switch(key){
        case 'extensions':
            break;
        /* c8 ignore next 4 */ case 'unsafe':
            $64bc31b6b64620ad$var$list(base[key], extension[key]);
            break;
        case 'join':
            $64bc31b6b64620ad$var$list(base[key], extension[key]);
            break;
        case 'handlers':
            $64bc31b6b64620ad$var$map(base[key], extension[key]);
            break;
        default:
            // @ts-expect-error: matches.
            base.options[key] = extension[key];
    }
    return base;
}
/**
 * @template T
 * @param {Array<T>} left
 * @param {Array<T> | null | undefined} right
 */ function $64bc31b6b64620ad$var$list(left, right) {
    if (right) left.push(...right);
}
/**
 * @template T
 * @param {Record<string, T>} left
 * @param {Record<string, T> | null | undefined} right
 */ function $64bc31b6b64620ad$var$map(left, right) {
    if (right) Object.assign(left, right);
}



/**
 * @import {Join} from 'mdast-util-to-markdown'
 */ 

const $b073814c6b22779d$export$f7e2c8231c57a8bd = [
    $b073814c6b22779d$var$joinDefaults
];
/** @type {Join} */ function $b073814c6b22779d$var$joinDefaults(left, right, parent, state) {
    // Indented code after list or another indented code.
    if (right.type === 'code' && (0, $3abff2cebb74e7e4$export$8c0df78a8cad9f4b)(right, state) && (left.type === 'list' || left.type === right.type && (0, $3abff2cebb74e7e4$export$8c0df78a8cad9f4b)(left, state))) return false;
    // Join children of a list or an item.
    // In which case, `parent` has a `spread` field.
    if ('spread' in parent && typeof parent.spread === 'boolean') {
        if (left.type === 'paragraph' && // Two paragraphs.
        (left.type === right.type || right.type === 'definition' || // Paragraph followed by a setext heading.
        right.type === 'heading' && (0, $8f4380e3d2d5e11a$export$78863676235adfbc)(right, state))) return;
        return parent.spread ? 1 : 0;
    }
}


/**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain things like attention (emphasis, strong), images, or links.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * @type {Array<ConstructName>}
 */ const $a7745b3e1631c595$var$fullPhrasingSpans = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
const $a7745b3e1631c595$export$aa1c11b655786597 = [
    {
        character: '\t',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: '\t',
        before: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: '\t',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde'
        ]
    },
    {
        character: '\r',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde',
            'codeFencedMetaGraveAccent',
            'codeFencedMetaTilde',
            'destinationLiteral',
            'headingAtx'
        ]
    },
    {
        character: '\n',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde',
            'codeFencedMetaGraveAccent',
            'codeFencedMetaTilde',
            'destinationLiteral',
            'headingAtx'
        ]
    },
    {
        character: ' ',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: ' ',
        before: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: ' ',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde'
        ]
    },
    // An exclamation mark can start an image, if it is followed by a link or
    // a link reference.
    {
        character: '!',
        after: '\\[',
        inConstruct: 'phrasing',
        notInConstruct: $a7745b3e1631c595$var$fullPhrasingSpans
    },
    // A quote can break out of a title.
    {
        character: '"',
        inConstruct: 'titleQuote'
    },
    // A number sign could start an ATX heading if it starts a line.
    {
        atBreak: true,
        character: '#'
    },
    {
        character: '#',
        inConstruct: 'headingAtx',
        after: '(?:[\r\n]|$)'
    },
    // Dollar sign and percentage are not used in markdown.
    // An ampersand could start a character reference.
    {
        character: '&',
        after: '[#A-Za-z]',
        inConstruct: 'phrasing'
    },
    // An apostrophe can break out of a title.
    {
        character: "'",
        inConstruct: 'titleApostrophe'
    },
    // A left paren could break out of a destination raw.
    {
        character: '(',
        inConstruct: 'destinationRaw'
    },
    // A left paren followed by `]` could make something into a link or image.
    {
        before: '\\]',
        character: '(',
        inConstruct: 'phrasing',
        notInConstruct: $a7745b3e1631c595$var$fullPhrasingSpans
    },
    // A right paren could start a list item or break out of a destination
    // raw.
    {
        atBreak: true,
        before: '\\d+',
        character: ')'
    },
    {
        character: ')',
        inConstruct: 'destinationRaw'
    },
    // An asterisk can start thematic breaks, list items, emphasis, strong.
    {
        atBreak: true,
        character: '*',
        after: '(?:[ \t\r\n*])'
    },
    {
        character: '*',
        inConstruct: 'phrasing',
        notInConstruct: $a7745b3e1631c595$var$fullPhrasingSpans
    },
    // A plus sign could start a list item.
    {
        atBreak: true,
        character: '+',
        after: '(?:[ \t\r\n])'
    },
    // A dash can start thematic breaks, list items, and setext heading
    // underlines.
    {
        atBreak: true,
        character: '-',
        after: '(?:[ \t\r\n-])'
    },
    // A dot could start a list item.
    {
        atBreak: true,
        before: '\\d+',
        character: '.',
        after: '(?:[ \t\r\n]|$)'
    },
    // Slash, colon, and semicolon are not used in markdown for constructs.
    // A less than can start html (flow or text) or an autolink.
    // HTML could start with an exclamation mark (declaration, cdata, comment),
    // slash (closing tag), question mark (instruction), or a letter (tag).
    // An autolink also starts with a letter.
    // Finally, it could break out of a destination literal.
    {
        atBreak: true,
        character: '<',
        after: '[!/?A-Za-z]'
    },
    {
        character: '<',
        after: '[!/?A-Za-z]',
        inConstruct: 'phrasing',
        notInConstruct: $a7745b3e1631c595$var$fullPhrasingSpans
    },
    {
        character: '<',
        inConstruct: 'destinationLiteral'
    },
    // An equals to can start setext heading underlines.
    {
        atBreak: true,
        character: '='
    },
    // A greater than can start block quotes and it can break out of a
    // destination literal.
    {
        atBreak: true,
        character: '>'
    },
    {
        character: '>',
        inConstruct: 'destinationLiteral'
    },
    // Question mark and at sign are not used in markdown for constructs.
    // A left bracket can start definitions, references, labels,
    {
        atBreak: true,
        character: '['
    },
    {
        character: '[',
        inConstruct: 'phrasing',
        notInConstruct: $a7745b3e1631c595$var$fullPhrasingSpans
    },
    {
        character: '[',
        inConstruct: [
            'label',
            'reference'
        ]
    },
    // A backslash can start an escape (when followed by punctuation) or a
    // hard break (when followed by an eol).
    // Note: typical escapes are handled in `safe`!
    {
        character: '\\',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    // A right bracket can exit labels.
    {
        character: ']',
        inConstruct: [
            'label',
            'reference'
        ]
    },
    // Caret is not used in markdown for constructs.
    // An underscore can start emphasis, strong, or a thematic break.
    {
        atBreak: true,
        character: '_'
    },
    {
        character: '_',
        inConstruct: 'phrasing',
        notInConstruct: $a7745b3e1631c595$var$fullPhrasingSpans
    },
    // A grave accent can start code (fenced or text), or it can break out of
    // a grave accent code fence.
    {
        atBreak: true,
        character: '`'
    },
    {
        character: '`',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedMetaGraveAccent'
        ]
    },
    {
        character: '`',
        inConstruct: 'phrasing',
        notInConstruct: $a7745b3e1631c595$var$fullPhrasingSpans
    },
    // Left brace, vertical bar, right brace are not used in markdown for
    // constructs.
    // A tilde can start code (fenced).
    {
        atBreak: true,
        character: '~'
    }
];


/**
 * @import {AssociationId} from '../types.js'
 */ 
function $934833ed9e37d72a$export$c4ca1a6065421754(node) {
    if (node.label || !node.identifier) return node.label || '';
    return (0, $0b56131e225d9ff8$export$a0fb664af7d0cc44)(node.identifier);
}


/**
 * @import {CompilePattern} from '../types.js'
 */ /**
 * @type {CompilePattern}
 */ function $6d3542ff6c666380$export$2db8af076f277cbf(pattern) {
    if (!pattern._compiled) {
        const before = (pattern.atBreak ? '[\\r\\n][\\t ]*' : '') + (pattern.before ? '(?:' + pattern.before + ')' : '');
        pattern._compiled = new RegExp((before ? '(' + before + ')' : '') + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? '\\' : '') + pattern.character + (pattern.after ? '(?:' + pattern.after + ')' : ''), 'g');
    }
    return pattern._compiled;
}


/**
 * @import {Handle, Info, State} from 'mdast-util-to-markdown'
 * @import {PhrasingParents} from '../types.js'
 */ 
function $cf21afe648de355e$export$f4090a9439f37631(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    let before = info.before;
    /** @type {string | undefined} */ let encodeAfter;
    indexStack.push(-1);
    let tracker = state.createTracker(info);
    while(++index < children.length){
        const child = children[index];
        /** @type {string} */ let after;
        indexStack[indexStack.length - 1] = index;
        if (index + 1 < children.length) {
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            let handle = state.handle.handlers[children[index + 1].type];
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, state, {
                before: '',
                after: '',
                ...tracker.current()
            }).charAt(0) : '';
        } else after = info.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === '\r' || before === '\n') && child.type === 'html') {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, ' ');
            before = ' ';
            // To do: does this work to reset tracker?
            tracker = state.createTracker(info);
            tracker.move(results.join(''));
        }
        let value = state.handle(child, parent, state, {
            ...tracker.current(),
            after: after,
            before: before
        });
        // If we had to encode the first character after the previous node and it’s
        // still the same character,
        // encode it.
        if (encodeAfter && encodeAfter === value.slice(0, 1)) value = (0, $5992f65195685991$export$5810cf1e579e9d5b)(encodeAfter.charCodeAt(0)) + value.slice(1);
        const encodingInfo = state.attentionEncodeSurroundingInfo;
        state.attentionEncodeSurroundingInfo = undefined;
        encodeAfter = undefined;
        // If we have to encode the first character before the current node and
        // it’s still the same character,
        // encode it.
        if (encodingInfo) {
            if (results.length > 0 && encodingInfo.before && before === results[results.length - 1].slice(-1)) results[results.length - 1] = results[results.length - 1].slice(0, -1) + (0, $5992f65195685991$export$5810cf1e579e9d5b)(before.charCodeAt(0));
            if (encodingInfo.after) encodeAfter = after;
        }
        tracker.move(value);
        results.push(value);
        before = value.slice(-1);
    }
    indexStack.pop();
    return results.join('');
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {FlowChildren, FlowParents, TrackFields} from '../types.js'
 */ /**
 * @param {FlowParents} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $ffbf0ec20599d168$export$134f7fdacfea8b16(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    const tracker = state.createTracker(info);
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    indexStack.push(-1);
    while(++index < children.length){
        const child = children[index];
        indexStack[indexStack.length - 1] = index;
        results.push(tracker.move(state.handle(child, parent, state, {
            before: '\n',
            after: '\n',
            ...tracker.current()
        })));
        if (child.type !== 'list') state.bulletLastUsed = undefined;
        if (index < children.length - 1) results.push(tracker.move($ffbf0ec20599d168$var$between(child, children[index + 1], parent, state)));
    }
    indexStack.pop();
    return results.join('');
}
/**
 * @param {FlowChildren} left
 * @param {FlowChildren} right
 * @param {FlowParents} parent
 * @param {State} state
 * @returns {string}
 */ function $ffbf0ec20599d168$var$between(left, right, parent, state) {
    let index = state.join.length;
    while(index--){
        const result = state.join[index](left, right, parent, state);
        if (result === true || result === 1) break;
        if (typeof result === 'number') return '\n'.repeat(1 + result);
        if (result === false) return '\n\n<!---->\n\n';
    }
    return '\n\n';
}


/**
 * @import {IndentLines} from '../types.js'
 */ const $656329f876538247$var$eol = /\r?\n|\r/g;
function $656329f876538247$export$7c3cf23d514b264a(value, map) {
    /** @type {Array<string>} */ const result = [];
    let start = 0;
    let line = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = $656329f876538247$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join('');
    /**
   * @param {string} value
   */ function one(value) {
        result.push(map(value, line, !value));
    }
}


/**
 * @import {SafeConfig, State} from 'mdast-util-to-markdown'
 */ 

function $95ddacb55c28ae92$export$170b8c323eee7bec(state, input, config) {
    const value = (config.before || '') + (input || '') + (config.after || '');
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const result = [];
    /** @type {Record<number, {before: boolean, after: boolean}>} */ const infos = {};
    let index = -1;
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        if (!(0, $a349916310745a86$export$78221a09424368d)(state.stack, pattern)) continue;
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        while(match = expression.exec(value)){
            const before = 'before' in pattern || Boolean(pattern.atBreak);
            const after = 'after' in pattern;
            const position = match.index + (before ? match[1].length : 0);
            if (positions.includes(position)) {
                if (infos[position].before && !before) infos[position].before = false;
                if (infos[position].after && !after) infos[position].after = false;
            } else {
                positions.push(position);
                infos[position] = {
                    before: before,
                    after: after
                };
            }
        }
    }
    positions.sort($95ddacb55c28ae92$var$numerical);
    let start = config.before ? config.before.length : 0;
    const end = value.length - (config.after ? config.after.length : 0);
    index = -1;
    while(++index < positions.length){
        const position = positions[index];
        // Character before or after matched:
        if (position < start || position >= end) continue;
        // If this character is supposed to be escaped because it has a condition on
        // the next character, and the next character is definitly being escaped,
        // then skip this escape.
        if (position + 1 < end && positions[index + 1] === position + 1 && infos[position].after && !infos[position + 1].before && !infos[position + 1].after || positions[index - 1] === position - 1 && infos[position].before && !infos[position - 1].before && !infos[position - 1].after) continue;
        if (start !== position) // If we have to use a character reference, an ampersand would be more
        // correct, but as backslashes only care about punctuation, either will
        // do the trick
        result.push($95ddacb55c28ae92$var$escapeBackslashes(value.slice(start, position), '\\'));
        start = position;
        if (/[!-/:-@[-`{-~]/.test(value.charAt(position)) && (!config.encode || !config.encode.includes(value.charAt(position)))) // Character escape.
        result.push('\\');
        else {
            // Character reference.
            result.push((0, $5992f65195685991$export$5810cf1e579e9d5b)(value.charCodeAt(position)));
            start++;
        }
    }
    result.push($95ddacb55c28ae92$var$escapeBackslashes(value.slice(start, end), config.after));
    return result.join('');
}
/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */ function $95ddacb55c28ae92$var$numerical(a, b) {
    return a - b;
}
/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */ function $95ddacb55c28ae92$var$escapeBackslashes(value, after) {
    const expression = /\\(?=[!-/:-@[-`{-~])/g;
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const results = [];
    const whole = value + after;
    let index = -1;
    let start = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = expression.exec(whole))positions.push(match.index);
    while(++index < positions.length){
        if (start !== positions[index]) results.push(value.slice(start, positions[index]));
        results.push('\\');
        start = positions[index];
    }
    results.push(value.slice(start));
    return results.join('');
}


/**
 * @import {CreateTracker, TrackCurrent, TrackMove, TrackShift} from '../types.js'
 */ /**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */ function $620265910a8ec706$export$6b2a7d5132615086(config) {
    // Defaults are used to prevent crashes when older utilities somehow activate
    // this code.
    /* c8 ignore next 5 */ const options = config || {};
    const now = options.now || {};
    let lineShift = options.lineShift || 0;
    let line = now.line || 1;
    let column = now.column || 1;
    return {
        move: move,
        current: current,
        shift: shift
    };
    /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */ function current() {
        return {
            now: {
                line: line,
                column: column
            },
            lineShift: lineShift
        };
    }
    /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */ function shift(value) {
        lineShift += value;
    }
    /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */ function move(input) {
        // eslint-disable-next-line unicorn/prefer-default-parameters
        const value = input || '';
        const chunks = value.split(/\r?\n|\r/g);
        const tail = chunks[chunks.length - 1];
        line += chunks.length - 1;
        column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
        return value;
    }
}


function $546c8012e8e57aca$export$49a1dda9e62e8ae6(tree, options) {
    const settings = options || {};
    /** @type {State} */ const state = {
        associationId: (0, $934833ed9e37d72a$export$c4ca1a6065421754),
        containerPhrasing: $546c8012e8e57aca$var$containerPhrasingBound,
        containerFlow: $546c8012e8e57aca$var$containerFlowBound,
        createTracker: (0, $620265910a8ec706$export$6b2a7d5132615086),
        compilePattern: $6d3542ff6c666380$export$2db8af076f277cbf,
        enter: enter,
        // @ts-expect-error: GFM / frontmatter are typed in `mdast` but not defined
        // here.
        handlers: {
            ...(0, $1dd28883d8b6efc1$export$8f34ce051745d39e)
        },
        // @ts-expect-error: add `handle` in a second.
        handle: undefined,
        indentLines: $656329f876538247$export$7c3cf23d514b264a,
        indexStack: [],
        join: [
            ...(0, $b073814c6b22779d$export$f7e2c8231c57a8bd)
        ],
        options: {},
        safe: $546c8012e8e57aca$var$safeBound,
        stack: [],
        unsafe: [
            ...(0, $a7745b3e1631c595$export$aa1c11b655786597)
        ]
    };
    (0, $64bc31b6b64620ad$export$8d21e34596265fa2)(state, settings);
    if (state.options.tightDefinitions) state.join.push($546c8012e8e57aca$var$joinDefinition);
    state.handle = (0, $8a9f9aad604403eb$export$d6a12bfbbedf6185)('type', {
        invalid: $546c8012e8e57aca$var$invalid,
        unknown: $546c8012e8e57aca$var$unknown,
        handlers: state.handlers
    });
    let result = state.handle(tree, undefined, state, {
        before: '\n',
        after: '\n',
        now: {
            line: 1,
            column: 1
        },
        lineShift: 0
    });
    if (result && result.charCodeAt(result.length - 1) !== 10 && result.charCodeAt(result.length - 1) !== 13) result += '\n';
    return result;
    /** @type {Enter} */ function enter(name) {
        state.stack.push(name);
        return exit;
        /**
     * @returns {undefined}
     */ function exit() {
            state.stack.pop();
        }
    }
}
/**
 * @param {unknown} value
 * @returns {never}
 */ function $546c8012e8e57aca$var$invalid(value) {
    throw new Error('Cannot handle value `' + value + '`, expected node');
}
/**
 * @param {unknown} value
 * @returns {never}
 */ function $546c8012e8e57aca$var$unknown(value) {
    // Always a node.
    const node = /** @type {Nodes} */ value;
    throw new Error('Cannot handle unknown node `' + node.type + '`');
}
/** @type {Join} */ function $546c8012e8e57aca$var$joinDefinition(left, right) {
    // No blank line between adjacent definitions.
    if (left.type === 'definition' && left.type === right.type) return 0;
}
/**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {PhrasingParents} parent
 *   Parent of flow nodes.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $546c8012e8e57aca$var$containerPhrasingBound(parent, info) {
    return (0, $cf21afe648de355e$export$f4090a9439f37631)(parent, this, info);
}
/**
 * Serialize the children of a parent that contains flow children.
 *
 * These children will typically be joined by blank lines.
 * What they are joined by exactly is defined by `Join` functions.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {FlowParents} parent
 *   Parent of flow nodes.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $546c8012e8e57aca$var$containerFlowBound(parent, info) {
    return (0, $ffbf0ec20599d168$export$134f7fdacfea8b16)(parent, this, info);
}
/**
 * Make a string safe for embedding in markdown constructs.
 *
 * In markdown, almost all punctuation characters can, in certain cases,
 * result in something.
 * Whether they do is highly subjective to where they happen and in what
 * they happen.
 *
 * To solve this, `mdast-util-to-markdown` tracks:
 *
 * * Characters before and after something;
 * * What “constructs” we are in.
 *
 * This information is then used by this function to escape or encode
 * special characters.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {string | null | undefined} value
 *   Raw value to make safe.
 * @param {SafeConfig} config
 *   Configuration.
 * @returns {string}
 *   Serialized markdown safe for embedding.
 */ function $546c8012e8e57aca$var$safeBound(value, config) {
    return (0, $95ddacb55c28ae92$export$170b8c323eee7bec)(this, value, config);
}





function $cfa5f84670490da4$export$a20071ce53c4b064(node, marks) {
    let result = node;
    for (const mark of marks)switch(mark.type.name){
        case 'strong':
            result = {
                type: 'strong',
                children: [
                    result
                ]
            };
            break;
        case 'em':
            result = {
                type: 'emphasis',
                children: [
                    result
                ]
            };
            break;
        case 'code':
            // Inline code — unwrap text value
            if (result.type === 'text') result = {
                type: 'inlineCode',
                value: result.value
            };
            break;
        case 'link':
            result = {
                type: 'link',
                url: mark.attrs.href ?? '',
                title: mark.attrs.title ?? null,
                children: [
                    result
                ]
            };
            break;
        case 'strike':
        case 'strikethrough':
            // GFM strikethrough ~~text~~ — symmetric with the `delete` handler in to-pm
            result = {
                type: 'delete',
                children: [
                    result
                ]
            };
            break;
        default:
            break;
    }
    return result;
}
function $cfa5f84670490da4$export$d157f1daa0528112(node, handlers) {
    const children = [];
    node.forEach((child)=>{
        const handler = handlers[child.type.name];
        if (handler) {
            const result = handler(child);
            if (result) {
                if (Array.isArray(result)) children.push(...result);
                else children.push(result);
            }
        }
    });
    return children;
}
/**
 * Returns a stable key representing the non-annotation marks on a text node,
 * used to determine whether adjacent text nodes can be merged for serialization.
 *
 * Two text nodes are mergeable if they have the same set of non-annotation marks
 * (in the same order — ProseMirror maintains mark order by schema rank).
 * Annotation marks are excluded because they are tracked as character ranges
 * separately from the markdown string and don't affect markdown syntax.
 */ function $cfa5f84670490da4$var$nonAnnotationMarkKey(marks) {
    return marks.filter((m)=>m.type.name !== 'annotation').map((m)=>`${m.type.name}:${JSON.stringify(m.attrs)}`).join('|');
}
function $cfa5f84670490da4$export$4db834a02b589b8(node, handlers) {
    const merged = [];
    node.forEach((child)=>{
        if (child.isText && child.text) {
            const last = merged[merged.length - 1];
            if (last && 'text' in last && $cfa5f84670490da4$var$nonAnnotationMarkKey(last.marks) === $cfa5f84670490da4$var$nonAnnotationMarkKey(child.marks)) // Same non-annotation marks — merge text into the previous run.
            last.text += child.text;
            else merged.push({
                text: child.text,
                marks: child.marks
            });
        } else merged.push({
            pmNode: child
        });
    });
    // Second pass: convert merged runs to mdast nodes.
    const children = [];
    for (const item of merged)if ('pmNode' in item) {
        const handler = handlers[item.pmNode.type.name];
        if (handler) {
            const result = handler(item.pmNode);
            if (result) {
                const nodes = Array.isArray(result) ? result : [
                    result
                ];
                children.push(...nodes);
            }
        }
    } else {
        // Use only non-annotation marks for markdown syntax — annotation marks
        // are tracked as character ranges, not embedded in the markdown string.
        const nonAnnotationMarks = item.marks.filter((m)=>m.type.name !== 'annotation');
        const textNode = $cfa5f84670490da4$export$a20071ce53c4b064({
            type: 'text',
            value: item.text
        }, nonAnnotationMarks);
        children.push(textNode);
    }
    return children;
}


function $804b3190649aae0b$export$9c206ddddb32a9b(node, handlers) {
    const children = (0, $cfa5f84670490da4$export$4db834a02b589b8)(node, handlers);
    return {
        type: 'paragraph',
        children: children
    };
}



function $c7e4eefbdee2c6a4$export$46e4a324ac90507f(node, handlers) {
    const depth = node.attrs.level ?? 1;
    const children = (0, $cfa5f84670490da4$export$4db834a02b589b8)(node, handlers);
    return {
        type: 'heading',
        depth: depth,
        children: children
    };
}


function $35882e360c2ed6c5$export$6f093cfa640b7166(node) {
    const value = node.text ?? '';
    return {
        type: 'text',
        value: value
    };
}


function $66f38a52494420d6$export$371da9dd35aba193() {
    return {
        type: 'break'
    };
}


function $b1fcdf17ea9d63dd$export$ba7b13e047416c03() {
    return {
        type: 'thematicBreak'
    };
}


function $915e4ff01cbf1ffe$export$5c452ff88e35e47d(node) {
    const url = node.attrs.src ?? '';
    const alt = node.attrs.alt ?? undefined;
    const title = node.attrs.title ?? undefined;
    return {
        type: 'image',
        url: url,
        alt: alt,
        title: title
    };
}


/**
 * Handlers for ADF `mediaSingle` / `media` nodes.
 *
 * Strategy: produce a CommonMark image (`![alt](url)`) so the markdown is
 * portable to external clients (VS Code preview, GitHub, etc.). What goes
 * in `url` depends on the media node's `type`:
 *
 *   - `external` — emit `attrs.url` verbatim. No auth involved.
 *   - `file`     — emit a tenant-scoped Confluence proxy URL
 *                  (`/wiki/download/attachments/{contentId}/{filename}`)
 *                  produced by an injected `serializeFileMedia` callback.
 *                  The proxy resolves with the viewer's Confluence session
 *                  cookie, so no media token / PAT ever lives in the
 *                  markdown text. When no callback is supplied (e.g. the
 *                  default platform handler used outside Confluence) we
 *                  fall back to alt-text-only — never a `blob:` / token
 *                  URL — to keep this safe by default.
 *
 * Caveats deliberately accepted in v1:
 *   - `mediaSingle` layout / width are dropped on serialise. CommonMark
 *     has no representation for them and the round-trip parser
 *     (`@atlaskit/editor-markdown-transformer` + `markdown-it-media`)
 *     re-applies schema defaults on the way back, so the editor will
 *     re-render them sensibly.
 *   - `mediaSingleCaption`, `mediaGroup` and `mediaInline` are filtered
 *     out before they reach this handler (see `filterToMarkdownSafeAdf`
 *     in @confluence/content-markdown-mode). Anything that does reach
 *     us is treated as a single media child.
 */ const $39ea8ef356c19cc4$var$readString = (value)=>typeof value === 'string' && value.length > 0 ? value : undefined;
const $39ea8ef356c19cc4$var$readNumber = (value)=>typeof value === 'number' && Number.isFinite(value) ? value : undefined;
/**
 * Convert a single `media` node to an mdast `image`. Returns `undefined`
 * when the node has no representable URL — the caller will skip it.
 */ const $39ea8ef356c19cc4$var$mediaToImage = (node, serializeFileMedia)=>{
    const attrs = node.attrs ?? {};
    const type = $39ea8ef356c19cc4$var$readString(attrs.type);
    const alt = $39ea8ef356c19cc4$var$readString(attrs.alt) ?? '';
    let url;
    if (type === 'external') // External media: URL is public and lives on `attrs.url`.
    url = $39ea8ef356c19cc4$var$readString(attrs.url);
    else if (type === 'file') {
        // File media: rely on the Confluence-supplied proxy serialiser.
        // Without one, we have no way to express the bytes in valid markdown
        // (we deliberately refuse to embed media tokens or fake `blob:` URLs).
        const id = $39ea8ef356c19cc4$var$readString(attrs.id);
        if (id && serializeFileMedia) url = serializeFileMedia({
            id: id,
            collection: $39ea8ef356c19cc4$var$readString(attrs.collection),
            alt: $39ea8ef356c19cc4$var$readString(attrs.alt),
            width: $39ea8ef356c19cc4$var$readNumber(attrs.width),
            height: $39ea8ef356c19cc4$var$readNumber(attrs.height)
        });
    } else // Unknown / future media types — best-effort: pick `url` if present,
    // otherwise drop. This keeps us forward-compatible without inventing
    // behaviour we can't reason about.
    url = $39ea8ef356c19cc4$var$readString(attrs.url);
    if (!url) {
        // No URL available. Surface the alt text as a plain image node with
        // an empty URL — `filterToMarkdownSafeAdf` should have prevented this
        // for `file` media in production paths, but better to emit
        // `![alt]()` than to throw or silently drop.
        if (!alt) return undefined;
        return {
            type: 'image',
            url: '',
            alt: alt
        };
    }
    return {
        type: 'image',
        url: url,
        alt: alt
    };
};
/**
 * Wrap an `Image` (mdast PhrasingContent — inline) in a `Paragraph` so it
 * can be inserted as a block-level child of the mdast root.
 *
 * Why: ADF's `mediaSingle` is a block-level node (sibling of `paragraph` /
 * `heading`), but CommonMark has no block-level image construct. The
 * closest valid representation is a paragraph containing only the image,
 * which `mdast-util-to-markdown` will surround with blank lines — exactly
 * the visual block effect we want.
 *
 * Skipping this wrapper causes `mdast-util-to-markdown` to concatenate
 * the inline image with neighbouring blocks (and to drop the blank-line
 * separators), which manifests as the entire document compressing onto
 * one line — see EDITOR-6636.
 */ const $39ea8ef356c19cc4$var$wrapInParagraph = (image)=>image ? {
        type: 'paragraph',
        children: [
            image
        ]
    } : undefined;
const $39ea8ef356c19cc4$export$987d49ffe1b0900f = (node)=>$39ea8ef356c19cc4$var$wrapInParagraph($39ea8ef356c19cc4$var$mediaToImage(node));
const $39ea8ef356c19cc4$export$969fe3781ca15058 = (node)=>{
    let mediaChild;
    node.forEach((child)=>{
        if (!mediaChild && child.type.name === 'media') mediaChild = child;
    });
    if (!mediaChild) return undefined;
    return $39ea8ef356c19cc4$var$wrapInParagraph($39ea8ef356c19cc4$var$mediaToImage(mediaChild));
};
const $39ea8ef356c19cc4$export$a0da5befa47b223d = ({ serializeFileMedia: serializeFileMedia } = {})=>({
        media: (node)=>$39ea8ef356c19cc4$var$wrapInParagraph($39ea8ef356c19cc4$var$mediaToImage(node, serializeFileMedia)),
        mediaSingle: (node)=>{
            let mediaChild;
            node.forEach((child)=>{
                if (!mediaChild && child.type.name === 'media') mediaChild = child;
            });
            return mediaChild ? $39ea8ef356c19cc4$var$wrapInParagraph($39ea8ef356c19cc4$var$mediaToImage(mediaChild, serializeFileMedia)) : undefined;
        }
    });


function $71071285b2554ea2$export$7bb0d5c671655cc4(node) {
    let value = '';
    node.forEach((child)=>{
        if (child.isText) value += child.text;
    });
    const result = {
        type: 'code',
        value: value
    };
    const lang = node.attrs.language ?? node.attrs.lang;
    if (lang) result.lang = lang;
    return result;
}



function $8357674f76c88979$export$67dc04e652a298ca(node, handlers) {
    const children = (0, $cfa5f84670490da4$export$d157f1daa0528112)(node, handlers);
    return {
        type: 'blockquote',
        children: children
    };
}


function $4066e8482d4fdfea$export$9852986a3ec5f6a0(node, handlers) {
    const rows = [];
    node.forEach((child)=>{
        const handler = handlers[child.type.name];
        if (handler) {
            const result = handler(child);
            if (result && !Array.isArray(result) && result.type === 'tableRow') rows.push(result);
        }
    });
    return {
        type: 'table',
        children: rows
    };
}


function $f63a7ec67024da20$export$ce666bf02318c957(node, handlers) {
    const cells = [];
    node.forEach((child)=>{
        const handler = handlers[child.type.name];
        if (handler) {
            const result = handler(child);
            if (result && !Array.isArray(result) && result.type === 'tableCell') cells.push(result);
        }
    });
    return {
        type: 'tableRow',
        children: cells
    };
}



function $dc3611802fc69a1f$export$e1e720e5f4603e6a(node, handlers) {
    const children = [];
    // Table cells contain paragraphs wrapping inline content; flatten them.
    // Use convertInlineChildren so non-text inline nodes (hard_break, image,
    // inlineCode, etc.) are handled via the handlers map rather than dropped.
    node.forEach((child)=>{
        if (child.type.name === 'paragraph') children.push(...(0, $cfa5f84670490da4$export$4db834a02b589b8)(child, handlers));
    });
    return {
        type: 'tableCell',
        children: children
    };
}





function $1d957cfd77fb65a4$export$25f0e92ed67918e2(node, ordered, handlers) {
    const children = [];
    node.forEach((child)=>{
        const handler = handlers[child.type.name];
        if (handler) {
            const result = handler(child);
            if (!result || Array.isArray(result)) return;
            if (result.type === 'listItem') children.push(result);
            else if (result.type === 'list' && children.length > 0 && (0, $dh538.fg)('platform_editor_fix_nested_markdown_tasks')) {
                const previous = children[children.length - 1];
                previous.children.push(result);
            }
        }
    });
    const start = ordered ? node.attrs.order ?? node.attrs.start ?? 1 : undefined;
    return {
        type: 'list',
        ordered: ordered,
        start: start,
        spread: false,
        children: children
    };
}



// Zero-width space placeholder. mdast's GFM task-list serializer needs a text
// child to emit an empty task marker like `* [ ]`; serializers strip it only
// from the generated empty task item body.
const $8fc4d31022a9f460$export$adb8a99c77edd84e = '\u200B';


function $abffb5c277b34023$var$getChecked(node) {
    const attrs = node.attrs;
    // Support both `checked` attr (standard) and `state` attr (ADF taskItem)
    if (attrs.checked === true) return true;
    if (attrs.checked === false) return false;
    if (attrs.state === 'DONE') return true;
    if (attrs.state === 'TODO') return false;
    return null;
}
function $abffb5c277b34023$export$da0c48111d4803f(node, handlers) {
    const checked = $abffb5c277b34023$var$getChecked(node);
    let children = (0, $cfa5f84670490da4$export$d157f1daa0528112)(node, handlers);
    if (checked !== null && children.length === 0) children = [
        {
            type: 'paragraph',
            children: [
                {
                    type: 'text',
                    value: (0, $8fc4d31022a9f460$export$adb8a99c77edd84e)
                }
            ]
        }
    ];
    return {
        type: 'listItem',
        spread: false,
        checked: checked,
        children: children
    };
}




const $f55209500775d049$export$d58124ced37e5234 = {
    paragraph: (node)=>(0, $804b3190649aae0b$export$9c206ddddb32a9b)(node, $f55209500775d049$export$d58124ced37e5234),
    heading: (node)=>(0, $c7e4eefbdee2c6a4$export$46e4a324ac90507f)(node, $f55209500775d049$export$d58124ced37e5234),
    text: (node)=>(0, $35882e360c2ed6c5$export$6f093cfa640b7166)(node),
    hard_break: (_node)=>(0, $66f38a52494420d6$export$371da9dd35aba193)(),
    hardBreak: (_node)=>(0, $66f38a52494420d6$export$371da9dd35aba193)(),
    horizontal_rule: (_node)=>(0, $b1fcdf17ea9d63dd$export$ba7b13e047416c03)(),
    rule: (_node)=>(0, $b1fcdf17ea9d63dd$export$ba7b13e047416c03)(),
    image: (node)=>(0, $915e4ff01cbf1ffe$export$5c452ff88e35e47d)(node),
    // `media` and `mediaSingle` map to a CommonMark image. The default
    // handler only knows how to serialise `type: "external"` media (which
    // has a public URL); `type: "file"` media is dropped because we don't
    // know the tenant or content scope here. Use `createMediaHandlers({
    // serializeFileMedia })` from './handlers/media' to opt in to
    // proxy-URL serialisation for file media (e.g. from Confluence).
    media: (node)=>(0, $39ea8ef356c19cc4$export$987d49ffe1b0900f)(node),
    mediaSingle: (node)=>(0, $39ea8ef356c19cc4$export$969fe3781ca15058)(node),
    media_single: (node)=>(0, $39ea8ef356c19cc4$export$969fe3781ca15058)(node),
    code_block: (node)=>(0, $71071285b2554ea2$export$7bb0d5c671655cc4)(node),
    codeBlock: (node)=>(0, $71071285b2554ea2$export$7bb0d5c671655cc4)(node),
    blockquote: (node)=>(0, $8357674f76c88979$export$67dc04e652a298ca)(node, $f55209500775d049$export$d58124ced37e5234),
    block_quote: (node)=>(0, $8357674f76c88979$export$67dc04e652a298ca)(node, $f55209500775d049$export$d58124ced37e5234),
    table: (node)=>(0, $4066e8482d4fdfea$export$9852986a3ec5f6a0)(node, $f55209500775d049$export$d58124ced37e5234),
    tableRow: (node)=>(0, $f63a7ec67024da20$export$ce666bf02318c957)(node, $f55209500775d049$export$d58124ced37e5234),
    tableCell: (node)=>(0, $dc3611802fc69a1f$export$e1e720e5f4603e6a)(node, $f55209500775d049$export$d58124ced37e5234),
    tableHeader: (node)=>(0, $dc3611802fc69a1f$export$e1e720e5f4603e6a)(node, $f55209500775d049$export$d58124ced37e5234),
    bullet_list: (node)=>(0, $1d957cfd77fb65a4$export$25f0e92ed67918e2)(node, false, $f55209500775d049$export$d58124ced37e5234),
    bulletList: (node)=>(0, $1d957cfd77fb65a4$export$25f0e92ed67918e2)(node, false, $f55209500775d049$export$d58124ced37e5234),
    ordered_list: (node)=>(0, $1d957cfd77fb65a4$export$25f0e92ed67918e2)(node, true, $f55209500775d049$export$d58124ced37e5234),
    orderedList: (node)=>(0, $1d957cfd77fb65a4$export$25f0e92ed67918e2)(node, true, $f55209500775d049$export$d58124ced37e5234),
    task_list: (node)=>(0, $1d957cfd77fb65a4$export$25f0e92ed67918e2)(node, false, $f55209500775d049$export$d58124ced37e5234),
    taskList: (node)=>(0, $1d957cfd77fb65a4$export$25f0e92ed67918e2)(node, false, $f55209500775d049$export$d58124ced37e5234),
    list_item: (node)=>(0, $abffb5c277b34023$export$da0c48111d4803f)(node, $f55209500775d049$export$d58124ced37e5234),
    listItem: (node)=>(0, $abffb5c277b34023$export$da0c48111d4803f)(node, $f55209500775d049$export$d58124ced37e5234),
    // task_item (snake_case ADF) also uses convertTaskItem so checked/state attrs are read
    task_item: (node)=>(0, $abffb5c277b34023$export$da0c48111d4803f)(node, $f55209500775d049$export$d58124ced37e5234),
    // ADF taskItem has inline content directly (no paragraph wrapper),
    // so we wrap it in a paragraph to satisfy the listItem → block content requirement.
    taskItem: (node)=>{
        const checked = node.attrs.state === 'DONE' ? true : node.attrs.state === 'TODO' ? false : node.attrs.checked ?? null;
        const children = (0, $cfa5f84670490da4$export$4db834a02b589b8)(node, $f55209500775d049$export$d58124ced37e5234);
        return {
            type: 'listItem',
            spread: false,
            checked: checked,
            children: [
                {
                    type: 'paragraph',
                    children: children.length > 0 ? children : checked !== null ? [
                        {
                            type: 'text',
                            value: (0, $8fc4d31022a9f460$export$adb8a99c77edd84e)
                        }
                    ] : []
                }
            ]
        };
    }
};


/**
 * Extracts annotation mark character ranges from a ProseMirror document by
 * correlating the PM node tree with the serialized markdown string.
 *
 * Strategy
 * --------
 * We walk the PM document in the same order that the markdown serializer does
 * (depth-first, left-to-right), accumulating a character offset counter as we
 * encounter text content. When we enter a text node that carries an annotation
 * mark, we record { id, from, to } where from/to are the character offsets of
 * that text node in the markdown string.
 *
 * For annotation marks that span multiple consecutive text nodes (e.g. when a
 * mark boundary splits a run), we merge adjacent runs with the same annotation
 * ID into a single contiguous range.
 *
 * Limitations
 * -----------
 * The character offset tracking works because the markdown serializer visits
 * nodes in the same depth-first order and emits text content contiguously.
 * However, the serializer also emits structural characters that don't appear
 * in the PM document (e.g. `**` for bold, `##` for headings, `\n\n` between
 * blocks). We account for these by searching for each text run in the markdown
 * string starting from our current offset — this makes the extraction robust
 * to any decorative characters the serializer inserts around text content.
 *
 * The search is always forward-only (we never scan backwards), so it correctly
 * handles repeated text content as long as the PM node order matches the
 * markdown output order — which it does for all standard handlers.
 */ /**
 * Escape a raw PM text string the same way `mdast-util-to-markdown` does, so
 * we can search for it in the serialized markdown when a direct `indexOf` fails.
 *
 * `mdast-util-to-markdown` escapes the following characters with a leading
 * backslash when they appear in plain text content: `*`, `_`, `` ` ``, `[`, `\`.
 * It does this character-by-character, so "hello *world" → "hello \*world".
 *
 * We replicate that transform here so that when `indexOf(rawText)` returns -1
 * (because the serializer inserted backslashes into the text), we can retry
 * with `indexOf(escapedText)` and still find the correct position.
 *
 * Note: this escape is intentionally conservative — we only escape characters
 * that mdast-util-to-markdown is known to escape in plain text nodes. Other
 * transformations (e.g. entity encoding, which we undo in `undoEdgeWhitespaceEncoding`)
 * are handled separately.
 */ function $651b62659681d5eb$var$escapedForMarkdown(text) {
    return text.replace(/[*_`[\\\]]/gu, (ch)=>`\\${ch}`);
}
function $651b62659681d5eb$export$1710d999c4016c72(doc, markdown) {
    // Map from annotation ID → { from, to } of the current open range.
    // We merge consecutive text nodes that carry the same annotation ID.
    const openRanges = new Map();
    const completed = [];
    // Current search position in the markdown string.
    // We advance this forward as we encounter text nodes.
    let searchFrom = 0;
    doc.descendants((node)=>{
        if (!node.isText || !node.text) return true; // descend into non-text nodes
        const text = node.text;
        // Find the position of this text run in the markdown string.
        // We search forward from `searchFrom` to handle repeated text correctly.
        let pos = markdown.indexOf(text, searchFrom);
        // The serializer may have escaped special characters (e.g. `*` → `\*`),
        // making the raw PM text no longer a direct substring. Retry with the
        // escaped form as a fallback.
        let matchLength = text.length;
        if (pos === -1) {
            const escaped = $651b62659681d5eb$var$escapedForMarkdown(text);
            if (escaped !== text) {
                pos = markdown.indexOf(escaped, searchFrom);
                if (pos !== -1) // The match is against the escaped string in the markdown, so
                // the range covers `escaped.length` characters, not `text.length`.
                matchLength = escaped.length;
            }
        }
        if (pos === -1) // Still not found — genuinely untranslateable node (e.g. hard_break).
        // Skip offset tracking for this node without advancing searchFrom.
        return true;
        const nodeFrom = pos;
        const nodeTo = pos + matchLength;
        // Collect the annotation IDs active on this text node.
        const activeIds = new Set();
        for (const mark of node.marks)if (mark.type.name === 'annotation' && mark.attrs.id) activeIds.add(mark.attrs.id);
        // Close any open ranges whose ID is no longer active on this node.
        for (const [id, range] of openRanges)if (!activeIds.has(id)) {
            completed.push({
                id: id,
                from: range.from,
                to: range.to
            });
            openRanges.delete(id);
        }
        // Extend or open ranges for active annotation IDs.
        for (const id of activeIds){
            const existing = openRanges.get(id);
            if (existing) // Extend the existing open range to cover this text node.
            existing.to = nodeTo;
            else // New annotation starting at this text node.
            openRanges.set(id, {
                from: nodeFrom,
                to: nodeTo
            });
        }
        // Advance the search position past this text node.
        searchFrom = nodeTo;
        return true;
    });
    // Close any ranges still open at the end of the document.
    for (const [id, range] of openRanges)completed.push({
        id: id,
        from: range.from,
        to: range.to
    });
    // Sort by start position for deterministic output.
    completed.sort((a, b)=>a.from - b.from || a.id.localeCompare(b.id));
    return completed;
}


/**
 * Strip backslash escapes from markdown that aren't load-bearing under
 * GFM parsing: greedily drop all candidates, re-parse, and compare against
 * the source mdast. If the trees match, the escapes weren't needed; if
 * not, bisect to find the minimal set that must stay.
 *
 * Lets the real GFM parser decide what's load-bearing rather than
 * hand-coding flanking rules per character.
 */ 






/*
 * Match the GFM extensions used by the serializer. Omits
 * gfm-autolink-literal: the serializer doesn't insert escapes to prevent
 * literal autolinking, so including it would cause unrelated verify
 * failures on any doc that mentions a URL.
 */ const $fdc279bcd413585a$var$PARSE_EXTENSIONS = [
    (0, $5490715e401c0d53$export$e36cebda627bf2dd)(),
    (0, $78c447656c76a7de$export$2912e8b2802475ff)(),
    (0, $8e04031d12c492e0$export$8bbec8ea1400a00e)()
];
const $fdc279bcd413585a$var$PARSE_MDAST_EXTENSIONS = [
    (0, $3bff305c903a5854$export$8bd0ec8ecf6adb7d)(),
    (0, $b4ef0b4c77ef6a57$export$a427a608608b215f)(),
    (0, $a41cbcc025bac23c$export$34d64e709dd0b9bb)()
];
// ASCII-punctuation escape set per CommonMark + GFM.
const $fdc279bcd413585a$var$ESCAPABLE = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/u;
/*
 * Index of each `\X` where X is escapable. Consecutive escape pairs
 * (e.g. `\\\\` for two literal backslashes) are reported as separate
 * candidates; the bisect step decides which can be removed.
 */ function $fdc279bcd413585a$var$findEscapePositions(md) {
    const positions = [];
    for(let i = 0; i < md.length - 1; i++)if (md[i] === '\\' && $fdc279bcd413585a$var$ESCAPABLE.test(md[i + 1])) {
        positions.push(i);
        // Skip the escaped char so it isn't misread as another escape.
        i += 1;
    }
    return positions;
}
function $fdc279bcd413585a$var$stripAt(md, drop) {
    if (drop.size === 0) return md;
    const parts = [];
    for(let i = 0; i < md.length; i++)if (!drop.has(i)) parts.push(md[i]);
    return parts.join('');
}
/*
 * Strip `position` so trees from different sources compare structurally.
 * Emit keys in sorted order so the `JSON.stringify`-based comparison
 * doesn't get tripped up if the PM handlers and `fromMarkdown` happen to
 * construct a given node type with different key orderings.
 */ function $fdc279bcd413585a$var$normalise(value) {
    if (Array.isArray(value)) return value.map($fdc279bcd413585a$var$normalise);
    if (value && typeof value === 'object') {
        const source = value;
        const out = {};
        for (const k of Object.keys(source).sort()){
            if (k === 'position') continue;
            out[k] = $fdc279bcd413585a$var$normalise(source[k]);
        }
        return out;
    }
    return value;
}
function $fdc279bcd413585a$var$treesEqual(a, b) {
    return JSON.stringify($fdc279bcd413585a$var$normalise(a)) === JSON.stringify($fdc279bcd413585a$var$normalise(b));
}
function $fdc279bcd413585a$var$parse(md) {
    return (0, $a2d866d1a57b6a8e$export$d744d789c09bfde6)(md, {
        extensions: $fdc279bcd413585a$var$PARSE_EXTENSIONS,
        mdastExtensions: $fdc279bcd413585a$var$PARSE_MDAST_EXTENSIONS
    });
}
/**
 * Identify which escapes in `positions` must be kept for `md` to round-trip
 * back to `target`, accumulating them into `kept`.
 *
 * Try removing every position at once; if the result still round-trips,
 * none of these escapes are needed. Otherwise split the candidate set in
 * half and recurse on each half independently — a 1-element set whose
 * trial fails is necessarily load-bearing.
 *
 * This is a delta-debugging-style search (ddmin family: Zeller, "Yesterday,
 * My Program Worked. Today, It Does Not. Why?"). The result is 1-minimal:
 * no single position in `kept` can be removed while preserving round-trip.
 * It is NOT necessarily a globally minimum subset — the defensive verify
 * in `reduceUnnecessaryEscaping` catches the rare case where individual
 * removals don't commute.
 */ function $fdc279bcd413585a$var$findMinimumEscapeSubset(md, positions, target, kept) {
    if (positions.length === 0) return;
    const trial = $fdc279bcd413585a$var$stripAt(md, new Set(positions));
    if ($fdc279bcd413585a$var$treesEqual($fdc279bcd413585a$var$parse(trial), target)) return;
    if (positions.length === 1) {
        kept.add(positions[0]);
        return;
    }
    const mid = Math.floor(positions.length / 2);
    $fdc279bcd413585a$var$findMinimumEscapeSubset(md, positions.slice(0, mid), target, kept);
    $fdc279bcd413585a$var$findMinimumEscapeSubset(md, positions.slice(mid), target, kept);
}
function $fdc279bcd413585a$export$554dd08306eafa82(md, target) {
    const positions = $fdc279bcd413585a$var$findEscapePositions(md);
    if (positions.length === 0) return md;
    // Fast path: drop everything at once.
    const allDropped = $fdc279bcd413585a$var$stripAt(md, new Set(positions));
    if ($fdc279bcd413585a$var$treesEqual($fdc279bcd413585a$var$parse(allDropped), target)) return allDropped;
    // Single escape that the fast path already proved is load-bearing.
    if (positions.length === 1) return md;
    /*
	 * Slow path: enter the recursion at the first split. The fast path
	 * already proved removing all positions fails, so re-running that
	 * same trial at the top of findMinimumEscapeSubset would be wasted
	 * work.
	 */ const kept = new Set();
    const mid = Math.floor(positions.length / 2);
    $fdc279bcd413585a$var$findMinimumEscapeSubset(md, positions.slice(0, mid), target, kept);
    $fdc279bcd413585a$var$findMinimumEscapeSubset(md, positions.slice(mid), target, kept);
    const candidate = $fdc279bcd413585a$var$stripAt(md, new Set(positions.filter((p)=>!kept.has(p))));
    /*
	 * The search assumes individual-escape removals commute. If that ever
	 * fails for some input, fall back to the always-safe original rather
	 * than emit something that doesn't round-trip.
	 */ if (!$fdc279bcd413585a$var$treesEqual($fdc279bcd413585a$var$parse(candidate), target)) return md;
    return candidate;
}


/**
 * Post-process markdown output to undo the `&#x20;` and `&#x9;` encoding
 * that `mdast-util-to-markdown` applies to leading/trailing whitespace in
 * phrasing contexts. See EDITOR-6558 comment in `fromProseMirror`.
 *
 * The library's `unsafe` configuration only supports *adding* patterns,
 * not removing defaults, so we can't prevent the encoding. Instead we
 * replace the character references back to literal characters after
 * serialisation.
 */ function $aeb2b691b0b10c51$var$undoEdgeWhitespaceEncoding(md) {
    return md.replace(/&#x20;/gu, ' ').replace(/&#x9;/gu, '\t').replace(/^(\s*(?:[-*+]|\d+\.) \[[ xX]\]) \u200B$/gmu, '$1');
}
function $aeb2b691b0b10c51$export$ab3fd54df7090dc2(schema, handlers = (0, $f55209500775d049$export$d58124ced37e5234)) {
    return function(doc) {
        let pmDoc;
        if ('type' in doc && typeof doc.type === 'string') // It's a JSON representation — hydrate it
        pmDoc = schema.nodeFromJSON(doc);
        else pmDoc = doc;
        const children = [];
        pmDoc.forEach((child)=>{
            const handler = handlers[child.type.name];
            if (!handler) // Throw on unsupported top-level nodes. Silently dropping at the top level
            // would mean a document with only unknown blocks would serialize to an empty
            // string with no indication something went wrong — a data-loss footgun.
            // Nested unknown nodes are still silently skipped by `convertBlockChildren`
            // so partial-but-meaningful output is still possible for documents whose
            // structure is mostly known.
            throw new Error(`ProseMirror node type "${child.type.name}" is not supported by mdast-util-from-pm. ` + `Either add a handler for this node type, or filter it out of the document before serializing.`);
            const result = handler(child);
            if (result) {
                if (Array.isArray(result)) children.push(...result);
                else children.push(result);
            }
        });
        const mdast = {
            type: 'root',
            children: children
        };
        // EDITOR-6558: `mdast-util-to-markdown` encodes leading/trailing
        // whitespace in phrasing contexts as HTML character references
        // (e.g. `&#x20;`). This is technically correct per CommonMark but
        // undesirable for our use case — it makes the markdown unreadable
        // and breaks round-trip identity in the source view.
        //
        // The library's `unsafe` configuration only supports *adding*
        // patterns, not removing defaults, so we post-process the output
        // to replace the character references back to literal characters.
        const rawMarkdown = (0, $546c8012e8e57aca$export$49a1dda9e62e8ae6)(mdast, {
            bullet: '*',
            listItemIndent: 'one',
            fences: true,
            // Both are functions in the ESM version (v1.x) installed in AFM
            extensions: [
                (0, $3bff305c903a5854$export$dafcad76ea6e0045)(),
                (0, $b4ef0b4c77ef6a57$export$9975722e7e834b78)(),
                (0, $a41cbcc025bac23c$export$1632835bd2c84956)()
            ]
        });
        const markdown = (0, $fdc279bcd413585a$export$554dd08306eafa82)($aeb2b691b0b10c51$var$undoEdgeWhitespaceEncoding(rawMarkdown), mdast);
        // Extract annotation ranges from the source PM document.
        // We do this after serialization so the character offsets we compute
        // are in terms of the *final* markdown string (post-encoding fixup).
        const annotations = (0, $651b62659681d5eb$export$1710d999c4016c72)(pmDoc, markdown);
        return {
            markdown: markdown,
            annotations: annotations
        };
    };
}
function $aeb2b691b0b10c51$export$ae379e0a36446b0a(schema, handlers = (0, $f55209500775d049$export$d58124ced37e5234)) {
    const withAnnotations = $aeb2b691b0b10c51$export$ab3fd54df7090dc2(schema, handlers);
    return function(doc) {
        return withAnnotations(doc).markdown;
    };
}






var $5SAOw = parcelRequire("5SAOw");

function $e3d5e5e47aa0f772$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $5SAOw.Mark).sameSet(a.marks, b.marks)) return a.withText((a.text ?? '') + (b.text ?? ''));
}
class $e3d5e5e47aa0f772$export$7254cc27399e90bd {
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(node) {
        if (this.stack.length) this.top().content.push(node);
    }
    /**
   * Adds the given text to the current position in the document,
   * using the current marks as styling.
   */ addText(text) {
        if (!text) return;
        const top = this.top(), nodes = top.content, last = nodes[nodes.length - 1], node = this.schema.text(text, top.marks);
        let merged;
        if (last && (merged = $e3d5e5e47aa0f772$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    /** Adds the given mark to the set of active marks. */ openMark(mark) {
        const top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    /** Removes the given mark from the set of active marks. */ closeMark(mark) {
        const top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    /** Add a node at the current position. */ addNode(type, attrs, content) {
        const top = this.top();
        const node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    /** Wrap subsequent content in a node of the given type. */ openNode(type, attrs = null) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $5SAOw.Mark).none
        });
    }
    /** Close and return the node that is currently on top of the stack. */ closeNode() {
        const info = this.stack.pop();
        if (!info) throw new Error('No node open at the top of the stack');
        return this.addNode(info.type, info.attrs, info.content);
    }
    parseTokens(nodes) {
        for(let i = 0; i < nodes.length; i++){
            const node = nodes[i];
            const handler = this.handlers[node.type];
            if (!handler) throw new Error('Node type `' + node.type + '` not supported');
            handler(this, node, i);
        }
    }
    constructor(schema, handlers){
        this.schema = schema;
        this.handlers = handlers;
        this.stack = [];
        this.rowIndex = null;
    }
}


function $17ef69f3494f5b3b$export$4aad817b79ae84b4(schema, handlers) {
    return function(mdast) {
        const state = new (0, $e3d5e5e47aa0f772$export$7254cc27399e90bd)(schema, handlers);
        // Root is not in the Content union in @types/mdast v3 but is a valid entry point.
        state.parseTokens([
            mdast
        ]);
        return state.closeNode();
    };
}


function $b71487fd40874600$export$e8e78c978b129247(state, node) {
    state.openNode(state.schema.topNodeType);
    state.parseTokens(node.children);
}


/** Matches `[!NOTE]` (possibly with trailing newline) at the start of a text node. */ const $2ac230ebef515fd5$var$alertTextPattern = /^\[!(\w+)\]\n?/u;
/** Matches `[!NOTE]` as the entire value of an html node (as emitted by mdast-util-from-pm). */ const $2ac230ebef515fd5$var$alertHtmlPattern = /^\[!(\w+)\]$/u;
/** Map GFM alert types to ADF panel types (inverse of panelTypeToAlert in mdast-util-from-pm). */ const $2ac230ebef515fd5$var$ALERT_TO_PANEL = {
    NOTE: 'note',
    TIP: 'success',
    IMPORTANT: 'info',
    WARNING: 'warning',
    CAUTION: 'error'
};
/**
 * Detect a GFM alert tag in the first child of a blockquote.
 *
 * Supports two formats:
 * 1. Legacy / raw GFM: the alert tag is the prefix of the first text node
 *    in the first paragraph,
 *    e.g. `{ type: 'paragraph', children: [{ type: 'text', value: '[!NOTE]\nBody' }] }`
 * 2. Serialised by mdast-util-from-pm: the alert tag is a block-level `html`
 *    node as the first direct child of the blockquote,
 *    e.g. `{ type: 'html', value: '[!NOTE]' }` followed by further block children.
 *
 * Returns `{ alertType, contentChildren }` or `null` if not an alert.
 */ function $2ac230ebef515fd5$var$detectAlert(node) {
    const firstChild = node.children[0];
    // Format 2: block-level html node (from mdast-util-from-pm)
    if (firstChild?.type === 'html') {
        const match = $2ac230ebef515fd5$var$alertHtmlPattern.exec(firstChild.value);
        if (match) return {
            alertType: match[1].toUpperCase(),
            contentChildren: node.children.slice(1)
        };
    }
    if (firstChild?.type !== 'paragraph') return null;
    // Format 1: alert tag as prefix of first text node
    const firstInline = firstChild.children[0];
    if (firstInline?.type === 'text') {
        const match = $2ac230ebef515fd5$var$alertTextPattern.exec(firstInline.value);
        if (match) {
            const remaining = firstInline.value.slice(match[0].length);
            const newFirstChildren = remaining.length > 0 ? [
                {
                    ...firstInline,
                    value: remaining
                },
                ...firstChild.children.slice(1)
            ] : firstChild.children.slice(1);
            const contentChildren = newFirstChildren.length > 0 ? [
                {
                    ...firstChild,
                    children: newFirstChildren
                },
                ...node.children.slice(1)
            ] : node.children.slice(1);
            return {
                alertType: match[1].toUpperCase(),
                contentChildren: contentChildren
            };
        }
    }
    return null;
}
function $2ac230ebef515fd5$export$67dc04e652a298ca(state, node) {
    const alert = $2ac230ebef515fd5$var$detectAlert(node);
    if (alert) {
        const panelType = $2ac230ebef515fd5$var$ALERT_TO_PANEL[alert.alertType];
        const panelNodeType = state.schema.nodes.panel ?? state.schema.nodes.note ?? state.schema.nodes.callout;
        if (panelType && panelNodeType) {
            state.openNode(panelNodeType, {
                panelType: panelType
            });
            state.parseTokens(alert.contentChildren.length > 0 ? alert.contentChildren : node.children.slice(1));
            state.closeNode();
            return;
        }
    }
    // Regular blockquote
    const nodeType = state.schema.nodes.blockquote ?? state.schema.nodes.block_quote;
    if (!nodeType) {
        // Gracefully degrade: schema has no blockquote node — render children directly
        state.parseTokens(node.children);
        return;
    }
    state.openNode(nodeType);
    state.parseTokens(node.children);
    state.closeNode();
}


function $72190984a6ffa402$export$46e4a324ac90507f(state, node) {
    const nodeType = state.schema.nodes.heading;
    if (!nodeType) {
        // Gracefully degrade: render heading content as a paragraph when schema
        // has no heading node. This preserves text content without crashing.
        state.openNode(state.schema.nodes.paragraph);
        state.parseTokens(node.children);
        state.closeNode();
        return;
    }
    state.openNode(nodeType, {
        level: node.depth
    });
    state.parseTokens(node.children);
    state.closeNode();
}


/**
 * When the schema uses `media` / `mediaSingle` instead of `image` (Confluence
 * markdown preset) and the paragraph is a lone image, emit
 * `mediaSingle > media (type: "external")` so `![alt](url)` round-trips
 * instead of degrading to alt-text only. Mixed-content paragraphs fall
 * through to the generic handler.
 */ const $c7d89ee22e40fc0a$var$tryEmitMediaSingle = (state, node)=>{
    const { mediaSingle: mediaSingle, media: media } = state.schema.nodes;
    if (!mediaSingle || !media) return false;
    if (!$c7d89ee22e40fc0a$var$isLoneImageParagraph(node)) return false;
    const image = node.children[0];
    const url = typeof image.url === 'string' && image.url.length > 0 ? image.url : undefined;
    if (!url) return false;
    state.openNode(mediaSingle);
    state.addNode(media, {
        url: url,
        alt: image.alt ?? null,
        type: 'external'
    }, []);
    state.closeNode();
    return true;
};
function $c7d89ee22e40fc0a$export$9c206ddddb32a9b(state, node) {
    const { paragraph: paragraph } = state.schema.nodes;
    if (!paragraph) {
        // Gracefully degrade: schema has no paragraph node — render inline children directly
        state.parseTokens(node.children);
        return;
    }
    if (!state.schema.nodes.image && $c7d89ee22e40fc0a$var$isLoneImageParagraph(node)) {
        if ($c7d89ee22e40fc0a$var$tryEmitMediaSingle(state, node)) return;
    }
    state.openNode(paragraph);
    state.parseTokens(node.children);
    state.closeNode();
}
const $c7d89ee22e40fc0a$var$isLoneImageParagraph = (node)=>node.children.length === 1 && node.children[0].type === 'image';


function $726992287582621a$export$8837f4fc672e936d(state, node) {
    // If the schema has a taskList node and ALL items are task items (checked !== null/undefined),
    // use taskList instead of bullet_list.
    //
    // Note: mixed lists (some checked, some not) fall through to bullet_list. This is intentional
    // — GFM allows mixed task/regular items in a single list, but ADF taskList requires all items
    // to be taskItems. A future enhancement could split mixed lists, but for now the simpler
    // behaviour (all-or-nothing) is safer and avoids invalid PM documents.
    const taskListType = state.schema.nodes.taskList ?? state.schema.nodes.task_list;
    if (!node.ordered && taskListType && node.children.length > 0 && node.children.every((item)=>item.checked !== null && item.checked !== undefined)) {
        state.openNode(taskListType);
        state.parseTokens(node.children);
        state.closeNode();
        return;
    }
    const nodeType = node.ordered ? state.schema.nodes.ordered_list ?? state.schema.nodes.orderedList : state.schema.nodes.bullet_list ?? state.schema.nodes.bulletList;
    if (!nodeType) {
        // Gracefully degrade: schema has no list node — render children directly as block content
        state.parseTokens(node.children);
        return;
    }
    const attrs = node.ordered ? {
        order: node.start ?? 1
    } : null;
    state.openNode(nodeType, attrs);
    state.parseTokens(node.children);
    state.closeNode();
}





function $8e2436fc214b4794$export$76c7e83ecc9cdf05(state, node) {
    const isTask = node.checked !== null && node.checked !== undefined;
    // If the schema has a dedicated taskItem node (ADF style), use it
    const taskItemType = state.schema.nodes.taskItem ?? state.schema.nodes.task_item;
    if (isTask && taskItemType) {
        const taskAttrs = {};
        const attrSpec = taskItemType.spec.attrs ?? {};
        if ('state' in attrSpec) // ADF convention: state is 'DONE' or 'TODO'
        taskAttrs.state = node.checked ? 'DONE' : 'TODO';
        if ('checked' in attrSpec) taskAttrs.checked = node.checked;
        state.openNode(taskItemType, taskAttrs);
        // taskItem is `inline*`; defer block children so they emit as siblings of
        // the taskItem inside the parent taskList (ADF's nested-task-list shape).
        const deferredBlockChildren = [];
        for (const child of node.children){
            if (child.type === 'paragraph') state.parseTokens(child.children);
            else if ((0, $dh538.fg)('platform_editor_fix_nested_markdown_tasks')) deferredBlockChildren.push(child);
            else state.parseTokens([
                child
            ]);
        }
        state.closeNode();
        if (deferredBlockChildren.length > 0) state.parseTokens(deferredBlockChildren);
        return;
    }
    // Regular list item (or task item falling back to list_item when no taskItem node)
    const itemType = state.schema.nodes.list_item ?? state.schema.nodes.listItem;
    if (!itemType) {
        // Gracefully degrade: schema has no list item node — render children directly
        state.parseTokens(node.children);
        return;
    }
    const attrs = {};
    if ('checked' in (itemType.spec.attrs ?? {})) // Always write the checked attr when the schema supports it (null for non-task items)
    attrs.checked = isTask ? node.checked : null;
    state.openNode(itemType, attrs);
    if (node.children.length === 0) {
        // Empty list item (e.g. `* ` with no content) — insert an empty paragraph
        // so the ADF listItem node satisfies the schema's content requirement
        // (listItem requires at least one paragraph child). Without this, the
        // empty listItem is dropped during PM node normalization.
        const paragraphType = state.schema.nodes.paragraph;
        if (paragraphType) state.push(paragraphType.create());
    } else state.parseTokens(node.children);
    state.closeNode();
}


function $78eab2966e813e9d$export$9852986a3ec5f6a0(state, node) {
    const nodeType = state.schema.nodes.table;
    if (!nodeType) {
        // Gracefully degrade: schema has no table node — render children directly
        // (tableRow/tableCell handlers will also degrade gracefully)
        state.parseTokens(node.children);
        return;
    }
    state.openNode(nodeType);
    state.parseTokens(node.children);
    state.closeNode();
}


function $a7d7690b6c827cd5$export$ce666bf02318c957(state, node, index) {
    const nodeType = state.schema.nodes.tableRow ?? state.schema.nodes.table_row;
    if (!nodeType) {
        // Gracefully degrade: schema has no tableRow node — render cells directly
        state.rowIndex = index;
        state.parseTokens(node.children);
        state.rowIndex = null;
        return;
    }
    state.openNode(nodeType);
    state.rowIndex = index;
    state.parseTokens(node.children);
    state.rowIndex = null;
    state.closeNode();
}


function $d665c5df0e8ce56a$export$e1e720e5f4603e6a(state, node) {
    // rowIndex === 0 is the header row (falsy), subsequent rows are body cells
    const cellTypeName = state.rowIndex ? 'tableCell' : 'tableHeader';
    const cellType = state.schema.nodes[cellTypeName] ?? state.schema.nodes.table_cell ?? state.schema.nodes.td;
    const paragraphType = state.schema.nodes.paragraph;
    if (!cellType) {
        // Gracefully degrade: schema has no table cell node — render paragraph content only
        if (paragraphType) {
            state.openNode(paragraphType);
            state.parseTokens(node.children);
            state.closeNode();
        } else state.parseTokens(node.children);
        return;
    }
    state.openNode(cellType);
    if (paragraphType) {
        state.openNode(paragraphType);
        state.parseTokens(node.children);
        state.closeNode();
    } else state.parseTokens(node.children);
    state.closeNode();
}


function $9cc59f0c5b4c2b6d$export$6565f9f03506010b(state, node) {
    const nodeType = state.schema.nodes.code_block ?? state.schema.nodes.codeBlock;
    if (!nodeType) {
        // Gracefully degrade: render code value as a plain text paragraph
        state.openNode(state.schema.nodes.paragraph);
        state.addText(node.value);
        state.closeNode();
        return;
    }
    const attrs = {};
    if (node.lang) attrs.language = node.lang;
    state.addNode(nodeType, attrs, node.value ? [
        state.schema.text(node.value)
    ] : []);
}


function $19efb5bb9971831b$export$ba7b13e047416c03(state, _node) {
    const nodeType = state.schema.nodes.horizontal_rule ?? state.schema.nodes.rule ?? state.schema.nodes.hr;
    if (!nodeType) // Gracefully degrade: schema has no rule node — skip the thematic break
    return;
    state.addNode(nodeType, null, []);
}


function $6ff819c8713c5abd$export$371da9dd35aba193(state, _node) {
    const nodeType = state.schema.nodes.hard_break ?? state.schema.nodes.hardBreak;
    if (!nodeType) {
        // Gracefully degrade: no hard break node — add a space instead
        state.addText(' ');
        return;
    }
    state.addNode(nodeType, null, []);
}


function $01a1bffb755080d3$export$5c452ff88e35e47d(state, node) {
    const nodeType = state.schema.nodes.image;
    if (!nodeType) {
        // Gracefully degrade: schema has no image node — render alt text as plain text
        if (node.alt) state.addText(node.alt);
        return;
    }
    state.addNode(nodeType, {
        src: node.url,
        alt: node.alt ?? null,
        title: node.title ?? null
    }, []);
}



var $10CKv = parcelRequire("10CKv");

function $a947388072c46527$export$6f093cfa640b7166(state, node) {
    state.addText((0, $10CKv.trimLines)(String(node.value)));
}


function $3354d81f10a56e62$export$59ae2c325a998f89(state, node) {
    if (!state.schema.marks.strong) {
        // Gracefully degrade: render children as plain text when schema has no strong mark
        state.parseTokens(node.children);
        return;
    }
    const mark = state.schema.marks.strong.create();
    state.openMark(mark);
    state.parseTokens(node.children);
    state.closeMark(mark);
}


function $d519f7620645ad1e$export$bef81ba411953b51(state, node) {
    if (!state.schema.marks.em) {
        // Gracefully degrade: render children as plain text when schema has no em mark
        state.parseTokens(node.children);
        return;
    }
    const mark = state.schema.marks.em.create();
    state.openMark(mark);
    state.parseTokens(node.children);
    state.closeMark(mark);
}


function $13d65cd19d35fbc7$export$91b9bee19a0d8569(state, node) {
    if (!state.schema.marks.code) {
        // Gracefully degrade: render as plain text when schema has no code mark
        state.addText(node.value);
        return;
    }
    const mark = state.schema.marks.code.create();
    state.openMark(mark);
    state.addText(node.value);
    state.closeMark(mark);
}


function $ac2e6559f196ca9a$export$9c30223ca0a664fb(state, node) {
    if (!state.schema.marks.link) {
        // Gracefully degrade: render children as plain text when schema has no link mark
        state.parseTokens(node.children);
        return;
    }
    const mark = state.schema.marks.link.create({
        href: node.url,
        title: node.title ?? null
    });
    state.openMark(mark);
    state.parseTokens(node.children);
    state.closeMark(mark);
}


function $d57b5176aa4576de$export$b05da9e94a08038f(state, node) {
    const markType = state.schema.marks.strike ?? state.schema.marks.strikethrough;
    if (markType) {
        const mark = markType.create();
        state.openMark(mark);
        state.parseTokens(node.children);
        state.closeMark(mark);
    } else // Graceful degradation: render content without mark
    state.parseTokens(node.children);
}


// asHandler casts a specific-subtype handler to the generic Handler type.
// This is safe: parseTokens only calls a handler with a node whose `type` matches the key.
// TypeScript cannot express this constraint without a cast due to function parameter
// contravariance — a handler accepting (node: Blockquote) is not assignable to one accepting
// (node: Content) even though we only ever call it with a Blockquote node.
const $88a98ec8ce2b22ae$var$asHandler = (fn)=>fn;
const $88a98ec8ce2b22ae$export$455ce229eb3d2472 = {
    root: $88a98ec8ce2b22ae$var$asHandler((0, $b71487fd40874600$export$e8e78c978b129247)),
    blockquote: $88a98ec8ce2b22ae$var$asHandler((0, $2ac230ebef515fd5$export$67dc04e652a298ca)),
    paragraph: $88a98ec8ce2b22ae$var$asHandler((0, $c7d89ee22e40fc0a$export$9c206ddddb32a9b)),
    heading: $88a98ec8ce2b22ae$var$asHandler((0, $72190984a6ffa402$export$46e4a324ac90507f)),
    list: $88a98ec8ce2b22ae$var$asHandler((0, $726992287582621a$export$8837f4fc672e936d)),
    listItem: $88a98ec8ce2b22ae$var$asHandler((0, $8e2436fc214b4794$export$76c7e83ecc9cdf05)),
    table: $88a98ec8ce2b22ae$var$asHandler((0, $78eab2966e813e9d$export$9852986a3ec5f6a0)),
    tableRow: $88a98ec8ce2b22ae$var$asHandler((0, $a7d7690b6c827cd5$export$ce666bf02318c957)),
    tableCell: $88a98ec8ce2b22ae$var$asHandler((0, $d665c5df0e8ce56a$export$e1e720e5f4603e6a)),
    code: $88a98ec8ce2b22ae$var$asHandler((0, $9cc59f0c5b4c2b6d$export$6565f9f03506010b)),
    thematicBreak: $88a98ec8ce2b22ae$var$asHandler((0, $19efb5bb9971831b$export$ba7b13e047416c03)),
    break: $88a98ec8ce2b22ae$var$asHandler((0, $6ff819c8713c5abd$export$371da9dd35aba193)),
    image: $88a98ec8ce2b22ae$var$asHandler((0, $01a1bffb755080d3$export$5c452ff88e35e47d)),
    text: $88a98ec8ce2b22ae$var$asHandler((0, $a947388072c46527$export$6f093cfa640b7166)),
    strong: $88a98ec8ce2b22ae$var$asHandler((0, $3354d81f10a56e62$export$59ae2c325a998f89)),
    emphasis: $88a98ec8ce2b22ae$var$asHandler((0, $d519f7620645ad1e$export$bef81ba411953b51)),
    inlineCode: $88a98ec8ce2b22ae$var$asHandler((0, $13d65cd19d35fbc7$export$91b9bee19a0d8569)),
    link: $88a98ec8ce2b22ae$var$asHandler((0, $ac2e6559f196ca9a$export$9c30223ca0a664fb)),
    delete: $88a98ec8ce2b22ae$var$asHandler((0, $d57b5176aa4576de$export$b05da9e94a08038f))
};


const $4a459e9a38530e96$var$emptyTaskListItemPattern = /^(\s*)([-*+]|\d+\.) \[([ xX])\](\r?)$/u;
const $4a459e9a38530e96$var$fencePattern = /^\s*(`{3,}|~{3,})(.*)$/u;
/**
 * `mdast-util-gfm-task-list-item` only treats `[ ]` / `[x]` as a task marker
 * when there is trailing item content. Users can still create an empty task
 * item in source view as `* [ ]`; normalize that to the equivalent form with
 * invisible placeholder content before parsing so it round-trips as a task item
 * instead of a bullet item containing literal bracket text. The placeholder is
 * stripped from the parsed ProseMirror doc immediately after parsing.
 */ const $4a459e9a38530e96$var$normalizeEmptyTaskListItems = (markdown)=>{
    let openFence;
    let didNormalize = false;
    const lines = markdown.split('\n');
    const normalizedLines = [];
    for (const line of lines){
        const fenceMatch = $4a459e9a38530e96$var$fencePattern.exec(line);
        const fence = fenceMatch?.[1];
        if (fence) {
            if (!openFence) {
                openFence = {
                    character: fence[0],
                    length: fence.length
                };
                normalizedLines.push(line);
                continue;
            }
            const fenceSuffix = fenceMatch?.[2] ?? '';
            if (fence[0] === openFence.character && fence.length >= openFence.length && fenceSuffix.trim().length === 0) openFence = undefined;
            normalizedLines.push(line);
            continue;
        }
        if (openFence) {
            normalizedLines.push(line);
            continue;
        }
        const match = $4a459e9a38530e96$var$emptyTaskListItemPattern.exec(line);
        const normalizedLine = match ? `${match[1]}${match[2]} [${match[3]}] ${0, $8fc4d31022a9f460$export$adb8a99c77edd84e}${match[4]}` : line;
        didNormalize || (didNormalize = Boolean(match));
        normalizedLines.push(normalizedLine);
    }
    return {
        didNormalize: didNormalize,
        markdown: didNormalize ? normalizedLines.join('\n') : markdown
    };
};
const $4a459e9a38530e96$var$removeEmptyTaskListPlaceholders = (doc, schema)=>{
    const strip = (node)=>{
        if (!node || typeof node !== 'object') return node;
        const json = node;
        if (json.type === 'text' && json.text !== undefined) {
            if (json.text === (0, $8fc4d31022a9f460$export$adb8a99c77edd84e)) return null;
            return json;
        }
        if (Array.isArray(json.content)) return {
            ...json,
            content: json.content.map(strip).filter(Boolean)
        };
        return json;
    };
    return schema.nodeFromJSON(strip(doc.toJSON()));
};
const $4a459e9a38530e96$var$markdownToAdfViaMdast = (markdown, schema, options)=>{
    const mdast = (0, $a2d866d1a57b6a8e$export$d744d789c09bfde6)(markdown, {
        extensions: [
            (0, $8e04031d12c492e0$export$8bbec8ea1400a00e)(),
            (0, $5490715e401c0d53$export$e36cebda627bf2dd)(),
            (0, $78c447656c76a7de$export$2912e8b2802475ff)()
        ],
        mdastExtensions: [
            (0, $a41cbcc025bac23c$export$34d64e709dd0b9bb)(),
            (0, $3bff305c903a5854$export$8bd0ec8ecf6adb7d)(),
            (0, $b4ef0b4c77ef6a57$export$a427a608608b215f)()
        ]
    });
    const doc = (0, $17ef69f3494f5b3b$export$4aad817b79ae84b4)(schema, (0, $88a98ec8ce2b22ae$export$455ce229eb3d2472))(mdast);
    if (!doc) throw new Error('[markdownToAdf] mdast-util-to-pm returned null for the given markdown');
    return options?.stripEmptyTaskListPlaceholders ? $4a459e9a38530e96$var$removeEmptyTaskListPlaceholders(doc, schema) : doc;
};
const $4a459e9a38530e96$export$3768801c4ab752e6 = (doc, schema, options = {})=>{
    const handlers = options.serializeFileMedia ? {
        ...(0, $f55209500775d049$export$d58124ced37e5234),
        ...(0, $39ea8ef356c19cc4$export$a0da5befa47b223d)({
            serializeFileMedia: options.serializeFileMedia
        })
    } : (0, $f55209500775d049$export$d58124ced37e5234);
    return (0, $aeb2b691b0b10c51$export$ab3fd54df7090dc2)(schema, handlers)(doc);
};
const $4a459e9a38530e96$export$aa0067ded6a6b28d = (markdown, schema)=>{
    const normalized = (0, $dh538.fg)('platform_editor_fix_md_empty_list_roundtrip') ? $4a459e9a38530e96$var$normalizeEmptyTaskListItems(markdown) : {
        didNormalize: false,
        markdown: markdown
    };
    return $4a459e9a38530e96$var$markdownToAdfViaMdast(normalized.markdown, schema, {
        stripEmptyTaskListPlaceholders: normalized.didNormalize
    });
};


/* MarkdownSourceView.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * MarkdownSourceView — markdown source editor for Confluence Live Docs in
 * Markdown Mode.
 *
 * Behaviour:
 *  - On mount, convert the live ProseMirror document (`initialAdfDoc`) to
 *    markdown via `@atlassian/mdast-util-from-pm` and seed a CodeMirror 6 editor
 *    with it.
 *  - User edits live in the CodeMirror EditorState; we do NOT push them back
 *    into the ProseMirror editor on every keystroke (too expensive and would
 *    fight the collab provider).
 *  - On unmount (i.e. when the user switches back to WYSIWYG / preview), we
 *    read the editor's current doc, validate it parses back to ADF via
 *    `@atlassian/mdast-util-to-pm`, and hand the markdown string
 *    off to the parent through `onMarkdownCommit`. The parent is responsible
 *    for applying it to the editor.
 *  - If the user did NOT actually edit the markdown buffer
 *    (`finalMarkdown === initialMarkdown`), we skip the commit entirely.
 *    This avoids a lossy ADF→markdown→ADF round-trip on every no-op visit
 *    to source view, which would otherwise reset collab cursors and undo
 *    history and could subtly mutate the doc (the markdown round-trip is
 *    not a strict identity).
 *  - If the markdown can't be parsed we `console.warn` and discard the change
 *    rather than crashing the editor. A user-facing surface for lossy
 *    round-trips is deferred — see TODO below.
 *
 * Re-seeding: callers may pass a `revision` prop. CodeMirror is destroyed
 * and re-mounted whenever `revision` changes, so the parent can force a
 * fresh seed (e.g. when re-entering source view with a new ADF snapshot).
 * The component is a single React tree across re-seeds — only the inner
 * CodeMirror state is recreated.
 *
 * The component intentionally takes a stable, narrow prop interface so other
 * agents (BRAVO's preview view + LivePageComponent plumbing, CHARLIE's tests)
 * can rely on it. Do not change the shape of `MarkdownSourceViewProps` without
 * coordinating with those agents.
 *
 * TODO(EDITOR-6558-source): surface lossy round-trips to the user (flag /
 * inline warning) instead of silently warning to the console.
 *
 * Ticket: https://hello.jira.atlassian.cloud/browse/EDITOR-6558
 * Parent epic: https://hello.jira.atlassian.cloud/browse/EDITOR-6490
 */ 



var $gMc0m = parcelRequire("gMc0m");


var $gv6AH = parcelRequire("gv6AH");











var $kqMBA = parcelRequire("kqMBA");


var $aXWIB = parcelRequire("aXWIB");


var $36Wvq = parcelRequire("36Wvq");





/**
 * Returns true if the given pre-processed line (escape sequences and balanced
 * inline code spans already stripped) has unbalanced markdown inline syntax —
 * e.g. the user has typed `*ital` but not yet the closing `*`.
 *
 * Tokens checked (all require balanced pairs on the same line):
 *   - `` ` `` (inline code) — odd count of backticks
 *   - `*` / `**` / `***` (em / strong / bold-italic) — odd count per run-length
 *   - `[` without a matching `](` later on the line (link syntax)
 */ function $3ce01f6cfcb6c596$var$lineHasUnbalancedInlineSyntax(strippedLine) {
    // Odd backtick count → unclosed inline code span.
    const backtickCount = (strippedLine.match(/`/gu) ?? []).length;
    if (backtickCount % 2 !== 0) return true;
    // Each distinct asterisk run-length must appear an even number of times.
    // e.g. `**bol` has one `**` token → odd → unbalanced.
    const asteriskRuns = strippedLine.match(/\*+/gu) ?? [];
    const runCounts = new Map();
    for (const run of asteriskRuns){
        const len = run.length;
        runCounts.set(len, (runCounts.get(len) ?? 0) + 1);
    }
    for (const count of runCounts.values()){
        if (count % 2 !== 0) return true;
    }
    // Unclosed link — `[text` without a following `](` on the same line.
    if (/\[[^\]]*$/u.test(strippedLine)) return true;
    return false;
}
/**
 * Pre-processes a line for syntax balance checking: strips escape sequences,
 * balanced inline code spans, and leading list-item markers so they don't
 * skew token counts.
 *
 * List-item prefixes (`* `, `- `, `+ `, or `1. ` / `123. `) begin with a
 * `*` or `-` / `+` that is structural (a block-level marker), not inline
 * emphasis syntax. Stripping them before the asterisk-balance check prevents
 * false positives on every bullet-list line.
 */ function $3ce01f6cfcb6c596$var$stripLineForBalanceCheck(line) {
    // Strip leading list-item marker: unordered (* / - / +) or ordered (N.)
    // followed by at least one space.
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- one replace per line, unavoidable
    const withoutListPrefix = line.replace(/^(\s*(?:[*+\-]|\d+\.)\s+)/u, '');
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- one replace per line, unavoidable
    return withoutListPrefix.replace(/\\.|`[^`]*`/gu, '');
}
function $3ce01f6cfcb6c596$export$cf49bba3d053a321(markdown, cursorPos) {
    // Strip escape sequences first so `\`` doesn't interfere with fence detection.
    const unescaped = markdown.replace(/\\./gu, '');
    // --- Global check: unclosed fenced code block ---
    // Strip complete balanced fenced blocks (``` ... ```) so their content is
    // not counted. An odd number of remaining ``` markers means there is an
    // unclosed fence somewhere in the document.
    const withoutFences = unescaped.replace(RegExp("^```.*?^```", "gmsu"), '');
    const fenceCount = (withoutFences.match(/^```/gmu) ?? []).length;
    if (fenceCount % 2 !== 0) return true;
    // --- Per-line check: inline syntax on the cursor's line only ---
    // Find the line boundaries from the raw markdown (before escape-stripping)
    // so that cursorPos maps correctly to character offsets.
    const lineStart = markdown.lastIndexOf('\n', cursorPos - 1) + 1;
    const lineEndRaw = markdown.indexOf('\n', cursorPos);
    const lineEnd = lineEndRaw === -1 ? markdown.length : lineEndRaw;
    const currentLine = markdown.slice(lineStart, lineEnd);
    // Fence delimiter lines (``` ...) are not inline syntax — skip the check.
    if (/^```/u.test(currentLine)) return false;
    // Thematic break lines (e.g. `***`, `* * *`, `---`, `___`) are block-level
    // syntax, not inline emphasis. A `***` line would otherwise be counted as
    // three unbalanced asterisks of length 1. Detect and skip.
    // Spec: three or more `*`, `-`, or `_`, optionally separated by spaces,
    // with nothing else on the line (except leading/trailing spaces).
    if (/^\s{0,3}((\*[ \t]*){3,}|([ \t]*-){3,}|(_[ \t]*){3,})\s*$/u.test(currentLine)) return false;
    // If the cursor is inside a balanced fence block, the line is code content
    // not markdown syntax — skip the inline check.
    // We detect this by checking whether cursorPos falls within a stripped region.
    // Simple heuristic: count ``` markers before the cursor line in the unescaped
    // string; if the count is odd, we're inside a fence.
    const beforeCursor = unescaped.slice(0, lineStart);
    const fencesBeforeCursor = (beforeCursor.match(/^```/gmu) ?? []).length;
    if (fencesBeforeCursor % 2 !== 0) return false;
    return $3ce01f6cfcb6c596$var$lineHasUnbalancedInlineSyntax($3ce01f6cfcb6c596$var$stripLineForBalanceCheck(currentLine));
}



/**
 * Text-level diff helpers for the source view's non-clobbering live-refresh
 * path. Pure functions returning CM6-shaped `{from, to, insert}` ops; the
 * source view dispatches them via `view.dispatch({ changes })`.
 */ 
var $eOoFF = parcelRequire("eOoFF");

const $ce2afba5a872a11f$export$294aa3c46d6af4a5 = (oldText, newText)=>{
    const hunks = [];
    for (const [from, to, insert] of (0, $eOoFF.calcPatch)(oldText, newText))hunks.push({
        from: from,
        to: to,
        insert: insert
    });
    return hunks;
};
const $ce2afba5a872a11f$export$e291136b00c395d = (seed, buffer, next)=>{
    const remoteHunks = $ce2afba5a872a11f$export$294aa3c46d6af4a5(seed, next);
    if (remoteHunks.length === 0) return [];
    const userHunks = $ce2afba5a872a11f$export$294aa3c46d6af4a5(seed, buffer);
    if (userHunks.length === 0) return remoteHunks;
    for (const rh of remoteHunks)for (const uh of userHunks){
        if ($ce2afba5a872a11f$var$rangesOverlap(rh, uh)) return null;
    }
    return remoteHunks.map((rh)=>{
        let delta = 0;
        for (const uh of userHunks)if (uh.to <= rh.from) delta += uh.insert.length - (uh.to - uh.from);
        return {
            from: rh.from + delta,
            to: rh.to + delta,
            insert: rh.insert
        };
    });
};
const $ce2afba5a872a11f$var$rangesOverlap = (a, b)=>{
    // Strict interior overlap.
    if (a.from < b.to && b.from < a.to) return true;
    // Concurrent zero-width inserts at the same position: ambiguous order.
    if (a.from === b.from && a.to === a.from && b.to === b.from) return true;
    return false;
};


// Annotation decoration support
//
// Annotation marks (inline comments) from the ADF document are surfaced as
// highlighted spans in the CodeMirror source view. These are purely visual —
// the markdown string itself is clean (no annotation syntax). The highlights
// shift correctly as the user edits because CM6's RangeSet maps them through
// document changes via the StateField update function.
// ---------------------------------------------------------------------------
// noinspection JSVoidFunctionReturnValueUsed -- WebStorm seems to incorrectly infer the type of StateEffect as being a DOM thing
/** Effect dispatched to replace the annotation decoration set. */ const $6584100e45685489$var$setAnnotationRangesEffect = (0, $5oQvt.StateEffect).define(); /**
                                                                                          * Returns a CM6 decoration mark for the given annotation ID.
                                                                                          * The `id` attribute is set so that `document.getElementById(annotationId)`
                                                                                          * finds this visible CM6 element (rather than the hidden ProseMirror span)
                                                                                          * when the inline comment popup calculates its anchor position.
                                                                                          */ 
function $6584100e45685489$var$annotationMarkForId(annotationId) {
    return (0, $kqMBA.Decoration).mark({
        class: 'cm-annotation-highlight',
        attributes: {
            id: annotationId
        }
    });
} /**
   * Extract the current annotation character ranges from a CM6 DecorationSet,
   * matching each decoration back to its original annotation ID.
   *
   * CM6's `StateField` maps decorations through document changes automatically
   * (via `decorations.map(tr.changes)`), so after user edits the positions in
   * the DecorationSet reflect the shifted character offsets. We recover the
   * annotation ID by matching the shifted range against the original snapshot
   * list — first by exact position, then by any overlap (best-effort).
   */ 
function $6584100e45685489$var$extractCurrentAnnotationRanges(decorations, originalRanges) {
    const result = [];
    const cursor = decorations.iter();
    while(cursor.value !== null){
        const { from: from, to: to } = cursor; // Try to match to an original annotation by exact position first,
        // then fall back to overlap — the id is what matters for re-application.
        const matched = originalRanges.find((a)=>a.from === from && a.to === to) ?? originalRanges.find((a)=>a.from < to && a.to > from); // Only push if we found a matching annotation — an empty-string ID is
        // meaningless and would corrupt the ranges array passed downstream.
        if (matched) result.push({
            id: matched.id,
            from: from,
            to: to
        });
        cursor.next();
    }
    return result;
} /**
   * Keep the latest value in a stable ref for CodeMirror callbacks that are
   * intentionally created once per source-view mount.
   */ 
function $6584100e45685489$var$useReactiveRef(targetValue) {
    const ref = (0, $42omo.useRef)(targetValue);
    (0, $42omo.useEffect)(()=>{
        ref.current = targetValue;
    }, [
        targetValue
    ]);
    return ref;
} // noinspection JSVoidFunctionReturnValueUsed -- WebStorm seems to incorrectly infer the type of StateEffect as being a DOM thing
/**
 * CM6 StateField that holds the current annotation DecorationSet.
 *
 * On `setAnnotationRangesEffect`: rebuilds the decoration set from the new
 * ranges. On any other transaction: maps the existing decorations through
 * the document changes so character positions stay correct after edits.
 */ const $6584100e45685489$var$annotationDecorationsField = (0, $5oQvt.StateField).define({
    create () {
        return (0, $kqMBA.Decoration).none;
    },
    update (decorations, tr) {
        // Check for a setAnnotationRangesEffect in this transaction.
        for (const effect of tr.effects)if (effect.is($6584100e45685489$var$setAnnotationRangesEffect)) {
            const ranges = effect.value;
            if (ranges.length === 0) return (0, $kqMBA.Decoration).none;
             // Rebuild the decoration set from the new ranges.
            // Ranges must be sorted and non-overlapping for a single decoration
            // type — we sort by `from` and clamp to doc length.
            const docLen = tr.state.doc.length;
            const builder = new (0, $5oQvt.RangeSetBuilder)();
            const sorted = [
                ...ranges
            ].sort((a, b)=>a.from - b.from);
            for (const { from: from, to: to, id: id } of sorted){
                const clampedFrom = Math.min(Math.max(from, 0), docLen);
                const clampedTo = Math.min(Math.max(to, 0), docLen);
                if (clampedFrom < clampedTo) builder.add(clampedFrom, clampedTo, $6584100e45685489$var$annotationMarkForId(id));
            }
            return builder.finish();
        }
         // No range update — map existing decorations through any document changes.
        return tr.docChanged ? decorations.map(tr.changes) : decorations;
    },
    provide (field) {
        return (0, $kqMBA.EditorView).decorations.from(field);
    }
});
const $6584100e45685489$var$containerStyles = null;
const $6584100e45685489$var$editorStyles = null; /**
                            * Stable public prop interface for `MarkdownSourceView`.
                            *
                            * Other agents depend on this contract — DO NOT change without coordination.
                            */ 
const $6584100e45685489$export$eb7c1c6ff6845883 = ({ contentId: _contentId, initialAdfDoc: initialAdfDoc, seedMarkdown: seedMarkdown, schema: schema, revision: revision = 0, onMarkdownCommit: onMarkdownCommit, liveAdfDoc: liveAdfDoc, postWritebackAdfDoc: postWritebackAdfDoc, onSourceMarkdownChange: onSourceMarkdownChange, sourceChangeDebounceMs: sourceChangeDebounceMs = 2000, serializeFileMedia: serializeFileMedia, annotationRanges: annotationRanges, onAnnotationRangesChange: onAnnotationRangesChange, onAnnotationClick: onAnnotationClick, onRegisterCommandDispatch: onRegisterCommandDispatch, onSourceFormatStateChange: onSourceFormatStateChange })=>{
    const intl = (0, $aXWIB.useIntl)(); // Stash the file-media serialiser in a ref so changing the function
    // reference does not rebuild CodeMirror or invalidate the live-doc
    // effect. The function is read at call time inside `adfToMarkdown`.
    const serializeFileMediaRef = $6584100e45685489$var$useReactiveRef(serializeFileMedia); // Stash the schema + commit callback in refs so the unmount cleanup can
    // keep its dep list narrow (we only want the seed/teardown to run on
    // revision change, not whenever the parent re-renders with a new
    // function ref).
    const schemaRef = $6584100e45685489$var$useReactiveRef(schema);
    const onCommitRef = $6584100e45685489$var$useReactiveRef(onMarkdownCommit); // EDITOR-6558 Tier 2 — keep the live source-change callback + debounce in
    // refs so the seed effect's CodeMirror extension list (which captures
    // these once at mount) always reads the latest values without rebuilding
    // the editor on every parent re-render.
    const onSourceMarkdownChangeRef = $6584100e45685489$var$useReactiveRef(onSourceMarkdownChange);
    const sourceChangeDebounceMsRef = $6584100e45685489$var$useReactiveRef(sourceChangeDebounceMs); // Latest ADF doc the parent has handed us, kept in a ref so the seed
    // effect can read the most-recent value without re-running on every
    // `initialAdfDoc` reference change. The seed effect deliberately reads
    // it only when `revision` changes.
    const initialAdfDocRef = $6584100e45685489$var$useReactiveRef(initialAdfDoc); // Pre-computed markdown from the parent (sync-snapshot), mirrored to a ref and
    // updated during render so the seed effect reads the value for the current revision.
    const seedMarkdownPropRef = (0, $42omo.useRef)(seedMarkdown);
    seedMarkdownPropRef.current = seedMarkdown; // Ref to the host element CodeMirror mounts into.
    const hostRef = (0, $42omo.useRef)(null); // Ref to the live EditorView so the cleanup can read its doc.
    const viewRef = (0, $42omo.useRef)(null); // The markdown the editor was *seeded* with for the current revision —
    // used to detect no-op commits and skip the writeback round-trip. Also
    // the baseline for the disjoint/overlap analysis in the live-refresh path.
    const seedMarkdownRef = (0, $42omo.useRef)(''); // Most recently deferred `liveAdfDoc` update. Set when an incoming remote
    // change overlaps the user's unsynced typing. Discarded on next
    // `postWritebackAdfDoc` (its content is already in the post-rebase PM).
    const pendingLiveMarkdownRef = (0, $42omo.useRef)(null);
    const ariaLabel = intl.formatMessage((0, $36Wvq.markdownModeMessages).sourceAriaLabel);
    const ariaLabelRef = $6584100e45685489$var$useReactiveRef(ariaLabel); // EDITOR-6558 Tier 2 — flag set while we're applying a programmatic
    // `liveAdfDoc` change to CodeMirror, so the resulting `updateListener`
    // fire is recognised as an echo and not pushed back to the parent. The
    // flag is set immediately before `view.dispatch({ changes })` and
    // cleared on the next microtask (CodeMirror's update listeners run
    // synchronously inside `dispatch`). Using a ref so the closure captured
    // inside the extension can read it.
    const suppressSourceChangeRef = (0, $42omo.useRef)(false); // Debounce timer for `onSourceMarkdownChange` — scoped to the view so
    // teardown cleans it up.
    const sourceChangeTimerRef = (0, $42omo.useRef)(null); // The line number (1-based) where the last doc change occurred.
    // Used to detect when the cursor has moved to a different line so we can
    // short-circuit the debounce and flush the pending writeback early.
    const lastEditLineRef = (0, $42omo.useRef)(null); // Stash onAnnotationRangesChange in a ref so the sourceChangeListener
    // (captured once at mount) always reads the latest callback without
    // rebuilding CodeMirror on every parent re-render.
    const onAnnotationRangesChangeRef = $6584100e45685489$var$useReactiveRef(onAnnotationRangesChange); // Stash onAnnotationClick in a ref so the CM6 domEventHandlers click
    // extension (captured once at mount) always reads the latest callback.
    const onAnnotationClickRef = $6584100e45685489$var$useReactiveRef(onAnnotationClick); // Stash onRegisterCommandDispatch in a ref so the effect below doesn't
    // re-run when the parent re-renders with a new function reference.
    const onRegisterCommandDispatchRef = $6584100e45685489$var$useReactiveRef(onRegisterCommandDispatch);
    const onSourceFormatStateChangeRef = $6584100e45685489$var$useReactiveRef(onSourceFormatStateChange); // Expose a stable dispatcher function via the onRegisterCommandDispatch
    // prop so MarkdownModeContentComponent can register it with the plugin
    // whenever api changes. The function reads viewRef at call time so it
    // always dispatches to the live CM6 EditorView.
    const dispatchCmd = (0, $42omo.useCallback)((cmd)=>{
        const view = viewRef.current;
        if (!view) return false;
        return cmd(view);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- viewRef is a stable ref — intentionally not in deps.
    []); // Register/unregister the dispatcher via the onRegisterCommandDispatch prop.
    // This fires on mount (register) and unmount (null). Re-registration when
    // the plugin rebuilds is handled by MarkdownModeContentComponent which
    // passes an updated onRegisterCommandDispatch whenever api changes.
    (0, $42omo.useEffect)(()=>{
        const onRegisterCommandDispatch = onRegisterCommandDispatchRef.current;
        onRegisterCommandDispatch?.(dispatchCmd);
        return ()=>{
            onRegisterCommandDispatch?.(null);
        };
    }, [
        dispatchCmd,
        onRegisterCommandDispatchRef
    ]); // Annotation ranges — kept in a ref so the CM6 StateField (created once
    // at mount) can always read the latest value. Updated whenever the prop
    // changes (i.e. when the parent re-seeds on revision change or live update).
    const annotationRangesRef = (0, $42omo.useRef)(annotationRanges ?? []);
    (0, $42omo.useEffect)(()=>{
        annotationRangesRef.current = annotationRanges ?? []; // If the view is mounted, notify the StateField to recompute decorations.
        const view = viewRef.current;
        if (view) view.dispatch({
            effects: $6584100e45685489$var$setAnnotationRangesEffect.of(annotationRanges ?? [])
        });
    }, [
        annotationRanges
    ]); // Mount/seed CodeMirror on every `revision` change. Tear down + commit
    // on cleanup (revision change OR component unmount).
    (0, $42omo.useEffect)(()=>{
        const host = hostRef.current;
        if (!host) return undefined;
        const schema = schemaRef.current;
        const serializeFileMedia = serializeFileMediaRef.current;
        const onCommit = onCommitRef.current;
        const onAnnotationRangesChange = onAnnotationRangesChangeRef.current; // Seed markdown for this revision. Prefer the parent's pre-computed value
        // (sync-snapshot, avoids a second conversion); otherwise convert here.
        let seedMarkdownValue;
        const precomputedSeed = seedMarkdownPropRef.current;
        if (precomputedSeed !== undefined) seedMarkdownValue = precomputedSeed;
        else try {
            const result = (0, $4a459e9a38530e96$export$3768801c4ab752e6)(initialAdfDocRef.current, schema, {
                serializeFileMedia: serializeFileMedia
            });
            seedMarkdownValue = result.markdown;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('[MarkdownSourceView] Failed to convert ADF doc to markdown; starting with empty buffer.', err);
            seedMarkdownValue = '';
        }
        seedMarkdownRef.current = seedMarkdownValue; // How long to wait before retrying a flush when the current line has
        // unbalanced syntax (e.g. user typed `*ital` and paused mid-word).
        // Long enough to give the user time to finish their syntax, but short
        // enough to guarantee the doc eventually syncs even if they leave it
        // unfinished (e.g. intentional bare `*` or just navigated away).
        const UNBALANCED_RETRY_MS = 5000; // Shared flush function — reads the current CM6 state and fires the
        // writeback callbacks. If the cursor's current line has unbalanced
        // markdown syntax (e.g. `*ital` mid-word) the flush is deferred by
        // UNBALANCED_RETRY_MS instead of firing immediately, giving the user
        // time to finish the syntax without corrupting the live PM doc.
        // Called both by the debounce timer and by the line-change short-circuit.
        const flushSourceChange = (editorView)=>{
            const markdownNow = editorView.state.doc.toString();
            const cursorPos = editorView.state.selection.main.head; // If the current line has unbalanced syntax, reschedule rather than
            // firing. Writing e.g. `*ital` into the PM editor would round-trip
            // back as `\*ital`, clobbering the source view. We defer instead of
            // suppressing indefinitely — worst case the user leaves a bare `*`
            // and it commits after UNBALANCED_RETRY_MS.
            if ((0, $3ce01f6cfcb6c596$export$cf49bba3d053a321)(markdownNow, cursorPos)) {
                sourceChangeTimerRef.current = setTimeout(()=>{
                    sourceChangeTimerRef.current = null;
                    const newEditorView = viewRef.current;
                    if (newEditorView) flushSourceChange(newEditorView);
                }, UNBALANCED_RETRY_MS);
                return;
            } // Fire the annotation ranges change callback FIRST so that
            // currentAnnotationRangesRef is up-to-date before onSourceMarkdownChange
            // reads it to re-apply annotation marks. If onSourceMarkdownChange fired
            // first it would see stale/empty ranges on the first flush, stripping
            // all annotation marks from the live PM doc.
            const onRangesChange = onAnnotationRangesChangeRef.current;
            if (onRangesChange && annotationRangesRef.current.length > 0) {
                const currentRanges = $6584100e45685489$var$extractCurrentAnnotationRanges(editorView.state.field($6584100e45685489$var$annotationDecorationsField), annotationRangesRef.current);
                onRangesChange(currentRanges);
            }
            const cb = onSourceMarkdownChangeRef.current;
            if (cb) cb(markdownNow);
        };
        const sourceChangeListener = (0, $kqMBA.EditorView).updateListener.of((update)=>{
            if (suppressSourceChangeRef.current) return;
             // Push format state on every selection or doc change so the toolbar
            // can reflect isActive / isDisabled correctly while in source view.
            if (update.docChanged || update.selectionSet) onSourceFormatStateChangeRef.current?.({
                inline: (0, $c8eb22a0108df7ae$export$5069c0cb22ba97e6)(update.state),
                block: (0, $c8eb22a0108df7ae$export$96bc0c55bfc3ec38)(update.state),
                list: (0, $c8eb22a0108df7ae$export$19f8516089a6ae9b)(update.state)
            });
            if (update.docChanged) {
                // Record which line the edit happened on so we can short-circuit
                // the debounce if the cursor moves away before it fires.
                const headPos = update.state.selection.main.head;
                lastEditLineRef.current = update.state.doc.lineAt(headPos).number;
                if (!onSourceMarkdownChangeRef.current) return;
                 // Reset the debounce timer — 2000ms while the user is actively typing.
                if (sourceChangeTimerRef.current !== null) clearTimeout(sourceChangeTimerRef.current);
                sourceChangeTimerRef.current = setTimeout(()=>{
                    sourceChangeTimerRef.current = null;
                    lastEditLineRef.current = null;
                    const editorView = viewRef.current;
                    if (!editorView) return;
                    flushSourceChange(editorView);
                }, sourceChangeDebounceMsRef.current);
                return;
            } // Doc didn't change — check if the cursor has moved to a different line.
            // If there's a pending debounce timer and the cursor is now on a
            // different line than where the edit happened, short-circuit: cancel
            // the long timer and flush after a short 100ms grace period (to avoid
            // flushing on every arrow-key repeat).
            if (sourceChangeTimerRef.current !== null && lastEditLineRef.current !== null && update.selectionSet) {
                const headPos = update.state.selection.main.head;
                const currentLine = update.state.doc.lineAt(headPos).number;
                if (currentLine !== lastEditLineRef.current) {
                    clearTimeout(sourceChangeTimerRef.current);
                    sourceChangeTimerRef.current = setTimeout(()=>{
                        sourceChangeTimerRef.current = null;
                        lastEditLineRef.current = null;
                        const editorView = viewRef.current;
                        if (!editorView) return;
                        flushSourceChange(editorView);
                    }, 100);
                }
            }
        });
        const state = (0, $5oQvt.EditorState).create({
            doc: seedMarkdownValue,
            extensions: [
                (0, $kqMBA.highlightActiveLine)(),
                (0, $kqMBA.drawSelection)(),
                (0, $kqMBA.dropCursor)(),
                (0, $gv6AH.history)(),
                (0, $59nWR.indentOnInput)(),
                (0, $59nWR.bracketMatching)(),
                (0, $hugED.markdown)({
                    base: (0, $hugED.markdownLanguage)
                }),
                // Default code-mirror highlight style — colourises markdown
                // tokens (headings, emphasis, code, links, etc.) using the
                // CM6 default theme.
                (0, $59nWR.syntaxHighlighting)((0, $59nWR.defaultHighlightStyle), {
                    fallback: true
                }),
                (0, $kqMBA.EditorView).lineWrapping,
                // Formatting shortcuts — mirror the WYSIWYG toolbar shortcuts.
                (0, $kqMBA.keymap).of([
                    // Inline formatting
                    {
                        key: 'Mod-b',
                        run: (0, $c8eb22a0108df7ae$export$b850a936f66192a3)
                    },
                    {
                        key: 'Mod-i',
                        run: (0, $c8eb22a0108df7ae$export$227b5ef404be9031)
                    },
                    {
                        key: 'Mod-e',
                        run: (0, $c8eb22a0108df7ae$export$e7d955a85cfe503c)
                    },
                    {
                        key: 'Mod-Shift-s',
                        run: (0, $c8eb22a0108df7ae$export$a46d65f808b4881d)
                    },
                    // Headings (Mod-Alt-1 through Mod-Alt-6, matching WYSIWYG)
                    {
                        key: 'Mod-Alt-1',
                        run: (0, $c8eb22a0108df7ae$export$4e0d444e5782abea)
                    },
                    {
                        key: 'Mod-Alt-2',
                        run: (0, $c8eb22a0108df7ae$export$b8d734de6aecb0a3)
                    },
                    {
                        key: 'Mod-Alt-3',
                        run: (0, $c8eb22a0108df7ae$export$df05910f74b29e0)
                    },
                    {
                        key: 'Mod-Alt-4',
                        run: (0, $c8eb22a0108df7ae$export$ca48da5fbbd68542)
                    },
                    {
                        key: 'Mod-Alt-5',
                        run: (0, $c8eb22a0108df7ae$export$1335885ed6c2d3ac)
                    },
                    {
                        key: 'Mod-Alt-6',
                        run: (0, $c8eb22a0108df7ae$export$8381ca7ddcf8db0d)
                    },
                    // Blockquote
                    {
                        key: 'Mod-Shift-9',
                        run: (0, $c8eb22a0108df7ae$export$2cd68375ac1e5429)
                    },
                    // Lists
                    {
                        key: 'Mod-Shift-8',
                        run: (0, $c8eb22a0108df7ae$export$71c898cbdfd51c6e)
                    },
                    {
                        key: 'Mod-Shift-7',
                        run: (0, $c8eb22a0108df7ae$export$744c9722bde8c6b3)
                    }
                ]),
                (0, $kqMBA.keymap).of([
                    ...(0, $gv6AH.defaultKeymap),
                    ...(0, $gv6AH.historyKeymap)
                ]),
                (0, $kqMBA.EditorView).contentAttributes.of({
                    'aria-label': ariaLabelRef.current
                }),
                (0, $kqMBA.EditorView).theme({
                    '&': {
                        height: '100%',
                        width: '100%'
                    },
                    '.cm-scroller': (0, $dh538.fg)('platform_editor_md_source_sync_snapshot') ? // Token-aligned typography for the source view (ADS typography tokens
                    // instead of raw monospace/14px/1.6 values).
                    {
                        font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
                    } : {
                        fontFamily: 'monospace',
                        fontSize: '14px',
                        lineHeight: '1.6'
                    },
                    // Annotation (inline comment) highlight — subtle background tint
                    // matching the Confluence inline comment highlight colour.
                    // cursor:pointer signals the span is interactive (clickable).
                    '.cm-annotation-highlight': {
                        backgroundColor: 'rgba(255, 196, 0, 0.3)',
                        cursor: 'pointer'
                    }
                }),
                // Annotation decorations — renders inline comment highlights.
                // Only active when annotation ranges are provided. The StateField
                // maps ranges through document changes so highlights shift
                // correctly as the user edits.
                $6584100e45685489$var$annotationDecorationsField,
                // Click handler for annotation highlights. When the user clicks
                // inside a `.cm-annotation-highlight` span, we look up which
                // annotation range contains the clicked character position and
                // fire `onAnnotationClick` with its ID. The parent dispatches
                // the appropriate ProseMirror command to open the comment popup
                // or panel — mirroring the click behaviour in the WYSIWYG view.
                (0, $kqMBA.EditorView).domEventHandlers({
                    click (event, view) {
                        const cb = onAnnotationClickRef.current;
                        if (!cb) return false;
                        const ranges = annotationRangesRef.current;
                        if (!ranges.length) return false;
                         // Use CM6's posAtCoords to get the character offset at the
                        // click position, then find the annotation range that contains it.
                        const pos = view.posAtCoords({
                            x: event.clientX,
                            y: event.clientY
                        });
                        if (pos === null) return false;
                         // Read the current (possibly-shifted) decoration positions from
                        // the StateField so clicks work correctly after the user has
                        // edited text around the annotation highlights.
                        const decorationsField = view.state.field($6584100e45685489$var$annotationDecorationsField, false);
                        if (!decorationsField) // Fall back to the original snapshot ranges if the field
                        // isn't present (e.g. annotationRanges wasn't provided).
                        return false;
                        const currentRanges = $6584100e45685489$var$extractCurrentAnnotationRanges(decorationsField, ranges);
                        const clickedRange = currentRanges.find((range)=>pos >= range.from && pos < range.to);
                        if (!clickedRange) return false;
                        cb(clickedRange.id);
                        return true;
                    }
                }),
                sourceChangeListener
            ]
        });
        const view = new (0, $kqMBA.EditorView)({
            state: state,
            parent: host
        });
        viewRef.current = view;
        onSourceFormatStateChangeRef.current?.({
            inline: (0, $c8eb22a0108df7ae$export$5069c0cb22ba97e6)(view.state),
            block: (0, $c8eb22a0108df7ae$export$96bc0c55bfc3ec38)(view.state),
            list: (0, $c8eb22a0108df7ae$export$19f8516089a6ae9b)(view.state)
        }); // Seed the annotation decorations for this revision if ranges were provided.
        // We dispatch immediately after view creation so the initial highlights
        // are visible on mount without waiting for the next render cycle.
        if (annotationRangesRef.current.length > 0) view.dispatch({
            effects: $6584100e45685489$var$setAnnotationRangesEffect.of(annotationRangesRef.current)
        });
        return ()=>{
            // Tier 2: drop any pending source-change debounce — we're tearing
            // down the view, the parent will get either the final commit
            // (below) or nothing.
            if (sourceChangeTimerRef.current !== null) {
                clearTimeout(sourceChangeTimerRef.current);
                sourceChangeTimerRef.current = null;
            } // Read the final markdown AND annotation ranges BEFORE destroying the view.
            const finalMarkdown = view.state.doc.toString(); // Fire the final annotation ranges to the parent so handleMarkdownCommit
            // has the latest CM6-tracked positions (not the stale snapshot ranges).
            if (onAnnotationRangesChange && annotationRangesRef.current.length > 0) {
                const finalRanges = $6584100e45685489$var$extractCurrentAnnotationRanges(view.state.field($6584100e45685489$var$annotationDecorationsField), annotationRangesRef.current);
                onAnnotationRangesChange(finalRanges);
            }
            view.destroy();
            viewRef.current = null;
            if (!onCommit) return;
             // No-op guard: if the user didn't change the buffer, don't fire
            // a writeback. The markdown round-trip is lossy in general, so
            // committing the unchanged buffer would still mutate the live
            // doc (and reset collab cursors / undo history).
            if (finalMarkdown === seedMarkdownRef.current) return;
            try {
                // Validate by attempting to parse — if it throws we discard the
                // change. We deliberately do NOT pass the parsed PMNode out;
                // the parent re-parses against its own editor schema (which
                // may differ at the margins from ours) when applying.
                (0, $4a459e9a38530e96$export$aa0067ded6a6b28d)(finalMarkdown, schema);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.warn('[MarkdownSourceView] Failed to parse markdown back to ADF on commit; discarding change.', err);
                return;
            }
            onCommit(finalMarkdown);
        }; // `revision` is the only dependency: a bump forces a destroy + re-seed.
    // Schema/commit/aria/initialAdfDoc are all read through refs above so
    // they don't reseed the editor (which would clobber the user's edits).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        revision
    ]);
    // EDITOR-6558 Tier 1 — react to live WYSIWYG → source updates.
    //
    // We diff the new markdown against the current CodeMirror buffer and
    // dispatch a minimal-replace `ChangeSet`, so the user's caret survives
    // updates that don't touch the position they're editing at.
    //
    // `seedMarkdownRef` is updated on every successful diff-apply so a later
    // no-op-guard commit on unmount/revision-change still works correctly
    // (the "seed" for that revision is logically the most-recent live doc,
    // not the doc we mounted with).
    (0, $42omo.useEffect)(()=>{
        if (liveAdfDoc === undefined) return;
        const schema = schemaRef.current;
        const serializeFileMedia = serializeFileMediaRef.current;
        const view = viewRef.current;
        if (!view) return;
        let nextMarkdown;
        try {
            const result = (0, $4a459e9a38530e96$export$3768801c4ab752e6)(liveAdfDoc, schema, {
                serializeFileMedia: serializeFileMedia
            });
            nextMarkdown = result.markdown;
        } catch (err) {
            // Live doc contains a node that the markdown serialiser can't
            // represent. Don't blow away the user's buffer — just skip.
            // eslint-disable-next-line no-console
            console.warn('[MarkdownSourceView] Failed to convert live ADF doc to markdown; skipping live update.', err);
            return;
        }
        const currentBuffer = view.state.doc.toString();
        if (nextMarkdown === currentBuffer) {
            // Echo from our own writeback (or no-op live update). Update the
            // seed reference so the no-op guard on the next commit reflects
            // the latest agreed-on text.
            seedMarkdownRef.current = nextMarkdown;
            return;
        } // EDITOR-6558 Option C — "source markdown is canonical".
        //
        // The user is typing in CodeMirror. Their buffer is THE truth. The
        // `liveAdfDoc` we just received may be semantically equal to what
        // the user typed but disagree on the markdown surface form (e.g.
        // `*ital` vs `\*ital` after the round-trip escape, or trailing
        // space → `&#x20;`). In those cases we must skip the diff-apply.
        //
        // Comparison strategy: re-serialise BOTH sides via `adfToMarkdown`
        // and compare the markdown strings. Reasoning:
        //  - JSON.stringify identity fails when plugins assign attrs like
        //    `localId` to the live doc that aren't in the parsed buffer.
        //  - `Node.eq` (with `schema.nodeFromJSON(liveAdfDoc)`) ALSO fails
        //    for the same reason — Node.eq is attr-strict.
        //  - Re-serialising both sides via the same pipeline drops
        //    non-semantic attrs (the markdown serialiser doesn't include
        //    `localId`), so byte-equal markdown ⇒ semantically equivalent
        //    docs. This is the same approach the integration test bed
        //    proved correct.
        try {
            const currentBufferAsAdf = (0, $4a459e9a38530e96$export$aa0067ded6a6b28d)(currentBuffer, schema);
            const { markdown: bufferAsMarkdown } = (0, $4a459e9a38530e96$export$3768801c4ab752e6)(currentBufferAsAdf, schema, {
                serializeFileMedia: serializeFileMedia
            });
            if (bufferAsMarkdown === nextMarkdown) // Don't bump seedMarkdownRef here — the user's buffer is the
            // authoritative seed for the no-op-commit guard. If they
            // switch back to wysiwyg without further edits, the commit
            // will correctly fire because their buffer differs from the
            // markdown we seeded with at mount.
            return;
        } catch (err) {
        // (e.g. unbalanced syntax). Fall through to the diff-apply
        // path below.
        }
        const changes = (0, $ce2afba5a872a11f$export$e291136b00c395d)(seedMarkdownRef.current, currentBuffer, nextMarkdown);
        if (!changes) {
            // Overlap with user's typing — defer until next postWritebackAdfDoc.
            pendingLiveMarkdownRef.current = nextMarkdown;
            return;
        }
        if (changes.length > 0) {
            // Suppress the user-edit listener for this programmatic dispatch —
            // CM6 update listeners run synchronously inside `view.dispatch`, so
            // it's safe to clear immediately after.
            suppressSourceChangeRef.current = true;
            try {
                view.dispatch({
                    changes: changes
                });
            } finally{
                suppressSourceChangeRef.current = false;
            }
        }
        seedMarkdownRef.current = nextMarkdown;
        pendingLiveMarkdownRef.current = null;
    }, [
        liveAdfDoc,
        schemaRef,
        serializeFileMediaRef
    ]);
    // Re-seed CM6 from the post-rebase PM doc the orchestrator pushed after
    // its own-writeback. Any deferred overlapping liveAdfDoc is already in PM
    // and is discarded.
    (0, $42omo.useEffect)(()=>{
        if (postWritebackAdfDoc === undefined) return;
        const view = viewRef.current;
        if (!view) return;
        const schema = schemaRef.current;
        let nextMarkdown;
        try {
            nextMarkdown = (0, $4a459e9a38530e96$export$3768801c4ab752e6)(postWritebackAdfDoc, schema, {
                serializeFileMedia: serializeFileMediaRef.current
            }).markdown;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('[MarkdownSourceView] Failed to serialise post-writeback ADF; skipping re-seed.', err);
            return;
        }
        const currentBuffer = view.state.doc.toString(); // Minimal-replace via diffHunks instead of a full-buffer overwrite, so the
        // cursor stays put when it's outside any rebased remote hunk. Only the
        // rebased-flush case (post-rebase PM differs from buffer) actually dispatches.
        const hunks = (0, $ce2afba5a872a11f$export$294aa3c46d6af4a5)(currentBuffer, nextMarkdown);
        if (hunks.length > 0) {
            suppressSourceChangeRef.current = true;
            try {
                view.dispatch({
                    changes: hunks
                });
            } finally{
                suppressSourceChangeRef.current = false;
            }
        }
        seedMarkdownRef.current = nextMarkdown;
        pendingLiveMarkdownRef.current = null;
    }, [
        postWritebackAdfDoc,
        schemaRef,
        serializeFileMediaRef
    ]);
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "markdown-source-view",
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4t3i1osq _p12f8stt _ahbq1wug _12l21wug _1bsb1osq"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        ref: hostRef,
        "data-testid": "markdown-source-view--codemirror",
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _19itglyw _2rko1mok _1reo1wug _18m91wug _1e0c1txw _1tke1mjv _bfhk1j9a _1bsb1osq _4t3i1osq _12zu1r31 _bx0sglyw _1p891o36"
        ])
    }));
};


const $6eb5d9f28b495ad0$var$EMPTY_ADF_DOC = {
    type: 'doc',
    version: 1,
    content: []
};
const $6eb5d9f28b495ad0$export$b761619be3df29f = ({ api: api, editorView: editorView, config: config, currentView: currentView })=>{
    if (!config.isMarkdownMode) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6eb5d9f28b495ad0$var$MarkdownModeOrchestrator, {
        api: api,
        markdownView: currentView,
        editorView: editorView,
        config: config
    });
};
const $6eb5d9f28b495ad0$var$MarkdownModeOrchestrator = ({ api: api, markdownView: markdownView, editorView: editorView, config: config })=>{
    // ---------------------------------------------------------------
    // State
    // ---------------------------------------------------------------
    const [adfDoc, setAdfDoc] = (0, $42omo.useState)($6eb5d9f28b495ad0$var$EMPTY_ADF_DOC);
    const [snapshotRevision, setSnapshotRevision] = (0, $42omo.useState)(0);
    const [liveAdfDoc, setLiveAdfDoc] = (0, $42omo.useState)(undefined);
    // Snapshot markdown, pre-computed once under platform_editor_md_source_sync_snapshot.
    // `undefined` = not pre-computed; the source view converts on mount instead.
    const [seedMarkdown, setSeedMarkdown] = (0, $42omo.useState)(undefined);
    const liveDocDebounceRef = (0, $42omo.useRef)(null);
    const dispatchTapInstalledRef = (0, $42omo.useRef)(false);
    const pendingWritebackNodeRef = (0, $42omo.useRef)(null);
    // Annotation ranges extracted at snapshot time and updated on live doc changes.
    const [annotationRanges, setAnnotationRanges] = (0, $42omo.useState)([]);
    const lastAnnotationRangesRef = (0, $42omo.useRef)([]);
    // Current CM6-tracked annotation ranges — updated by onAnnotationRangesChange
    // after every debounced user edit in source mode. These reflect the shifted
    // positions after the user inserts or deletes text around annotated spans.
    // Used by handleSourceMarkdownChange and handleMarkdownCommit to re-apply
    // annotation marks correctly (fixes EDITOR-6844).
    const currentAnnotationRangesRef = (0, $42omo.useRef)([]);
    // ---------------------------------------------------------------
    // Snapshot — synchronously read the current doc from PM.
    // ---------------------------------------------------------------
    const snapshotAdf = (0, $42omo.useCallback)(()=>{
        if (!editorView || editorView.isDestroyed) return null;
        return editorView.state.doc.toJSON();
    }, [
        editorView
    ]);
    // Snapshot whenever the user transitions away from preview.
    (0, $42omo.useEffect)(()=>{
        if (markdownView === 'preview') return;
        const snap = snapshotAdf();
        if (snap && snap.type === 'doc') {
            setAdfDoc(snap);
            setSnapshotRevision((r)=>r + 1);
            setLiveAdfDoc(undefined);
            // Convert once here and reuse for both the source-view seed and the
            // annotation ranges (avoids a second conversion in MarkdownSourceView).
            try {
                const schema = editorView.state.schema;
                const pmDoc = editorView.state.doc;
                const { markdown: markdown, annotations: annotations } = (0, $4a459e9a38530e96$export$3768801c4ab752e6)(pmDoc, schema, {
                    serializeFileMedia: config.serializeFileMedia
                });
                if ((0, $dh538.fg)('platform_editor_md_source_sync_snapshot')) setSeedMarkdown(markdown);
                setAnnotationRanges(annotations);
                lastAnnotationRangesRef.current = annotations;
            } catch  {
                // Conversion failed — clear the seed so the source view falls back.
                if ((0, $dh538.fg)('platform_editor_md_source_sync_snapshot')) setSeedMarkdown(undefined);
                setAnnotationRanges([]);
                lastAnnotationRangesRef.current = [];
            }
        }
    }, [
        markdownView,
        snapshotAdf,
        editorView,
        config.serializeFileMedia
    ]);
    // ---------------------------------------------------------------
    // Dispatch tap — push debounced live updates to source/preview.
    // ---------------------------------------------------------------
    (0, $42omo.useEffect)(()=>{
        if (markdownView === 'preview') return;
        if (!editorView || editorView.isDestroyed) return;
        if (dispatchTapInstalledRef.current) return;
        const original = editorView.props.dispatchTransaction;
        const tap = (tr)=>{
            // Always run the original dispatcher first.
            if (original) original.call(editorView, tr);
            else editorView.updateState(editorView.state.apply(tr));
            if (!tr.docChanged) return;
            // Debounce: coalesce rapid keystrokes.
            if (liveDocDebounceRef.current !== null) clearTimeout(liveDocDebounceRef.current);
            liveDocDebounceRef.current = setTimeout(()=>{
                liveDocDebounceRef.current = null;
                if (!editorView || editorView.isDestroyed) return;
                const json = editorView.state.doc.toJSON();
                // Tier 2 echo guard via Node.eq
                if (pendingWritebackNodeRef.current !== null) {
                    if (pendingWritebackNodeRef.current.eq(editorView.state.doc)) {
                        pendingWritebackNodeRef.current = null;
                        return;
                    }
                    pendingWritebackNodeRef.current = null;
                }
                setLiveAdfDoc(json);
            }, 150);
        };
        editorView.setProps({
            dispatchTransaction: tap
        });
        dispatchTapInstalledRef.current = true;
        return ()=>{
            // Clean up debounce timer on unmount.
            if (liveDocDebounceRef.current !== null) {
                clearTimeout(liveDocDebounceRef.current);
                liveDocDebounceRef.current = null;
            }
        };
    }, [
        markdownView,
        editorView
    ]);
    // Clean up debounce on unmount.
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (liveDocDebounceRef.current !== null) {
                clearTimeout(liveDocDebounceRef.current);
                liveDocDebounceRef.current = null;
            }
        };
    }, []);
    // ---------------------------------------------------------------
    // Writeback handlers
    // ---------------------------------------------------------------
    // Stable ref for serializeFileMedia so it can be read inside
    // handleSourceMarkdownChange without adding it as a useCallback dep
    // (which would recreate the callback and re-register the source listener).
    const serializeFileMediaRef = (0, $42omo.useRef)(config.serializeFileMedia);
    serializeFileMediaRef.current = config.serializeFileMedia;
    /**
   * Called when the user clicks an annotation highlight in the CodeMirror
   * source view. Mirrors the click handler in the annotation plugin's
   * inline-comment.ts: checks the annotation is unresolved, then dispatches
   * setSelectedAnnotation (or setPendingSelectedAnnotation when the annotation
   * manager is enabled) on the live ProseMirror editor so that the comment
   * popup / comments panel opens, exactly as in the WYSIWYG view.
   */ const handleAnnotationClick = (0, $42omo.useCallback)((annotationId)=>{
        if (!editorView || editorView.isDestroyed) return;
        // Read annotation plugin state via api.annotation.sharedState — avoids
        // importing internal annotation plugin utilities directly and works
        // correctly with the pre-built dist in the browser dev environment.
        const annotationPluginState = api?.annotation?.sharedState.currentState();
        if (!annotationPluginState) return;
        const { annotations: annotations, isAnnotationManagerEnabled: isAnnotationManagerEnabled } = annotationPluginState;
        // Only react to unresolved annotations (matches WYSIWYG click handler).
        const isUnresolved = annotations && annotations[annotationId] === false;
        if (!isUnresolved) return;
        if (isAnnotationManagerEnabled) api?.annotation?.actions.setPendingSelectedAnnotation(annotationId)(editorView.state, editorView.dispatch);
        else api?.annotation?.actions.setSelectedAnnotation(annotationId)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        api
    ]);
    /**
   * Called by MarkdownSourceView after every debounced user edit with the
   * current CM6-tracked annotation ranges (shifted by document changes).
   * Stores them in currentAnnotationRangesRef for use in handleSourceMarkdownChange
   * and handleMarkdownCommit (fixes EDITOR-6844).
   */ const handleAnnotationRangesChange = (0, $42omo.useCallback)((ranges)=>{
        currentAnnotationRangesRef.current = ranges;
    }, []);
    /**
   * Forwarded to MarkdownSourceView as `onRegisterCommandDispatch`.
   * Called on mount with a stable dispatcher that routes CM6 commands to
   * the live CodeMirror EditorView, and with `null` on unmount.
   * Registers/unregisters the dispatcher on the markdownMode plugin action
   * so toolbar buttons can call `api.markdownMode.actions.dispatchSourceCommand`.
   * Only wired when `platform_editor_markdown_compatible_toolbar` is enabled.
   */ // Stable ref to the CM6 dispatcher — populated when MarkdownSourceView
    // mounts and cleared when it unmounts.
    const sourceDispatchRef = (0, $42omo.useRef)(null);
    const handleRegisterCommandDispatch = (0, $42omo.useCallback)((dispatcher)=>{
        sourceDispatchRef.current = dispatcher;
        api?.markdownMode?.actions.registerSourceCommandDispatch(dispatcher);
        if (dispatcher === null) api?.markdownMode?.actions.setSourceFormatState(null);
    }, [
        api
    ]);
    // Re-register the dispatcher whenever api changes (preset rebuild resets
    // the plugin closure, clearing sourceCommandDispatch to null).
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('platform_editor_markdown_compatible_toolbar')) return;
        if (sourceDispatchRef.current) api?.markdownMode?.actions.registerSourceCommandDispatch(sourceDispatchRef.current);
    }, [
        api
    ]);
    const handleSourceFormatStateChange = (0, $42omo.useCallback)((state)=>{
        api?.markdownMode?.actions.setSourceFormatState(state);
    }, [
        api
    ]);
    /**
   * Called by MarkdownSourceView on every debounced source change (Tier 2).
   * Parses markdown back to ADF and dispatches a replaceWith transaction.
   * Re-applies annotation marks using the current CM6-tracked ranges so
   * inline comments are preserved through source-mode edits (EDITOR-6844).
   */ const handleSourceMarkdownChange = (0, $42omo.useCallback)((markdown)=>{
        if (!editorView || editorView.isDestroyed) return;
        let adfNode;
        try {
            adfNode = (0, $4a459e9a38530e96$export$aa0067ded6a6b28d)(markdown, editorView.state.schema);
        } catch (err) {
            return;
        }
        // Re-apply annotation marks using the current CM6-tracked ranges.
        // currentAnnotationRangesRef is updated by onAnnotationRangesChange
        // (fired from MarkdownSourceView's sourceChangeListener) with positions
        // that have been mapped through the user's edits by CM6's StateField.
        // Without this, markdownToAdf produces a clean doc with no annotation
        // marks, and the replaceWith transaction below strips all inline comments
        // from the live editor (EDITOR-6844).
        if (currentAnnotationRangesRef.current.length > 0) try {
            adfNode = (0, $084c25d885898a33$export$65bdd44f71145a33)(adfNode, markdown, currentAnnotationRangesRef.current);
        } catch  {
        // Non-fatal: if re-application fails, proceed without annotation marks.
        }
        // Skip writeback if semantically equivalent to the current doc.
        //
        // We deliberately do NOT use `adfNode.eq(editorView.state.doc)` here
        // because ProseMirror's `Node.eq` is strict on attrs — nodes created
        // by the markdown parser only carry the attrs the markdown syntax
        // can express (e.g. `url`, `alt`, `type` for media), while the live
        // editor doc carries extra default attrs assigned by the schema or
        // Confluence plugins (`width`, `height`, `__mediaTraceId`, etc.).
        // Those attrs differ even for semantically identical docs, so
        // `Node.eq` returns false and we'd fire a spurious `replaceDocument`
        // transaction that rebuilds media nodes with incomplete attrs —
        // causing them to be stripped or rendered as "Preview unavailable".
        //
        // Instead, round-trip the LIVE doc through the same markdown
        // pipeline and compare the resulting strings. If they're identical,
        // the two docs are semantically equivalent from the markdown
        // perspective and we can safely skip writeback (EDITOR-6636).
        try {
            const { markdown: liveMarkdown } = (0, $4a459e9a38530e96$export$3768801c4ab752e6)(editorView.state.doc, editorView.state.schema, {
                serializeFileMedia: serializeFileMediaRef.current
            });
            if (liveMarkdown === markdown) return;
        } catch (err) {
        // Serialisation failed (e.g. unsupported node in live doc).
        // Fall through to writeback — it's better to attempt a repair
        // than to silently skip a real change.
        }
        try {
            const { state: state } = editorView;
            const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, adfNode.content).setMeta('addToHistory', false).setMeta('replaceDocument', true);
            pendingWritebackNodeRef.current = tr.doc;
            editorView.dispatch(tr);
        } catch (err) {
            pendingWritebackNodeRef.current = null;
        }
    }, [
        editorView
    ]);
    /**
   * Called by MarkdownSourceView on unmount / revision change when the
   * user actually edited the buffer (Tier 0 — batch commit).
   *
   * Re-applies annotation marks (tracked as CM6 decoration ranges) to the
   * parsed PM doc before dispatching — so inline comment anchors are correctly
   * preserved after the user edits the markdown source.
   */ const handleMarkdownCommit = (0, $42omo.useCallback)((finalMarkdown)=>{
        if (!editorView || editorView.isDestroyed) return;
        try {
            const liveSchema = editorView.state.schema;
            let adfNode = (0, $4a459e9a38530e96$export$aa0067ded6a6b28d)(finalMarkdown, liveSchema);
            // Re-apply annotation marks at their (possibly shifted) character
            // positions before writing back to the editor.
            // Use currentAnnotationRangesRef (updated by onAnnotationRangesChange on
            // every debounced edit and on teardown) rather than lastAnnotationRangesRef
            // (which only holds the stale snapshot-time positions — EDITOR-6844).
            const annotationsToApply = currentAnnotationRangesRef.current.length > 0 ? currentAnnotationRangesRef.current : lastAnnotationRangesRef.current;
            if (annotationsToApply.length > 0) try {
                adfNode = (0, $084c25d885898a33$export$65bdd44f71145a33)(adfNode, finalMarkdown, annotationsToApply);
            } catch  {
            // Non-fatal: if re-application fails, commit without annotation marks.
            }
            const { state: state } = editorView;
            const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, adfNode.content).setMeta('addToHistory', false).setMeta('replaceDocument', true);
            editorView.dispatch(tr);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('[MarkdownModeContentComponent] Failed to apply markdown source edits back to the editor; discarding change.', err);
        }
    }, [
        editorView
    ]);
    // ---------------------------------------------------------------
    // Hide the preview-editor ProseMirror DOM whenever the user is NOT in
    // preview view (i.e. they're in syntax or split-view).
    //
    // The platform's `FullPageContentArea` already attempts this via
    // `hideEditorContentAreaProsemirrorStyle`, but that style is gated on
    // `expValEqualsNoExposure('cc-markdown-mode', 'isEnabled', true)` AND
    // on the markdown-mode plugin's PM state being in sync — either of
    // which can fail (e.g. if the experiment value isn't loaded yet, or
    // if the contentComponent's view→PM sync hasn't run on first paint).
    // When that happens both the source CodeMirror AND the underlying
    // WYSIWYG ProseMirror render simultaneously (and any code-block
    // floating toolbar leaks through too).
    //
    // This effect targets the specific `editorView.dom` for this plugin
    // instance so it cannot affect other editors on the page, and
    // restores the original `display` value on cleanup so view→preview
    // transitions immediately re-show the editor.
    //
    // We also blur the editor when leaving preview so floating toolbars
    // (code-block toolbar, table controls, etc.) that follow editor
    // selection don't remain visible over the source view.
    (0, $42omo.useEffect)(()=>{
        if (!editorView || editorView.isDestroyed) return;
        if (markdownView === 'preview') return;
        const dom = editorView.dom;
        const originalDisplay = dom.style.display;
        dom.style.display = 'none';
        // Blur the editor to dismiss selection-anchored floating UI
        // (code-block toolbar, table controls). Guard against blur throwing
        // on a destroyed view.
        try {
            if (editorView.hasFocus()) dom.blur();
        } catch  {
        // no-op
        }
        return ()=>{
            if (!editorView.isDestroyed) dom.style.display = originalDisplay;
        };
    }, [
        markdownView,
        editorView
    ]);
    // ---------------------------------------------------------------
    // Render
    // ---------------------------------------------------------------
    const isPreview = markdownView === 'preview';
    if (isPreview) return null;
    const PreviewComponent = config.previewComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, markdownView === 'syntax' && (snapshotRevision > 0 || !(0, $dh538.fg)('platform_editor_md_source_sync_snapshot')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6584100e45685489$export$eb7c1c6ff6845883), {
        contentId: config.contentId,
        initialAdfDoc: adfDoc,
        seedMarkdown: seedMarkdown,
        schema: editorView.state.schema,
        revision: snapshotRevision,
        liveAdfDoc: liveAdfDoc,
        onSourceMarkdownChange: handleSourceMarkdownChange,
        onMarkdownCommit: handleMarkdownCommit,
        serializeFileMedia: config.serializeFileMedia,
        annotationRanges: annotationRanges,
        onAnnotationRangesChange: handleAnnotationRangesChange,
        onAnnotationClick: handleAnnotationClick,
        onRegisterCommandDispatch: (0, $dh538.fg)('platform_editor_markdown_compatible_toolbar') ? handleRegisterCommandDispatch : undefined,
        onSourceFormatStateChange: (0, $dh538.fg)('platform_editor_markdown_compatible_toolbar') ? handleSourceFormatStateChange : undefined
    }), markdownView === 'split-view' && PreviewComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PreviewComponent, {
        key: `preview-${snapshotRevision}`,
        adfDoc: liveAdfDoc ?? adfDoc
    }));
};


/**
 * MarkdownModeContentComponentDiff — experimental variant of
 * `MarkdownModeContentComponent` that writes source-view edits back to the
 * live ProseMirror doc as surgical `Step`s (via `@atlassian/content-reconciler`) instead of a
 * single full-document `replaceWith`.
 *
 * Selected by the plugin when `platform_editor_md-mode-use-content-reconciler`
 * is enabled. All other behaviour — snapshot, dispatch tap, source/preview
 * rendering, format-state plumbing — matches the legacy component.
 *
 * Differences vs `MarkdownModeContentComponent`:
 *  - `handleSourceMarkdownChange` and `handleMarkdownCommit` call
 *    `applyDiffSteps(editorView, adfNode)` instead of building a
 *    `replaceWith` transaction.
 *  - Annotations are passed to `@atlassian/content-reconciler` as ignored mark types
 *    (`{ ignoreMarkTypes: ['annotation'] }`). The library then:
 *      · doesn't fork prefix/suffix or similarity decisions on annotations,
 *      · inherits annotation marks into Replace/Insert slices from the old
 *        doc, so text edited inside an annotated span keeps the annotation
 *        without an explicit re-paint,
 *      · never emits `AddMark`/`RemoveMark` for annotation marks.
 *    Cross-boundary edits (an edit that spans two annotations, or partially
 *    overlaps one) are still ambiguous — the inheritance rule picks a side.
 *    Snapshot-time annotation ranges are passed to the source view so
 *    highlights render, and `onAnnotationClick` opens the comment popup.
 *  - Collab-safe. Steps are diffed against `seedPmDocRef` and rebased
 *    through `interveningMappingRef` (non-own txs since the seed). Both
 *    refs reset on snapshot and after every successful writeback.
 */ 



var $aXG5V = parcelRequire("aXG5V");




/**
 * Diff `seedDoc` → `newAdfNode` via `@atlassian/content-reconciler` and
 * dispatch the resulting Steps as one `addToHistory: false` tx. Each Step
 * is rebased through `interveningMapping` (non-own txs since the seed)
 * before dispatch, making the writeback safe to interleave with remote
 * collab steps. The tx carries `OWN_WRITEBACK_META` so the orchestrator's
 * dispatch tap can echo-filter it synchronously.
 */ 











function $0434f36357333af3$export$c04a05f66108dc98(content) {
    const out = [];
    let acc = null;
    for(let i = 0; i < content.childCount; i++){
        const child = content.child(i);
        if (child.isText && child.text !== undefined) {
            const text = child.text;
            if (acc === null) acc = {
                kind: 'textRun',
                text: text,
                spans: [
                    {
                        start: 0,
                        end: text.length,
                        marks: child.marks
                    }
                ]
            };
            else {
                const start = acc.text.length;
                acc.text += text;
                acc.spans.push({
                    start: start,
                    end: acc.text.length,
                    marks: child.marks
                });
            }
        } else {
            if (acc) {
                out.push(acc);
                acc = null;
            }
            out.push({
                kind: 'node',
                node: child
            });
        }
    }
    if (acc) out.push(acc);
    return out;
}
function $0434f36357333af3$export$865f3f3e3ebbacd6(run, from, to, mkText, extraMarks = []) {
    if (from >= to) return [];
    const out = [];
    let pos = from;
    while(pos < to){
        const span = $0434f36357333af3$var$spanCovering(run.spans, pos);
        const segEnd = Math.min(span?.end ?? to, to);
        const segText = run.text.slice(pos, segEnd);
        if (segText.length > 0) {
            const baseMarks = span?.marks ?? [];
            const marks = extraMarks.length === 0 ? baseMarks : $0434f36357333af3$var$mergeMarks(baseMarks, extraMarks);
            out.push(mkText(segText, marks));
        }
        pos = segEnd;
    }
    return out;
}
function $0434f36357333af3$export$772de15c541bba1a(run, pos, keep) {
    if (keep.size === 0) return [];
    const span = $0434f36357333af3$var$spanCovering(run.spans, pos);
    if (!span) return [];
    return span.marks.filter((m)=>keep.has(m.type.name));
}
function $0434f36357333af3$var$mergeMarks(a, b) {
    const out = [
        ...a
    ];
    for (const m of b)if (!out.some((existing)=>existing.eq(m))) out.push(m);
    return out;
}
function $0434f36357333af3$var$spanCovering(spans, pos) {
    // Linear scan is fine for the typical case (one or two text runs per paragraph).
    // Switch to binary search if benchmarks show this matters.
    for (const s of spans){
        if (pos >= s.start && pos < s.end) return s;
    }
    return null;
}



/**
 * Hirschberg's LCS algorithm: O(m*n) time, O(min(m,n)) space.
 * Returns matching index pairs (i in xs, j in ys).
 *
 * Ported from `core/lcs/Hirschberg.kt` in adf-content-reconciler.
 *
 * `maxRegions` is a safety cutoff: if the LCS would produce more than this many
 * distinct match runs (heuristically: the number of returned pairs is an upper
 * bound on the number of regions), we bail out and return `null` so the caller
 * can fall back to emitting a single Replace over the whole range. This protects
 * against pathological diffs on large inputs where surgical steps offer no real
 * benefit.
 */ function $98b3290a43041347$export$99056b812f67789a(xs, ys, equal, maxRegions = 0) {
    return $98b3290a43041347$var$hirschbergView(xs, 0, xs.length, ys, 0, ys.length, equal, maxRegions);
}
function $98b3290a43041347$var$hirschbergView(xs, xLo, xHi, ys, yLo, yHi, equal, maxRegions) {
    const xLen = xHi - xLo;
    const yLen = yHi - yLo;
    if (xLen === 0 || yLen === 0) return [];
    if (xLen === 1) {
        for(let j = 0; j < yLen; j++){
            if (equal(xs[xLo], ys[yLo + j])) return [
                [
                    xLo,
                    yLo + j
                ]
            ];
        }
        return [];
    }
    if (yLen === 1) {
        for(let i = 0; i < xLen; i++){
            if (equal(xs[xLo + i], ys[yLo])) return [
                [
                    xLo + i,
                    yLo
                ]
            ];
        }
        return [];
    }
    const midX = xLo + (xLen >> 1);
    const l1 = $98b3290a43041347$var$lcsRow(xs, xLo, midX, ys, yLo, yHi, equal, /*reverse*/ false);
    const l2 = $98b3290a43041347$var$lcsRow(xs, midX, xHi, ys, yLo, yHi, equal, /*reverse*/ true);
    // Find optimal split point in Y (relative offset into ys[yLo..yHi]).
    let bestK = 0;
    let bestSum = -1;
    for(let k = 0; k <= yLen; k++){
        const sum = l1[k] + l2[k];
        if (sum > bestSum) {
            bestSum = sum;
            bestK = k;
        }
    }
    const split = yLo + bestK;
    const left = $98b3290a43041347$var$hirschbergView(xs, xLo, midX, ys, yLo, split, equal, maxRegions);
    if (left === null) return null;
    if (maxRegions > 0 && left.length > maxRegions) return null;
    const right = $98b3290a43041347$var$hirschbergView(xs, midX, xHi, ys, split, yHi, equal, maxRegions);
    if (right === null) return null;
    if (maxRegions > 0 && left.length + right.length > maxRegions) return null;
    // Indices in `right` are already absolute (we passed absolute xs/ys plus bounds).
    return left.concat(right);
}
/**
 * One row of the LCS DP. When `reverse` is true, iterates from the high end
 * backwards, which produces the suffix-LCS lengths needed by the Hirschberg split.
 */ function $98b3290a43041347$var$lcsRow(xs, xLo, xHi, ys, yLo, yHi, equal, reverse) {
    const yLen = yHi - yLo;
    const dp = new Array(yLen + 1).fill(0);
    const xStart = reverse ? xHi - 1 : xLo;
    const xEnd = reverse ? xLo - 1 : xHi;
    const xStep = reverse ? -1 : 1;
    for(let i = xStart; i !== xEnd; i += xStep){
        let prev = 0;
        const yStart = reverse ? yLen - 1 : 0;
        const yEnd = reverse ? -1 : yLen;
        const yStep = reverse ? -1 : 1;
        for(let j = yStart; j !== yEnd; j += yStep){
            // Forward: dp[j+1] = match? prev+1 : max(dp[j+1], dp[j])
            // Reverse: dp[j]   = match? prev+1 : max(dp[j],   dp[j+1])
            const cur = reverse ? j : j + 1;
            const other = reverse ? j + 1 : j;
            const temp = dp[cur];
            dp[cur] = equal(xs[i], ys[yLo + j]) ? prev + 1 : Math.max(dp[cur], dp[other]);
            prev = temp;
        }
    }
    return dp;
}


function $2264f50d340a3ffa$export$268be64a1d1b0703(oldList, newList, emit, similarity = (a, b)=>a === b, maxRegions = 0, strictEqual = similarity) {
    const oldSize = oldList.length;
    const newSize = newList.length;
    // Common prefix
    let prefix = 0;
    while(prefix < Math.min(oldSize, newSize) && strictEqual(oldList[prefix], newList[prefix]))prefix++;
    // Common suffix (only over the part not already consumed by prefix)
    let suffix = 0;
    while(suffix < Math.min(oldSize, newSize) - prefix && strictEqual(oldList[oldSize - 1 - suffix], newList[newSize - 1 - suffix]))suffix++;
    if (prefix > 0) emit({
        kind: 'match',
        oldIndex: 0,
        newIndex: 0,
        length: prefix
    });
    if (suffix > 0) emit({
        kind: 'match',
        oldIndex: oldSize - suffix,
        newIndex: newSize - suffix,
        length: suffix
    });
    if (prefix === oldSize && prefix === newSize) return;
    const oldMidLo = prefix;
    const oldMidHi = oldSize - suffix;
    const newMidLo = prefix;
    const newMidHi = newSize - suffix;
    const oldMid = oldList.slice(oldMidLo, oldMidHi);
    const newMid = newList.slice(newMidLo, newMidHi);
    // Phase 1: lock strict-equal pairs as anchors.
    // If `strictEqual` is the same function reference as `similarity` (the
    // default), the anchor pass is degenerate with the LCS pass below; skip it.
    const anchors = strictEqual === similarity ? [] : (0, $98b3290a43041347$export$99056b812f67789a)(oldMid, newMid, strictEqual, 0) ?? [];
    // Phase 2: run same-type LCS inside each gap between anchors.
    // The result `lcsRelative` is the union of all anchor pairs and gap LCS
    // pairs, in increasing order, in coords relative to oldMid / newMid.
    let lcsRelative = [];
    let lastOldEnd = 0;
    let lastNewEnd = 0;
    const runGap = (oldLo, oldHi, newLo, newHi)=>{
        if (lcsRelative === null) return;
        if (oldHi - oldLo === 0 || newHi - newLo === 0) return;
        const gapPairs = (0, $98b3290a43041347$export$99056b812f67789a)(oldMid.slice(oldLo, oldHi), newMid.slice(newLo, newHi), similarity, maxRegions);
        if (gapPairs === null) {
            lcsRelative = null;
            return;
        }
        for (const [i, j] of gapPairs)lcsRelative.push([
            oldLo + i,
            newLo + j
        ]);
    };
    for (const [aOld, aNew] of anchors){
        runGap(lastOldEnd, aOld, lastNewEnd, aNew);
        if (lcsRelative === null) break;
        lcsRelative.push([
            aOld,
            aNew
        ]);
        lastOldEnd = aOld + 1;
        lastNewEnd = aNew + 1;
    }
    if (lcsRelative !== null) runGap(lastOldEnd, oldMid.length, lastNewEnd, newMid.length);
    // LCS aborted (too many regions in some gap) → collapse to a single replace
    // over the entire middle. Anchors are discarded here on purpose: once we've
    // decided to fall back to wholesale replace, partial anchoring would emit a
    // weird mix of small matches plus a giant replace around them.
    if (lcsRelative === null) {
        emit({
            kind: 'replace',
            replaceFrom: oldMidLo,
            replaceTo: oldMidHi,
            from: newMidLo,
            to: newMidHi
        });
        return;
    }
    // Adjust LCS pairs back to absolute indices.
    const lcs = lcsRelative.map(([i, j])=>[
            i + prefix,
            j + prefix
        ]);
    if (lcs.length === 0) {
        // No matches in the middle - one of insert/delete/replace
        if (oldMidHi - oldMidLo === 0) emit({
            kind: 'insert',
            insertAt: oldMidHi,
            from: newMidLo,
            to: newMidHi
        });
        else if (newMidHi - newMidLo === 0) emit({
            kind: 'delete',
            from: oldMidLo,
            to: oldMidHi
        });
        else emit({
            kind: 'replace',
            replaceFrom: oldMidLo,
            replaceTo: oldMidHi,
            from: newMidLo,
            to: newMidHi
        });
        return;
    }
    // Walk old/new in tandem, emitting Match/Insert/Delete runs based on LCS pairs.
    let oldIdx = prefix;
    let newIdx = prefix;
    let lcsIdx = 0;
    const matched = ()=>lcsIdx < lcs.length && oldIdx === lcs[lcsIdx][0] && newIdx === lcs[lcsIdx][1];
    const shouldInsert = ()=>{
        if (newIdx >= newSize) return false;
        if (lcsIdx < lcs.length) return newIdx < lcs[lcsIdx][1];
        return newSize - newIdx > oldSize - oldIdx;
    };
    const shouldDelete = ()=>{
        if (oldIdx >= oldSize) return false;
        if (lcsIdx < lcs.length) return oldIdx < lcs[lcsIdx][0];
        return oldSize - oldIdx > newSize - newIdx;
    };
    while(oldIdx + suffix < oldSize || newIdx + suffix < newSize){
        if (matched()) {
            const oldStart = oldIdx;
            const newStart = newIdx;
            let len = 0;
            do {
                oldIdx++;
                newIdx++;
                lcsIdx++;
                len++;
            }while (matched());
            emit({
                kind: 'match',
                oldIndex: oldStart,
                newIndex: newStart,
                length: len
            });
        } else if (shouldInsert()) {
            const start = newIdx;
            do newIdx++;
            while (shouldInsert());
            emit({
                kind: 'insert',
                insertAt: oldIdx,
                from: start,
                to: newIdx
            });
        } else {
            const start = oldIdx;
            do oldIdx++;
            while (shouldDelete());
            emit({
                kind: 'delete',
                from: start,
                to: oldIdx
            });
        }
    }
}








function $c26a9f58a509d806$export$8f0d278bb8862aee(marks, ignore) {
    if (ignore.size === 0) return marks;
    if (!marks.some((m)=>ignore.has(m.type.name))) return marks;
    return marks.filter((m)=>!ignore.has(m.type.name));
}
const $c26a9f58a509d806$export$499e45ef1aa79998 = (v)=>{
    if (v === null || typeof v !== 'object') return JSON.stringify(v) ?? 'null';
    if (Array.isArray(v)) return `[${v.map($c26a9f58a509d806$export$499e45ef1aa79998).join(',')}]`;
    const o = v;
    return `{${Object.keys(o).sort().map((k)=>`${JSON.stringify(k)}:${$c26a9f58a509d806$export$499e45ef1aa79998(o[k])}`).join(',')}}`;
};
function $c26a9f58a509d806$export$88a30e5386bda853(a, b, ignore) {
    if (ignore.size === 0) return a.eq(b);
    if (a.eq(b)) return true; // fast path; covers the common case
    if (a.type !== b.type) return false;
    if (!$c26a9f58a509d806$var$sameMarkSet($c26a9f58a509d806$export$8f0d278bb8862aee(a.marks, ignore), $c26a9f58a509d806$export$8f0d278bb8862aee(b.marks, ignore))) return false;
    // PM attrs are plain JSON values; compare them independent of object key order.
    if ($c26a9f58a509d806$export$499e45ef1aa79998(a.attrs ?? {}) !== $c26a9f58a509d806$export$499e45ef1aa79998(b.attrs ?? {})) return false;
    if (a.isText) return a.text === b.text;
    if (a.type.inlineContent) return $c26a9f58a509d806$var$inlineContentEqIgnoring(a.content, b.content, ignore);
    if (a.childCount !== b.childCount) return false;
    for(let i = 0; i < a.childCount; i++){
        if (!$c26a9f58a509d806$export$88a30e5386bda853(a.child(i), b.child(i), ignore)) return false;
    }
    return true;
}
/**
 * Inline-aware equality: walks two inline-content fragments as a character
 * stream + non-text token stream, applying mark filtering per character. This
 * sidesteps PM's text-node auto-merging differences between the two sides.
 */ function $c26a9f58a509d806$var$inlineContentEqIgnoring(a, b, ignore) {
    const tokens = (frag)=>{
        const out = [];
        for(let i = 0; i < frag.childCount; i++){
            const child = frag.child(i);
            if (child.isText && child.text !== undefined) {
                const marks = $c26a9f58a509d806$export$8f0d278bb8862aee(child.marks, ignore);
                for (const ch of child.text)out.push({
                    kind: 'char',
                    ch: ch,
                    marks: marks
                });
            } else out.push({
                kind: 'node',
                node: child
            });
        }
        return out;
    };
    const at = tokens(a);
    const bt = tokens(b);
    if (at.length !== bt.length) return false;
    for(let i = 0; i < at.length; i++){
        const x = at[i];
        const y = bt[i];
        if (x.kind !== y.kind) return false;
        if (x.kind === 'char' && y.kind === 'char') {
            if (x.ch !== y.ch) return false;
            if (!$c26a9f58a509d806$var$sameMarkSet(x.marks, y.marks)) return false;
        } else if (x.kind === 'node' && y.kind === 'node') {
            if (!$c26a9f58a509d806$export$88a30e5386bda853(x.node, y.node, ignore)) return false;
        }
    }
    return true;
}
function $c26a9f58a509d806$var$sameMarkSet(a, b) {
    if (a.length !== b.length) return false;
    return a.every((m)=>b.some((n)=>n.eq(m)));
}
function $c26a9f58a509d806$export$fbd56eac4544ec5f(a, b, ignore) {
    if (a.type.inlineContent || b.type.inlineContent) return $c26a9f58a509d806$var$inlineContentEqIgnoring(a.content, b.content, ignore);
    if (a.childCount !== b.childCount) return false;
    for(let i = 0; i < a.childCount; i++){
        if (!$c26a9f58a509d806$export$88a30e5386bda853(a.child(i), b.child(i), ignore)) return false;
    }
    return true;
}
const $c26a9f58a509d806$export$51d01ce5f35c1d = (i)=>i.kind === 'textRun';


function $7dcdc2bd62e3dce4$export$6edd5090aa051c73(oldNode, newNode, pos, ctx) {
    if ((0, $c26a9f58a509d806$export$88a30e5386bda853)(oldNode, newNode, ctx.ignoreMarks)) return null;
    // ---------------------------------------------------------------------------
    // Case 1: same content, different shell (type and/or attrs+marks)
    // ---------------------------------------------------------------------------
    // Same type with different attrs is handled by AttrStep elsewhere, so this
    // pattern is meaningful only when the type itself changes.
    if (oldNode.type !== newNode.type && (0, $c26a9f58a509d806$export$fbd56eac4544ec5f)(oldNode, newNode, ctx.ignoreMarks)) return $7dcdc2bd62e3dce4$var$wrapStep(/* from   */ pos, /* to     */ pos + oldNode.nodeSize, /* gapFrom*/ pos + 1, /* gapTo  */ pos + 1 + oldNode.content.size, /* shell  */ newNode.type.create(newNode.attrs, null, newNode.marks), /* insert */ 1);
    // ---------------------------------------------------------------------------
    // Case 2: wrap (newNode has a single child equal to oldNode, modulo ignored marks)
    // ---------------------------------------------------------------------------
    if (newNode.childCount === 1 && (0, $c26a9f58a509d806$export$88a30e5386bda853)(newNode.firstChild, oldNode, ctx.ignoreMarks)) return $7dcdc2bd62e3dce4$var$wrapStep(/* from   */ pos, /* to     */ pos + oldNode.nodeSize, /* gapFrom*/ pos, /* gapTo  */ pos + oldNode.nodeSize, /* shell  */ newNode.type.create(newNode.attrs, null, newNode.marks), /* insert */ 1);
    // ---------------------------------------------------------------------------
    // Case 3: unwrap (oldNode has a single child equal to newNode, modulo ignored marks)
    // ---------------------------------------------------------------------------
    if (oldNode.childCount === 1 && (0, $c26a9f58a509d806$export$88a30e5386bda853)(oldNode.firstChild, newNode, ctx.ignoreMarks)) return new (0, $aXG5V.ReplaceAroundStep)(pos, pos + oldNode.nodeSize, pos + 1, pos + 1 + newNode.nodeSize, (0, $5SAOw.Slice).empty, 0, /* structure */ true);
    return null;
}
function $7dcdc2bd62e3dce4$var$wrapStep(from, to, gapFrom, gapTo, shell, insert) {
    return new (0, $aXG5V.ReplaceAroundStep)(from, to, gapFrom, gapTo, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(shell), 0, 0), insert, /* structure */ true);
}











const $989a191b95797c3f$var$markKey = (m)=>`${m.type.name}:${(0, $c26a9f58a509d806$export$499e45ef1aa79998)(m.attrs ?? {})}`;
const $989a191b95797c3f$export$9171f3c03db619a = (a, b)=>{
    if (a.length !== b.length) return false;
    const bKeys = new Set(b.map($989a191b95797c3f$var$markKey));
    return a.every((m)=>bKeys.has($989a191b95797c3f$var$markKey(m)));
};
/**
 * Returns marks present in `as` but not in `bs` (by type + attrs).
 */ function $989a191b95797c3f$var$subtractMarks(as, bs) {
    const bKeys = new Set(bs.map($989a191b95797c3f$var$markKey));
    return as.filter((m)=>!bKeys.has($989a191b95797c3f$var$markKey(m)));
}
function $989a191b95797c3f$export$95843026304694ba(oldSpans, newSpans) {
    const events = [];
    for (const s of oldSpans){
        events.push({
            pos: s.start,
            isStart: true,
            fromOld: true,
            marks: s.marks
        });
        events.push({
            pos: s.end,
            isStart: false,
            fromOld: true,
            marks: s.marks
        });
    }
    for (const s of newSpans){
        events.push({
            pos: s.start,
            isStart: true,
            fromOld: false,
            marks: s.marks
        });
        events.push({
            pos: s.end,
            isStart: false,
            fromOld: false,
            marks: s.marks
        });
    }
    // Sort by pos; for equal positions, OLD events first so the new state
    // takes effect for any sub-range starting at that boundary.
    events.sort((a, b)=>a.pos - b.pos || (a.fromOld === b.fromOld ? 0 : a.fromOld ? -1 : 1));
    const deltas = [];
    let curOld = [];
    let curNew = [];
    let last = 0;
    for (const ev of events){
        if (!ev.isStart && last < ev.pos) {
            for (const m of $989a191b95797c3f$var$subtractMarks(curNew, curOld))deltas.push({
                type: 'insert',
                from: last,
                to: ev.pos,
                mark: m
            });
            for (const m of $989a191b95797c3f$var$subtractMarks(curOld, curNew))deltas.push({
                type: 'delete',
                from: last,
                to: ev.pos,
                mark: m
            });
        }
        if (ev.fromOld) curOld = ev.marks;
        else curNew = ev.marks;
        last = ev.pos;
    }
    return deltas;
}
function $989a191b95797c3f$export$8c5998c7a945df3e(spans, from, to) {
    if (from >= to) return [];
    const result = [];
    for (const s of spans){
        if (s.end <= from) continue;
        if (s.start >= to) break;
        result.push({
            start: Math.max(s.start, from),
            end: Math.min(s.end, to),
            marks: s.marks
        });
    }
    return result;
}



function $aa9df9132800d435$export$7f227f8ae15d3928(oldRun, newRun, parentPos, ctx) {
    const schema = ctx.schema;
    const ignore = ctx.ignoreMarks;
    const steps = [];
    if (oldRun.text.length === 0 && newRun.text.length === 0) return [];
    if (oldRun.text.length === 0) {
        const nodes = (0, $0434f36357333af3$export$865f3f3e3ebbacd6)(newRun, 0, newRun.text.length, schema.text.bind(schema));
        steps.push(new (0, $aXG5V.ReplaceStep)(parentPos, parentPos, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(nodes), 0, 0)));
        return steps;
    }
    if (newRun.text.length === 0) {
        steps.push(new (0, $aXG5V.ReplaceStep)(parentPos, parentPos + oldRun.text.length, (0, $5SAOw.Slice).empty));
        return steps;
    }
    (0, $2264f50d340a3ffa$export$268be64a1d1b0703)(Array.from(oldRun.text), Array.from(newRun.text), (op)=>{
        switch(op.kind){
            case 'match':
                {
                    const oldClipped = $aa9df9132800d435$var$filteredClipped(oldRun.spans, op.oldIndex, op.oldIndex + op.length, op.oldIndex, ignore);
                    const newClipped = $aa9df9132800d435$var$filteredClipped(newRun.spans, op.newIndex, op.newIndex + op.length, op.newIndex, ignore);
                    for (const d of (0, $989a191b95797c3f$export$95843026304694ba)(oldClipped, newClipped)){
                        const from = parentPos + op.oldIndex + d.from;
                        const to = parentPos + op.oldIndex + d.to;
                        steps.push(d.type === 'insert' ? new (0, $aXG5V.AddMarkStep)(from, to, d.mark) : new (0, $aXG5V.RemoveMarkStep)(from, to, d.mark));
                    }
                    return;
                }
            case 'insert':
                {
                    const insertPos = parentPos + op.insertAt;
                    // Inherit ignored marks from the char just before the insertion point
                    // (or position 0 if we're at the start of the run).
                    const inheritFrom = Math.max(0, op.insertAt - 1);
                    const inherited = (0, $0434f36357333af3$export$772de15c541bba1a)(oldRun, inheritFrom, ignore);
                    const nodes = (0, $0434f36357333af3$export$865f3f3e3ebbacd6)(newRun, op.from, op.to, schema.text.bind(schema), inherited);
                    steps.push(new (0, $aXG5V.ReplaceStep)(insertPos, insertPos, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(nodes), 0, 0)));
                    return;
                }
            case 'delete':
                steps.push(new (0, $aXG5V.ReplaceStep)(parentPos + op.from, parentPos + op.to, (0, $5SAOw.Slice).empty));
                return;
            case 'replace':
                {
                    // Inherit ignored marks from the start of the replaced range.
                    // (Crossing an annotation boundary mid-range is an inherent
                    // ambiguity; the start-position rule keeps the typical "edit text
                    // inside one annotation" case correct.)
                    const inherited = (0, $0434f36357333af3$export$772de15c541bba1a)(oldRun, op.replaceFrom, ignore);
                    const nodes = (0, $0434f36357333af3$export$865f3f3e3ebbacd6)(newRun, op.from, op.to, schema.text.bind(schema), inherited);
                    steps.push(new (0, $aXG5V.ReplaceStep)(parentPos + op.replaceFrom, parentPos + op.replaceTo, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(nodes), 0, 0)));
                    return;
                }
        }
    }, (a, b)=>a === b, ctx.maxTextRegions);
    return steps;
}
/**
 * Clips spans to `[from, to)`, normalises them to range-local coordinates
 * (subtracting `origin`), and strips marks whose type is in `ignore`. Used by
 * the Match handler so mark-delta computation runs on the visible mark set
 * only.
 */ function $aa9df9132800d435$var$filteredClipped(spans, from, to, origin, ignore) {
    return (0, $989a191b95797c3f$export$8c5998c7a945df3e)(spans, from, to).map((s)=>({
            start: s.start - origin,
            end: s.end - origin,
            marks: (0, $c26a9f58a509d806$export$8f0d278bb8862aee)(s.marks, ignore)
        }));
}



const $243ee249cede0db4$var$MAX_CONTENT_REGIONS = 200;
function $243ee249cede0db4$export$b02b9ec391dbf2d0(oldContent, newContent, parentPos, ctx) {
    const oldKids = [];
    for(let i = 0; i < oldContent.childCount; i++)oldKids.push(oldContent.child(i));
    const newKids = [];
    for(let i = 0; i < newContent.childCount; i++)newKids.push(newContent.child(i));
    const positions = $243ee249cede0db4$var$childPositions(parentPos, oldKids);
    const steps = [];
    (0, $2264f50d340a3ffa$export$268be64a1d1b0703)(oldKids, newKids, (op)=>{
        switch(op.kind){
            case 'match':
                {
                    let childPos = positions[op.oldIndex];
                    for(let i = 0; i < op.length; i++){
                        steps.push(...(0, $dbd4acf6a178c667$export$f8dfe7066e572f15)(oldKids[op.oldIndex + i], newKids[op.newIndex + i], childPos, ctx));
                        childPos += oldKids[op.oldIndex + i].nodeSize;
                    }
                    return;
                }
            case 'insert':
                {
                    const insertPos = positions[op.insertAt];
                    const slice = $243ee249cede0db4$var$blockSlice(newKids.slice(op.from, op.to));
                    // structure=true on Insert is safe (the range is empty) and gives
                    // better rebase semantics: a concurrent insert at the same position
                    // won't be silently clobbered.
                    steps.push(new (0, $aXG5V.ReplaceStep)(insertPos, insertPos, slice, true));
                    return;
                }
            case 'delete':
                steps.push(new (0, $aXG5V.ReplaceStep)(positions[op.from], positions[op.to], (0, $5SAOw.Slice).empty));
                return;
            case 'replace':
                {
                    // Single-node-to-single-node Replace ops are the only shape where a
                    // structural ReplaceAround can apply (type change preserving content,
                    // wrap, or unwrap). Try that first; fall back to a wholesale
                    // ReplaceStep for anything more complex.
                    if (op.replaceTo - op.replaceFrom === 1 && op.to - op.from === 1) {
                        const around = (0, $7dcdc2bd62e3dce4$export$6edd5090aa051c73)(oldKids[op.replaceFrom], newKids[op.from], positions[op.replaceFrom], ctx);
                        if (around) {
                            steps.push(around);
                            return;
                        }
                    }
                    const slice = $243ee249cede0db4$var$blockSlice(newKids.slice(op.from, op.to));
                    steps.push(new (0, $aXG5V.ReplaceStep)(positions[op.replaceFrom], positions[op.replaceTo], slice));
                    return;
                }
        }
    }, $243ee249cede0db4$var$nodesMatchable, $243ee249cede0db4$var$MAX_CONTENT_REGIONS, (a, b)=>(0, $c26a9f58a509d806$export$88a30e5386bda853)(a, b, ctx.ignoreMarks));
    return steps;
}
function $243ee249cede0db4$export$c0c809a65b2f72dc(oldContent, newContent, parentPos, ctx) {
    const oldItems = (0, $0434f36357333af3$export$c04a05f66108dc98)(oldContent);
    const newItems = (0, $0434f36357333af3$export$c04a05f66108dc98)(newContent);
    const positions = $243ee249cede0db4$var$inlineChildPositions(parentPos, oldItems);
    const steps = [];
    (0, $2264f50d340a3ffa$export$268be64a1d1b0703)(oldItems, newItems, (op)=>{
        switch(op.kind){
            case 'match':
                {
                    let childPos = positions[op.oldIndex];
                    for(let i = 0; i < op.length; i++){
                        const a = oldItems[op.oldIndex + i];
                        const b = newItems[op.newIndex + i];
                        if ((0, $c26a9f58a509d806$export$51d01ce5f35c1d)(a) && (0, $c26a9f58a509d806$export$51d01ce5f35c1d)(b)) {
                            steps.push(...$243ee249cede0db4$var$diffTextRunPair(a, b, childPos, ctx));
                            childPos += a.text.length;
                        } else if (!(0, $c26a9f58a509d806$export$51d01ce5f35c1d)(a) && !(0, $c26a9f58a509d806$export$51d01ce5f35c1d)(b)) {
                            steps.push(...(0, $dbd4acf6a178c667$export$f8dfe7066e572f15)(a.node, b.node, childPos, ctx));
                            childPos += a.node.nodeSize;
                        } else // Shouldn't happen if `nodesMatchable` worked correctly.
                        throw new Error('inline match between textRun and non-text node');
                    }
                    return;
                }
            case 'insert':
                {
                    const insertPos = positions[op.insertAt];
                    const nodes = $243ee249cede0db4$var$inlineNodesFromItems(newItems.slice(op.from, op.to), ctx);
                    steps.push(new (0, $aXG5V.ReplaceStep)(insertPos, insertPos, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(nodes), 0, 0)));
                    return;
                }
            case 'delete':
                steps.push(new (0, $aXG5V.ReplaceStep)(positions[op.from], positions[op.to], (0, $5SAOw.Slice).empty));
                return;
            case 'replace':
                {
                    const nodes = $243ee249cede0db4$var$inlineNodesFromItems(newItems.slice(op.from, op.to), ctx);
                    steps.push(new (0, $aXG5V.ReplaceStep)(positions[op.replaceFrom], positions[op.replaceTo], new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(nodes), 0, 0)));
                    return;
                }
        }
    }, $243ee249cede0db4$var$inlineItemsMatchable, $243ee249cede0db4$var$MAX_CONTENT_REGIONS, (a, b)=>$243ee249cede0db4$var$inlineItemsStrictEq(a, b, ctx.ignoreMarks));
    return steps;
}
/**
 * Strict equality for inline items, ignoring marks of types in `ignore`. Used
 * by the inline prefix/suffix strip so a TextRun that differs only in ignored
 * marks (e.g. an annotation present in pmBase but absent in pmNew) gets
 * stripped cheaply instead of going through the LCS path.
 */ function $243ee249cede0db4$var$inlineItemsStrictEq(a, b, ignore) {
    if ((0, $c26a9f58a509d806$export$51d01ce5f35c1d)(a) && (0, $c26a9f58a509d806$export$51d01ce5f35c1d)(b)) {
        if (a.text !== b.text) return false;
        // Per-character mark equality on the filtered mark sets. Span boundaries
        // can differ between sides without that being a real difference, so we
        // compare position-by-position rather than span-by-span.
        let ai = 0;
        let bi = 0;
        for(let p = 0; p < a.text.length; p++){
            while(ai < a.spans.length && a.spans[ai].end <= p)ai++;
            while(bi < b.spans.length && b.spans[bi].end <= p)bi++;
            const aMarks = ai < a.spans.length ? (0, $c26a9f58a509d806$export$8f0d278bb8862aee)(a.spans[ai].marks, ignore) : [];
            const bMarks = bi < b.spans.length ? (0, $c26a9f58a509d806$export$8f0d278bb8862aee)(b.spans[bi].marks, ignore) : [];
            if (aMarks.length !== bMarks.length) return false;
            if (!aMarks.every((m)=>bMarks.some((n)=>n.eq(m)))) return false;
        }
        return true;
    }
    if (!(0, $c26a9f58a509d806$export$51d01ce5f35c1d)(a) && !(0, $c26a9f58a509d806$export$51d01ce5f35c1d)(b)) return a.node.eq(b.node);
    return false;
}
function $243ee249cede0db4$var$diffTextRunPair(a, b, pos, ctx) {
    return (0, $aa9df9132800d435$export$7f227f8ae15d3928)(a, b, pos, ctx);
}
function $243ee249cede0db4$var$inlineNodesFromItems(items, ctx) {
    const schema = ctx.schema;
    const out = [];
    for (const it of items)if ((0, $c26a9f58a509d806$export$51d01ce5f35c1d)(it)) out.push(...(0, $0434f36357333af3$export$865f3f3e3ebbacd6)(it, 0, it.text.length, schema.text.bind(schema)));
    else out.push(it.node);
    return out;
}
function $243ee249cede0db4$var$blockSlice(nodes) {
    return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(nodes), 0, 0);
}
/**
 * "Similar enough to be a match candidate" for the block-level LCS:
 * - both nodes share the same type (attrs may differ; handled in recursion)
 * - text equality lives inside the inline path, not here
 */ function $243ee249cede0db4$var$nodesMatchable(a, b) {
    return a.type === b.type;
}
function $243ee249cede0db4$var$inlineItemsMatchable(a, b) {
    if ((0, $c26a9f58a509d806$export$51d01ce5f35c1d)(a) && (0, $c26a9f58a509d806$export$51d01ce5f35c1d)(b)) return true;
    if (!(0, $c26a9f58a509d806$export$51d01ce5f35c1d)(a) && !(0, $c26a9f58a509d806$export$51d01ce5f35c1d)(b)) return a.node.type === b.node.type;
    return false;
}
function $243ee249cede0db4$var$childPositions(parentPos, kids) {
    const out = new Array(kids.length + 1);
    out[0] = parentPos + 1;
    for(let i = 0; i < kids.length; i++)out[i + 1] = out[i] + kids[i].nodeSize;
    return out;
}
function $243ee249cede0db4$var$inlineChildPositions(parentPos, items) {
    const out = new Array(items.length + 1);
    out[0] = parentPos + 1;
    for(let i = 0; i < items.length; i++){
        const size = (0, $c26a9f58a509d806$export$51d01ce5f35c1d)(items[i]) ? items[i].text.length : items[i].node.nodeSize;
        out[i + 1] = out[i] + size;
    }
    return out;
}




function $dbd4acf6a178c667$export$f8dfe7066e572f15(oldNode, newNode, pos, ctx) {
    if ((0, $c26a9f58a509d806$export$88a30e5386bda853)(oldNode, newNode, ctx.ignoreMarks)) return [];
    // Text vs text: handled by the inline diff path normally, but if we get here
    // (e.g. a doc whose top-level child IS a text node, unusual but possible in
    // custom schemas) just produce a Replace.
    if (oldNode.isText && newNode.isText) {
        if (oldNode.text === newNode.text) // Same text, different marks - emit mark deltas via add/remove.
        return $dbd4acf6a178c667$var$markDeltaSteps(oldNode.marks, newNode.marks, pos, pos + oldNode.nodeSize, /*isInline*/ true, ctx);
        return [
            new (0, $aXG5V.ReplaceStep)(pos, pos + oldNode.nodeSize, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(newNode), 0, 0))
        ];
    }
    if (oldNode.type !== newNode.type) {
        // Type change → replace the whole node. structure=false because the range
        // contains real content (the old node's body); structure=true would reject.
        if (pos < 0) throw new Error('diffNodes: root doc node type mismatch');
        return [
            new (0, $aXG5V.ReplaceStep)(pos, pos + oldNode.nodeSize, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(newNode), 0, 0))
        ];
    }
    // Same block type. Three orthogonal concerns:
    //   1. attrs   → AttrStep(s) on this node
    //   2. content → recurse (inline vs block path)
    //   3. marks   → AddNodeMark/RemoveNodeMark on this node
    const steps = [];
    if (pos >= 0) steps.push(...$dbd4acf6a178c667$var$attrSteps(oldNode, newNode, pos));
    if (oldNode.type.inlineContent) steps.push(...(0, $243ee249cede0db4$export$c0c809a65b2f72dc)(oldNode.content, newNode.content, pos, ctx));
    else steps.push(...(0, $243ee249cede0db4$export$b02b9ec391dbf2d0)(oldNode.content, newNode.content, pos, ctx));
    if (pos >= 0) steps.push(...$dbd4acf6a178c667$var$nodeMarkDeltaSteps(oldNode.marks, newNode.marks, pos, ctx));
    return steps;
}
function $dbd4acf6a178c667$var$attrSteps(oldNode, newNode, pos) {
    const oldAttrs = oldNode.attrs ?? {};
    const newAttrs = newNode.attrs ?? {};
    const changed = [];
    const keys = new Set([
        ...Object.keys(oldAttrs),
        ...Object.keys(newAttrs)
    ]);
    for (const k of keys)if (!$dbd4acf6a178c667$var$compareDeep(oldAttrs[k], newAttrs[k])) changed.push([
        k,
        newAttrs[k] ?? null
    ]);
    return changed.map(([k, v])=>new (0, $aXG5V.AttrStep)(pos, k, v));
}
// Mirrors prosemirror-model's compareDeep helper used for attribute equality.
function $dbd4acf6a178c667$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a === 'object') || !(b && typeof b === 'object')) return false;
    const isArray = Array.isArray(a);
    if (Array.isArray(b) !== isArray) return false;
    if (isArray) {
        const aArray = a;
        const bArray = b;
        if (aArray.length !== bArray.length) return false;
        for(let i = 0; i < aArray.length; i++){
            if (!$dbd4acf6a178c667$var$compareDeep(aArray[i], bArray[i])) return false;
        }
    } else {
        const aObject = a;
        const bObject = b;
        for(const prop in aObject){
            if (!(prop in bObject) || !$dbd4acf6a178c667$var$compareDeep(aObject[prop], bObject[prop])) return false;
        }
        for(const prop in bObject){
            if (!(prop in aObject)) return false;
        }
    }
    return true;
}
function $dbd4acf6a178c667$var$nodeMarkDeltaSteps(oldMarks, newMarks, pos, ctx) {
    const oldM = (0, $c26a9f58a509d806$export$8f0d278bb8862aee)(oldMarks, ctx.ignoreMarks);
    const newM = (0, $c26a9f58a509d806$export$8f0d278bb8862aee)(newMarks, ctx.ignoreMarks);
    if ((0, $989a191b95797c3f$export$9171f3c03db619a)(oldM, newM)) return [];
    const steps = [];
    for (const m of newM)if (!oldM.some((om)=>om.eq(m))) steps.push(new (0, $aXG5V.AddNodeMarkStep)(pos, m));
    for (const m of oldM)if (!newM.some((nm)=>nm.eq(m))) steps.push(new (0, $aXG5V.RemoveNodeMarkStep)(pos, m));
    return steps;
}
function $dbd4acf6a178c667$var$markDeltaSteps(oldMarks, newMarks, from, to, isInline, ctx) {
    const oldM = (0, $c26a9f58a509d806$export$8f0d278bb8862aee)(oldMarks, ctx.ignoreMarks);
    const newM = (0, $c26a9f58a509d806$export$8f0d278bb8862aee)(newMarks, ctx.ignoreMarks);
    if ((0, $989a191b95797c3f$export$9171f3c03db619a)(oldM, newM)) return [];
    const steps = [];
    for (const m of newM)if (!oldM.some((om)=>om.eq(m))) steps.push(isInline ? new (0, $aXG5V.AddMarkStep)(from, to, m) : new (0, $aXG5V.AddNodeMarkStep)(from, m));
    for (const m of oldM)if (!newM.some((nm)=>nm.eq(m))) steps.push(isInline ? new (0, $aXG5V.RemoveMarkStep)(from, to, m) : new (0, $aXG5V.RemoveNodeMarkStep)(from, m));
    return steps;
}








function $1408d0667a1e7286$var$isStructural(step) {
    return step.structure === true;
}
function $1408d0667a1e7286$export$4a231d1a3b7e81fc(steps) {
    if (steps.length === 0) return [];
    const out = [
        steps[0]
    ];
    for(let i = 1; i < steps.length; i++){
        const next = steps[i];
        const last = out[out.length - 1];
        if (last instanceof (0, $aXG5V.ReplaceStep) && next instanceof (0, $aXG5V.ReplaceStep) && !$1408d0667a1e7286$var$isStructural(last) && !$1408d0667a1e7286$var$isStructural(next) && last.to === next.from && // All four opens must be 0: the merged slice is built `Slice(_, 0, 0)`,
        // so a non-zero open on either side would either misclaim the outer
        // opens or reinterpret an open-at-junction node as complete.
        last.slice.openStart === 0 && last.slice.openEnd === 0 && next.slice.openStart === 0 && next.slice.openEnd === 0) {
            out[out.length - 1] = new (0, $aXG5V.ReplaceStep)(last.from, next.to, $1408d0667a1e7286$var$mergeSlices(last.slice, next.slice));
            continue;
        }
        if (last instanceof (0, $aXG5V.AddMarkStep) && next instanceof (0, $aXG5V.AddMarkStep) && last.mark.eq(next.mark) && last.from <= next.to && last.to >= next.from) {
            out[out.length - 1] = new (0, $aXG5V.AddMarkStep)(Math.min(last.from, next.from), Math.max(last.to, next.to), next.mark);
            continue;
        }
        if (last instanceof (0, $aXG5V.RemoveMarkStep) && next instanceof (0, $aXG5V.RemoveMarkStep) && last.mark.eq(next.mark) && last.from <= next.to && last.to >= next.from) {
            out[out.length - 1] = new (0, $aXG5V.RemoveMarkStep)(Math.min(last.from, next.from), Math.max(last.to, next.to), next.mark);
            continue;
        }
        out.push(next);
    }
    return out;
}
function $1408d0667a1e7286$var$mergeSlices(a, b) {
    const aContent = a.content;
    const bContent = b.content;
    if (aContent.size === 0) return new (0, $5SAOw.Slice)(bContent, 0, 0);
    if (bContent.size === 0) return new (0, $5SAOw.Slice)(aContent, 0, 0);
    const aLast = aContent.child(aContent.childCount - 1);
    const bFirst = bContent.child(0);
    if (aLast.isText && bFirst.isText && $1408d0667a1e7286$var$sameMarkSet(aLast.marks, bFirst.marks)) {
        const merged = aLast.type.schema.text((aLast.text ?? '') + (bFirst.text ?? ''), aLast.marks);
        const aHead = (0, $5SAOw.Fragment).from($1408d0667a1e7286$var$takeAll(aContent, aContent.childCount - 1));
        const bTail = (0, $5SAOw.Fragment).from($1408d0667a1e7286$var$takeAllFrom(bContent, 1));
        return new (0, $5SAOw.Slice)(aHead.append((0, $5SAOw.Fragment).from(merged)).append(bTail), 0, 0);
    }
    return new (0, $5SAOw.Slice)(aContent.append(bContent), 0, 0);
}
function $1408d0667a1e7286$var$sameMarkSet(a, b) {
    if (a.length !== b.length) return false;
    return a.every((m)=>b.some((n)=>n.eq(m)));
}
function $1408d0667a1e7286$var$takeAll(frag, n) {
    const out = [];
    for(let i = 0; i < n; i++)out.push(frag.child(i));
    return out;
}
function $1408d0667a1e7286$var$takeAllFrom(frag, start) {
    const out = [];
    for(let i = start; i < frag.childCount; i++)out.push(frag.child(i));
    return out;
}



const $bfbaa043dadccad3$var$DEFAULT_MAX_TEXT_REGIONS = 10;
function $bfbaa043dadccad3$var$makeContext(schema, opts) {
    return {
        schema: schema,
        ignoreMarks: new Set(opts?.ignoreMarkTypes ?? []),
        maxTextRegions: opts?.maxTextRegions ?? $bfbaa043dadccad3$var$DEFAULT_MAX_TEXT_REGIONS
    };
}
function $bfbaa043dadccad3$export$96d86b1e79ab6058(oldDoc, newDoc, opts) {
    if (oldDoc.type.schema !== newDoc.type.schema) throw new Error('diffNodes: schemas differ between old and new doc');
    const ctx = $bfbaa043dadccad3$var$makeContext(oldDoc.type.schema, opts);
    if ((0, $c26a9f58a509d806$export$88a30e5386bda853)(oldDoc, newDoc, ctx.ignoreMarks)) return [];
    return (0, $1408d0667a1e7286$export$4a231d1a3b7e81fc)((0, $dbd4acf6a178c667$export$f8dfe7066e572f15)(oldDoc, newDoc, -1, ctx));
}


const $4e0701cdc0c72e32$export$372e47604067462f = 'mdMode$ownWriteback';
const $4e0701cdc0c72e32$export$c0dd7bd7f3654863 = (editorView, seedDoc, newAdfNode, interveningMapping, opts)=>{
    if (editorView.isDestroyed) return null;
    const steps = (0, $bfbaa043dadccad3$export$96d86b1e79ab6058)(seedDoc, newAdfNode, opts);
    if (steps.length === 0) return null;
    const tr = editorView.state.tr;
    for (const step of steps){
        const rebased = step.map(interveningMapping);
        if (!rebased) throw new Error('applyDiffSteps: step did not survive rebase');
        const mapped = rebased.map(tr.mapping);
        if (!mapped) throw new Error('applyDiffSteps: step could not be mapped');
        tr.step(mapped);
    }
    tr.setMeta('addToHistory', false);
    tr.setMeta($4e0701cdc0c72e32$export$372e47604067462f, true);
    editorView.dispatch(tr);
    return tr;
};



/**
 * Confluence appends a trailing empty paragraph to the live PM doc for cursor
 * placement; mdast strips trailing blank lines on round-trip, so without
 * padding the diff emits a wholesale delete of that paragraph on every
 * writeback. Cosmetic non-collab; collides with concurrent end-of-doc appends
 * under collab.
 */ 


const $1977d03e742bf42f$var$isEmptyParagraph = (node)=>!!node && node.type.name === 'paragraph' && node.childCount === 0;
const $1977d03e742bf42f$export$cecc4bbbdf07f0bc = (oldDoc, newDoc)=>{
    if (!$1977d03e742bf42f$var$isEmptyParagraph(oldDoc.lastChild)) return newDoc;
    if ($1977d03e742bf42f$var$isEmptyParagraph(newDoc.lastChild)) return newDoc;
    const paragraphType = newDoc.type.schema.nodes.paragraph;
    if (!paragraphType) return newDoc;
    return newDoc.copy(newDoc.content.append((0, $5SAOw.Fragment).from(paragraphType.create())));
};



const $74874246d05d99ad$var$EMPTY_ADF_DOC = {
    type: 'doc',
    version: 1,
    content: []
};
const $74874246d05d99ad$export$f6ff746d302c10e = ({ api: api, editorView: editorView, config: config, currentView: currentView })=>{
    if (!config.isMarkdownMode) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($74874246d05d99ad$var$MarkdownModeOrchestratorDiff, {
        api: api,
        markdownView: currentView,
        editorView: editorView,
        config: config
    });
};
const $74874246d05d99ad$var$MarkdownModeOrchestratorDiff = ({ api: api, markdownView: markdownView, editorView: editorView, config: config })=>{
    // ---------------------------------------------------------------
    // State
    // ---------------------------------------------------------------
    const [adfDoc, setAdfDoc] = (0, $42omo.useState)($74874246d05d99ad$var$EMPTY_ADF_DOC);
    const [snapshotRevision, setSnapshotRevision] = (0, $42omo.useState)(0);
    const [liveAdfDoc, setLiveAdfDoc] = (0, $42omo.useState)(undefined);
    // Pre-computed markdown for the snapshot (platform_editor_md_source_sync_snapshot).
    const [seedMarkdown, setSeedMarkdown] = (0, $42omo.useState)(undefined);
    // Pushed to MarkdownSourceView after every successful own-writeback so CM6
    // can re-seed (absorbs any remote content that was folded in via rebase).
    const [postWritebackAdfDoc, setPostWritebackAdfDoc] = (0, $42omo.useState)(undefined);
    const liveDocDebounceRef = (0, $42omo.useRef)(null);
    const dispatchTapInstalledRef = (0, $42omo.useRef)(false);
    // Collab-safe diff baseline: steps are computed against `seedPmDocRef` and
    // rebased through `interveningMappingRef`. Both reset on snapshot and after
    // every successful writeback.
    const seedPmDocRef = (0, $42omo.useRef)(null);
    const interveningMappingRef = (0, $42omo.useRef)(new (0, $aXG5V.Mapping)());
    // Stable ref for serializeFileMedia so effects and callbacks can read the
    // latest value without taking it as a dep (unstable parent references would
    // otherwise re-fire the snapshot effect and wipe the refs above).
    const serializeFileMediaRef = (0, $42omo.useRef)(config.serializeFileMedia);
    serializeFileMediaRef.current = config.serializeFileMedia;
    // Annotation ranges extracted at snapshot time — passed to the source view
    // purely so highlight decorations render and click-to-open works. The diff
    // writeback path does NOT re-apply annotation marks (see file header).
    const [annotationRanges, setAnnotationRanges] = (0, $42omo.useState)([]);
    // ---------------------------------------------------------------
    // Snapshot — synchronously read the current doc from PM.
    // ---------------------------------------------------------------
    const snapshotAdf = (0, $42omo.useCallback)(()=>{
        if (!editorView || editorView.isDestroyed) return null;
        return editorView.state.doc.toJSON();
    }, [
        editorView
    ]);
    // Snapshot whenever the user transitions away from preview (the WYSIWYG editor).
    (0, $42omo.useEffect)(()=>{
        if (markdownView === 'preview') return;
        const snap = snapshotAdf();
        if (snap && snap.type === 'doc') {
            setAdfDoc(snap);
            setSnapshotRevision((r)=>r + 1);
            setLiveAdfDoc(undefined);
            setPostWritebackAdfDoc(undefined);
            seedPmDocRef.current = editorView.state.doc;
            interveningMappingRef.current = new (0, $aXG5V.Mapping)();
            // Convert the snapshot to markdown a SINGLE time here and reuse for
            // both the source-view seed and annotation ranges.
            try {
                const schema = editorView.state.schema;
                const pmDoc = editorView.state.doc;
                const { markdown: markdown, annotations: annotations } = (0, $4a459e9a38530e96$export$3768801c4ab752e6)(pmDoc, schema, {
                    serializeFileMedia: serializeFileMediaRef.current
                });
                if ((0, $dh538.fg)('platform_editor_md_source_sync_snapshot')) setSeedMarkdown(markdown);
                setAnnotationRanges(annotations);
            } catch  {
                if ((0, $dh538.fg)('platform_editor_md_source_sync_snapshot')) setSeedMarkdown(undefined);
                setAnnotationRanges([]);
            }
        }
    }, [
        markdownView,
        snapshotAdf,
        editorView
    ]);
    // ---------------------------------------------------------------
    // Dispatch tap — push debounced live updates to source/preview.
    // ---------------------------------------------------------------
    (0, $42omo.useEffect)(()=>{
        if (markdownView === 'preview') return;
        if (!editorView || editorView.isDestroyed) return;
        if (dispatchTapInstalledRef.current) return;
        const original = editorView.props.dispatchTransaction;
        const tap = (tr)=>{
            // Always run the original dispatcher first.
            if (original) original.call(editorView, tr);
            else editorView.updateState(editorView.state.apply(tr));
            if (!tr.docChanged) return;
            if (tr.getMeta((0, $4e0701cdc0c72e32$export$372e47604067462f))) return; // our writeback — don't accumulate, don't push to source view
            for (const map of tr.mapping.maps)interveningMappingRef.current.appendMap(map);
            // Debounce: coalesce rapid keystrokes.
            if (liveDocDebounceRef.current !== null) clearTimeout(liveDocDebounceRef.current);
            liveDocDebounceRef.current = setTimeout(()=>{
                liveDocDebounceRef.current = null;
                if (!editorView || editorView.isDestroyed) return;
                setLiveAdfDoc(editorView.state.doc.toJSON());
            }, 150);
        };
        editorView.setProps({
            dispatchTransaction: tap
        });
        dispatchTapInstalledRef.current = true;
        return ()=>{
            if (liveDocDebounceRef.current !== null) {
                clearTimeout(liveDocDebounceRef.current);
                liveDocDebounceRef.current = null;
            }
            // Restore the original dispatcher so the tap closure (and the React
            // fiber it captures via setLiveAdfDoc) can be GC'd, and so a future
            // editorView change re-installs cleanly.
            if (!editorView.isDestroyed) editorView.setProps({
                dispatchTransaction: original
            });
            dispatchTapInstalledRef.current = false;
        };
    }, [
        markdownView,
        editorView
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (liveDocDebounceRef.current !== null) {
                clearTimeout(liveDocDebounceRef.current);
                liveDocDebounceRef.current = null;
            }
        };
    }, []);
    // ---------------------------------------------------------------
    // Writeback handlers
    // ---------------------------------------------------------------
    // Same stable-ref pattern for the dev-only step-observer callback.
    const onDiffStepsAppliedRef = (0, $42omo.useRef)(config.onDiffStepsApplied);
    onDiffStepsAppliedRef.current = config.onDiffStepsApplied;
    /**
   * Called when the user clicks an annotation highlight in the CodeMirror
   * source view. Mirrors the click handler in the annotation plugin's
   * inline-comment.ts: checks the annotation is unresolved, then dispatches
   * setSelectedAnnotation (or setPendingSelectedAnnotation when the annotation
   * manager is enabled) on the live ProseMirror editor so that the comment
   * popup / comments panel opens, exactly as in the WYSIWYG view.
   */ const handleAnnotationClick = (0, $42omo.useCallback)((annotationId)=>{
        if (!editorView || editorView.isDestroyed) return;
        // Read annotation plugin state via api.annotation.sharedState — avoids
        // importing internal annotation plugin utilities directly and works
        // correctly with the pre-built dist in the browser dev environment.
        const annotationPluginState = api?.annotation?.sharedState.currentState();
        if (!annotationPluginState) return;
        const { annotations: annotations, isAnnotationManagerEnabled: isAnnotationManagerEnabled } = annotationPluginState;
        // Only react to unresolved annotations (matches WYSIWYG click handler).
        const isUnresolved = annotations && annotations[annotationId] === false;
        if (!isUnresolved) return;
        if (isAnnotationManagerEnabled) api?.annotation?.actions.setPendingSelectedAnnotation(annotationId)(editorView.state, editorView.dispatch);
        else api?.annotation?.actions.setSelectedAnnotation(annotationId)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        api
    ]);
    /**
   * Forwarded to MarkdownSourceView as `onRegisterCommandDispatch`.
   * Called on mount with a stable dispatcher that routes CM6 commands to
   * the live CodeMirror EditorView, and with `null` on unmount.
   * Registers/unregisters the dispatcher on the markdownMode plugin action
   * so toolbar buttons can call `api.markdownMode.actions.dispatchSourceCommand`.
   * Only wired when `platform_editor_markdown_compatible_toolbar` is enabled.
   */ // Stable ref to the CM6 dispatcher — populated when MarkdownSourceView
    // mounts and cleared when it unmounts.
    const sourceDispatchRef = (0, $42omo.useRef)(null);
    const handleRegisterCommandDispatch = (0, $42omo.useCallback)((dispatcher)=>{
        sourceDispatchRef.current = dispatcher;
        api?.markdownMode?.actions.registerSourceCommandDispatch(dispatcher);
        if (dispatcher === null) api?.markdownMode?.actions.setSourceFormatState(null);
    }, [
        api
    ]);
    // Re-register the dispatcher whenever api changes (preset rebuild resets
    // the plugin closure, clearing sourceCommandDispatch to null).
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('platform_editor_markdown_compatible_toolbar')) return;
        if (sourceDispatchRef.current) api?.markdownMode?.actions.registerSourceCommandDispatch(sourceDispatchRef.current);
    }, [
        api
    ]);
    const handleSourceFormatStateChange = (0, $42omo.useCallback)((state)=>{
        api?.markdownMode?.actions.setSourceFormatState(state);
    }, [
        api
    ]);
    /**
   * Called by MarkdownSourceView on every debounced source change (Tier 2).
   * Parses markdown back to ADF and applies the delta to the live PM doc via
   * surgical `Step`s computed by `@atlassian/content-reconciler`.
   */ const handleSourceMarkdownChange = (0, $42omo.useCallback)((markdown)=>{
        if (!editorView || editorView.isDestroyed) return;
        const seedDoc = seedPmDocRef.current;
        if (!seedDoc) return;
        let adfNode;
        try {
            adfNode = (0, $4a459e9a38530e96$export$aa0067ded6a6b28d)(markdown, editorView.state.schema);
        } catch (err) {
            // Bound interveningMapping growth while the user iterates on invalid
            // markdown; next valid input diffs against the post-remote baseline.
            seedPmDocRef.current = editorView.state.doc;
            interveningMappingRef.current = new (0, $aXG5V.Mapping)();
            return;
        }
        // Early-out + re-seed: if live PM already serializes to the requested
        // markdown, the diff is a no-op and current PM is the right new seed.
        try {
            const { markdown: liveMarkdown } = (0, $4a459e9a38530e96$export$3768801c4ab752e6)(editorView.state.doc, editorView.state.schema, {
                serializeFileMedia: serializeFileMediaRef.current
            });
            if (liveMarkdown === markdown) {
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $aXG5V.Mapping)();
                return;
            }
        } catch (err) {
        // fall through to diff path
        }
        // Capture before dispatch so the dev callback sees the diff baseline.
        const oldDocForCallback = editorView.state.doc;
        const paddedAdfNode = (0, $1977d03e742bf42f$export$cecc4bbbdf07f0bc)(oldDocForCallback, adfNode);
        try {
            const tr = (0, $4e0701cdc0c72e32$export$c0dd7bd7f3654863)(editorView, seedDoc, paddedAdfNode, interveningMappingRef.current, {
                ignoreMarkTypes: [
                    'annotation'
                ]
            });
            if (tr) {
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $aXG5V.Mapping)();
                setPostWritebackAdfDoc(editorView.state.doc.toJSON());
                onDiffStepsAppliedRef.current?.({
                    markdown: markdown,
                    newDoc: paddedAdfNode,
                    oldDoc: oldDocForCallback,
                    source: 'live',
                    steps: tr.steps
                });
            }
        } catch (err) {
            // Re-seed so a positional rebase failure is recoverable: next flush
            // diffs against the live doc; user's typing wins. (Note: CM6's
            // seedMarkdownRef is NOT bumped here — the source view keeps the
            // user's intent intact and just sees a wider userDiff next round.)
            seedPmDocRef.current = editorView.state.doc;
            interveningMappingRef.current = new (0, $aXG5V.Mapping)();
        }
    }, [
        editorView
    ]);
    /**
   * Called by MarkdownSourceView on unmount / revision change when the
   * user actually edited the buffer (Tier 0 — batch commit). Applies the
   * delta as surgical steps via the same path as handleSourceMarkdownChange.
   */ const handleMarkdownCommit = (0, $42omo.useCallback)((finalMarkdown)=>{
        if (!editorView || editorView.isDestroyed) return;
        const seedDoc = seedPmDocRef.current;
        if (!seedDoc) return;
        try {
            // MarkdownSourceView's per-seed guard only catches open-then-close-
            // without-typing. Live WYSIWYG updates flow into the source buffer via
            // the dispatch tap, so finalMarkdown can differ from the seed yet still
            // round-trip to the current live doc.
            try {
                const { markdown: liveMarkdown } = (0, $4a459e9a38530e96$export$3768801c4ab752e6)(editorView.state.doc, editorView.state.schema, {
                    serializeFileMedia: serializeFileMediaRef.current
                });
                if (liveMarkdown === finalMarkdown) {
                    seedPmDocRef.current = editorView.state.doc;
                    interveningMappingRef.current = new (0, $aXG5V.Mapping)();
                    return;
                }
            } catch (err) {
            // fall through to diff path
            }
            const adfNode = (0, $4a459e9a38530e96$export$aa0067ded6a6b28d)(finalMarkdown, editorView.state.schema);
            const oldDocForCallback = editorView.state.doc;
            const paddedAdfNode = (0, $1977d03e742bf42f$export$cecc4bbbdf07f0bc)(oldDocForCallback, adfNode);
            const tr = (0, $4e0701cdc0c72e32$export$c0dd7bd7f3654863)(editorView, seedDoc, paddedAdfNode, interveningMappingRef.current, {
                ignoreMarkTypes: [
                    'annotation'
                ]
            });
            if (tr) {
                seedPmDocRef.current = editorView.state.doc;
                interveningMappingRef.current = new (0, $aXG5V.Mapping)();
                setPostWritebackAdfDoc(editorView.state.doc.toJSON());
                onDiffStepsAppliedRef.current?.({
                    markdown: finalMarkdown,
                    newDoc: paddedAdfNode,
                    oldDoc: oldDocForCallback,
                    source: 'commit',
                    steps: tr.steps
                });
            }
        } catch (err) {
            // Same recovery as handleSourceMarkdownChange.
            seedPmDocRef.current = editorView.state.doc;
            interveningMappingRef.current = new (0, $aXG5V.Mapping)();
            // eslint-disable-next-line no-console
            console.warn('[MarkdownModeContentComponentDiff] Failed to apply markdown source edits back to the editor; discarding change.', err);
        }
    }, [
        editorView
    ]);
    // Hide the WYSIWYG ProseMirror DOM in syntax and split-view modes. The
    // platform's `FullPageContentArea` attempts this via
    // `hideEditorContentAreaProsemirrorStyle`, but that style is gated on the
    // `cc-markdown-mode` experiment AND on the plugin's PM state being in sync
    // — either can fail on first paint, leaving both the source CodeMirror
    // and the underlying ProseMirror visible (with floating toolbars leaking
    // through). Scoped to this plugin's `editorView.dom`; original `display`
    // is restored on cleanup. Blur on leaving preview dismisses
    // selection-anchored floating UI (code-block toolbar, table controls).
    (0, $42omo.useEffect)(()=>{
        if (!editorView || editorView.isDestroyed) return;
        if (markdownView === 'preview') return;
        const dom = editorView.dom;
        const originalDisplay = dom.style.display;
        dom.style.display = 'none';
        // Guard against blur throwing on a destroyed view.
        try {
            if (editorView.hasFocus()) dom.blur();
        } catch  {
        // no-op
        }
        return ()=>{
            if (!editorView.isDestroyed) dom.style.display = originalDisplay;
        };
    }, [
        markdownView,
        editorView
    ]);
    // ---------------------------------------------------------------
    // Render
    // ---------------------------------------------------------------
    const isPreview = markdownView === 'preview';
    if (isPreview) return null;
    const PreviewComponent = config.previewComponent;
    // Resolve the gate once per render so paired props stay consistent and
    // we don't fire duplicate exposures.
    const compatibleToolbarEnabled = (0, $dh538.fg)('platform_editor_markdown_compatible_toolbar');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, markdownView === 'syntax' && (snapshotRevision > 0 || !(0, $dh538.fg)('platform_editor_md_source_sync_snapshot')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6584100e45685489$export$eb7c1c6ff6845883), {
        contentId: config.contentId,
        initialAdfDoc: adfDoc,
        seedMarkdown: seedMarkdown,
        schema: editorView.state.schema,
        revision: snapshotRevision,
        liveAdfDoc: liveAdfDoc,
        postWritebackAdfDoc: postWritebackAdfDoc,
        onSourceMarkdownChange: handleSourceMarkdownChange,
        onMarkdownCommit: handleMarkdownCommit,
        serializeFileMedia: config.serializeFileMedia,
        annotationRanges: annotationRanges,
        onAnnotationClick: handleAnnotationClick,
        onRegisterCommandDispatch: compatibleToolbarEnabled ? handleRegisterCommandDispatch : undefined,
        onSourceFormatStateChange: compatibleToolbarEnabled ? handleSourceFormatStateChange : undefined
    }), markdownView === 'split-view' && PreviewComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PreviewComponent, {
        key: `preview-${snapshotRevision}`,
        adfDoc: liveAdfDoc ?? adfDoc
    }));
};


/* MarkdownModeViewToggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $hgeg8 = parcelRequire("hgeg8");





var $7ERUE = parcelRequire("7ERUE");

var $48SU7 = parcelRequire("48SU7");

var $iIVVb = parcelRequire("iIVVb");


var $2aKPB = parcelRequire("2aKPB");


var $1boHL = parcelRequire("1boHL");


var $eIlE7 = parcelRequire("eIlE7");




const $4256021958837d3a$var$styles = {
    wrapper: "_f97wq98m _89hze4h9 _1p1rnqa1 _1p171f4h"
}; // ---------------------------------------------------------------------------
const $4256021958837d3a$export$dfbf3d9b6d36cb67 = ({ view: view, onViewChange: onViewChange })=>{
    const intl = (0, $aXWIB.useIntl)();
    const handleClick = (0, $42omo.useCallback)((nextView)=>{
        if (nextView === view) return;
        onViewChange(nextView);
    }, [
        view,
        onViewChange
    ]); // Stable per-view click handlers so the IconButtons receive a referentially
    // equal `onClick` prop across renders (avoids breaking memoisation in the
    // IconButton subtree). `handleClick` itself is already memoised on
    // (view, onViewChange).
    const handleSyntaxClick = (0, $42omo.useCallback)(()=>handleClick('syntax'), [
        handleClick
    ]);
    const handlePreviewClick = (0, $42omo.useCallback)(()=>handleClick('preview'), [
        handleClick
    ]);
    const handleSplitViewClick = (0, $42omo.useCallback)(()=>handleClick('split-view'), [
        handleClick
    ]);
    const syntaxLabel = intl.formatMessage((0, $36Wvq.markdownModeMessages).source);
    const previewLabel = intl.formatMessage((0, $36Wvq.markdownModeMessages).wysiwyg); // Note: i18n message keys (`i18n.source`, `i18n.sourceAriaLabel`) are
    // intentionally left as-is to preserve translation memory for the
    // 'Syntax editor' / 'Markdown source' strings already in production.
    const splitViewLabel = intl.formatMessage((0, $36Wvq.markdownModeMessages).preview);
    const groupLabel = intl.formatMessage((0, $36Wvq.markdownModeMessages).groupLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $4256021958837d3a$var$styles.wrapper,
        role: "group",
        "aria-label": groupLabel,
        testId: "markdown-mode-view-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hgeg8.ToolTipContent), {
            description: syntaxLabel,
            keymap: view === 'preview' ? (0, $hgeg8.toggleMarkdownView) : undefined
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))), {
            size: "small",
            label: syntaxLabel
        }),
        label: syntaxLabel,
        isSelected: view === 'syntax',
        onClick: handleSyntaxClick,
        testId: "markdown-mode-view-toggle--syntax",
        ariaKeyshortcuts: view === 'preview' ? (0, $hgeg8.toggleMarkdownView).description : undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hgeg8.ToolTipContent), {
            description: previewLabel,
            keymap: view === 'syntax' ? (0, $hgeg8.toggleMarkdownView) : undefined
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2aKPB))), {
            size: "small",
            label: previewLabel
        }),
        label: previewLabel,
        isSelected: view === 'preview',
        onClick: handlePreviewClick,
        testId: "markdown-mode-view-toggle--preview",
        ariaKeyshortcuts: view === 'syntax' ? (0, $hgeg8.toggleMarkdownView).description : undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hgeg8.ToolTipContent), {
            description: splitViewLabel
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1boHL))), {
            size: "small",
            label: splitViewLabel
        }),
        label: splitViewLabel,
        isSelected: view === 'split-view',
        onClick: handleSplitViewClick,
        testId: "markdown-mode-view-toggle--split-view",
        isDisabled: true
    }))));
};
const $4256021958837d3a$export$aa32935aa228c6fd = ({ api: api })=>{
    const { view: view, isMarkdownMode: isMarkdownMode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>({
            view: states.markdownModeState?.view ?? 'preview',
            isMarkdownMode: states.markdownModeState?.isMarkdownMode ?? false
        }));
    const handleViewChange = (0, $42omo.useCallback)((nextView)=>{
        api?.markdownMode?.actions.setView(nextView);
    }, [
        api
    ]);
    if (!isMarkdownMode) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4256021958837d3a$export$dfbf3d9b6d36cb67, {
        view: view,
        onViewChange: handleViewChange
    });
};


const $49316df42372e253$var$HEADING_SOURCE_VIEW_COMMANDS = {
    1: (0, $c8eb22a0108df7ae$export$4e0d444e5782abea),
    2: (0, $c8eb22a0108df7ae$export$b8d734de6aecb0a3),
    3: (0, $c8eb22a0108df7ae$export$df05910f74b29e0),
    4: (0, $c8eb22a0108df7ae$export$ca48da5fbbd68542),
    5: (0, $c8eb22a0108df7ae$export$1335885ed6c2d3ac),
    6: (0, $c8eb22a0108df7ae$export$8381ca7ddcf8db0d)
};
// so a floating selection toolbar has nothing to anchor to.
const $49316df42372e253$var$contextualFormattingOverrideForView = (view)=>view === 'preview' ? 'controlled' : 'always-pinned'; // Mirrors `selection-toolbar/PrimaryToolbarComponent`: prefers
// `userPreferences.toolbarDockingPosition` when the new plugin is enabled,
// otherwise falls back to `selectionToolbar.toolbarDocking`. In source /
// preview view the primary toolbar is forcibly pinned via the toolbar
// override (see `setView` below), so we treat the toolbar as docked-to-top
// regardless of the user's saved preference — otherwise the view-switcher
// renders in-content while the toolbar is actually pinned at the top.
const $49316df42372e253$var$useIsToolbarDockedToTop = (api)=>{
    const { dockingPositionFromPrefs: dockingPositionFromPrefs, dockingFromSelectionToolbar: dockingFromSelectionToolbar, view: view } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'userPreferences',
        'selectionToolbar',
        'markdownMode'
    ], (states)=>({
            dockingPositionFromPrefs: states.userPreferencesState?.preferences?.toolbarDockingPosition,
            dockingFromSelectionToolbar: states.selectionToolbarState?.toolbarDocking,
            view: states.markdownModeState?.view
        }));
    if (view && view !== 'preview' && (0, $dh538.fg)('platform_editor_toolbar_mode_override')) return true;
    if ((0, $dh538.fg)('platform_editor_use_preferences_plugin')) return dockingPositionFromPrefs === 'top';
    return dockingFromSelectionToolbar === 'top';
};
const $49316df42372e253$var$MarkdownModeContentComponentWrapper = ({ editorView: editorView, config: config, api: api })=>{
    const hasReconciledPersistedViewRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false); // Transient fallback: if the shared state hasn't hydrated yet, treat the
    // view as 'preview' so we don't briefly mount the syntax editor over the
    // PM editor. The authoritative initial view (which can be 'syntax') is
    // resolved upstream via `config.viewModePersistence.getInitialView` and
    // will populate `markdownModeState.view` once the plugin initialises.
    const currentView = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.view ?? 'preview');
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (hasReconciledPersistedViewRef.current) return;
        hasReconciledPersistedViewRef.current = true;
        const persistedView = config.viewModePersistence?.getInitialView?.();
        if (!persistedView || persistedView === currentView) return;
        api?.markdownMode?.actions.setView(persistedView);
    }, [
        api,
        config.viewModePersistence,
        currentView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6eb5d9f28b495ad0$export$b761619be3df29f), {
        editorView: editorView,
        config: config,
        currentView: currentView,
        api: api
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($49316df42372e253$export$5a3a24cc1474d9cc, {
        api: api
    }));
};
/**
 * Parallel wrapper for the content-reconciler writeback component.
 * Identical to `MarkdownModeContentComponentWrapper` except it mounts
 * `MarkdownModeContentComponentDiff`. Kept as a duplicate (rather than
 * parameterising the existing wrapper) so the legacy code path stays
 * byte-for-byte unchanged while the gate is off.
 */ const $49316df42372e253$var$MarkdownModeContentComponentDiffWrapper = ({ editorView: editorView, config: config, api: api })=>{
    const hasReconciledPersistedViewRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false); // Transient fallback: if the shared state hasn't hydrated yet, treat the
    // view as 'preview' so we don't briefly mount the syntax editor over the
    // PM editor. The authoritative initial view (which can be 'syntax') is
    // resolved upstream via `config.viewModePersistence.getInitialView` and
    // will populate `markdownModeState.view` once the plugin initialises.
    const currentView = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.view ?? 'preview');
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (hasReconciledPersistedViewRef.current) return;
        hasReconciledPersistedViewRef.current = true;
        const persistedView = config.viewModePersistence?.getInitialView?.();
        if (!persistedView || persistedView === currentView) return;
        api?.markdownMode?.actions.setView(persistedView);
    }, [
        api,
        config.viewModePersistence,
        currentView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $74874246d05d99ad$export$f6ff746d302c10e), {
        editorView: editorView,
        config: config,
        currentView: currentView,
        api: api
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($49316df42372e253$export$5a3a24cc1474d9cc, {
        api: api
    }));
};
const $49316df42372e253$var$styles = {
    trailingSection: "_kqswstnw _rjxputpp _152t1ssb _t9ec1i34 _1e0c1txw _4cvr1h6o",
    inContentToggleStickyRow: "_kqsw1n9t _152tu2gc _rjxp1ejb _1pbyb4wl _lcxvglyw",
    inContentToggleAnchor: "_2rko1mok _1rjc1b66 _18zr1b66 _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o _bfhkvuon _lcxv1wug"
};
const $49316df42372e253$var$InToolbarToggle = ({ api: api })=>{
    const isDockedToTop = $49316df42372e253$var$useIsToolbarDockedToTop(api);
    if (!isDockedToTop) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $49316df42372e253$var$styles.trailingSection,
        testId: "markdown-mode-view-toggle-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4256021958837d3a$export$aa32935aa228c6fd), {
        api: api
    }));
};
const $49316df42372e253$export$5a3a24cc1474d9cc = ({ api: api })=>{
    const isDockedToTop = $49316df42372e253$var$useIsToolbarDockedToTop(api);
    if (isDockedToTop) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $49316df42372e253$var$styles.inContentToggleStickyRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $49316df42372e253$var$styles.inContentToggleAnchor,
        testId: "markdown-mode-view-toggle-in-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4256021958837d3a$export$aa32935aa228c6fd), {
        api: api
    })));
};
const $49316df42372e253$var$buildToolbarComponents = (config, api)=>{
    if (!config?.isMarkdownMode) return [];
    return [
        {
            type: (0, $cPCP8.VIEW_MODE_TOGGLE_SECTION).type,
            key: (0, $cPCP8.VIEW_MODE_TOGGLE_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.VIEW_MODE_TOGGLE_SECTION).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($49316df42372e253$var$InToolbarToggle, {
                    api: api
                })
        }
    ];
};
const $49316df42372e253$export$f3055fdbf3cad094 = ({ config: config, api: api })=>{
    let editorView;
    let sourceCommandDispatch = null;
    const dispatchSource = (cmd)=>{
        if (!(0, $dh538.fg)('platform_editor_markdown_compatible_toolbar')) return false;
        if (!sourceCommandDispatch) return false;
        return sourceCommandDispatch(cmd);
    };
    const setEditorView = (newEditorView)=>{
        editorView = newEditorView;
    };
    const dispatchSourceFormatState = (formatState)=>{
        if (!editorView) return;
        editorView.dispatch(editorView.state.tr.setMeta((0, $f77ee1d521b258ad$export$160e35dbff8be862), {
            sourceBlockFormatState: formatState?.block ?? null,
            sourceInlineFormatState: formatState?.inline ?? null,
            sourceListFormatState: formatState?.list ?? null
        }));
    }; // Resolve the initial view ONCE, at plugin construction time — not in
    // `init()`, which re-runs on `state.reconfigure` and would clobber any
    // in-flight user choice on every preset rebuild.
    //
    // When the initial view is browser-persisted, SSR cannot know the stored
    // value. Keep SSR and the first hydrating client render on the deterministic
    // default, then reconcile the persisted value from the content component's
    // mount effect.
    const initialView = 'syntax';
    api?.toolbar?.actions.registerComponents($49316df42372e253$var$buildToolbarComponents(config, api));
    return {
        name: 'markdownMode',
        getSharedState (editorState) {
            if (!editorState) return {
                view: initialView,
                isMarkdownMode: config?.isMarkdownMode ?? false,
                sourceInlineFormatState: null,
                sourceBlockFormatState: null,
                sourceListFormatState: null
            };
            return (0, $f77ee1d521b258ad$export$160e35dbff8be862).getState(editorState) ?? {
                view: initialView,
                isMarkdownMode: config?.isMarkdownMode ?? false,
                sourceInlineFormatState: null,
                sourceBlockFormatState: null,
                sourceListFormatState: null
            };
        },
        actions: {
            setView (view) {
                if (!editorView) return;
                const prevView = (0, $f77ee1d521b258ad$export$160e35dbff8be862).getState(editorView.state)?.view ?? initialView;
                if (prevView === view) return;
                const tr = editorView.state.tr;
                if ((0, $dh538.fg)('platform_editor_toolbar_mode_override')) api?.toolbar?.commands.setContextualFormattingModeOverride($49316df42372e253$var$contextualFormattingOverrideForView(view))({
                    tr: tr
                });
                tr.setMeta((0, $f77ee1d521b258ad$export$160e35dbff8be862), {
                    view: view
                });
                editorView.dispatch(tr);
                config?.viewModePersistence?.onViewChange?.(view, prevView);
            },
            dispatchSourceCommand: dispatchSource,
            toggleSourceBlockquote: ()=>dispatchSource((0, $c8eb22a0108df7ae$export$2cd68375ac1e5429)),
            toggleSourceBulletList: ()=>dispatchSource((0, $c8eb22a0108df7ae$export$71c898cbdfd51c6e)),
            toggleSourceOrderedList: ()=>dispatchSource((0, $c8eb22a0108df7ae$export$744c9722bde8c6b3)),
            toggleSourceTaskList: ()=>dispatchSource((0, $c8eb22a0108df7ae$export$49b8416aa3f9522a)),
            toggleSourceHeading: (level)=>dispatchSource($49316df42372e253$var$HEADING_SOURCE_VIEW_COMMANDS[level]),
            toggleSourceBold: ()=>dispatchSource((0, $c8eb22a0108df7ae$export$b850a936f66192a3)),
            toggleSourceItalic: ()=>dispatchSource((0, $c8eb22a0108df7ae$export$227b5ef404be9031)),
            toggleSourceInlineCode: ()=>dispatchSource((0, $c8eb22a0108df7ae$export$e7d955a85cfe503c)),
            toggleSourceStrike: ()=>dispatchSource((0, $c8eb22a0108df7ae$export$a46d65f808b4881d)),
            registerSourceCommandDispatch (dispatcher) {
                if (!(0, $dh538.fg)('platform_editor_markdown_compatible_toolbar')) return;
                sourceCommandDispatch = dispatcher;
            },
            setSourceBlockFormatState (formatState) {
                if (!(0, $dh538.fg)('platform_editor_markdown_compatible_toolbar') || !editorView) return;
                editorView.dispatch(editorView.state.tr.setMeta((0, $f77ee1d521b258ad$export$160e35dbff8be862), {
                    sourceBlockFormatState: formatState
                }));
            },
            setSourceFormatState (formatState) {
                if (!(0, $dh538.fg)('platform_editor_markdown_compatible_toolbar')) return;
                dispatchSourceFormatState(formatState);
            },
            setSourceInlineFormatState (formatState) {
                if (!(0, $dh538.fg)('platform_editor_markdown_compatible_toolbar') || !editorView) return;
                editorView.dispatch(editorView.state.tr.setMeta((0, $f77ee1d521b258ad$export$160e35dbff8be862), {
                    sourceInlineFormatState: formatState
                }));
            },
            setSourceListFormatState (formatState) {
                if (!(0, $dh538.fg)('platform_editor_markdown_compatible_toolbar') || !editorView) return;
                editorView.dispatch(editorView.state.tr.setMeta((0, $f77ee1d521b258ad$export$160e35dbff8be862), {
                    sourceListFormatState: formatState
                }));
            }
        },
        contentComponent ({ editorView: contentEditorView }) {
            if (!config?.isMarkdownMode || !contentEditorView) return null;
            if ((0, $dh538.fg)('platform_editor_md-mode-use-content-reconciler')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($49316df42372e253$var$MarkdownModeContentComponentDiffWrapper, {
                editorView: contentEditorView,
                config: config,
                api: api
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($49316df42372e253$var$MarkdownModeContentComponentWrapper, {
                editorView: contentEditorView,
                config: config,
                api: api
            });
        },
        pmPlugins () {
            return [
                {
                    name: 'markdownModeState',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            key: (0, $f77ee1d521b258ad$export$160e35dbff8be862),
                            state: {
                                init: ()=>({
                                        view: initialView,
                                        isMarkdownMode: config?.isMarkdownMode ?? false,
                                        sourceInlineFormatState: null,
                                        sourceBlockFormatState: null,
                                        sourceListFormatState: null
                                    }),
                                apply (tr, currentState) {
                                    const meta = tr.getMeta((0, $f77ee1d521b258ad$export$160e35dbff8be862));
                                    if (meta) return {
                                        ...currentState,
                                        ...meta.view !== undefined ? {
                                            view: meta.view
                                        } : {},
                                        ...meta.sourceInlineFormatState !== undefined ? {
                                            sourceInlineFormatState: meta.sourceInlineFormatState
                                        } : {},
                                        ...meta.sourceBlockFormatState !== undefined ? {
                                            sourceBlockFormatState: meta.sourceBlockFormatState
                                        } : {},
                                        ...meta.sourceListFormatState !== undefined ? {
                                            sourceListFormatState: meta.sourceListFormatState
                                        } : {}
                                    };
                                    return currentState;
                                }
                            },
                            view (newEditorView) {
                                setEditorView(newEditorView);
                                let destroyed = false; // Seed the toolbar override on first mount so a page that
                                // opens straight into source/preview pins the toolbar without
                                // needing a user-triggered `setView`.
                                if (config?.isMarkdownMode && (0, $dh538.fg)('platform_editor_toolbar_mode_override')) // Deferred to a microtask: dispatching synchronously inside
                                // `view()` is a PM re-entry hazard — the meta can be dropped
                                // before downstream plugins' `apply()` runs. By the next
                                // microtask the editor is fully constructed and dispatch is safe.
                                // The `destroyed` guard prevents dispatching on a torn-down
                                // view if `destroy()` runs before the microtask fires (e.g.
                                // React StrictMode double-mount).
                                Promise.resolve().then(()=>{
                                    if (destroyed) return;
                                    const tr = newEditorView.state.tr;
                                    api?.toolbar?.commands.setContextualFormattingModeOverride($49316df42372e253$var$contextualFormattingOverrideForView(initialView))({
                                        tr: tr
                                    });
                                    newEditorView.dispatch(tr);
                                });
                                 // Register a global keydown listener for the toggle shortcut.
                                // We use document-level rather than a PM keymap because in
                                // source view the PM editor is hidden/blurred and PM keymaps
                                // never fire.
                                const handler = (0, $eeb551b796465707$export$ed529ff4eb54147f)(api, ()=>editorView);
                                const doc = (0, $hTKp4.getDocument)();
                                const unbind = doc ? (0, $fFa3V.bind)(doc, {
                                    type: 'keydown',
                                    listener: handler
                                }) : ()=>{};
                                return {
                                    destroy () {
                                        destroyed = true;
                                        unbind();
                                    }
                                };
                            }
                        });
                    }
                }
            ];
        }
    };
};
module.exports["markdownModePlugin"] = $49316df42372e253$export$f3055fdbf3cad094;

});

parcelRegister("6WVPv", function(module, exports) {
const $df869d2f1c421c2a$export$13f2d1f50f16890a = [
    // Hyperlinks → `[text](url)`
    'hyperlink',
    // Tables → GFM tables
    'table',
    // Headings → `#`/`##`/`###`/...
    'heading1',
    'heading2',
    'heading3',
    'heading4',
    'heading5',
    'heading6',
    // Code blocks → ` ``` `
    'codeblock',
    // Block quote → `>`
    'blockquote',
    // Lists → `-`/`*`/`1.` and task lists → `- [x]`
    'unorderedList',
    'orderedList',
    'action',
    // Horizontal rule → `---`
    'rule',
    // Media — EDITOR-6636: `mediaSingle` + `media` now round-trip cleanly
    // through the markdown pipeline.
    //   - `type: "external"` → `![alt](https://…)` verbatim.
    //   - `type: "file"`     → `![alt](/wiki/download/attachments/{contentId}/{name})`
    //                          (Confluence tenant proxy URL, auth via session cookie).
    //
    // NOTE: Confluence uses `editor-plugin-media-insert` (the newer flow),
    // which registers the quick-insert item with id `'media-insert'` — NOT
    // `'media'` (which is the legacy media plugin's id used when mediaInsert
    // is absent). Both are allowlisted here for compatibility.
    'media-insert',
    'media'
];
const $df869d2f1c421c2a$export$5775271e6e45828a = new Set($df869d2f1c421c2a$export$13f2d1f50f16890a);
const $df869d2f1c421c2a$export$a2dbfb573dc4efa5 = (item)=>{
    if (!item.id) return false;
    return $df869d2f1c421c2a$export$5775271e6e45828a.has(item.id);
};
module.exports["isMarkdownCompatibleQuickInsertItem"] = $df869d2f1c421c2a$export$a2dbfb573dc4efa5;

});

parcelRegister("dme7x", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $140a6738094f1583$export$43594b7b1d8b2d04 = new (0, $ks2lK.PluginKey)('contentFormat');
const $140a6738094f1583$export$ae829ec7b2625219 = ({ initialContentMode: initialContentMode })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $140a6738094f1583$export$43594b7b1d8b2d04,
        state: {
            init: ()=>({
                    contentMode: initialContentMode ?? 'standard'
                }),
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($140a6738094f1583$export$43594b7b1d8b2d04);
                if (meta) {
                    const { contentMode: contentMode } = meta;
                    return {
                        contentMode: contentMode ?? currentPluginState.contentMode
                    };
                }
                return currentPluginState;
            }
        }
    });
};
const $140a6738094f1583$export$c0bae1e3feda2109 = ({ config: options })=>{
    let previousContentMode;
    return {
        name: 'contentFormat',
        getSharedState (editorState) {
            if (!editorState) return {
                contentMode: options?.initialContentMode ?? 'standard'
            };
            const pluginState = $140a6738094f1583$export$43594b7b1d8b2d04.getState(editorState);
            return {
                contentMode: pluginState?.contentMode ?? 'standard'
            };
        },
        commands: {
            updateContentMode: (contentMode)=>({ tr: tr })=>{
                    if (contentMode === previousContentMode) return null;
                    previousContentMode = contentMode;
                    return tr.setMeta($140a6738094f1583$export$43594b7b1d8b2d04, {
                        contentMode: contentMode
                    });
                }
        },
        pmPlugins () {
            return [
                {
                    name: 'contentFormat',
                    plugin: ()=>$140a6738094f1583$export$ae829ec7b2625219({
                            initialContentMode: options?.initialContentMode ?? 'standard'
                        })
                }
            ];
        }
    };
};
module.exports["contentFormatPlugin"] = $140a6738094f1583$export$c0bae1e3feda2109;

});

parcelRegister("hlZXw", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $dh538 = parcelRequire("dh538");


var $5SAOw = parcelRequire("5SAOw");




var $cO9ey = parcelRequire("cO9ey");

class $b03ef52bfaf548e0$export$7ee2d944cdf187e1 extends (0, $cO9ey.Step) {
    invert(doc) {
        return new $b03ef52bfaf548e0$export$7ee2d944cdf187e1({
            inverted: true,
            from: this.from,
            to: this.to,
            mark: this.mark
        });
    }
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    map(mapping) {
        const mappedFrom = mapping.mapResult(this.from, 1);
        const mappedTo = mapping.mapResult(this.to, 1);
        if (mappedFrom.deleted || mappedTo.deleted) return null;
        return new $b03ef52bfaf548e0$export$7ee2d944cdf187e1({
            inverted: this.inverted,
            from: mappedFrom.pos,
            to: mappedTo.pos
        });
    }
    getMap() {
        return new (0, $aXG5V.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    static from(step) {
        const { mark: mark, from: from, to: to } = step;
        return new $b03ef52bfaf548e0$export$7ee2d944cdf187e1({
            mark: mark,
            from: from,
            to: to
        });
    }
    constructor({ inverted: inverted, from: from, to: to, mark: mark }){
        super();
        this.inverted = void 0;
        this.from = void 0;
        this.to = void 0;
        this.mark = void 0;
        this.inverted = Boolean(inverted);
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
}
class $b03ef52bfaf548e0$export$2a0a7f94dceaed30 extends (0, $cO9ey.Step) {
    invert(doc) {
        return new $b03ef52bfaf548e0$export$2a0a7f94dceaed30({
            inverted: true,
            pos: this.pos,
            mark: this.mark
        });
    }
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    map(mapping) {
        const mappedPos = mapping.mapResult(this.pos, 1);
        if (mappedPos.deleted) return null;
        return new $b03ef52bfaf548e0$export$2a0a7f94dceaed30({
            inverted: this.inverted,
            pos: mappedPos.pos
        });
    }
    getMap() {
        return new (0, $aXG5V.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    static from(step) {
        const { mark: mark, pos: pos } = step;
        return new $b03ef52bfaf548e0$export$2a0a7f94dceaed30({
            mark: mark,
            pos: pos
        });
    }
    constructor({ inverted: inverted, pos: pos, mark: mark }){
        super();
        this.inverted = void 0;
        this.pos = void 0;
        this.mark = void 0;
        this.inverted = Boolean(inverted);
        this.pos = pos;
        this.mark = mark;
    }
}


const $50cbf7161ff57c52$var$createFilterStepsPlugin = (api)=>()=>new (0, $1S4f7.SafePlugin)({
            filterTransaction: (tr)=>{
                const mode = api?.editorViewMode?.sharedState.currentState()?.mode;
                if (mode !== 'view') return true;
                if (tr.getMeta('isRemote') || tr.getMeta('replaceDocument') || tr.getMeta('allowViewModeTransaction') && (0, $dh538.fg)('platform_editor_allow_viewmode_transaction')) return true;
                const viewModeSteps = tr.steps.reduce((acc, s)=>{
                    if (s instanceof (0, $b03ef52bfaf548e0$export$2a0a7f94dceaed30) || s instanceof (0, $b03ef52bfaf548e0$export$7ee2d944cdf187e1)) acc.push(s);
                    return acc;
                }, []);
                if (viewModeSteps.length === 0 || !api) {
                    if (tr.docChanged && // Check if the transaction contains any steps that modify the document (view mode steps do not)
                    tr.steps.filter((s)=>s instanceof (0, $aXG5V.ReplaceAroundStep) || s instanceof (0, $aXG5V.ReplaceStep) || s instanceof (0, $aXG5V.AddMarkStep) || s instanceof (0, $aXG5V.AddNodeMarkStep) || s instanceof (0, $aXG5V.RemoveMarkStep) || s instanceof (0, $aXG5V.RemoveNodeMarkStep)).length) return false;
                    return true;
                }
                viewModeSteps.forEach((step)=>{
                    if (step.inverted || !step.mark) return;
                    if (step.mark.type.name === 'annotation') {
                        if (step instanceof (0, $b03ef52bfaf548e0$export$2a0a7f94dceaed30)) api.collabEdit?.actions.addInlineCommentNodeMark({
                            mark: step.mark,
                            pos: step.pos
                        });
                        else if (step instanceof (0, $b03ef52bfaf548e0$export$7ee2d944cdf187e1)) api.collabEdit?.actions.addInlineCommentMark({
                            mark: step.mark,
                            from: step.from,
                            to: step.to
                        });
                    }
                });
                // Ignored via go/ees007
                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                // TODO: Follow-up and improve annotation logic so we can filter out transactions here
                return true;
            }
        });
const $50cbf7161ff57c52$var$createReplaceDocumentTransactionPlugin = (api)=>()=>new (0, $1S4f7.SafePlugin)({
            // Shouldn't need explicit types but sometimes TS can't infer them so 🤷
            appendTransaction: (transactions, _oldState, newState)=>{
                if (!api) return;
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode) return;
                const remoteReplaceDocumentTransaction = transactions.find((tr)=>api.collabEdit?.actions?.isRemoteReplaceDocumentTransaction(tr));
                if (!remoteReplaceDocumentTransaction || !remoteReplaceDocumentTransaction.selectionSet) return;
                const doc = newState.doc;
                const nextTr = newState.tr;
                const emptySelection = new (0, $ks2lK.TextSelection)(doc.resolve(0));
                nextTr.setSelection(emptySelection);
                return nextTr;
            }
        });
const $50cbf7161ff57c52$export$d510e4d48c393847 = ({ api: api })=>({
        name: 'editorViewModeEffects',
        actions: {
            allowViewModeTransaction: (tr)=>{
                tr.setMeta('allowViewModeTransaction', true);
                return tr;
            },
            applyViewModeStepAt: (tr)=>{
                const marksSteps = tr.steps.reduce((acc, s)=>{
                    // Ignored via go/ees007
                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                    // TODO: We probably want to check the RemoveMarkStep flow too.
                    if (s instanceof (0, $aXG5V.AddMarkStep) || s instanceof (0, $aXG5V.AddNodeMarkStep)) acc.push(s);
                    return acc;
                }, []);
                if (marksSteps.length === 0) return false;
                marksSteps.reverse().map((s)=>s instanceof (0, $aXG5V.AddNodeMarkStep) ? tr.step((0, $b03ef52bfaf548e0$export$2a0a7f94dceaed30).from(s)) : tr.step((0, $b03ef52bfaf548e0$export$7ee2d944cdf187e1).from(s)));
                return true;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'editorViewModeEffectsFilterSteps',
                    plugin: $50cbf7161ff57c52$var$createFilterStepsPlugin(api)
                },
                {
                    name: 'editorViewModeEffectsReplaceDocumentTransaction',
                    plugin: $50cbf7161ff57c52$var$createReplaceDocumentTransactionPlugin(api)
                }
            ];
        }
    });
module.exports["editorViewModeEffectsPlugin"] = $50cbf7161ff57c52$export$d510e4d48c393847;

});

parcelRegister("1chBq", function(module, exports) {

var $b7atO = parcelRequire("b7atO");


var $6qdjm = parcelRequire("6qdjm");


var $1oCLl = parcelRequire("1oCLl");


var $vDe3Q = parcelRequire("vDe3Q");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $bd6b8d63fb0cd3e9$export$4d696a2f56515a41 = new (0, $ks2lK.PluginKey)('limitedModePlugin');
/**
 * Determines whether limited mode should be enabled for a document.
 * If this logic changes, update the duplicate in `editor-common/src/node-anchor/node-anchor-provider.ts` to avoid drift.
 *
 * Limited mode is activated when ANY of the following conditions are met:
 * 1. Document size exceeds `LIMITED_MODE_DEFAULT_DOC_SIZE_THRESHOLD`
 * 2. Node count exceeds `LIMITED_MODE_DEFAULT_NODE_COUNT_THRESHOLD`
 * 3. Document contains a legacy-content macro (LCM)
 *
 * Performance optimisations:
 * - Doc size is checked first (O(1)) - if it exceeds threshold, we skip traversal entirely.
 * - If we find an LCM during traversal, we exit early since limited mode will be enabled.
 */ const $bd6b8d63fb0cd3e9$var$shouldEnableLimitedModeForDocument = (doc)=>{
    const nodeCountThreshold = (0, $vDe3Q.LIMITED_MODE_DEFAULT_NODE_COUNT_THRESHOLD);
    const docSizeThreshold = (0, $vDe3Q.LIMITED_MODE_DEFAULT_DOC_SIZE_THRESHOLD);
    // Early exit: doc size exceeds threshold - O(1), no traversal needed
    if (doc.nodeSize > docSizeThreshold) return true;
    // Single traversal for node count and LCM detection
    let nodeCount = 0;
    let hasLcm = false;
    doc.descendants((node)=>{
        nodeCount += 1;
        if (node.attrs?.extensionKey === 'legacy-content') {
            hasLcm = true;
            // Early exit: LCM found — limited mode will be enabled
            return false;
        }
    });
    // LCM condition takes precedence (if we early exited traversal, this is why)
    if (hasLcm) return true;
    // Check node count threshold
    if (nodeCount > nodeCountThreshold) return true;
    return false;
};
const $bd6b8d63fb0cd3e9$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $bd6b8d63fb0cd3e9$export$4d696a2f56515a41,
        view: (_view)=>{
            return {};
        },
        state: {
            init (_config, editorState) {
                return {
                    documentSizeBreachesThreshold: $bd6b8d63fb0cd3e9$var$shouldEnableLimitedModeForDocument(editorState.doc)
                };
            },
            apply: (tr, currentPluginState, _oldState, _newState)=>{
                // Don't check the document size if we're already in limited mode.
                // We ALWAYS want to re-check the document size if we're replacing the document (e.g. live-to-live page navigation).
                if (currentPluginState.documentSizeBreachesThreshold && !tr.getMeta('replaceDocument')) return currentPluginState;
                return {
                    documentSizeBreachesThreshold: $bd6b8d63fb0cd3e9$var$shouldEnableLimitedModeForDocument(tr.doc)
                };
            }
        }
    });
};


const $c6eda9ff2d183267$export$9f825df6a9c9b35b = ({ api: api })=>{
    return {
        name: 'limitedMode',
        pmPlugins () {
            return [
                {
                    name: 'limitedModePlugin',
                    plugin: (0, $bd6b8d63fb0cd3e9$export$ae829ec7b2625219)
                }
            ];
        },
        getSharedState (editorState) {
            if (editorState) return {
                get enabled () {
                    return (0, $bd6b8d63fb0cd3e9$export$4d696a2f56515a41).getState(editorState)?.documentSizeBreachesThreshold ?? false;
                },
                limitedModePluginKey: $bd6b8d63fb0cd3e9$export$4d696a2f56515a41
            };
            return {
                enabled: false,
                limitedModePluginKey: $bd6b8d63fb0cd3e9$export$4d696a2f56515a41
            };
        },
        usePluginHook: ({ editorView: editorView })=>{
            (0, $6qdjm.usePluginStateEffect)(api, [
                'limitedMode'
            ], ({ limitedModeState: limitedModeState })=>{
                if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                    const isEnabled = limitedModeState?.enabled ?? false;
                    const nodeIdProvider = (0, $b7atO.getNodeIdProvider)(editorView);
                    // When limited mode is enabled first time,
                    // We need to remove all existing data-node-anchor attributes
                    // And nodeIdProvider to limited mode to prevent adding data-node-anchor on new nodes
                    if (isEnabled && nodeIdProvider && !nodeIdProvider.isLimitedMode()) nodeIdProvider.setLimitedMode();
                }
            });
        }
    };
};
module.exports["limitedModePlugin"] = $c6eda9ff2d183267$export$9f825df6a9c9b35b;

});

parcelRegister("8peeT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1S4f7 = parcelRequire("1S4f7");


var $bAxHS = parcelRequire("bAxHS");


var $ks2lK = parcelRequire("ks2lK");

const $4f3bbf66819555bf$export$ef2bd08fc1b88107 = new (0, $ks2lK.PluginKey)('aiSpeechToText');






var $eiA8Z = parcelRequire("eiA8Z");


var $65N98 = parcelRequire("65N98");


var $h7vq2 = parcelRequire("h7vq2");


var $iM8hV = parcelRequire("iM8hV");


var $6gw6B = parcelRequire("6gw6B");


var $6nf0w = parcelRequire("6nf0w");


const $6e9f8fa3c2ed9770$export$27e3d771cf5f0905 = ({ api: api, cloudId: cloudId })=>{
    const { isListening: isListening } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiSpeechToText'
    ], (states)=>({
            isListening: states.aiSpeechToTextState?.isListening ?? false
        }));
    const { handleTranscriptUpdate: handleTranscriptUpdate, rejectTranscriptedText: rejectTranscriptedText, disposeTranscriptedText: disposeTranscriptedText } = (0, $h7vq2.useTranscriptionToEditorText)();
    const onVoiceDictationUpdate = (0, $42omo.useCallback)((result)=>{
        switch(result.state){
            case (0, $65N98.VoiceDictationState).Recording:
                if (!api?.core?.actions?.execute) return;
                api.core.actions.execute(({ tr: tr })=>handleTranscriptUpdate(result.transcription, tr));
                break;
            case (0, $65N98.VoiceDictationState).Stopped:
                if (result.stopReason === (0, $65N98.VoiceDictationStopReason).TimeoutAccepted) {
                    disposeTranscriptedText();
                    api?.core.actions.execute(({ tr: tr })=>{
                        tr.setMeta((0, $4f3bbf66819555bf$export$ef2bd08fc1b88107), {
                            isListening: false
                        });
                        return tr;
                    });
                }
                break;
            default:
                break;
        }
    }, [
        handleTranscriptUpdate,
        api,
        disposeTranscriptedText
    ]);
    const [, { startRecording: startRecording, stopRecording: stopRecording }] = (0, $iM8hV.useVoiceDictation)(onVoiceDictationUpdate, cloudId);
    const handleAccept = (0, $42omo.useCallback)(()=>{
        disposeTranscriptedText();
        stopRecording((0, $65N98.VoiceDictationStopReason).StoppedAccepted);
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4f3bbf66819555bf$export$ef2bd08fc1b88107), {
                isListening: false
            });
            return tr;
        });
    }, [
        stopRecording,
        disposeTranscriptedText,
        api
    ]);
    const handleReject = (0, $42omo.useCallback)(()=>{
        stopRecording((0, $65N98.VoiceDictationStopReason).StoppedRejected);
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4f3bbf66819555bf$export$ef2bd08fc1b88107), {
                isListening: false
            });
            return rejectTranscriptedText(tr);
        });
    }, [
        stopRecording,
        rejectTranscriptedText,
        api
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isListening) startRecording();
        else stopRecording();
    }, [
        isListening,
        startRecording,
        stopRecording
    ]);
    if (!isListening) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6gw6B.VoiceAcceptButton), {
        onClick: handleAccept
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6nf0w.VoiceRejectButton), {
        onClick: handleReject
    }));
};


// This CLOUD_ID works only for internal usage and POC purposes. Do not use it in production or share it externally.
// TODO: We need to implement here a logic to get the current user's cloudId.
const $0f42ee7f81761719$var$CLOUD_ID_INTERNAL_USE_ONLY = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $0f42ee7f81761719$var$EMPTY_STATE = {
    isListening: false,
    error: null
};
const $0f42ee7f81761719$export$8fc6b5430a555c3d = ({ api: api })=>{
    return {
        name: 'aiSpeechToText',
        getSharedState (editorState) {
            if (!editorState) return $0f42ee7f81761719$var$EMPTY_STATE;
            return (0, $4f3bbf66819555bf$export$ef2bd08fc1b88107).getState(editorState) ?? $0f42ee7f81761719$var$EMPTY_STATE;
        },
        pmPlugins () {
            return [
                {
                    name: 'speechToText',
                    plugin: ()=>new (0, $1S4f7.SafePlugin)({
                            key: (0, $4f3bbf66819555bf$export$ef2bd08fc1b88107),
                            state: {
                                init () {
                                    return $0f42ee7f81761719$var$EMPTY_STATE;
                                },
                                apply (tr, oldPluginState) {
                                    const meta = tr.getMeta((0, $4f3bbf66819555bf$export$ef2bd08fc1b88107));
                                    if (meta) return {
                                        ...oldPluginState,
                                        ...meta
                                    };
                                    return oldPluginState;
                                }
                            }
                        })
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ()=>[
                    {
                        id: 'aiSpeechToText',
                        title: 'Speech to text',
                        description: 'Dictate text using your voice',
                        priority: 600,
                        keywords: [
                            'speech',
                            'voice',
                            'dictation',
                            'microphone',
                            'audio',
                            'speak',
                            'stt'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAxHS))), {
                                label: "AI Speech to Text"
                            }),
                        action: (insert)=>{
                            const tr = insert('');
                            return tr.setMeta((0, $4f3bbf66819555bf$export$ef2bd08fc1b88107), {
                                isListening: true
                            });
                        }
                    }
                ]
        },
        contentComponent () {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e9f8fa3c2ed9770$export$27e3d771cf5f0905), {
                cloudId: $0f42ee7f81761719$var$CLOUD_ID_INTERNAL_USE_ONLY,
                api: api
            });
        }
    };
};
module.exports["aiSpeechToTextPlugin"] = $0f42ee7f81761719$export$8fc6b5430a555c3d;

});

parcelRegister("2Q35l", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $b0RMS = parcelRequire("b0RMS");

var $4HWgE = parcelRequire("4HWgE");


var $kLUwv = parcelRequire("kLUwv");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $ks2lK = parcelRequire("ks2lK");

const $b28d00192bc1ed83$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('aiImageGenerationPlugin');


const $802b4ba70913279d$export$f766031ad28e12e3 = 'OPEN_POPUP';
const $802b4ba70913279d$export$1be3e111c71a5c61 = 'CLOSE_POPUP';
const $802b4ba70913279d$var$setPopupMeta = ({ type: type, tr: tr })=>tr.setMeta((0, $b28d00192bc1ed83$export$18d4026d1ea86bb1), {
        type: type
    });
const $802b4ba70913279d$export$32885d2e40b7f4e1 = (tr)=>{
    return $802b4ba70913279d$var$setPopupMeta({
        type: $802b4ba70913279d$export$f766031ad28e12e3,
        tr: tr
    });
};
const $802b4ba70913279d$export$ce1e1e9445fb8c72 = (tr)=>{
    return $802b4ba70913279d$var$setPopupMeta({
        type: $802b4ba70913279d$export$1be3e111c71a5c61,
        tr: tr
    });
};



var $1S4f7 = parcelRequire("1S4f7");


var $ftzrq = parcelRequire("ftzrq");



const $0e68c5a8b6112cc3$export$330c1774242547b5 = 'data-ai-image-generation-anchor';
const $0e68c5a8b6112cc3$var$ANCHOR_DECORATION_KEY = 'ai-image-generation-anchor';
const $0e68c5a8b6112cc3$var$createAnchorWidget = (pos)=>(0, $ftzrq.Decoration).widget(pos, ()=>{
        const el = document.createElement('span');
        el.setAttribute($0e68c5a8b6112cc3$export$330c1774242547b5, 'true');
        el.contentEditable = 'false';
        el.style.cssText = 'display: inline-block; width: 0; height: 0; vertical-align: baseline; pointer-events: none;';
        return el;
    }, {
        side: -1,
        key: $0e68c5a8b6112cc3$var$ANCHOR_DECORATION_KEY
    });
const $0e68c5a8b6112cc3$export$f99f3880a7ce1ed9 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init () {
                return {
                    isOpen: false,
                    decorations: (0, $ftzrq.DecorationSet).empty
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $b28d00192bc1ed83$export$18d4026d1ea86bb1));
                const mappedDecorations = pluginState.decorations.map(tr.mapping, tr.doc);
                switch(meta?.type){
                    case 0, $802b4ba70913279d$export$f766031ad28e12e3:
                        return {
                            isOpen: true,
                            decorations: (0, $ftzrq.DecorationSet).create(tr.doc, [
                                $0e68c5a8b6112cc3$var$createAnchorWidget(tr.selection.from)
                            ])
                        };
                    case 0, $802b4ba70913279d$export$1be3e111c71a5c61:
                        return {
                            isOpen: false,
                            decorations: (0, $ftzrq.DecorationSet).empty
                        };
                    default:
                        // If a doc edit destroyed the anchor position, auto-close so the
                        // popup can't render against a missing target.
                        if (pluginState.isOpen && mappedDecorations.find().length === 0) return {
                            isOpen: false,
                            decorations: (0, $ftzrq.DecorationSet).empty
                        };
                        return {
                            isOpen: pluginState.isOpen,
                            decorations: mappedDecorations
                        };
                }
            }
        },
        key: (0, $b28d00192bc1ed83$export$18d4026d1ea86bb1),
        props: {
            decorations (state) {
                return (0, $b28d00192bc1ed83$export$18d4026d1ea86bb1).getState(state)?.decorations;
            }
        }
    });
};



/* AIImageGenerationPopup.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");





var $bEBg8 = parcelRequire("bEBg8");

var $jwWgu = parcelRequire("jwWgu");

var $g6sXu = parcelRequire("g6sXu");


var $aFUXX = parcelRequire("aFUXX");


var $gdv5Z = parcelRequire("gdv5Z");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1qfLF = parcelRequire("1qfLF");


var $e6Iiv = parcelRequire("e6Iiv");


var $auTg8 = parcelRequire("auTg8");


var $1JdaQ = parcelRequire("1JdaQ");


var $fi7Vj = parcelRequire("fi7Vj");


var $55skd = parcelRequire("55skd");


var $khxQ7 = parcelRequire("khxQ7");


var $acwPl = parcelRequire("acwPl");


var $gyXPd = parcelRequire("gyXPd");


var $jS0a0 = parcelRequire("jS0a0");


var $36iDo = parcelRequire("36iDo");


var $kYgUn = parcelRequire("kYgUn");


var $gCiM9 = parcelRequire("gCiM9");


var $fMaLE = parcelRequire("fMaLE");


var $euUgw = parcelRequire("euUgw");


var $8tSmd = parcelRequire("8tSmd");


var $2Nwuj = parcelRequire("2Nwuj");


var $lAFHW = parcelRequire("lAFHW");







var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $kw19Z = parcelRequire("kw19Z");


var $6T8v4 = parcelRequire("6T8v4");


var $9URG7 = parcelRequire("9URG7");

const $b97c0e98741375a9$var$i18n = (0, $aXWIB.defineMessages)({
    createImageLabel: {
        id: "ai-image-generation.image-from-ai-generation.create-image-label",
        defaultMessage: "Create an image"
    },
    rovoIconAlt: {
        id: "ai-image-generation.image-from-ai-generation.rovo-icon-alt",
        defaultMessage: "Rovo icon"
    },
    describeImagePrompt: {
        id: "ai-image-generation.image-from-ai-generation.describe-image-prompt",
        defaultMessage: "Describe an image to create"
    },
    describeImagePlaceholder: {
        id: "ai-image-generation.image-from-ai-generation.describe-image-placeholder",
        defaultMessage: "Describe what you'd like to see..."
    },
    generateImage: {
        id: "ai-image-generation.image-from-ai-generation.generate-image",
        defaultMessage: "Generate image"
    },
    pickStyleLabel: {
        id: "ai-image-generation.image-from-ai-generation.pick-style-label",
        defaultMessage: "Pick a style"
    },
    pickRatioLabel: {
        id: "ai-image-generation.image-from-ai-generation.pick-ratio-label",
        defaultMessage: "Ratio"
    },
    styleWatercolors: {
        id: "ai-image-generation.image-from-ai-generation.style-watercolors",
        defaultMessage: "Watercolors"
    },
    styleSketch: {
        id: "ai-image-generation.image-from-ai-generation.style-sketch",
        defaultMessage: "Sketch"
    },
    styleThreeD: {
        id: "ai-image-generation.image-from-ai-generation.style-3d",
        defaultMessage: "3D"
    },
    aspectRatioLabel: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-label",
        defaultMessage: "Select a ratio"
    },
    aspectRatioAuto: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-auto-16-9",
        defaultMessage: "Auto 16:9"
    },
    aspectRatioLandscape: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-landscape",
        defaultMessage: "Landscape 3:2"
    },
    aspectRatioSquare: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-square",
        defaultMessage: "Square 1:1"
    },
    aspectRatioPortrait: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-portrait",
        defaultMessage: "Portrait 2:3"
    },
    aspectRatioNarrow: {
        id: "ai-image-generation.image-from-ai-generation.aspect-ratio-narrow",
        defaultMessage: "Narrow 9:16"
    },
    footerMessage: {
        id: "ai-image-generation.image-from-ai-generation.footer-message",
        defaultMessage: "Uses AI. Verify results."
    }
});
const $b97c0e98741375a9$var$styles = {
    rovoIcon: "_1bsb7vkz _4t3i7vkz _18u0v77o _1e0c1txw _4cvr1h6o _1bah1h6o",
    imagePromptContainer: "_2rko1mok _1dqonqa1 _1h6d1l7x _189ee4h9 _18zrpxbi _1bsb1osq _1e0c1txw _4cvr1h6o _1wpz1fhb _1bah1h6o _bfhkvuon _1q51pxbi _85i5utpp _1pfhutpp _16qs1btb",
    stack: "_1bsb1osq _2lx21bp4",
    actionsRow: "_1bsb1osq _1e0c1txw _4cvr1h6o _1bahesu3",
    ratioPickerContainer: "_n3tdu2gc",
    footer: "_syaz1rpy _1q51u2gc _1e0c1txw _1bah1h6o _1pfh196n _6rthxmi2"
};
function $b97c0e98741375a9$export$1d338a5d45615a0b({ mediaUploadCollection: mediaUploadCollection, closePopup: closePopup, onSubmit: onSubmit, insertMedia: insertMedia }) {
    const intl = (0, $aXWIB.useIntl)();
    const [selectedTheme, setSelectedTheme] = (0, $42omo.useState)(null);
    const [selectedAspectRatio, setSelectedAspectRatio] = (0, $42omo.useState)(null);
    const [isSubmitDisabled, setIsSubmitDisabled] = (0, $42omo.useState)(true);
    const themeOptions = [
        {
            label: intl.formatMessage($b97c0e98741375a9$var$i18n.styleWatercolors),
            value: (0, $9URG7.IMAGE_GENERATION_THEMES).watercolors
        },
        {
            label: intl.formatMessage($b97c0e98741375a9$var$i18n.styleSketch),
            value: (0, $9URG7.IMAGE_GENERATION_THEMES).sketch
        },
        {
            label: intl.formatMessage($b97c0e98741375a9$var$i18n.styleThreeD),
            value: (0, $9URG7.IMAGE_GENERATION_THEMES).threeD
        }
    ];
    const aspectRatioOptions = [
        {
            label: intl.formatMessage($b97c0e98741375a9$var$i18n.aspectRatioAuto),
            value: '16:9'
        },
        {
            label: intl.formatMessage($b97c0e98741375a9$var$i18n.aspectRatioLandscape),
            value: '3:2'
        },
        {
            label: intl.formatMessage($b97c0e98741375a9$var$i18n.aspectRatioSquare),
            value: '1:1'
        },
        {
            label: intl.formatMessage($b97c0e98741375a9$var$i18n.aspectRatioPortrait),
            value: '2:3'
        },
        {
            label: intl.formatMessage($b97c0e98741375a9$var$i18n.aspectRatioNarrow),
            value: '9:16'
        }
    ];
    const textRef = (0, $42omo.useRef)('');
    const textSerializerRef = (0, $42omo.useRef)(null);
    const handleSubmit = (0, $42omo.useCallback)((prompt)=>{
        if (!prompt.trim()) return;
        const aspectRatioToSend = selectedAspectRatio?.value ?? null;
        const imageStyleToSend = selectedTheme?.value ?? null;
        onSubmit(prompt, aspectRatioToSend, imageStyleToSend);
    }, [
        onSubmit,
        selectedAspectRatio,
        selectedTheme
    ]);
    const handleSubmitRef = (0, $42omo.useRef)(handleSubmit);
    (0, $42omo.useEffect)(()=>{
        handleSubmitRef.current = handleSubmit;
    }, [
        handleSubmit
    ]);
    const getTextSerializer = (0, $42omo.useCallback)((editorView)=>{
        if (!textSerializerRef.current) textSerializerRef.current = (0, $kw19Z.default).fromSchema(editorView.state.schema);
        return textSerializerRef.current;
    }, []);
    const onSave = (0, $42omo.useCallback)((editorView)=>{
        const text = getTextSerializer(editorView).serializeFragment(editorView.state.doc.content);
        handleSubmitRef.current(text);
    }, [
        getTextSerializer
    ]);
    const handleEditorChange = (0, $42omo.useCallback)((editorView)=>{
        const text = getTextSerializer(editorView).serializeFragment(editorView.state.doc.content);
        textRef.current = text;
        setIsSubmitDisabled(!text.trim());
    }, [
        getTextSerializer
    ]);
    const handleSubmitClick = (0, $42omo.useCallback)(()=>{
        handleSubmit(textRef.current);
    }, [
        handleSubmit
    ]);
    const { preset: preset } = (0, $1JdaQ.usePreset)((builder)=>builder.add([
            (0, $fi7Vj.default),
            {}
        ]).add((0, $gyXPd.compositionPlugin)).add((0, $jS0a0.focusPlugin)).add((0, $55skd.betterTypeHistoryPlugin)).add([
            (0, $36iDo.pastePlugin),
            {}
        ]).add((0, $acwPl.default)).add((0, $fMaLE.typeAheadPlugin)).add([
            (0, $kYgUn.placeholderPlugin),
            {
                placeholder: intl.formatMessage($b97c0e98741375a9$var$i18n.describeImagePlaceholder)
            }
        ]).add([
            (0, $khxQ7.blockTypePlugin),
            {
                allowBlockType: {
                    exclude: [
                        'heading',
                        'blockquote'
                    ]
                }
            }
        ]).add([
            (0, $gCiM9.saveOnEnterPlugin),
            onSave
        ]), [
        onSave,
        intl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auTg8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b97c0e98741375a9$var$styles.rovoIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
        appearance: "brand",
        size: "xsmall",
        label: intl.formatMessage($b97c0e98741375a9$var$i18n.rovoIconAlt)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "medium",
        weight: "bold"
    }, intl.formatMessage($b97c0e98741375a9$var$i18n.createImageLabel)))), (0, $dh538.fg)('m0_editor_image_generation_exclusion') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        inputId: "image-generation-theme-picker",
        "aria-label": intl.formatMessage($b97c0e98741375a9$var$i18n.pickStyleLabel),
        options: themeOptions,
        value: selectedTheme,
        onChange: (newValue)=>setSelectedTheme(newValue),
        placeholder: intl.formatMessage($b97c0e98741375a9$var$i18n.pickStyleLabel),
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 9999
                })
        },
        menuPortalTarget: typeof document !== 'undefined' ? document.body : null
    }), (0, $dh538.fg)('m0_editor_image_generation_exclusion') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b97c0e98741375a9$var$styles.ratioPickerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage($b97c0e98741375a9$var$i18n.pickRatioLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        inputId: "image-generation-aspect-ratio-picker",
        "aria-label": intl.formatMessage($b97c0e98741375a9$var$i18n.aspectRatioLabel),
        options: aspectRatioOptions,
        value: selectedAspectRatio,
        onChange: (newValue)=>setSelectedAspectRatio(newValue),
        placeholder: intl.formatMessage($b97c0e98741375a9$var$i18n.aspectRatioLabel),
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 9999
                })
        },
        menuPortalTarget: typeof document !== 'undefined' ? document.body : null
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b97c0e98741375a9$var$styles.imagePromptContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b97c0e98741375a9$var$styles.stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6Iiv.ComposableEditor), {
        appearance: "chromeless",
        preset: preset,
        shouldFocus: true,
        onChange: handleEditorChange,
        assistiveLabel: intl.formatMessage($b97c0e98741375a9$var$i18n.describeImagePlaceholder)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b97c0e98741375a9$var$styles.actionsRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        testId: "image-generation-submit",
        appearance: "primary",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($euUgw))),
        label: intl.formatMessage($b97c0e98741375a9$var$i18n.generateImage),
        isDisabled: isSubmitDisabled,
        onClick: handleSubmitClick
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b97c0e98741375a9$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
        color: "currentColor",
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        appearance: "subtle",
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, intl.formatMessage($b97c0e98741375a9$var$i18n.footerMessage)))))));
}




const $043a657859b4c507$var$PopupWithListeners = (0, $g6sXu.default)((0, $jwWgu.default));
const $043a657859b4c507$var$styles = {
    wrapper: "_2rko12b0 _o5724jg8 _y3gn18uv _16qs1nax _1bsb5x59 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhk1bhr"
};
function $043a657859b4c507$export$63fb1df4e3d7b0a7({ api: api, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { mediaProvider: mediaProvider, isOpen: isOpen } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'media',
        'aiImageGeneration'
    ], (states)=>({
            mediaProvider: states.mediaState?.mediaProvider,
            isOpen: states.aiImageGenerationState?.isOpen
        }));
    const closePopup = (0, $42omo.useCallback)(()=>{
        editorView.dispatch((0, $802b4ba70913279d$export$ce1e1e9445fb8c72)(editorView.state.tr));
        editorView.focus();
    }, [
        editorView
    ]);
    const handleClickOutside = (0, $42omo.useCallback)((event)=>{
        // When clicking a Select option, react-select removes the clicked
        // element from the DOM before this handler fires. The detached node
        // is no longer contained in the popup wrapper, so withOuterListeners
        // incorrectly treats it as an outside click. Skip closing when the
        // target has been disconnected from the document.
        const target = event.target;
        if (target && !target.isConnected) return;
        event.preventDefault();
        closePopup();
    }, [
        closePopup
    ]);
    const handleEscapeKeydown = (0, $42omo.useCallback)((event)=>{
        event.preventDefault();
        closePopup();
    }, [
        closePopup
    ]);
    const handleSubmit = (0, $42omo.useCallback)((prompt)=>{
        // TODO: EDITOR-7394 - Implement this functionality
        return null;
    }, []);
    const insertMediaSingle = (0, $42omo.useCallback)(({ id: id, collection: collection, fileMimeType: fileMimeType, dimensions: dimensions })=>{
        const { width: width, height: height } = dimensions || {
            height: undefined,
            width: undefined
        };
        const node = editorView.state.schema.nodes.media.create({
            id: id,
            type: 'file',
            collection: collection,
            width: width,
            height: height,
            __fileMimeType: fileMimeType
        });
        api?.media.actions.insertMediaAsMediaSingle(editorView, node, (0, $d925B.INPUT_METHOD).MEDIA_PICKER, (0, $d925B.INSERT_MEDIA_VIA).EXTERNAL_UPLOAD);
    }, [
        api,
        editorView
    ]);
    if (!isOpen || !mediaProvider) return null;
     // Anchor to the decoration widget that the PM plugin mounts at the caret
    // when the popup opens. The widget is an inline zero-width DOM node, so its
    // bounding rect is aligned with the caret even in center/right-aligned
    // paragraphs, layout columns, table cells, etc.
    const targetRef = editorView.dom.querySelector(`[${(0, $0e68c5a8b6112cc3$export$330c1774242547b5)}]`); // Without a real anchor element Popper would position against the viewport
    // origin. Bail out instead of rendering a mis-placed popup — the next
    // transaction that mounts the widget (or closes the plugin) will re-render.
    if (!targetRef) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($043a657859b4c507$var$PopupWithListeners, {
        ariaLabel: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).aiImageGenerationPopupAriaLabel),
        offset: [
            0,
            12
        ],
        target: targetRef,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        fitHeight: 390,
        fitWidth: 340,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown,
        scrollableElement: popupsScrollableElement,
        preventOverflow: true,
        focusTrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bEBg8.PlainOutsideClickTargetRefContext).Consumer, null, (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: setOutsideClickTargetRef,
            xcss: $043a657859b4c507$var$styles.wrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b97c0e98741375a9$export$1d338a5d45615a0b), {
            mediaUploadCollection: mediaProvider.uploadParams?.collection,
            insertMedia: insertMediaSingle,
            closePopup: closePopup,
            onSubmit: handleSubmit
        }))));
}






function $65df88ae42ef114b$export$e25ea543915fb1a5({ closeMediaInsertPicker: closeMediaInsertPicker, mediaProvider: mediaProvider, api: api }) {
    const handleSubmit = (0, $42omo.useCallback)((prompt, aspectRatio, imageStyle)=>{
        closeMediaInsertPicker();
        const remixModalMetadata = {
            interactionSource: 'remixModalFromMediaInserts',
            aiFeatureName: 'imageGenerationMediaInsert',
            userPrompt: prompt,
            aspectRatio: aspectRatio,
            imageStyle: imageStyle,
            dynamicUiType: 'image',
            remixSource: 'mediaInsert',
            onCancel: ()=>{
                const cmd = api?.mediaInsert?.commands.showMediaInsertPopup();
                if (cmd) api?.core.actions.execute(cmd);
            }
        };
        const cmd = api?.malleableUi?.commands.startRemixThinking({
            remixModalMetadata: remixModalMetadata
        });
        if (!cmd) return;
        api?.core.actions.execute(cmd);
    }, [
        api,
        closeMediaInsertPicker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b97c0e98741375a9$export$1d338a5d45615a0b), {
        mediaUploadCollection: mediaProvider.uploadParams?.collection,
        closePopup: closeMediaInsertPicker,
        onSubmit: handleSubmit
    });
}


const $1841637a271db95a$var$MEDIA_INSERT_AI_TAB_KEY = 'ai-image-generation';
/**
 * Renders the "Create" tab label using the same
 * `intl.formatMessage(...)` pattern that `MediaInsertPicker` uses for its
 * built-in `fileTabTitle` and `linkTabTitle` tabs. Defined at module scope so
 * the component reference is stable across renders.
 */ const $1841637a271db95a$var$GenerateTabLabel = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, intl.formatMessage((0, $b0RMS.mediaInsertMessages).generateTabTitle));
};
const $1841637a271db95a$export$961e3fbb53954d8c = ({ api: api, config: config })=>{
    // Register a "Create" tab on the media insert picker. This keeps
    // the public `editor-plugin-media-insert` package free of `@atlassian/*`
    // dependencies — it only knows about the registry interface, not about
    // AI image generation.
    const { isRemixHidden: isRemixHidden, isRovoLLMEnabled: isRovoLLMEnabled } = config ?? {
        isRemixHidden: true,
        isRovoLLMEnabled: false
    };
    const isRemixEnabled = isRovoLLMEnabled && (0, $dZ8uq.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    if ((0, $1oCLl.expValEquals)('cc_page_experiences_editor_image_generation', 'isEnabled', true) && api && !isRemixHidden && isRemixEnabled) api?.mediaInsert?.actions.registerInsertTab({
        key: $1841637a271db95a$var$MEDIA_INSERT_AI_TAB_KEY,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1841637a271db95a$var$GenerateTabLabel, null),
        component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $65df88ae42ef114b$export$e25ea543915fb1a5), {
                closeMediaInsertPicker: props.closeMediaInsertPicker,
                dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
                insertMediaSingle: props.insertMediaSingle,
                mediaProvider: props.mediaProvider,
                api: api
            })
    });
    return {
        name: 'aiImageGeneration',
        pmPlugins () {
            return [
                {
                    name: 'aiImageGeneration',
                    plugin: ()=>(0, $0e68c5a8b6112cc3$export$f99f3880a7ce1ed9)()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                isOpen: false
            };
            const state = (0, $b28d00192bc1ed83$export$18d4026d1ea86bb1).getState(editorState);
            if (!state) return {
                isOpen: false
            };
            return {
                isOpen: state.isOpen
            };
        },
        commands: {
            showAIImageGenerationPopup: ()=>({ tr: tr })=>(0, $802b4ba70913279d$export$32885d2e40b7f4e1)(tr)
        },
        contentComponent: ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $043a657859b4c507$export$63fb1df4e3d7b0a7), {
                api: api,
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>{
                /**
         * expValEquals('cc_page_experiences_editor_image_generation', 'isEnabled', true) is for overall experiment
         *
         * fg('m0_editor_image_generation_exclusion') for features that's been hidden in M0. If this is not on
         * it should not show up in the quick insert.
         */ if (!(0, $1oCLl.expValEquals)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) return [];
                if (!(0, $dh538.fg)('m0_editor_image_generation_exclusion')) return [];
                const title = formatMessage((0, $4HWgE.toolbarInsertBlockMessages).aiImageGeneration);
                return [
                    {
                        id: 'aiImageGeneration',
                        title: title,
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).aiImageGenerationDescription),
                        priority: 500,
                        keywords: [
                            'ai',
                            'generate',
                            'image',
                            'create',
                            'picture'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kLUwv))), {
                                label: title,
                                color: "currentColor"
                            }),
                        isDisabledOffline: true,
                        action (insert) {
                            const tr = insert('');
                            api?.aiImageGeneration.commands.showAIImageGenerationPopup()({
                                tr: tr
                            });
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};
module.exports["aiImageGenerationPlugin"] = $1841637a271db95a$export$961e3fbb53954d8c;

});

parcelRegister("bpbkI", function(module, exports) {

var $42omo = parcelRequire("42omo");





var $24P9d = parcelRequire("24P9d");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");

/* SuggestionIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");




const $95fcf8bb61fa82af$export$e4f30354a76c156b = (0, $aXWIB.defineMessages)({
    suggestEditsButtonLabel: {
        id: "fabric.editor.ai.suggestions.suggestEditsButtonLabel",
        defaultMessage: "Review"
    },
    suggestEditsPromptPrefix: {
        id: "fabric.editor.ai.suggestions.suggestEditsPromptPrefix.non-final",
        defaultMessage: "Review my content with "
    },
    suggestionsToolbarButtonLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.label.non-final",
        defaultMessage: "Suggestions"
    },
    suggestionsToolbarButtonLoadingLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.loadingLabel.non-final",
        defaultMessage: "Loading"
    },
    suggestionsToolbarButtonReadyLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.readyLabel.non-final",
        defaultMessage: "View"
    },
    suggestionsToolbarButtonErrorLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.errorLabel.non-final",
        defaultMessage: "Retry"
    },
    previewLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.previewLabel.non-final",
        defaultMessage: "Preview"
    },
    viewLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.viewLabel.non-final",
        defaultMessage: "View"
    },
    titleLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.titleLabel.non-final",
        defaultMessage: "Title"
    },
    reviewNote: {
        id: "fabric.editor.ai.suggestions.stagingArea.reviewNote.non-final",
        defaultMessage: "Review \u2022 Only visible to you"
    },
    applyChangesButtonLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.applyChangesButtonLabel.non-final",
        defaultMessage: "Apply changes"
    },
    fetchSuggestionsButtonLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.fetchSuggestionsButtonLabel.non-final",
        defaultMessage: "Fetch suggestions"
    },
    fetchSuggestionsButtonLoadingLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.fetchSuggestionsButtonLoadingLabel.non-final",
        defaultMessage: "Loading\u2026"
    },
    iconButtonSuggestionsCountLabel: {
        id: "fabric.editor.ai.suggestions.iconButton.suggestionsCountLabel.non-final",
        defaultMessage: "{count} suggestions"
    },
    originalViewLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.originalViewLabel.non-final",
        defaultMessage: "Original \u2022 View only"
    },
    suggestedLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.suggestedLabel.non-final",
        defaultMessage: "Suggested"
    },
    suggestionsLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.suggestionsLabel.non-final",
        defaultMessage: "Suggestions"
    },
    cardCloseButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.closeButtonLabel.non-final",
        defaultMessage: "Close"
    },
    cardShowSidebarButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.showSidebarButtonLabel.non-final",
        defaultMessage: "Show sidebar"
    },
    cardExpandButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.expandButtonLabel.non-final",
        defaultMessage: "Expand"
    },
    cardCollapseButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.collapseButtonLabel.non-final",
        defaultMessage: "Collapse"
    },
    cardRovoTitle: {
        id: "fabric.editor.ai.suggestions.card.rovoTitle.non-final",
        defaultMessage: "Rovo"
    },
    cardPrivateLabel: {
        id: "fabric.editor.ai.suggestions.card.privateLabel.non-final",
        defaultMessage: "Private"
    },
    cardPrivateTooltipLabel: {
        id: "fabric.editor.ai.suggestions.card.privateTooltipLabel.non-final",
        defaultMessage: "Only you and those with access to the sources can see this private suggestion."
    },
    cardSourcesButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.sourcesButtonLabel.non-final",
        defaultMessage: "Sources"
    },
    cardSourcesHideButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.sourcesHideButtonLabel.non-final",
        defaultMessage: "Hide reasoning"
    },
    cardSourcesShowButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.sourcesShowButtonLabel.non-final",
        defaultMessage: "Show reasoning"
    },
    cardAcceptButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.acceptButtonLabel.non-final",
        defaultMessage: "Accept"
    },
    cardDiscardButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.discardButtonLabel.non-final",
        defaultMessage: "Discard"
    },
    cardMoreOptionsButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.moreOptionsButtonLabel.non-final",
        defaultMessage: "More options"
    },
    cardOnlyShowSuggestionOptionLabel: {
        id: "fabric.editor.ai.suggestions.card.onlyShowSuggestionOptionLabel.non-final",
        defaultMessage: "Only show suggestion"
    },
    cardCompareWithOriginalOptionLabel: {
        id: "fabric.editor.ai.suggestions.card.compareWithOriginalOptionLabel.non-final",
        defaultMessage: "Compare with original"
    },
    cardScrollBackToSuggestionLabel: {
        id: "fabric.editor.ai.suggestions.card.scrollBackToSuggestionLabel.non-final",
        defaultMessage: "Back to suggestion"
    },
    thinkingEscHint: {
        id: "fabric.editor.ai.suggestions.thinking.escHint.non-final",
        defaultMessage: "Esc"
    },
    thinkingStopLabel: {
        id: "fabric.editor.ai.suggestions.thinking.stopLabel.non-final",
        defaultMessage: "Stop"
    },
    thinkingReviewingContent: {
        id: "fabric.editor.ai.suggestions.thinking.reviewingContent.non-final",
        defaultMessage: "Reviewing content"
    },
    thinkingCheckingRelatedSources: {
        id: "fabric.editor.ai.suggestions.thinking.checkingRelatedSources.non-final",
        defaultMessage: "Checking related sources"
    },
    thinkingIdentifyingImprovements: {
        id: "fabric.editor.ai.suggestions.thinking.identifyingImprovements.non-final",
        defaultMessage: "Identifying improvements"
    },
    thinkingPreparingSuggestions: {
        id: "fabric.editor.ai.suggestions.thinking.preparingSuggestions.non-final",
        defaultMessage: "Preparing suggestions"
    },
    thinkingCompleteReviewComplete: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.reviewComplete.non-final",
        defaultMessage: "Suggestions ready"
    },
    thinkingCompleteNoSuggestions: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.noSuggestions.non-final",
        defaultMessage: "No suggestions found"
    },
    thinkingCompleteViewSuggestions: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.viewSuggestions.non-final",
        defaultMessage: "View"
    },
    thinkingCompleteClose: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.close.non-final",
        defaultMessage: "Close"
    }
});



var $eiA8Z = parcelRequire("eiA8Z");


var $3gadb = parcelRequire("3gadb");

/* SuggestionIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $4c15c1a45640068e$var$sizeStyles = {
    small: "_1bsb1crf _4t3i1crf",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $4c15c1a45640068e$var$svgStyles = null;
const $4c15c1a45640068e$export$29d3364b0f29ebd1 = (props)=>{
    const { size: size = 'large', label: label } = props;
    const clipPathId = (0, $42omo.useId)();
    return /*#__PURE__*/ $42omo.createElement("svg", {
        fill: "none",
        viewBox: "0 0 16 16",
        "aria-label": label,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lcxvglyw",
            $4c15c1a45640068e$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $42omo.createElement("defs", null, /*#__PURE__*/ $42omo.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $42omo.createElement("path", {
        d: "M8.11719 1.00879C8.38352 1.05062 8.61063 1.23423 8.70508 1.49316L10.2549 5.74414L14.5068 7.29492C14.8027 7.40285 14.9998 7.6841 15 7.99902V8.00098C14.9998 8.3159 14.8027 8.59715 14.5068 8.70508L10.2549 10.2549L8.70508 14.5068C8.59715 14.8027 8.3159 14.9998 8.00098 15H7.99902C7.6841 14.9998 7.40285 14.8027 7.29492 14.5068L5.74414 10.2549L1.49316 8.70508C1.19728 8.59715 1.00018 8.3159 1 8.00098V7.99902C1.00018 7.6841 1.19728 7.40285 1.49316 7.29492L5.74414 5.74414L7.29492 1.49316L7.34277 1.38672C7.47321 1.15076 7.72343 1.00016 7.99902 1H8.00098L8.11719 1.00879Z"
    }))), /*#__PURE__*/ $42omo.createElement("g", {
        clipPath: `url(#${clipPathId})`
    }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
        x: "0",
        y: "0",
        width: "16",
        height: "16",
        transform: "rotate(-45 8 8)"
    }, props.children)));
};


const $cbd7514796298a2b$var$suggestionIconScaleVar = '--suggestion-icon-scale';
const $cbd7514796298a2b$var$suggestionIconRotateVar = '--suggestion-icon-rotate';
const $cbd7514796298a2b$var$suggestionIconOpacityVar = '--suggestion-icon-opacity';
const $cbd7514796298a2b$var$styles = {
    container: "_kqswstnw _t9ecxwn4 _lcxv1rj4",
    button: "_1e0c1ule _1xt0kb7n _f5sg1i1e _1189kb7n _hpcc1ule _1ie5ye00 _15n719f8 _2pmaidpf",
    svgContainer: "_v56411vi _1e0c1txw _4cvr1h6o _1bah1h6o _8hrzaqso _t9echyyl",
    baseIconColorForeignObject: "_v564jm62 _4t3i1osq _1bsb1osq _kqswstnw _154iidpf _1ltvidpf",
    iconColor: "_bfhkdgkc _tzy41it5",
    iconColorHover: "_11q71ir1 _tzy41rrz"
};
const $cbd7514796298a2b$var$AnimatedIcon = ()=>/*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $cbd7514796298a2b$var$styles.svgContainer
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $4c15c1a45640068e$export$29d3364b0f29ebd1), {
        label: "",
        size: "small"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $cbd7514796298a2b$var$styles.baseIconColorForeignObject,
            $cbd7514796298a2b$var$styles.iconColor
        ])
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $cbd7514796298a2b$var$styles.baseIconColorForeignObject,
            $cbd7514796298a2b$var$styles.iconColorHover
        ])
    })));
function $cbd7514796298a2b$export$b6eb36123ab7ffdf({ leftAdjustment: leftAdjustment, suggestion: suggestion, suggestionsCount: suggestionsCount, isSelected: isSelected, api: api, intl: intl, topAdjustment: topAdjustment }) {
    const { baseLocalIdBySuggestionId: baseLocalIdBySuggestionId } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions'
    ], (state)=>{
        const { baseLocalIdBySuggestionId: baseLocalIdBySuggestionId } = state?.aiSuggestionsState ?? {};
        return {
            baseLocalIdBySuggestionId: baseLocalIdBySuggestionId
        };
    });
    const onSelectSuggestion = ()=>{
        api?.aiSuggestions?.actions.selectSuggestion(suggestion.id, {
            entryPoint: 'card'
        });
    };
    const tooltipContent = (0, $42omo.useMemo)(()=>suggestionsCount > 1 ? intl?.formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).iconButtonSuggestionsCountLabel, {
            count: suggestionsCount
        }) || suggestion.shortDescription : suggestion.shortDescription, [
        intl,
        suggestion.shortDescription,
        suggestionsCount
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $aXWIB.IntlProvider), {
        defaultLocale: intl?.defaultLocale || 'en-US',
        locale: intl?.locale || 'en-US',
        messages: intl?.messages,
        formats: intl?.formats
    }, /*#__PURE__*/ $42omo.createElement("span", {
        style: {
            anchorName: `--button-${baseLocalIdBySuggestionId?.get(suggestion.id)}`,
            top: topAdjustment ?? 0,
            right: `calc(${"var(--ds-space-negative-300, -24px)"} + ${"var(--ds-space-negative-300, -24px)"} - ${leftAdjustment ?? 0}px)`
        },
        className: (0, $gMc0m.default)([
            $cbd7514796298a2b$var$styles.container
        ])
    }, // We keep the anchorName span rendered so that the suggestion card can reference it
    !isSelected && /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        content: tooltipContent,
        position: "right"
    }, /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $cbd7514796298a2b$var$styles.button
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
        shape: "circle",
        type: "button",
        label: tooltipContent,
        onClick: onSelectSuggestion,
        appearance: "subtle",
        spacing: "compact",
        icon: $cbd7514796298a2b$var$AnimatedIcon
    })))));
}


function $ffa0ca393e54921b$export$8eb2ba4e0b5d0f47(params) {
    const suggestionById = new Map();
    const suggestionIdsByLocalId = new Map();
    const baseLocalIdBySuggestionId = new Map();
    const suggestionIdsByBaseLocalId = new Map();
    const orderedSuggestionIds = [];
    if (!params) return {
        suggestionById: suggestionById,
        baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
        orderedSuggestionIds: orderedSuggestionIds,
        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId
    };
    const { suggestions: suggestions, doc: doc } = params;
    for (const suggestion of suggestions){
        suggestionById.set(suggestion.id, suggestion);
        const firstToolCall = suggestion.toolCalls[0];
        /**
		 * Only add the first tool call to the suggestionIdsByLocalId map
		 * to simplify navigation, stacking, and getting logic.
		 */ if (firstToolCall) {
            const localId = 'localId' in firstToolCall.arguments ? firstToolCall.arguments.localId : undefined;
            if (localId) {
                const ids = suggestionIdsByLocalId.get(localId) ?? new Set();
                ids.add(suggestion.id);
                suggestionIdsByLocalId.set(localId, ids);
            }
        }
    }
    // Map each top-level block position (doc depth 1) to suggestion IDs that target any localId
    // under that block — same docLevelPos as `doc.resolve(pos).before(1)` in the decorations plugin.
    doc.descendants((node, pos)=>{
        const nodeLocalId = node.attrs?.localId;
        if (!nodeLocalId) return true;
        const suggestionIdsAtLocalId = suggestionIdsByLocalId.get(nodeLocalId);
        if (suggestionIdsAtLocalId?.size) {
            const $pos = doc.resolve(pos);
            const baseLocalId = doc.nodeAt($pos.before(1))?.attrs?.localId;
            if (!baseLocalId) return true;
            suggestionIdsAtLocalId.forEach((suggestionId)=>{
                // A localId can repeat across the doc (e.g. clones produced by collab/copy-paste).
                // Keep the first-encountered mapping so each suggestion is anchored once and appears
                // exactly once in the navigation order, otherwise the card stalls on duplicates.
                if (baseLocalIdBySuggestionId.has(suggestionId)) return;
                // each suggestion maps to a base local id
                baseLocalIdBySuggestionId.set(suggestionId, baseLocalId);
                // we use doc.descendants order to determine the order of the suggestions
                orderedSuggestionIds.push(suggestionId);
            });
            const baseSet = suggestionIdsByBaseLocalId.get(baseLocalId) ?? new Set();
            const childSet = suggestionIdsByLocalId.get(nodeLocalId);
            if (childSet) // concat it into the base set
            suggestionIdsByBaseLocalId.set(baseLocalId, new Set([
                ...baseSet,
                ...childSet
            ]));
        }
        return true;
    });
    return {
        suggestionById: suggestionById,
        baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
        orderedSuggestionIds: orderedSuggestionIds,
        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId
    };
}



/**
 * Streaming response types for ConvoAI
 */ function $4bf5ab6f56ba7ee1$export$9167f99f9be83b24() {
    const { origin: origin = '', port: port = '', hostname: hostname = '' } = typeof window.location !== 'undefined' ? window.location : {};
    if (hostname === 'localhost' && port !== '8081' || [
        'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
        'statlas.prod.atl-paas.net',
        'atlaskit.atlassian.com'
    ].some((h)=>hostname === h)) return 'https://pug.jira-dev.com';
    return origin;
}
async function $4bf5ab6f56ba7ee1$export$7ba546d072711b5d(body, options = {}) {
    const { onChunk: onChunk, onFinalResponse: onFinalResponse, onError: onError, signal: signal } = options;
    const reader = body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '';
    let finalResponse = null;
    const chunks = [];
    try {
        while(!signal?.aborted){
            const { value: value, done: done } = await reader.read();
            if (done) break;
            const chunk = decoder.decode(value, {
                stream: true
            });
            buffer += chunk;
            // Split by newlines and process complete lines
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            const lines = buffer.split('\n');
            // Keep the last potentially incomplete line in the buffer
            buffer = lines.pop() || '';
            for (const line of lines){
                if (!line.trim()) continue;
                try {
                    const data = JSON.parse(line);
                    chunks.push(data);
                    onChunk?.(data);
                    // Check for FINAL_RESPONSE type (ConvoAI pattern)
                    if (data.type === 'FINAL_RESPONSE') {
                        finalResponse = data;
                        onFinalResponse?.(data);
                    }
                } catch (parseError) {
                    const error = new Error(`Failed to parse JSON line: ${parseError instanceof Error ? parseError.message : String(parseError)}`);
                    onError?.(error);
                }
            }
        }
        // Check if aborted
        if (signal?.aborted) reader.cancel();
        // Process any remaining buffer content
        if (buffer.trim()) try {
            const data = JSON.parse(buffer);
            chunks.push(data);
            onChunk?.(data);
            if (data.type === 'FINAL_RESPONSE') {
                finalResponse = data;
                onFinalResponse?.(data);
            }
        } catch  {
        // Ignore incomplete final chunk
        }
    } catch (error) {
        const streamError = error instanceof Error ? error : new Error(String(error));
        onError?.(streamError);
        throw streamError;
    }
    return {
        finalResponse: finalResponse,
        chunks: chunks
    };
}
async function $4bf5ab6f56ba7ee1$export$95b9987b6ac049ec(options) {
    const { url: url, fetchOptions: fetchOptions = {}, signal: signal, onChunk: onChunk, onError: onError, onFinalResponse: onFinalResponse } = options;
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        ...fetchOptions,
        signal: signal
    });
    if (!response.ok) {
        const error = new Error(`Response not OK: ${response.status}`);
        onError?.(error);
        throw error;
    }
    if (!response.body) {
        const error = new Error('No response body');
        onError?.(error);
        throw error;
    }
    return $4bf5ab6f56ba7ee1$export$7ba546d072711b5d(response.body, {
        onChunk: onChunk,
        onError: onError,
        onFinalResponse: onFinalResponse,
        signal: signal
    });
}


async function $e60244890fd6203e$export$ebf2f44fe450da2b({ contentAri: contentAri, signal: signal }) {
    const url = `${(0, $4bf5ab6f56ba7ee1$export$9167f99f9be83b24)()}/gateway/api/assist/api/ai/v2/ai-feature/content-suggested-edits/suggestions?content_ari=${encodeURIComponent(contentAri)}&status=PENDING`;
    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        signal: signal
    });
    if (!response.ok) throw new Error(`Get suggestions request failed: ${response.status}`);
    const data = await response.json();
    const items = data?.ai_feature_output?.items;
    return Array.isArray(items) ? items : [];
}
async function $e60244890fd6203e$export$1d496d000386893c({ updates: updates, signal: signal }) {
    // /ai-features/content-suggested-edits/update-status
    const payload = {
        experience_id: 'ai-content-suggested-edits',
        ai_feature_input: {
            updates: updates
        }
    };
    const url = `${(0, $4bf5ab6f56ba7ee1$export$9167f99f9be83b24)()}/gateway/api/assist/api/ai/v2/ai-feature/content-suggested-edits/update-status`;
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Channel-Id': 'editor',
            'X-Product': 'confluence',
            'X-Experience-Id': 'editor'
        },
        body: JSON.stringify(payload),
        signal: signal
    });
    if (!response.ok) throw new Error(`Content suggested edits request failed: ${response.status}`);
}


const $072616480be2cdf6$export$740daa9a9ce77ea8 = async ({ api: api, contentAri: contentAri, signal: signal })=>{
    if (!api) return;
    /**
	 * If the contentAri is not provided
	 */ if (!contentAri) {
        const suggestions = await (0, $e60244890fd6203e$export$ebf2f44fe450da2b)({
            contentAri: '',
            signal: signal
        });
        api?.core?.actions?.execute(({ tr: tr })=>{
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'SET_SUGGESTIONS',
                suggestions: suggestions,
                contentAri: contentAri || undefined
            });
            return tr;
        });
        return;
    }
    const suggestions = await (0, $e60244890fd6203e$export$ebf2f44fe450da2b)({
        contentAri: contentAri,
        signal: signal
    });
    api?.core?.actions?.execute(({ tr: tr })=>{
        tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
            action: 'SET_SUGGESTIONS',
            suggestions: suggestions,
            contentAri: contentAri || undefined
        });
        return tr;
    });
};


/**
 * We have different adjustments for aligned headings vs. non-aligned headings because
 * they have different margins for some reason, see platform/packages/editor/editor-common/src/styles/shared/headings.ts
 *
 * This is just hard coded at the moment to mimic the positioning logic of block controls plugin, and won't be needed
 * once the icon button positioning logic is moved to a new block controls plugin API.
 */ const $4eed6fc998ed6bbf$var$nodeTopAdjustments = {
    table: 12,
    paragraph: 2,
    heading1: 5,
    heading2: 2,
    heading3: -1,
    heading4: -3,
    heading5: -3,
    heading6: -3,
    heading1_aligned: 5,
    heading2_aligned: 2,
    heading3_aligned: -1,
    heading4_aligned: -3,
    heading5_aligned: -3,
    heading6_aligned: -3,
    layoutSection: 8
};
/**
 * It would be easier to get the margin from the DOM but we don't have access to the view / DOM here
 * so we hard code these values for now, until everything's moved to the block controls plugin.
 */ const $4eed6fc998ed6bbf$var$nodeTopMargins = {
    table: 12,
    paragraph: 12,
    bulletList: 12,
    orderedList: 12,
    decisionList: 8,
    taskList: 12,
    codeBlock: 12,
    panel: 12,
    rule: 4,
    heading1: 40,
    heading2: 32,
    heading3: 24,
    heading4: 20,
    heading5: 20,
    heading6: 20,
    heading1_aligned: 45,
    heading2_aligned: 41,
    heading3_aligned: 36,
    heading4_aligned: 21,
    heading5_aligned: 22,
    heading6_aligned: 18,
    blockquote: 12,
    expand: 4
};
/**
 * Bottom margins of nodes that affect how the icon button is positioned
 */ const $4eed6fc998ed6bbf$var$nodeBeforeAdjustments = {
    rule: 24,
    extension: 12
};
const $4eed6fc998ed6bbf$var$constructHeadingAdjustmentKey = (node)=>{
    if (node.type.name === 'heading') {
        const level = node.attrs.level;
        const hasAlignment = node.marks.some((mark)=>mark.type.name === 'alignment');
        return `heading${level}${hasAlignment ? '_aligned' : ''}`;
    }
    return node.type.name;
};
/**
 * If `pos` resolves to inside one (or more) `expand` / `nestedExpand` nodes,
 * return the doc-coordinate range of the *outermost* such ancestor. Used to
 * pin the suggestion card's anchor spans to the visible top/bottom of the
 * expand instead of to the deep inner target node — that way the card lines
 * up with the expand the user actually sees, not with content buried in its
 * (now revealed) body.
 */ function $4eed6fc998ed6bbf$var$findOutermostExpandRange(doc, pos) {
    const $pos = doc.resolve(pos);
    let outermostExpandDepth;
    for(let depth = $pos.depth; depth > 0; depth--){
        const node = $pos.node(depth);
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') outermostExpandDepth = depth;
    }
    if (outermostExpandDepth === undefined) return undefined;
    return {
        startPos: $pos.before(outermostExpandDepth),
        endPos: $pos.after(outermostExpandDepth)
    };
}
const $4eed6fc998ed6bbf$export$dbbefe45c19011aa = new (0, $ks2lK.PluginKey)('aiSuggestionsPlugin');
const $4eed6fc998ed6bbf$var$pointTouchesRange = (point, range)=>point >= range.from && point <= range.to;
const $4eed6fc998ed6bbf$var$rangesOverlap = (rangeA, rangeB)=>{
    if (rangeA.from === rangeA.to) return $4eed6fc998ed6bbf$var$pointTouchesRange(rangeA.from, rangeB);
    if (rangeB.from === rangeB.to) return $4eed6fc998ed6bbf$var$pointTouchesRange(rangeB.from, rangeA);
    return rangeA.from < rangeB.to && rangeB.from < rangeA.to;
};
const $4eed6fc998ed6bbf$var$getDecoratedNodeRanges = (doc, suggestionIdsByBaseLocalId)=>{
    const decoratedNodeRanges = [];
    doc.descendants((node, pos)=>{
        if (suggestionIdsByBaseLocalId.has(node.attrs?.localId)) {
            decoratedNodeRanges.push({
                from: pos,
                to: pos + node.nodeSize
            });
            return false;
        }
        return true;
    });
    return decoratedNodeRanges;
};
const $4eed6fc998ed6bbf$var$docChangeAffectsDecorations = ({ doc: doc, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, tr: tr })=>{
    if (!tr.docChanged || suggestionIdsByBaseLocalId.size === 0) return false;
    const decoratedNodeRanges = $4eed6fc998ed6bbf$var$getDecoratedNodeRanges(doc, suggestionIdsByBaseLocalId);
    if (decoratedNodeRanges.length === 0) return false;
    return tr.mapping.maps.some((stepMap)=>{
        let affectsDecorations = false;
        stepMap.forEach((oldStart, oldEnd)=>{
            if (affectsDecorations) return;
            const changedRange = {
                from: oldStart,
                to: oldEnd
            };
            affectsDecorations = decoratedNodeRanges.some((decoratedRange)=>$4eed6fc998ed6bbf$var$rangesOverlap(changedRange, decoratedRange));
        });
        return affectsDecorations;
    });
};
function $4eed6fc998ed6bbf$var$calculateSuggestionsDecorations({ doc: doc, suggestionById: suggestionById, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, api: api, intl: intl, selectedSuggestion: selectedSuggestion, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    if (suggestionById.size === 0) return (0, $ftzrq.DecorationSet).empty;
    const decorations = [];
    doc.descendants((node, pos)=>{
        const { localId: localId } = node.attrs;
        if (localId) {
            const suggestionsAtLocalId = suggestionIdsByBaseLocalId.get(localId);
            if (suggestionsAtLocalId?.size) {
                const firstSuggestionId = suggestionsAtLocalId.values().next().value;
                const firstSuggestion = firstSuggestionId ? suggestionById.get(firstSuggestionId) : undefined;
                if (firstSuggestion) {
                    const element = document.createElement('span');
                    const nodeTypeName = node.type.name === 'heading' ? $4eed6fc998ed6bbf$var$constructHeadingAdjustmentKey(node) : node.type.name;
                    element.setAttribute('style', (0, $24P9d.convertToInlineCss)({
                        position: 'relative',
                        width: '100%',
                        display: 'block',
                        pointerEvents: 'none'
                    }));
                    const key = crypto.randomUUID();
                    const isSelected = Boolean(selectedSuggestion && suggestionsAtLocalId.has(selectedSuggestion));
                    // Tables don't use breakout for resizing, the width is stored in the attrs
                    // The (-4) is mimicking spacing of the remix icon button in block controls plugin
                    const leftAdjustment = node.type.name === 'table' && typeof node.attrs?.width === 'number' ? (node.attrs.width - 760) / 2 - 4 : 0;
                    const nodeBefore = doc.resolve(pos).nodeBefore;
                    const isBlockLeafNodeBefore = nodeBefore?.isBlock && nodeBefore.isLeaf;
                    const topAdjustment = $4eed6fc998ed6bbf$var$nodeTopAdjustments[nodeTypeName] ?? 0;
                    const topMargin = $4eed6fc998ed6bbf$var$nodeTopMargins[nodeTypeName] ?? 0;
                    const nodeBeforeAdjustment = $4eed6fc998ed6bbf$var$nodeBeforeAdjustments[nodeBefore?.type.name ?? ''] ?? 0;
                    const calculatedTopAdjustment = (pos === 0 ? 0 : isBlockLeafNodeBefore ? Math.max(0, topMargin - nodeBeforeAdjustment) : topMargin) + topAdjustment;
                    decorations.push((0, $ftzrq.Decoration).widget(pos, ()=>{
                        nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbd7514796298a2b$export$b6eb36123ab7ffdf), {
                                leftAdjustment: leftAdjustment,
                                topAdjustment: calculatedTopAdjustment,
                                suggestion: firstSuggestion,
                                suggestionsCount: suggestionsAtLocalId?.size,
                                isSelected: isSelected,
                                api: api,
                                intl: intl
                            }), element, key);
                        return element;
                    }, {
                        side: -2,
                        key: key,
                        marks: node.marks.filter((mark)=>mark.type.name === 'breakout'),
                        destroy: ()=>{
                        // Clean up properly
                        // nodeViewPortalProviderAPI.remove(key);
                        }
                    }));
                    if (isSelected) {
                        const selectedSuggestionData = selectedSuggestion ? suggestionById.get(selectedSuggestion) : undefined;
                        const selectedSuggestionFirstToolCall = selectedSuggestionData?.toolCalls[0];
                        const selectedSuggestionFirstToolCallLocalId = selectedSuggestionFirstToolCall && 'localId' in selectedSuggestionFirstToolCall.arguments ? selectedSuggestionFirstToolCall.arguments.localId : undefined;
                        if (selectedSuggestionFirstToolCallLocalId) {
                            let firstToolCallNodePosition;
                            if (selectedSuggestionFirstToolCallLocalId === localId) firstToolCallNodePosition = {
                                pos: pos,
                                nodeSize: node.nodeSize
                            };
                            else node.descendants((descendant, descendantPos)=>{
                                if (firstToolCallNodePosition) return false;
                                const descendantLocalId = descendant.attrs?.localId;
                                if (descendantLocalId === selectedSuggestionFirstToolCallLocalId) {
                                    firstToolCallNodePosition = {
                                        pos: pos + descendantPos + 1,
                                        nodeSize: descendant.nodeSize
                                    };
                                    return false;
                                }
                                return true;
                            });
                            const innerCardStartPos = firstToolCallNodePosition?.pos ?? pos;
                            const innerCardEndPos = firstToolCallNodePosition ? firstToolCallNodePosition.pos + firstToolCallNodePosition.nodeSize : pos + node.nodeSize;
                            // If the target sits inside an `expand` / `nestedExpand`, pin the card
                            // to the *outermost* expand's boundaries instead. The icon button is
                            // rendered on the doc-level (depth 1) baseLocalId block — i.e. on the
                            // expand itself — so the user clicked at the top of the expand and
                            // expects the card to open next to that, not deep inside the (now
                            // revealed) expand body where the actual tool call target lives.
                            const expandRange = $4eed6fc998ed6bbf$var$findOutermostExpandRange(doc, innerCardStartPos);
                            const cardStartPos = expandRange?.startPos ?? innerCardStartPos;
                            const cardEndPos = expandRange?.endPos ?? innerCardEndPos;
                            /**
               * These decoration widgets are used to track the top and bottom of the localId,
               * also accounting for other decoration widgets (such as diffs).
               */ decorations.push((0, $ftzrq.Decoration).widget(cardStartPos, ()=>{
                                const spanElement = document.createElement('span');
                                spanElement.setAttribute('style', (0, $24P9d.convertToInlineCss)({
                                    anchorName: `--card-${selectedSuggestionFirstToolCallLocalId}-start`
                                }));
                                return spanElement;
                            }, {
                                side: -2
                            }));
                            decorations.push((0, $ftzrq.Decoration).widget(cardEndPos, ()=>{
                                const spanElement = document.createElement('span');
                                spanElement.setAttribute('style', (0, $24P9d.convertToInlineCss)({
                                    anchorName: `--card-${selectedSuggestionFirstToolCallLocalId}-end`
                                }));
                                return spanElement;
                            }, {
                                side: 2
                            }));
                        }
                    }
                }
            }
        }
        return false;
    });
    if (!decorations.length) return (0, $ftzrq.DecorationSet).empty;
    return (0, $ftzrq.DecorationSet).create(doc, decorations);
}
const { suggestionById: $4eed6fc998ed6bbf$var$initSuggestionById, suggestionIdsByBaseLocalId: $4eed6fc998ed6bbf$var$initSuggestionIdsByBaseLocalId, baseLocalIdBySuggestionId: $4eed6fc998ed6bbf$var$initBaseLocalIdBySuggestionId, orderedSuggestionIds: $4eed6fc998ed6bbf$var$initOrderedSuggestionIds } = (0, $ffa0ca393e54921b$export$8eb2ba4e0b5d0f47)(undefined);
const $4eed6fc998ed6bbf$var$initState = {
    contentAri: undefined,
    decorations: (0, $ftzrq.DecorationSet).empty,
    isHidden: false,
    selectedSuggestion: undefined,
    suggestionById: $4eed6fc998ed6bbf$var$initSuggestionById,
    suggestionIdsByBaseLocalId: $4eed6fc998ed6bbf$var$initSuggestionIdsByBaseLocalId,
    baseLocalIdBySuggestionId: $4eed6fc998ed6bbf$var$initBaseLocalIdBySuggestionId,
    orderedSuggestionIds: $4eed6fc998ed6bbf$var$initOrderedSuggestionIds
};
function $4eed6fc998ed6bbf$export$ae829ec7b2625219({ api: api, intl: intl, contentAri: contentAri, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    return new (0, $1S4f7.SafePlugin)({
        key: $4eed6fc998ed6bbf$export$dbbefe45c19011aa,
        state: {
            init (_config, _state) {
                return $4eed6fc998ed6bbf$var$initState;
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta($4eed6fc998ed6bbf$export$dbbefe45c19011aa);
                let nextState = pluginState;
                if (meta) switch(meta.action){
                    case 'SET_SUGGESTIONS':
                        {
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = (0, $ffa0ca393e54921b$export$8eb2ba4e0b5d0f47)({
                                suggestions: meta.suggestions,
                                doc: newState.doc
                            });
                            // Track the content these suggestions belong to. Prefer the explicit
                            // `contentAri` on the meta, falling back to the suggestions' own
                            // `contentAri` so direct dispatchers are covered too. `||` (not `??`)
                            // is intentional so an empty-string `contentAri` is treated as "not
                            // provided" rather than a distinct page (which would cause a spurious
                            // reset against a previously-tracked ARI).
                            const incomingContentAri = meta.contentAri || meta.suggestions[0]?.contentAri;
                            // When the suggestions belong to a different page than the one currently
                            // tracked, the selection (and its diff) is stale — reset it. Suggestions
                            // refreshed for the *same* page keep the existing selection.
                            const contentChanged = incomingContentAri !== undefined && pluginState.contentAri !== undefined && incomingContentAri !== pluginState.contentAri;
                            const nextSelectedSuggestion = contentChanged ? undefined : pluginState.selectedSuggestion;
                            nextState = {
                                ...pluginState,
                                contentAri: incomingContentAri ?? pluginState.contentAri,
                                selectedSuggestion: nextSelectedSuggestion,
                                suggestionById: suggestionById,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                orderedSuggestionIds: orderedSuggestionIds,
                                decorations: pluginState.isHidden ? (0, $ftzrq.DecorationSet).empty : $4eed6fc998ed6bbf$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    suggestionById: suggestionById,
                                    suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: nextSelectedSuggestion,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                })
                            };
                            break;
                        }
                    case 'CLEAR_SUGGESTIONS':
                        {
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = (0, $ffa0ca393e54921b$export$8eb2ba4e0b5d0f47)({
                                doc: newState.doc,
                                suggestions: []
                            });
                            nextState = {
                                ...pluginState,
                                suggestionById: suggestionById,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                orderedSuggestionIds: orderedSuggestionIds,
                                selectedSuggestion: undefined,
                                decorations: (0, $ftzrq.DecorationSet).empty
                            };
                            break;
                        }
                    case 'SELECT_SUGGESTION':
                        nextState = {
                            ...pluginState,
                            selectedSuggestion: meta.id,
                            decorations: pluginState.isHidden ? (0, $ftzrq.DecorationSet).empty : $4eed6fc998ed6bbf$var$calculateSuggestionsDecorations({
                                doc: newState.doc,
                                suggestionById: pluginState.suggestionById,
                                suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                                api: api,
                                intl: intl,
                                selectedSuggestion: meta.id,
                                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                            })
                        };
                        break;
                    case 'SET_UI_VISIBILITY':
                        nextState = {
                            ...pluginState,
                            isHidden: meta.isHidden,
                            decorations: meta.isHidden ? (0, $ftzrq.DecorationSet).empty : $4eed6fc998ed6bbf$var$calculateSuggestionsDecorations({
                                doc: newState.doc,
                                suggestionById: pluginState.suggestionById,
                                suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                                api: api,
                                intl: intl,
                                selectedSuggestion: pluginState.selectedSuggestion,
                                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                            })
                        };
                        break;
                    case 'REMOVE_SUGGESTION':
                        {
                            const { suggestionById: suggestionById, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, orderedSuggestionIds: orderedSuggestionIds } = pluginState;
                            const removedId = meta.id;
                            const suggestion = suggestionById.get(removedId);
                            if (!suggestion) {
                                nextState = {
                                    ...pluginState,
                                    decorations: $4eed6fc998ed6bbf$var$calculateSuggestionsDecorations({
                                        doc: newState.doc,
                                        suggestionById: suggestionById,
                                        suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                        api: api,
                                        intl: intl,
                                        selectedSuggestion: undefined,
                                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                    })
                                };
                                break;
                            }
                            suggestionById.delete(removedId);
                            const baseLocalId = baseLocalIdBySuggestionId.get(removedId);
                            baseLocalIdBySuggestionId.delete(removedId);
                            if (baseLocalId) suggestionIdsByBaseLocalId.get(baseLocalId)?.delete(removedId);
                            nextState = {
                                ...pluginState,
                                suggestionById: suggestionById,
                                baseLocalIdBySuggestionId: baseLocalIdBySuggestionId,
                                suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                orderedSuggestionIds: orderedSuggestionIds.filter((id)=>id !== removedId),
                                selectedSuggestion: undefined,
                                decorations: $4eed6fc998ed6bbf$var$calculateSuggestionsDecorations({
                                    doc: newState.doc,
                                    suggestionById: suggestionById,
                                    suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId,
                                    api: api,
                                    intl: intl,
                                    selectedSuggestion: undefined,
                                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                                })
                            };
                            break;
                        }
                    default:
                        break;
                }
                else {
                    const shouldRecalculateDecorations = $4eed6fc998ed6bbf$var$docChangeAffectsDecorations({
                        doc: _oldState.doc,
                        suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                        tr: tr
                    });
                    nextState = {
                        ...pluginState,
                        decorations: pluginState.isHidden ? (0, $ftzrq.DecorationSet).empty : shouldRecalculateDecorations ? $4eed6fc998ed6bbf$var$calculateSuggestionsDecorations({
                            doc: newState.doc,
                            suggestionById: pluginState.suggestionById,
                            suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                            api: api,
                            intl: intl,
                            selectedSuggestion: pluginState.selectedSuggestion,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        }) : pluginState.decorations.map(tr.mapping, tr.doc)
                    };
                }
                return nextState;
            }
        },
        /**
     * The diff lives in the (separate) show-diff plugin, so it can't be reset from
     * this plugin's `apply`. When the tracked `contentAri` changes — i.e. the
     * suggestions now belong to a different page than the one whose diff is on
     * screen — hide the diff so a stale diff doesn't linger on the new page (which
     * can otherwise re-render whenever the new page contains a node with the same
     * `localId`). The matching selection/decoration reset happens in the
     * `SET_SUGGESTIONS` handler above.
     */ appendTransaction (_transactions, oldState, newState) {
            const previousContentAri = $4eed6fc998ed6bbf$export$dbbefe45c19011aa.getState(oldState)?.contentAri;
            const nextContentAri = $4eed6fc998ed6bbf$export$dbbefe45c19011aa.getState(newState)?.contentAri;
            const contentChanged = previousContentAri !== undefined && nextContentAri !== undefined && previousContentAri !== nextContentAri;
            if (!contentChanged) return null;
            const { tr: tr } = newState;
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        },
        props: {
            decorations (state) {
                return $4eed6fc998ed6bbf$export$dbbefe45c19011aa.getState(state)?.decorations ?? (0, $ftzrq.DecorationSet).empty;
            }
        },
        view: ()=>{
            const abortController = new AbortController();
            if (contentAri && api) (0, $072616480be2cdf6$export$740daa9a9ce77ea8)({
                contentAri: contentAri,
                api: api,
                signal: abortController.signal
            });
            return {
                destroy: ()=>{
                    abortController.abort();
                }
            };
        }
    });
}




var $6tl2G = parcelRequire("6tl2G");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

function $4c37aae2f1ec7493$var$wrapChild(fragment, type, attrs) {
    if (!fragment.firstChild) return null;
    const wrappingNodeTypes = type.contentMatch.findWrapping(fragment.firstChild.type);
    let currentChildNodes = null;
    if (wrappingNodeTypes) {
        currentChildNodes = fragment.content;
        for(let i = wrappingNodeTypes.length - 1; i >= 0; i--){
            const wrappingNodeType = wrappingNodeTypes[i];
            const nextChildNode = wrappingNodeType.createAndFill(null, currentChildNodes);
            if (nextChildNode) currentChildNodes = [
                nextChildNode
            ];
            else {
                currentChildNodes = null;
                break;
            }
        }
    }
    if (currentChildNodes) return type.createAndFill(attrs, currentChildNodes);
    return null;
}
function $4c37aae2f1ec7493$var$findPosForNode(node, $to) {
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        if (ancestor.type.contentMatch.matchType(node.type)) return $to.after(depth + 1);
    }
    return null;
}
const $4c37aae2f1ec7493$export$5a065b4e594c5a9c = ({ toolCallArguments: toolCallArguments, tr: tr, pos: pos })=>{
    const $from = tr.doc.resolve(pos);
    const node = tr.doc.nodeAt(pos);
    if (!node) return tr;
    const $to = tr.doc.resolve(pos + node.nodeSize);
    const range = $from.blockRange($to);
    if (range) {
        const type = tr.doc.type.schema.nodes[toolCallArguments.wrapperType];
        const attrs = toolCallArguments.wrapperAttrs;
        try {
            const wrapping = (0, $aXG5V.findWrapping)(range, type, attrs);
            if (wrapping !== null) tr.wrap(range, wrapping);
            else {
                const slice = tr.doc.slice(range.$from.pos, range.$to.pos);
                const fragment = slice.content;
                let node = type.createAndFill(attrs, fragment);
                if (!node) node = $4c37aae2f1ec7493$var$wrapChild(fragment, type, attrs);
                if (node) {
                    const insertPos = $4c37aae2f1ec7493$var$findPosForNode(node, $to);
                    if (insertPos !== null) {
                        tr.insert(insertPos, node);
                        tr.replaceRange(range.$from.pos, range.$to.pos, (0, $5SAOw.Slice).empty);
                    }
                }
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    return tr;
};


function $1b9408db26f8cffe$var$createNodeFromToolCallValue(schema, value) {
    try {
        const parsed = typeof value === 'string' ? JSON.parse(value) : value;
        return (0, $6tl2G.processRawValue)(schema, parsed);
    } catch  {
        return undefined;
    }
}
function $1b9408db26f8cffe$var$getPositionsByLocalId(doc, localId) {
    let result;
    doc.descendants((node, pos)=>{
        if (result) return false;
        if (node.attrs.localId === localId) result = {
            from: pos,
            to: pos + node.nodeSize
        };
        return !result;
    });
    return result;
}
// Looks up `localId` in the original snapshot and maps the position into current `tr.doc`
// coords. Resolving against the live `tr.doc` would match a duplicate localId inserted by an
// earlier tool call (e.g. a "move" encoded as insertNodeBefore + removeNode). Returns undefined
// if the node was deleted by an earlier step.
function $1b9408db26f8cffe$var$resolveMappedPositions(tr, originalDoc, baseStepCount, localId) {
    const original = $1b9408db26f8cffe$var$getPositionsByLocalId(originalDoc, localId);
    if (!original) return undefined;
    const mapping = tr.mapping.slice(baseStepCount);
    const from = mapping.map(original.from, 1);
    const to = mapping.map(original.to, -1);
    if (to <= from) return undefined;
    return {
        from: from,
        to: to
    };
}
function $1b9408db26f8cffe$var$applyToolCall(tr, toolCall, originalDoc, baseStepCount) {
    if (toolCall.name === 'removeNodes') {
        for (const id of toolCall.arguments.localIds){
            const positions = $1b9408db26f8cffe$var$resolveMappedPositions(tr, originalDoc, baseStepCount, id);
            if (positions) tr.delete(positions.from, positions.to);
        }
        return;
    }
    const positions = $1b9408db26f8cffe$var$resolveMappedPositions(tr, originalDoc, baseStepCount, toolCall.arguments.localId);
    if (!positions) return;
    switch(toolCall.name){
        case 'replaceNode':
        case 'insertNodeBefore':
        case 'insertNodeAfter':
            {
                const node = $1b9408db26f8cffe$var$createNodeFromToolCallValue(tr.doc.type.schema, toolCall.arguments.value);
                if (!node) return;
                const from = toolCall.name === 'insertNodeAfter' ? positions.to : positions.from;
                const to = toolCall.name === 'replaceNode' ? positions.to : from;
                tr.replaceWith(from, to, node);
                return;
            }
        case 'removeNode':
            tr.delete(positions.from, positions.to);
            return;
        case 'wrap':
        case 'wrapNode':
            (0, $4c37aae2f1ec7493$export$5a065b4e594c5a9c)({
                toolCallArguments: toolCall.arguments,
                tr: tr,
                pos: positions.from
            });
            return;
        case 'setAttrs':
            {
                const node = tr.doc.nodeAt(positions.from);
                if (!node) return;
                tr.setNodeMarkup(positions.from, undefined, {
                    ...node.attrs,
                    ...toolCall.arguments.attrs
                });
                return;
            }
    }
}
function $1b9408db26f8cffe$export$e450239860b6dfe1({ tr: tr, suggestion: suggestion }) {
    const originalDoc = tr.doc;
    const baseStepCount = tr.steps.length;
    for (const toolCall of suggestion.toolCalls)$1b9408db26f8cffe$var$applyToolCall(tr, toolCall, originalDoc, baseStepCount);
    return tr;
}


const $246bd17543716cd3$export$21100d27fbd5548c = (api)=>()=>{
        const suggestionById = api?.aiSuggestions?.sharedState.currentState()?.suggestionById;
        if (!suggestionById || suggestionById.size === 0) return false;
        // Snapshot suggestions up-front: dispatching CLEAR_SUGGESTIONS will mutate plugin state,
        // so iterating the live Map during dispatch is unsafe.
        const suggestions = Array.from(suggestionById.values());
        api?.core?.actions.execute(({ tr: tr })=>{
            for (const suggestion of suggestions)(0, $1b9408db26f8cffe$export$e450239860b6dfe1)({
                tr: tr,
                suggestion: suggestion
            });
            tr.setMeta('scrollIntoView', false);
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'CLEAR_SUGGESTIONS'
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        const updates = suggestions.map(({ id: id })=>({
                id: id,
                status: 'ACTIONED'
            }));
        (0, $e60244890fd6203e$export$1d496d000386893c)({
            updates: updates
        });
        return true;
    };




var $d925B = parcelRequire("d925B");

// Walks an inserted ADF subtree to collect every `localId` and node `type`. Captures localIds at
// every depth because tool-call collisions can be triggered by nested ids, not just the root.
function $a40008a482edd544$var$collectFromAdf(node, localIds, nodeTypes) {
    if (!node || typeof node !== 'object') return;
    if (typeof node.type === 'string') nodeTypes.add(node.type);
    const localId = node.attrs?.localId;
    if (typeof localId === 'string') localIds.add(localId);
    if (Array.isArray(node.content)) for (const child of node.content)$a40008a482edd544$var$collectFromAdf(child, localIds, nodeTypes);
}
function $a40008a482edd544$var$collectFromToolCall(toolCall, localIds, nodeTypes) {
    if (toolCall.name === 'removeNodes') {
        for (const id of toolCall.arguments.localIds)localIds.add(id);
        return;
    }
    localIds.add(toolCall.arguments.localId);
    if ('value' in toolCall.arguments && typeof toolCall.arguments.value === 'string') try {
        $a40008a482edd544$var$collectFromAdf(JSON.parse(toolCall.arguments.value), localIds, nodeTypes);
    } catch  {
    // Ignore malformed JSON - the tool call would also fail to apply, surfaced elsewhere.
    }
}
function $a40008a482edd544$var$collectToolCallAttributes(toolCall) {
    const localIds = new Set();
    const nodeTypes = new Set();
    $a40008a482edd544$var$collectFromToolCall(toolCall, localIds, nodeTypes);
    return {
        name: toolCall.name,
        localIds: Array.from(localIds),
        nodeTypes: Array.from(nodeTypes)
    };
}
const $a40008a482edd544$export$707043ea55006b30 = (editorAnalyticsAPI)=>(transaction, suggestion)=>{
        const toolCalls = suggestion.toolCalls.map($a40008a482edd544$var$collectToolCallAttributes);
        const payload = {
            action: (0, $d925B.ACTION).NO_DIFF_FOUND,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                suggestionType: suggestion.type,
                toolCalls: toolCalls
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $a40008a482edd544$export$d485252031168fc9 = (suggestion)=>{
    const ids = new Set();
    for (const toolCall of suggestion.toolCalls){
        if (toolCall.name === 'removeNodes') for (const id of toolCall.arguments.localIds)ids.add(id);
        else ids.add(toolCall.arguments.localId);
    }
    return ids.size;
};
/**
 * Returns the total plain text characters being added by a suggestion.
 * Derived from the `value` ADF JSON of inserting/replacing tool calls.
 */ function $a40008a482edd544$var$getTextFromAdfNode(node) {
    if (node.type === 'text' && typeof node.text === 'string') return node.text;
    if (Array.isArray(node.content)) return node.content.map((child)=>$a40008a482edd544$var$getTextFromAdfNode(child)).join('');
    return '';
}
const $a40008a482edd544$export$d01a7319a5878cbe = (suggestion)=>{
    let count = 0;
    for (const toolCall of suggestion.toolCalls){
        if ('value' in toolCall.arguments && typeof toolCall.arguments.value === 'string') try {
            count += $a40008a482edd544$var$getTextFromAdfNode(JSON.parse(toolCall.arguments.value)).length;
        } catch  {
        // malformed JSON — skip
        }
    }
    return count;
};
const $a40008a482edd544$export$1dd4e3d2c42a2395 = (suggestion, doc)=>{
    const removingCalls = [
        'removeNode',
        'removeNodes',
        'replaceNode'
    ];
    const visitedIds = new Set();
    let count = 0;
    for (const toolCall of suggestion.toolCalls){
        if (!removingCalls.includes(toolCall.name)) continue;
        const localIds = toolCall.name === 'removeNodes' ? toolCall.arguments.localIds : [
            toolCall.arguments.localId
        ];
        for (const localId of localIds){
            if (visitedIds.has(localId)) continue;
            visitedIds.add(localId);
            doc.descendants((node)=>{
                if (node.attrs.localId === localId) {
                    count += node.textContent.length;
                    return false;
                }
            });
        }
    }
    return count;
};
const $a40008a482edd544$export$ec701ea77bc93a9f = (editorAnalyticsAPI)=>(transaction, suggestion, entryPoint)=>{
        const payload = {
            action: (0, $d925B.ACTION).DISCARDED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                suggestionType: suggestion.type,
                entryPoint: entryPoint
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $a40008a482edd544$export$799e089d141dbbc0 = (suggestion, doc)=>{
    const localIds = new Set();
    const nodeTypes = new Set();
    for (const toolCall of suggestion.toolCalls)$a40008a482edd544$var$collectFromToolCall(toolCall, localIds, nodeTypes);
    // Look up removed nodes in the doc by localId to capture their types (removeNodes has no ADF value).
    doc.descendants((node)=>{
        if (typeof node.attrs?.localId === 'string' && localIds.has(node.attrs.localId)) nodeTypes.add(node.type.name);
    });
    const schema = doc.type.schema;
    return Array.from(nodeTypes).filter((typeName)=>schema.nodes[typeName]?.isBlock === true);
};
const $a40008a482edd544$export$aaae075a5bab9523 = (editorAnalyticsAPI)=>(transaction, suggestion, entryPoint)=>{
        const payload = {
            action: (0, $d925B.ACTION).VIEWED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                affectedBlocks: $a40008a482edd544$export$d485252031168fc9(suggestion),
                blockTypes: $a40008a482edd544$export$799e089d141dbbc0(suggestion, transaction.doc),
                charactersToAdd: $a40008a482edd544$export$d01a7319a5878cbe(suggestion),
                charactersToRemove: $a40008a482edd544$export$1dd4e3d2c42a2395(suggestion, transaction.doc),
                entryPoint: entryPoint,
                suggestionCardCharacterCount: suggestion.shortDescription?.length ?? 0,
                suggestionType: suggestion.type
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };
const $a40008a482edd544$export$f1a852c299619cdc = (editorAnalyticsAPI)=>(transaction, suggestion, entryPoint)=>{
        const payload = {
            action: (0, $d925B.ACTION).ACCEPTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                affectedBlocks: $a40008a482edd544$export$d485252031168fc9(suggestion),
                charactersAdded: $a40008a482edd544$export$d01a7319a5878cbe(suggestion),
                charactersRemoved: $a40008a482edd544$export$1dd4e3d2c42a2395(suggestion, transaction.doc),
                suggestionType: suggestion.type,
                entryPoint: entryPoint
            }
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
        return transaction;
    };



function $05fd2bd9ebeb5b7e$export$b632b48a7eefd3bb({ api: api, suggestion: suggestion }) {
    api?.core.actions.execute(({ tr: tr })=>{
        const appliedTr = (0, $1b9408db26f8cffe$export$e450239860b6dfe1)({
            tr: tr,
            suggestion: suggestion
        });
        appliedTr.setMeta('scrollIntoView', false);
        return appliedTr;
    });
}


const $648150141ab98191$export$11f54cceda85c938 = (api)=>(id)=>{
        let suggestion;
        api?.core?.actions.execute(({ tr: tr })=>{
            suggestion = api?.aiSuggestions?.sharedState.currentState()?.suggestionById.get(id);
            if (!suggestion) return tr;
            (0, $a40008a482edd544$export$f1a852c299619cdc)(api?.analytics?.actions)(tr, suggestion, 'sidebar');
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'REMOVE_SUGGESTION',
                id: id
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        if (!suggestion) return false;
        (0, $05fd2bd9ebeb5b7e$export$b632b48a7eefd3bb)({
            api: api,
            suggestion: suggestion
        });
        return true;
    };








const $25171e55829ce194$export$1acc4db37d317889 = new (0, $ks2lK.PluginKey)('aiSuggestionsThinkingPlugin');
function $25171e55829ce194$export$145797582d57a3db({ dispatch: dispatch }) {
    return new (0, $1S4f7.SafePlugin)({
        key: $25171e55829ce194$export$1acc4db37d317889,
        state: {
            init () {
                return {
                    status: 'idle'
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($25171e55829ce194$export$1acc4db37d317889);
                if (meta && meta.status !== pluginState.status) {
                    const result = {
                        status: meta.status
                    };
                    dispatch($25171e55829ce194$export$1acc4db37d317889, result);
                    return result;
                }
                return pluginState;
            }
        }
    });
}


const $4ccbb8acf041332a$export$d3355a5693c51fd3 = (api)=>()=>{
        return api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $25171e55829ce194$export$1acc4db37d317889), {
                status: 'complete'
            });
            return tr;
        }) || false;
    };




const $6e04719468ffdcd4$export$7cd05c39d88c72e0 = (api)=>()=>{
        const suggestionById = api?.aiSuggestions?.sharedState.currentState()?.suggestionById;
        if (!suggestionById || suggestionById.size === 0) return false;
        const ids = Array.from(suggestionById.keys());
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'CLEAR_SUGGESTIONS'
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        const updates = ids.map((id)=>({
                id: id,
                status: 'DISMISSED'
            }));
        (0, $e60244890fd6203e$export$1d496d000386893c)({
            updates: updates
        });
        return true;
    };




const $264e001355aecef2$export$97ae1e6707b788ba = (api)=>(id)=>{
        let found = false;
        api?.core?.actions.execute(({ tr: tr })=>{
            const pluginState = api?.aiSuggestions?.sharedState.currentState();
            const suggestion = pluginState?.suggestionById.get(id);
            if (!suggestion) return tr;
            found = true;
            (0, $a40008a482edd544$export$ec701ea77bc93a9f)(api?.analytics?.actions)(tr, suggestion, 'sidebar');
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'REMOVE_SUGGESTION',
                id: id
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        return found;
    };


const $73e02324b1e4dc9e$export$63a2edde6c848f66 = (api)=>()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
        return true;
    };



const $187fa16e9a98c2ed$export$8c023f02ab5dbd45 = (api, contentAri)=>{
    return ()=>{
        if (!api) return false;
        (0, $072616480be2cdf6$export$740daa9a9ce77ea8)({
            api: api,
            contentAri: contentAri
        });
        return true;
    };
};








/**
 * Returns the position of the first node in `doc` whose `localId` attr matches
 * one of `suggestion`'s tool call argument localIds. Tool calls are checked in
 * order; for `removeNodes` we walk its `localIds` array in order too.
 *
 * Used as a scroll target when applying the suggestion produces no diff: the
 * show-diff plugin's `scrollIntoView` is a no-op without any diff decorations,
 * so without this the card stays anchored to its tool call localId but the
 * viewport never moves, leaving the card pinned to the viewport edge instead
 * of sitting next to its target node.
 */ function $27af45f05a8358d3$var$findFirstToolCallNodePosition(doc, suggestion) {
    const findLocalIdPos = (localId)=>{
        let result;
        doc.descendants((node, pos)=>{
            if (result !== undefined) return false;
            if (node.attrs?.localId === localId) {
                result = pos;
                return false;
            }
            return true;
        });
        return result;
    };
    for (const toolCall of suggestion.toolCalls){
        const localIds = toolCall.name === 'removeNodes' ? toolCall.arguments.localIds : [
            toolCall.arguments.localId
        ];
        for (const localId of localIds){
            const pos = findLocalIdPos(localId);
            if (pos !== undefined) return pos;
        }
    }
    return undefined;
}
/**
 * Open every `expand` / `nestedExpand` ancestor of `pos` so the card's
 * `anchor-name` spans (emitted at the suggestion target) become layout-
 * visible instead of being hidden under the expand's collapsed content
 * wrapper, where CSS anchor positioning can't resolve them.
 *
 * Delegates to `toggleExpandRange` — it writes `expandedState` (the
 * expand's source of truth) *and* sets meta the expand plugin reads to
 * emit `Decoration.node({ forceExpandOpen })`, which is the outer-deco
 * change that makes PM call `ExpandNodeView.update()`. The range starts
 * at the top-level ancestor so `nodesBetween` definitely visits every
 * wrapping expand.
 */ function $27af45f05a8358d3$var$revealAncestorExpands(api, doc, pos, tr) {
    const $pos = doc.resolve(pos);
    if ($pos.depth === 0) return;
    let hasExpandAncestor = false;
    for(let depth = $pos.depth; depth > 0; depth--){
        const node = $pos.node(depth);
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') {
            hasExpandAncestor = true;
            break;
        }
    }
    if (!hasExpandAncestor) return;
    api?.expand?.commands.toggleExpandRange($pos.before(1), pos, true)?.({
        tr: tr
    });
}
const $27af45f05a8358d3$export$85c07d6dab7fe6b1 = (api)=>(id, options)=>{
        // Captured during the `execute` callback so we can run the scroll after the
        // transaction has been dispatched — that way `SELECT_SUGGESTION` has already
        // flowed through the plugin state and the card anchors are in the DOM by
        // the time the viewport moves into place.
        let noDiffScrollPos;
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'SELECT_SUGGESTION',
                id: id ?? undefined
            });
            if (id === null) // Deselecting — hide the diff
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            else {
                // Selecting — show the diff for this suggestion
                const suggestion = api?.aiSuggestions?.sharedState.currentState()?.suggestionById.get(id);
                if (suggestion) {
                    // Fire viewed analytics when an explicit user-driven open from a known entry point.
                    if (options?.entryPoint) (0, $a40008a482edd544$export$aaae075a5bab9523)(api?.analytics?.actions)(tr, suggestion, options.entryPoint);
                    const firstToolCallPos = $27af45f05a8358d3$var$findFirstToolCallNodePosition(tr.doc, suggestion);
                    if (firstToolCallPos !== undefined) $27af45f05a8358d3$var$revealAncestorExpands(api, tr.doc, firstToolCallPos, tr);
                    // Apply tool calls to an isolated transaction so we can read its `steps`
                    // and `before` for diff visualisation without affecting the source transaction.
                    const isolatedTr = new (0, $aXG5V.Transform)(tr.doc);
                    const appliedTr = (0, $1b9408db26f8cffe$export$e450239860b6dfe1)({
                        tr: isolatedTr,
                        suggestion: suggestion
                    });
                    if (appliedTr.before.eq(appliedTr.doc)) {
                        //fire analytics if there is no diff
                        (0, $a40008a482edd544$export$707043ea55006b30)(api?.analytics?.actions)(tr, suggestion);
                        // No diff → showDiff's `scrollIntoView` won't scroll (no decorations).
                        // Stash the first tool call localId position so we can scroll the
                        // viewport to it ourselves after dispatch.
                        noDiffScrollPos = firstToolCallPos;
                    }
                    api?.showDiff?.commands.showDiff({
                        // For a multi-step transaction, each step's `from`/`to` are
                        // in the coordinate space of the doc BEFORE that specific
                        // step is applied — i.e. `appliedTr.docs[i]`, not the
                        // initial `appliedTr.before`. Inverting every step against
                        // `appliedTr.before` throws `RangeError` (or silently
                        // produces broken inverted steps) for any step past index 0.
                        // Reverse the inverted-step array so they apply back to the
                        // original order when the diff plugin replays them on
                        // `appliedTr.doc`.
                        steps: appliedTr.steps.map((step, i)=>step.invert(appliedTr.docs[i])).reverse(),
                        originalDoc: appliedTr.doc,
                        isInverted: true,
                        diffType: 'step',
                        hideDeletedDiffs: options?.hideDeletedDiffs,
                        scrollIntoView: true
                    })({
                        tr: tr
                    });
                }
            }
            return tr;
        });
        if (noDiffScrollPos !== undefined) api?.core?.actions.scrollToPos(noDiffScrollPos, {
            behavior: 'smooth',
            block: 'start'
        });
        return true;
    };



const $1741cc5ffd05c197$export$6525a287b5847561 = (api)=>(isHidden)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'SET_UI_VISIBILITY',
                isHidden: isHidden
            });
            return tr;
        });
        return true;
    };






const $49a3354e5fae2e0c$export$abeb109a09e4f140 = (api)=>(id, options)=>{
        let found = false;
        api?.core?.actions.execute(({ tr: tr })=>{
            const suggestion = api?.aiSuggestions?.sharedState.currentState()?.suggestionById.get(id);
            if (!suggestion) return tr;
            found = true;
            // Apply tool calls to an isolated transaction so we can read its `steps`
            // and `before` for diff visualisation without affecting the source transaction.
            // PM nodes are immutable, so reusing tr.doc is safe.
            const isolatedTr = (0, $ks2lK.EditorState).create({
                doc: tr.doc
            }).tr;
            const appliedTr = (0, $1b9408db26f8cffe$export$e450239860b6dfe1)({
                tr: isolatedTr,
                suggestion: suggestion
            });
            api?.showDiff?.commands.showDiff({
                // Each step's positions live in the doc BEFORE that step is applied
                // (= `appliedTr.docs[i]`). Inverting every step against
                // `appliedTr.before` throws `RangeError` for any step past index 0
                // in a multi-tool-call suggestion. Reverse afterwards so the inverted
                // steps replay back to the original doc when the diff plugin applies
                // them to `appliedTr.doc`.
                steps: appliedTr.steps.map((step, i)=>step.invert(appliedTr.docs[i])).reverse(),
                originalDoc: appliedTr.doc,
                isInverted: true,
                diffType: 'step',
                hideDeletedDiffs: options?.hideDeletedDiffs,
                scrollIntoView: true
            })({
                tr: tr
            });
            return tr;
        });
        return found;
    };



const $c8607a1691626c1d$export$b9b07f03787433d = (api)=>()=>{
        return api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $25171e55829ce194$export$1acc4db37d317889), {
                status: 'thinking'
            });
            return tr;
        }) || false;
    };



const $bc01aad1a76ed984$export$cf0309e29c0b89b8 = (api)=>()=>{
        return api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $25171e55829ce194$export$1acc4db37d317889), {
                status: 'idle'
            });
            return tr;
        }) || false;
    };




/* SuggestionCardContentComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $7YjFd = parcelRequire("7YjFd");





const $90dbd3b55eab9b77$var$SCROLL_MARGIN = 32;
const $90dbd3b55eab9b77$export$8d7a4d77df9967d4 = ({ id: id, root: root, targetStart: targetStart, targetBase: targetBase, targetEnd: targetEnd, cardRef: cardRef })=>{
    const [anchorLeft, setAnchorLeft] = (0, $42omo.useState)(null);
    const [isTargetAboveViewport, setIsTargetAboveViewport] = (0, $42omo.useState)(false);
    const [isTargetBelowViewport, setIsTargetBelowViewport] = (0, $42omo.useState)(false);
    const [isCardBottomBelowViewport, setIsCardBottomBelowViewport] = (0, $42omo.useState)(false);
    const [isTargetRightOfViewport, setIsTargetRightOfViewport] = (0, $42omo.useState)(false);
    const [isTargetEndAboveViewport, setIsTargetEndAboveViewport] = (0, $42omo.useState)(false);
    const [isTargetEndBelowViewport, setIsTargetEndBelowViewport] = (0, $42omo.useState)(false);
    const [isMeasured, setIsMeasured] = (0, $42omo.useState)(false);
    const cardHeight = cardRef.current?.offsetHeight ?? 0;
    const cardWidth = cardRef.current?.offsetWidth ?? 0;
    /**
	 * Workaround for a Chromium bug where using anchor() on a
	 * `position: fixed` element produces correct paint but incorrect hit-testing.
	 * https://issues.chromium.org/issues/512171942
	 *
	 * Only needed for when (!isTargetRightOfViewport &&
	 * (isTargetAboveViewport || isCardBottomBelowViewport || isTargetBelowViewport))
	 * as these combinations have position: fixed with non-static inline position.
	 */ const shouldTrackAnchor = !isTargetRightOfViewport && (isTargetAboveViewport || isCardBottomBelowViewport || isTargetBelowViewport);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!targetBase || !shouldTrackAnchor) {
            setAnchorLeft(null);
            return;
        }
        setAnchorLeft(targetBase.getBoundingClientRect().left - (root?.getBoundingClientRect().left || 0));
        const observer = new ResizeObserver(()=>{
            setAnchorLeft(targetBase.getBoundingClientRect().left - (root?.getBoundingClientRect().left || 0));
        });
        if (root) observer.observe(root);
        return ()=>{
            observer.disconnect();
        };
    }, [
        shouldTrackAnchor,
        targetBase,
        root
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!id || !root || !targetStart || !targetEnd || !cardRef.current || !targetBase) {
            setIsTargetRightOfViewport(false);
            setIsTargetEndAboveViewport(false);
            setIsTargetEndBelowViewport(false);
            setIsTargetBelowViewport(false);
            setIsTargetAboveViewport(false);
            setIsCardBottomBelowViewport(false);
            setIsMeasured(false);
            return;
        }
        const verticalCardPositionObserver = new IntersectionObserver((entries)=>{
            const [entry] = entries;
            if (!entry || !entry.rootBounds) return;
            const { rootBounds: rootBounds, boundingClientRect: boundingClientRect } = entry;
            setIsTargetAboveViewport(boundingClientRect.top < rootBounds.top);
            setIsCardBottomBelowViewport(boundingClientRect.bottom > rootBounds.bottom);
        }, {
            root: root,
            rootMargin: `-${$90dbd3b55eab9b77$var$SCROLL_MARGIN}px 0px -${cardHeight + $90dbd3b55eab9b77$var$SCROLL_MARGIN}px 0px`
        });
        const verticalTargetObserver = new IntersectionObserver((entries)=>{
            const [entry] = entries;
            if (!entry || !entry.rootBounds) return;
            const { rootBounds: rootBounds, boundingClientRect: boundingClientRect } = entry;
            setIsTargetBelowViewport(boundingClientRect.top > rootBounds.bottom);
        }, {
            root: root,
            rootMargin: `${cardHeight + $90dbd3b55eab9b77$var$SCROLL_MARGIN}px 0px -${$90dbd3b55eab9b77$var$SCROLL_MARGIN}px 0px`
        });
        const targetEndObserver = new IntersectionObserver((entries)=>{
            const [entry] = entries;
            if (!entry || !entry.rootBounds) return;
            const { rootBounds: rootBounds, boundingClientRect: boundingClientRect } = entry;
            setIsTargetEndAboveViewport(boundingClientRect.top < rootBounds.top);
            setIsTargetEndBelowViewport(boundingClientRect.bottom > rootBounds.bottom);
        }, {
            root: root,
            // Extra 24 for the gap above card and content
            rootMargin: `0px 0px -${cardHeight + $90dbd3b55eab9b77$var$SCROLL_MARGIN + 24}px 0px`
        });
        /**
		 * This observer is for determining if there's enough space on the right side to display the card.
		 * We use arbitrarily large root margins to ensure that the intersection observer detects it even
		 * when the targetBase anchor (anchored to the icon button) is off the screen.
		 *
		 * A hypotheical edge case is if a toolcall's localid position is more than 99999px further than the
		 * doc-level node's local id, but that is really unlikely.
		 */ const horizontalObserver = new IntersectionObserver((entries)=>{
            const [entry] = entries;
            if (!entry || !entry.rootBounds) return;
            const { rootBounds: rootBounds, boundingClientRect: boundingClientRect } = entry;
            setIsTargetRightOfViewport(boundingClientRect.right > rootBounds.right);
            setIsMeasured(true);
        }, {
            root: root,
            rootMargin: `99999px -${cardWidth + $90dbd3b55eab9b77$var$SCROLL_MARGIN}px 99999px 0px`
        });
        verticalCardPositionObserver.observe(targetStart);
        horizontalObserver.observe(targetBase);
        targetEndObserver.observe(targetEnd);
        verticalTargetObserver.observe(targetStart);
        return ()=>{
            verticalCardPositionObserver.disconnect();
            horizontalObserver.disconnect();
            targetEndObserver.disconnect();
            verticalTargetObserver.disconnect();
        };
    }, [
        targetStart,
        targetBase,
        cardRef,
        root,
        targetEnd,
        cardHeight,
        cardWidth,
        id
    ]);
    return {
        anchorLeft: anchorLeft,
        isTargetAboveViewport: isTargetAboveViewport,
        isTargetBelowViewport: isTargetBelowViewport,
        isCardBottomBelowViewport: isCardBottomBelowViewport,
        isTargetRightOfViewport: isTargetRightOfViewport,
        isTargetEndAboveViewport: isTargetEndAboveViewport,
        isTargetEndBelowViewport: isTargetEndBelowViewport,
        isMeasured: isMeasured
    };
};





const $03e46e0f159f1893$var$selectSelectedSuggestion = (state)=>{
    const { selectedSuggestion: selectedId, suggestionById: suggestionById } = state ?? {};
    return selectedId !== undefined && suggestionById !== undefined ? suggestionById.get(selectedId) : undefined;
};
const $03e46e0f159f1893$var$selectBaseLocalId = (state)=>{
    const { selectedSuggestion: selectedId, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId } = state ?? {};
    return baseLocalIdBySuggestionId && selectedId ? baseLocalIdBySuggestionId.get(selectedId) : undefined;
};
const $03e46e0f159f1893$export$12e742fdeff6e7ba = (api)=>{
    const [selectedSuggestion, setSelectedSuggestion] = (0, $42omo.useState)(()=>$03e46e0f159f1893$var$selectSelectedSuggestion(api?.aiSuggestions?.sharedState.currentState()));
    const [baseLocalId, setBaseLocalId] = (0, $42omo.useState)(()=>$03e46e0f159f1893$var$selectBaseLocalId(api?.aiSuggestions?.sharedState.currentState()));
    (0, $42omo.useEffect)(()=>{
        const aiSuggestions = api?.aiSuggestions;
        if (!aiSuggestions) return;
        // Re-read once at subscription time so we don't miss a transaction that fired between
        // the initial render and the effect commit.
        const initial = aiSuggestions.sharedState.currentState();
        setSelectedSuggestion($03e46e0f159f1893$var$selectSelectedSuggestion(initial));
        setBaseLocalId($03e46e0f159f1893$var$selectBaseLocalId(initial));
        return aiSuggestions.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            setSelectedSuggestion($03e46e0f159f1893$var$selectSelectedSuggestion(nextSharedState));
            setBaseLocalId($03e46e0f159f1893$var$selectBaseLocalId(nextSharedState));
        });
    }, [
        api
    ]);
    return {
        selectedSuggestion: selectedSuggestion,
        baseLocalId: baseLocalId
    };
};





/* ScrollBackToSuggestionButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $ccHMk = parcelRequire("ccHMk");



var $22Iw9 = parcelRequire("22Iw9");


var $euUgw = parcelRequire("euUgw");


var $iXCQx = parcelRequire("iXCQx");

const $66cdea5890f962b5$var$styles = {
    buttonContainer: "_2rkopb1k _19itglyw _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _bfhkhp5a _16qs130s"
};
const $66cdea5890f962b5$export$1f302f0e3d37f52d = ({ direction: direction, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const label = formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardScrollBackToSuggestionLabel);
    const ArrowIcon = (0, $42omo.useCallback)(()=>{
        return direction === 'up' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
            label: "",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($22Iw9))), {
            label: "",
            size: "small"
        });
    }, [
        direction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $66cdea5890f962b5$var$styles.buttonContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: ArrowIcon,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "medium",
        color: "color.text.subtle"
    }, label)));
};


/* SuggestionCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $cO1el = parcelRequire("cO1el");


var $7642E = parcelRequire("7642E");


var $cvXh8 = parcelRequire("cvXh8");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $2AytZ = parcelRequire("2AytZ");


var $hmuev = parcelRequire("hmuev");


var $gKvd9 = parcelRequire("gKvd9");


var $9Q2dU = parcelRequire("9Q2dU");


var $jypE9 = parcelRequire("jypE9");


var $lAFHW = parcelRequire("lAFHW");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");






const $626f4055e58aa33e$var$stackTiltIn1 = null;
const $626f4055e58aa33e$var$stackTiltIn2 = null;
const $626f4055e58aa33e$var$styles = {
    sourceButton: "_zulpu2gc _1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syazazsu",
    card: "_2rkopb1k _zulppxbi _kqswh2mm _bfhkvuon _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _16qs130s _1bsb1178 _1e0c1txw _2lx21bp4 _vchhusvi",
    cardStack: "_rfx3pb1k _1cs8stnw _1kt9b3bt _1rusvuon _txdo130s _19woidpf _qnecidpf _1mp4120u _kfgtckbl _8kay14zx _1g0v1mrw _1088nkej _joxli9qs _zo24indk _1f25q7pw _1xoxglyw _1kky1w3d",
    additionalCardStack: "_14mjpb1k _18postnw _aetrb3bt _1hfkvuon _8x3u130s _1x88idpf _19doidpf _z0ainau3 _1qdgckbl _1tlb14zx _1bqq1m4m _19oh1mdo _kwc0i9qs _18lgindk _hxkhq7pw"
};
const $626f4055e58aa33e$export$5864b77b647e728c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function SuggestionCard({ onAccept: onAccept, onDiscard: onDiscard, onNavigate: onNavigate, onClose: onClose, onShowSidebar: onShowSidebar, suggestion: // onToggleOnlySuggestion,
// isShowingOnlySuggestion,
suggestion, stackSize: stackSize = 1 }, ref) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isSourcesExpanded, setIsSourcesExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const handleSourcesToggle = (0, $42omo.useCallback)(()=>{
        setIsSourcesExpanded((previous)=>!previous);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            $626f4055e58aa33e$var$styles.card,
            stackSize > 1 && $626f4055e58aa33e$var$styles.cardStack,
            stackSize > 2 && $626f4055e58aa33e$var$styles.additionalCardStack
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ ), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardExpandButtonLabel),
                size: "small"
            }),
        label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardExpandButtonLabel),
        appearance: "subtle",
        spacing: "compact",
        isDisabled: !onNavigate,
        onClick: onNavigate ? ()=>onNavigate('up') : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ ), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardCollapseButtonLabel),
                size: "small"
            }),
        label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardCollapseButtonLabel),
        appearance: "subtle",
        spacing: "compact",
        isDisabled: !onNavigate,
        onClick: onNavigate ? ()=>onNavigate('down') : undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, onShowSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))),
        label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardShowSidebarButtonLabel),
        appearance: "subtle",
        spacing: "compact",
        onClick: onShowSidebar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardCloseButtonLabel),
        appearance: "subtle",
        spacing: "compact",
        onClick: onClose
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
        label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardRovoTitle),
        size: "small",
        shouldUseNewLogoDesign: true,
        shouldUseHexLogo: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardRovoTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardPrivateTooltipLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7642E.IconTile), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))),
        label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardPrivateLabel),
        appearance: "gray",
        size: "xsmall"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p",
        color: "color.text"
    }, suggestion.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "start",
        direction: "column",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $626f4055e58aa33e$var$styles.sourceButton,
        onClick: handleSourcesToggle
    }, isSourcesExpanded ? formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardSourcesHideButtonLabel) : formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardSourcesShowButtonLabel), isSourcesExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: "",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: "",
        size: "small"
    })), isSourcesExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p",
        color: "color.text.subtle"
    }, suggestion.reasoning)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))),
        appearance: "primary",
        onClick: onAccept
    }, formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardAcceptButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
        appearance: "subtle",
        onClick: onDiscard
    }, formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).cardDiscardButtonLabel)))));
});


const $b71ad3bab76820ab$var$styles = {
    targetAnchoring: "_1e0c1ule _kqswstnw _152t9owe _1e02mofv",
    cardContainer: "_1pby16oo _17c61i8t _k8m01rjc _1oec1mzy _6fl41d08",
    preMeasurement: "_tzy4idpf",
    entranceAnimation: "_y44v1cyw _1bumglyw",
    scrollBackContainer: "_1bsb1178 _1e0c1txw _4cvr1h6o _1bah1h6o _kqsw1n9t",
    scrollBackTop: "_y44v1cyw _154i1ejb",
    scrollBackBottom: "_y44v14t8 _94n51ejb",
    scrollBackAnimation: "_ju251gea _1o511hrf _1bumglyw",
    scrollBackRight: "_1xi21i09",
    pinnedBottomRight: "_kqsw1n9t _94n51ejb _1xi21i09",
    anchoredToTargetEnd: "_kqswstnw _1xi21i09",
    pinnedTop: "_kqsw1n9t _154i1ejb",
    pinnedBottom: "_kqsw1n9t _94n51ejb",
    anchoredToTarget: "_kqswstnw",
    slideUp: "_tzy4idpf _t9eczo5i _k8m01rjc _1oec1mzy _6fl4indk _1lww1ko7",
    slideDown: "_tzy4idpf _t9ec1brm _k8m01rjc _1oec1mzy _6fl4indk _1lww1ko7"
};
const $b71ad3bab76820ab$export$b9f1c5d82af9ea41 = ({ api: api, onShowSidebar: onShowSidebar, view: view })=>{
    const cardRef = (0, $42omo.useRef)(null);
    const [isShowingOnlySuggestion, setIsShowingOnlySuggestion] = (0, $42omo.useState)(false); /**
                                                                                  * We use useState & useCallback to set the ref so that the popup will mount correctly after the
                                                                                  * anchor mounts. We have both target + targetEnd (two widgets, one at top and one at bottom of a block)
                                                                                  * to detect when it becomes out of the Editor viewport.
                                                                                  */ 
    const [targetStart, setTargetStart] = (0, $42omo.useState)();
    const targetStartRef = (0, $42omo.useCallback)((node)=>{
        setTargetStart(node);
    }, []);
    const [targetEnd, setTargetEnd] = (0, $42omo.useState)();
    const targetEndRef = (0, $42omo.useCallback)((node)=>{
        setTargetEnd(node);
    }, []);
    const [targetBase, setTargetBase] = (0, $42omo.useState)();
    const targetBaseRef = (0, $42omo.useCallback)((node)=>{
        setTargetBase(node);
    }, []);
    const [root, setRoot] = (0, $42omo.useState)();
    (0, $42omo.useLayoutEffect)(()=>{
        if (!view?.dom) {
            setRoot(undefined);
            return;
        }
        const _root = (0, $7YjFd.findOverflowScrollParent)(view.dom);
        setRoot(_root || undefined);
    }, [
        view
    ]); // Positioning-critical slice — kept synchronous (no debounce) so the CSS-anchor references
    // stay in lock-step with the ProseMirror transaction that swapped the selection.
    const { selectedSuggestion: selectedSuggestion, baseLocalId: baseLocalId } = (0, $03e46e0f159f1893$export$12e742fdeff6e7ba)(api);
    const firstToolCallLocalId = selectedSuggestion?.toolCalls[0] && 'localId' in selectedSuggestion.toolCalls[0].arguments ? selectedSuggestion.toolCalls[0].arguments.localId : undefined;
    const { stackSize: stackSize, orderedSuggestionIds: orderedSuggestionIds, isHidden: isHidden } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions'
    ], (state)=>{
        const { suggestionIdsByBaseLocalId: suggestionIdsByBaseLocalId, baseLocalIdBySuggestionId: baseLocalIdBySuggestionId, selectedSuggestion: selectedId, orderedSuggestionIds: orderedSuggestionIds, isHidden: isHidden } = state?.aiSuggestionsState ?? {};
        const _baseLocalId = baseLocalIdBySuggestionId && selectedId ? baseLocalIdBySuggestionId.get(selectedId) : undefined;
        return {
            stackSize: _baseLocalId ? suggestionIdsByBaseLocalId?.get(_baseLocalId)?.size : undefined,
            orderedSuggestionIds: orderedSuggestionIds,
            isHidden: isHidden
        };
    });
    const { anchorLeft: anchorLeft, isMeasured: isMeasured, isTargetAboveViewport: isTargetAboveViewport, isTargetBelowViewport: isTargetBelowViewport, isCardBottomBelowViewport: isCardBottomBelowViewport, isTargetRightOfViewport: isTargetRightOfViewport, isTargetEndAboveViewport: isTargetEndAboveViewport, isTargetEndBelowViewport: isTargetEndBelowViewport } = (0, $90dbd3b55eab9b77$export$8d7a4d77df9967d4)({
        root: root,
        targetStart: targetStart,
        targetEnd: targetEnd,
        targetBase: targetBase,
        cardRef: cardRef,
        id: baseLocalId
    });
    const onToggleOnlySuggestion = (0, $42omo.useCallback)(()=>{
        const nextIsShowingOnlySuggestion = !isShowingOnlySuggestion;
        setIsShowingOnlySuggestion(nextIsShowingOnlySuggestion);
        if (!selectedSuggestion) return;
        api?.aiSuggestions?.actions.selectSuggestion(selectedSuggestion.id, {
            hideDeletedDiffs: nextIsShowingOnlySuggestion
        });
    }, [
        api,
        isShowingOnlySuggestion,
        selectedSuggestion
    ]);
    const onScrollBackClick = (0, $42omo.useCallback)(()=>{
        if (!selectedSuggestion) return;
        api?.aiSuggestions?.actions.selectSuggestion(selectedSuggestion.id);
    }, [
        api,
        selectedSuggestion
    ]);
    if (selectedSuggestion === undefined || isHidden) return;
    const onClose = ()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'SELECT_SUGGESTION',
                id: undefined
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        });
    };
    const onDiscard = ()=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            (0, $e60244890fd6203e$export$1d496d000386893c)({
                updates: [
                    {
                        id: selectedSuggestion.id,
                        status: 'DISMISSED'
                    }
                ]
            });
            (0, $a40008a482edd544$export$ec701ea77bc93a9f)(api?.analytics?.actions)(tr, selectedSuggestion, 'card');
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'REMOVE_SUGGESTION',
                id: selectedSuggestion.id
            });
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            return tr;
        }); // navigate to the next suggestion
        onNavigate('down');
    };
    const onAccept = ()=>{
        (0, $e60244890fd6203e$export$1d496d000386893c)({
            updates: [
                {
                    id: selectedSuggestion.id,
                    status: 'ACTIONED'
                }
            ]
        });
        api?.core?.actions.execute(({ tr: tr })=>{
            (0, $a40008a482edd544$export$f1a852c299619cdc)(api?.analytics?.actions)(tr, selectedSuggestion, 'card');
            api?.showDiff?.commands.hideDiff?.({
                tr: tr
            });
            tr.setMeta((0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa), {
                action: 'REMOVE_SUGGESTION',
                id: selectedSuggestion.id
            });
            return tr;
        });
        setTimeout(()=>{
            (0, $05fd2bd9ebeb5b7e$export$b632b48a7eefd3bb)({
                api: api,
                suggestion: selectedSuggestion
            });
        }, 0); // navigate to the next suggestion
        onNavigate('down');
    };
    const onNavigate = (direction)=>{
        const currentId = selectedSuggestion.id;
        if (!orderedSuggestionIds || orderedSuggestionIds?.length === 0) return undefined;
        const idx = orderedSuggestionIds.indexOf(currentId);
        if (idx === -1) return undefined;
        const delta = direction === 'up' ? -1 : 1;
        const nextIdx = (idx + delta + orderedSuggestionIds.length) % orderedSuggestionIds.length;
        const nextId = orderedSuggestionIds[nextIdx]; // When only one suggestion exists, the modulo wraps back to the current id.
        // Skip navigation in that case so we don't re-select the suggestion that's about to be removed.
        if (nextId === currentId) return undefined;
        api?.aiSuggestions?.actions.selectSuggestion(nextId);
    };
    const shouldScrollUp = isTargetEndAboveViewport && isTargetAboveViewport;
    const shouldScrollDown = isTargetBelowViewport && isTargetEndBelowViewport; /**
                                                                               * Mutually exclusive positioning modes for the card. Each represents a
                                                                               * distinct combination of viewport state and resulting style:
                                                                               *  - `isPinnedBottomRight`     : fixed to the bottom-right of the viewport
                                                                               *  - `isAnchoredToTargetEnd`   : absolutely anchored to the end of the target
                                                                               *  - `isPinnedTop`             : fixed to the top of the viewport
                                                                               *  - `isPinnedBottom`          : fixed to the bottom of the viewport
                                                                               *  - `isAnchoredToTarget`      : absolutely anchored to the target (default)
                                                                               */ 
    const isPinnedBottomRight = isTargetRightOfViewport && isTargetEndBelowViewport;
    const isAnchoredToTargetEnd = isTargetRightOfViewport && !isTargetEndBelowViewport;
    const isPinnedTop = !isTargetRightOfViewport && isTargetAboveViewport;
    const isPinnedBottom = !isTargetRightOfViewport && !isTargetAboveViewport && (isCardBottomBelowViewport || isTargetBelowViewport);
    const isAnchoredToTarget = !isPinnedBottomRight && !isAnchoredToTargetEnd && !isPinnedTop && !isPinnedBottom;
    const isLeftPositionDynamic = isPinnedTop || isPinnedBottom;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: targetEndRef,
        style: {
            positionAnchor: `--card-${firstToolCallLocalId}-end`
        },
        className: (0, $gMc0m.default)([
            $b71ad3bab76820ab$var$styles.targetAnchoring
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: targetStartRef,
        style: {
            positionAnchor: `--card-${firstToolCallLocalId}-start`
        },
        className: (0, $gMc0m.default)([
            $b71ad3bab76820ab$var$styles.targetAnchoring
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: targetBaseRef,
        style: {
            positionAnchor: `--button-${baseLocalId}`
        },
        className: (0, $gMc0m.default)([
            $b71ad3bab76820ab$var$styles.targetAnchoring
        ])
    }), (shouldScrollUp || shouldScrollDown) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            left: !isTargetRightOfViewport && anchorLeft !== null ? anchorLeft : undefined
        },
        className: (0, $gMc0m.default)([
            $b71ad3bab76820ab$var$styles.cardContainer,
            $b71ad3bab76820ab$var$styles.scrollBackContainer,
            isTargetRightOfViewport && $b71ad3bab76820ab$var$styles.scrollBackRight,
            shouldScrollUp ? $b71ad3bab76820ab$var$styles.scrollBackTop : $b71ad3bab76820ab$var$styles.scrollBackBottom,
            $b71ad3bab76820ab$var$styles.scrollBackAnimation
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $66cdea5890f962b5$export$1f302f0e3d37f52d), {
        direction: shouldScrollUp ? 'up' : 'down',
        onClick: onScrollBackClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- this is being flagged by precommit hook incorrectly
            ...isAnchoredToTarget && {
                insetBlockStart: `anchor(--card-${firstToolCallLocalId}-start start)`,
                insetInlineStart: `anchor(--button-${baseLocalId} end)`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- this is being flagged by precommit hook incorrectly
            ...isLeftPositionDynamic && anchorLeft && {
                left: anchorLeft
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- this is being flagged by precommit hook incorrectly
            ...isAnchoredToTargetEnd && {
                insetBlockStart: `calc(anchor(--card-${firstToolCallLocalId}-end start) + ${"var(--ds-space-300, 24px)"})`
            }
        },
        className: (0, $gMc0m.default)([
            $b71ad3bab76820ab$var$styles.cardContainer,
            isMeasured && $b71ad3bab76820ab$var$styles.entranceAnimation,
            isPinnedBottomRight && $b71ad3bab76820ab$var$styles.pinnedBottomRight,
            isAnchoredToTargetEnd && $b71ad3bab76820ab$var$styles.anchoredToTargetEnd,
            isPinnedTop && $b71ad3bab76820ab$var$styles.pinnedTop,
            isPinnedBottom && $b71ad3bab76820ab$var$styles.pinnedBottom,
            isAnchoredToTarget && $b71ad3bab76820ab$var$styles.anchoredToTarget,
            !isMeasured && $b71ad3bab76820ab$var$styles.preMeasurement,
            shouldScrollUp && $b71ad3bab76820ab$var$styles.slideUp,
            shouldScrollDown && $b71ad3bab76820ab$var$styles.slideDown
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $626f4055e58aa33e$export$5864b77b647e728c), {
        ref: cardRef,
        suggestion: selectedSuggestion,
        onNavigate: orderedSuggestionIds && orderedSuggestionIds.length > 1 ? onNavigate : undefined,
        onClose: onClose,
        onDiscard: onDiscard,
        onAccept: onAccept,
        stackSize: stackSize,
        onToggleOnlySuggestion: onToggleOnlySuggestion,
        isShowingOnlySuggestion: isShowingOnlySuggestion,
        onShowSidebar: onShowSidebar
    })));
};


/* ThinkingContentComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $5gEqE = parcelRequire("5gEqE");









var $bPHr8 = parcelRequire("bPHr8");


var $ajfvU = parcelRequire("ajfvU");


var $aouqA = parcelRequire("aouqA");

const $3805b7821bb236f0$export$20928c7586c5104e = (precedingText)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: precedingText
                    },
                    {
                        type: 'inlineExtension',
                        attrs: {
                            extensionKey: 'skill:skillTag',
                            extensionType: 'com.atlassian.rovo.skill',
                            parameters: {
                                slug: 'suggest-edits'
                            }
                        }
                    }
                ]
            }
        ]
    });
function $3805b7821bb236f0$export$d4b080f8bd589023({ api: api, thinkingStatus: thinkingStatus, isRovoMounted: isRovoMounted }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createConversationOptimistically: createConversationOptimistically, sendMessage: sendMessage, abortRequests: abortRequests, setSelectedConversation: setSelectedConversation } = (0, $aouqA.useSmartCreationChatStoreApi)();
    const [conversationId, setConversationId] = (0, $42omo.useState)(null);
    const activeConversation = (0, $ajfvU.useConversationById)({
        conversationId: conversationId ?? ''
    });
    (0, $42omo.useEffect)(()=>{
        if (thinkingStatus === 'idle') {
            setConversationId(null);
            return;
        }
        if (thinkingStatus === 'thinking') {
            const nextConversationId = crypto.randomUUID();
            setConversationId(nextConversationId);
            const promptPrefix = formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).suggestEditsPromptPrefix);
            const run = async ()=>{
                await createConversationOptimistically({
                    id: nextConversationId
                });
                sendMessage({
                    prompt: $3805b7821bb236f0$export$20928c7586c5104e(promptPrefix),
                    conversationId: nextConversationId,
                    storeUserMessages: true,
                    thinkDeeperEnabled: true,
                    alphaExtendedThinkingMode: 'LONG_HORIZON'
                });
            };
            try {
                run();
            } catch  {
                api?.aiSuggestions?.actions.stopThinking();
            }
        }
    }, [
        api,
        thinkingStatus,
        createConversationOptimistically,
        sendMessage,
        formatMessage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!activeConversation) return;
        let timeout;
        switch(activeConversation.status){
            case (0, $bPHr8.CHAT_STORE_STATUS).idle:
                if (thinkingStatus === 'thinking') {
                    if (isRovoMounted) api?.aiSuggestions?.actions.stopThinking();
                    else {
                        api?.aiSuggestions?.actions.refreshSuggestions(false);
                        timeout = setTimeout(()=>{
                            api?.aiSuggestions?.actions.completeThinking();
                        }, 3000);
                    }
                }
                break;
            case (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError:
                api?.aiSuggestions?.actions.stopThinking();
                break;
        }
        return ()=>{
            if (timeout) clearTimeout(timeout);
        };
    }, [
        activeConversation,
        api,
        isRovoMounted,
        thinkingStatus
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isRovoMounted && thinkingStatus !== 'idle' && conversationId) setSelectedConversation({
            conversationId: conversationId
        });
    }, [
        conversationId,
        isRovoMounted,
        setSelectedConversation,
        thinkingStatus
    ]);
    const abortActiveConversation = (0, $42omo.useCallback)(()=>{
        if (conversationId) abortRequests?.({
            conversationId: conversationId
        });
    }, [
        abortRequests,
        conversationId
    ]);
    return {
        abortActiveConversation: abortActiveConversation
    };
}





const $9dd86bc44501ef3f$var$selectThinkingStatus = (state)=>state?.thinkingStatus;
const $9dd86bc44501ef3f$export$ddd92d4bbdb8026a = (api)=>{
    const [thinkingStatus, setThinkingStatus] = (0, $42omo.useState)(()=>$9dd86bc44501ef3f$var$selectThinkingStatus(api?.aiSuggestions?.sharedState.currentState()));
    (0, $42omo.useEffect)(()=>{
        const aiSuggestions = api?.aiSuggestions;
        if (!aiSuggestions) return;
        // Re-read once at subscription time so we don't miss a transaction that fired between
        // the initial render and the effect commit.
        setThinkingStatus($9dd86bc44501ef3f$var$selectThinkingStatus(aiSuggestions.sharedState.currentState()));
        return aiSuggestions.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            setThinkingStatus($9dd86bc44501ef3f$var$selectThinkingStatus(nextSharedState));
        });
    }, [
        api
    ]);
    return thinkingStatus;
};


/* Thinking.tsx generated by @compiled/babel-plugin v0.36.1 */ 













var $5lVpa = parcelRequire("5lVpa");





var $6UNNU = parcelRequire("6UNNU");


var $bHkwM = parcelRequire("bHkwM");

const $1337bb304aaeb013$var$ROTATION_INTERVAL_MS = 30000;
const $1337bb304aaeb013$var$DEFAULT_ESTIMATED_DURATION_MS = 120000;
const $1337bb304aaeb013$var$COMPLETION_ANIMATION_MS = 150; /**
                                      * Cycles through `texts` at a fixed interval, stopping on the last item.
                                      */ 
function $1337bb304aaeb013$var$useSequentialText(texts) {
    const [index, setIndex] = (0, $42omo.useState)(0);
    const indexRef = (0, $42omo.useRef)(0);
    const textsRef = (0, $42omo.useRef)(texts);
    textsRef.current = texts;
    (0, $42omo.useEffect)(()=>{
        if (textsRef.current.length <= 1) return;
        const interval = setInterval(()=>{
            const next = indexRef.current + 1;
            if (next < textsRef.current.length) {
                indexRef.current = next;
                setIndex(next);
            } else clearInterval(interval);
        }, $1337bb304aaeb013$var$ROTATION_INTERVAL_MS);
        return ()=>clearInterval(interval); // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only
    }, []);
    return textsRef.current[index] ?? textsRef.current[0] ?? '';
}
/**
 * Smooth facade progress value (0-1): animates from 0 to ~90% over
 * `estimatedDurationMs`, then on `isComplete` rapidly fills to 1.0 and
 * fires `onCompleteAnimationFinished`.
 */ function $1337bb304aaeb013$var$useProgressFacade({ isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, estimatedDurationMs: estimatedDurationMs = $1337bb304aaeb013$var$DEFAULT_ESTIMATED_DURATION_MS }) {
    const [progress, setProgress] = (0, $42omo.useState)(0);
    const targetRef = (0, $42omo.useRef)(0.85 + Math.random() * 0.1);
    const completionStartValueRef = (0, $42omo.useRef)(0);
    const completionStartTimeRef = (0, $42omo.useRef)(null);
    const hasCalledFinishedRef = (0, $42omo.useRef)(false);
    const onCompleteAnimationFinishedRef = (0, $42omo.useRef)(onCompleteAnimationFinished);
    onCompleteAnimationFinishedRef.current = onCompleteAnimationFinished;
    (0, $42omo.useEffect)(()=>{
        if (isComplete) return;
        let rafId;
        let startTime = null;
        const target = targetRef.current;
        const tick = (timestamp)=>{
            if (startTime === null) startTime = timestamp;
            const elapsed = timestamp - startTime;
            const linearProgress = Math.min(1, elapsed / estimatedDurationMs);
            setProgress(linearProgress * target);
            if (linearProgress < 1) rafId = requestAnimationFrame(tick);
        };
        rafId = requestAnimationFrame(tick);
        return ()=>cancelAnimationFrame(rafId);
    }, [
        isComplete,
        estimatedDurationMs
    ]);
    const handleCompletion = (0, $42omo.useCallback)(()=>{
        completionStartTimeRef.current = null;
        hasCalledFinishedRef.current = false;
        let rafId;
        const tick = (timestamp)=>{
            if (completionStartTimeRef.current === null) completionStartTimeRef.current = timestamp;
            const elapsed = timestamp - completionStartTimeRef.current;
            const t = Math.min(1, elapsed / $1337bb304aaeb013$var$COMPLETION_ANIMATION_MS);
            const startValue = completionStartValueRef.current;
            const value = startValue + (1 - startValue) * t;
            setProgress(value);
            if (t < 1) rafId = requestAnimationFrame(tick);
            else if (!hasCalledFinishedRef.current) {
                hasCalledFinishedRef.current = true;
                onCompleteAnimationFinishedRef.current?.();
            }
        };
        rafId = requestAnimationFrame(tick);
        return ()=>cancelAnimationFrame(rafId);
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (!isComplete) return;
        completionStartValueRef.current = progress;
        const cleanup = handleCompletion();
        return cleanup; // eslint-disable-next-line react-hooks/exhaustive-deps -- only trigger when isComplete flips
    }, [
        isComplete,
        handleCompletion
    ]);
    return progress;
}
const $1337bb304aaeb013$var$styles = {
    wrapper: "_2rko1tm3 _zulpu2gc _189ee4h9 _1dqonqa1 _1h6d1l7x _vchhusvi _kqswh2mm _4t3i1ex1 _1e0c1txw _4cvr1h6o _bfhk1bhr _19bvutpp _u5f3u2gc _ca0qu2gc _n3tdu2gc",
    textCell: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq",
    stopContainer: "_zulpu2gc _1e0c1txw _4cvr1h6o",
    escBadge: "_2rko12b0 _18zr1b66 _bfhkysee"
};
const $1337bb304aaeb013$var$StopIcon = ()=>/*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lVpa))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    });
function $1337bb304aaeb013$export$ae7b5e50e522fa95({ onStop: onStop, isComplete: isComplete = false, onCompleteAnimationFinished: onCompleteAnimationFinished }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const thinkingTexts = [
        formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).thinkingReviewingContent),
        formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).thinkingCheckingRelatedSources),
        formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).thinkingIdentifyingImprovements),
        formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).thinkingPreparingSuggestions)
    ];
    const thinkingTitle = $1337bb304aaeb013$var$useSequentialText(thinkingTexts);
    const progress = $1337bb304aaeb013$var$useProgressFacade({
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished
    });
    const progressBar = /*#__PURE__*/ $42omo.createElement((0, $bHkwM.RainbowProgressBar), {
        testId: "ai-suggestions-thinking-progress-bar",
        progress: progress * 100,
        appearance: "static-rainbow"
    });
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $1337bb304aaeb013$var$styles.wrapper
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $1337bb304aaeb013$var$styles.textCell
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $6UNNU.RovoThinkingIndicator), {
        title: thinkingTitle,
        animation: true,
        bottomAdornment: progressBar,
        testId: "ai-suggestions-thinking-indicator"
    })), onStop && /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $1337bb304aaeb013$var$styles.stopContainer
        ])
    }, /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $1337bb304aaeb013$var$styles.escBadge
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).thinkingEscHint))), /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
        testId: "ai-suggestions-thinking-stop-button",
        shape: "circle",
        onClick: onStop,
        icon: $1337bb304aaeb013$var$StopIcon,
        label: formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).thinkingStopLabel)
    })));
}


/* ThinkingComplete.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















const $7c2ee86a18aba3c0$var$styles = {
    wrapper: "_2rko1tm3 _189ee4h9 _1dqonqa1 _1h6d1l7x _vchhusvi _4t3i1ex1 _kqswh2mm _bfhk1bhr _1e0c1txw _4cvr1h6o _19bvutpp _u5f3u2gc _ca0qu2gc _n3tdu2gc",
    iconContainer: "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
    content: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _gy1pu2gc",
    buttonGroup: "_zulpu2gc _1e0c1txw _4cvr1h6o"
};
function $7c2ee86a18aba3c0$export$b34ca9c02c5ea263({ hasSuggestions: hasSuggestions, onClose: onClose, onViewSuggestions: onViewSuggestions }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $7c2ee86a18aba3c0$var$styles.wrapper
        ])
    }, hasSuggestions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $7c2ee86a18aba3c0$var$styles.content
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $7c2ee86a18aba3c0$var$styles.iconContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).thinkingCompleteReviewComplete))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $7c2ee86a18aba3c0$var$styles.buttonGroup
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "ai-suggestions-thinking-complete-close-button"
    }, formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).thinkingCompleteClose)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onViewSuggestions,
        testId: "ai-suggestions-thinking-complete-view-suggestions-button"
    }, formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).thinkingCompleteViewSuggestions)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $7c2ee86a18aba3c0$var$styles.content
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).thinkingCompleteNoSuggestions))));
}


/* ThinkingTransitionWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $g9Srd = parcelRequire("g9Srd");

function $81f2474d4aa2337b$var$useHideTransition(isHidden) {
    const [phase, setPhase] = (0, $42omo.useState)(isHidden ? 'hidden' : 'visible');
    const phaseRef = (0, $42omo.useRef)(phase);
    phaseRef.current = phase;
    (0, $42omo.useEffect)(()=>{
        const current = phaseRef.current;
        if (isHidden) {
            if (current === 'visible' || current === 'entering') setPhase('exiting');
            return;
        }
        if (current === 'hidden') setPhase('entering');
    }, [
        isHidden
    ]);
    const onAnimationEnd = (0, $42omo.useCallback)(()=>{
        if (phase === 'entering') {
            setPhase('visible');
            return;
        }
        if (phase === 'exiting') setPhase(isHidden ? 'hidden' : 'entering');
    }, [
        phase,
        isHidden
    ]);
    return {
        phase: phase,
        onAnimationEnd: onAnimationEnd
    };
}
const $81f2474d4aa2337b$var$ON_COMPLETE_DELAY_MS = 3000;
const $81f2474d4aa2337b$var$fadeIn = null;
const $81f2474d4aa2337b$var$fadeOut = null;
const $81f2474d4aa2337b$var$styles = {
    entering: "_j7hq1wwu _5sag1mzy _1pgl1d08 _1o51q7pw",
    exiting: "_j7hq1sbx _5sag1mzy _1pgl1d08 _1o51q7pw _lcxvglyw",
    reducedMotion: "_2hwz5cps",
    hidden: "_1e0cglyw"
};
function $81f2474d4aa2337b$var$Fade({ children: children }) {
    const { isExiting: isExiting, onFinish: onFinish } = (0, $g9Srd.useExitingPersistence)();
    return /*#__PURE__*/ $42omo.createElement("div", {
        onAnimationEnd: (event)=>{
            if (event.target !== event.currentTarget) return;
            onFinish?.();
        },
        className: (0, $gMc0m.default)([
            $81f2474d4aa2337b$var$styles.reducedMotion,
            isExiting ? $81f2474d4aa2337b$var$styles.exiting : $81f2474d4aa2337b$var$styles.entering
        ])
    }, children);
}
function $81f2474d4aa2337b$export$bed75bdfc026b4b({ thinkingStatus: thinkingStatus, isHidden: isHidden, children: children, onComplete: onComplete, onCompleteDelayMs: onCompleteDelayMs = $81f2474d4aa2337b$var$ON_COMPLETE_DELAY_MS }) {
    (0, $42omo.useEffect)(()=>{
        if (thinkingStatus !== 'complete') return;
        const timeoutId = setTimeout(()=>{
            onComplete?.();
        }, onCompleteDelayMs);
        return ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        onComplete,
        thinkingStatus,
        onCompleteDelayMs
    ]);
    const { phase: phase, onAnimationEnd: onAnimationEnd } = $81f2474d4aa2337b$var$useHideTransition(isHidden);
    const handleOuterAnimationEnd = (event)=>{
        // Inner `<Fade>` animations bubble up through this div — only progress
        // the hide state machine for the outer container's own animation.
        if (event.target !== event.currentTarget) return;
        onAnimationEnd();
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        onAnimationEnd: handleOuterAnimationEnd,
        className: (0, $gMc0m.default)([
            $81f2474d4aa2337b$var$styles.reducedMotion,
            phase === 'entering' && $81f2474d4aa2337b$var$styles.entering,
            phase === 'exiting' && $81f2474d4aa2337b$var$styles.exiting,
            phase === 'hidden' && $81f2474d4aa2337b$var$styles.hidden
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $g9Srd.default), {
        exitThenEnter: true
    }, thinkingStatus === 'thinking' && /*#__PURE__*/ $42omo.createElement($81f2474d4aa2337b$var$Fade, {
        key: "thinking"
    }, children('thinking')), thinkingStatus === 'complete' && /*#__PURE__*/ $42omo.createElement($81f2474d4aa2337b$var$Fade, {
        key: "complete"
    }, children('complete'))));
}


const $d546b01a98085447$var$styles = {
    container: "_kqsw1n9t _94n51ejb _1ul91kdj _1pby16oo _1ltv1ssb _t9eczr6s"
};
function $d546b01a98085447$export$58900a3f971bc8cc({ api: api }) {
    const thinkingStatus = (0, $9dd86bc44501ef3f$export$ddd92d4bbdb8026a)(api); /**
                                                        * We use this to detect when to hide / show the thinking component
                                                        */ 
    const { mounted: isRovoMounted } = (0, $5gEqE.useUIStore)();
    const { firstSuggestionId: firstSuggestionId } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiSuggestions'
    ], (state)=>({
            firstSuggestionId: state?.aiSuggestionsState?.orderedSuggestionIds?.[0]
        }));
    const { abortActiveConversation: abortActiveConversation } = (0, $3805b7821bb236f0$export$d4b080f8bd589023)({
        api: api,
        thinkingStatus: thinkingStatus,
        isRovoMounted: isRovoMounted
    });
    const handleStop = (0, $42omo.useCallback)(()=>{
        api?.aiSuggestions?.actions.stopThinking();
        abortActiveConversation();
    }, [
        api,
        abortActiveConversation
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        api?.aiSuggestions?.actions.stopThinking();
    }, [
        api
    ]);
    const onViewSuggestions = (0, $42omo.useCallback)(()=>{
        api?.aiSuggestions?.actions.stopThinking();
        api?.aiSuggestions?.actions.selectSuggestion(firstSuggestionId ?? null);
    }, [
        api,
        firstSuggestionId
    ]);
    const handleReturnToIdle = (0, $42omo.useCallback)(()=>{
        if (!firstSuggestionId) api?.aiSuggestions?.actions.stopThinking();
    }, [
        api,
        firstSuggestionId
    ]);
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $d546b01a98085447$var$styles.container
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $81f2474d4aa2337b$export$bed75bdfc026b4b), {
        thinkingStatus: thinkingStatus,
        isHidden: isRovoMounted,
        onComplete: handleReturnToIdle
    }, (phase)=>phase === 'thinking' ? /*#__PURE__*/ $42omo.createElement((0, $1337bb304aaeb013$export$ae7b5e50e522fa95), {
            onStop: handleStop
        }) : /*#__PURE__*/ $42omo.createElement((0, $7c2ee86a18aba3c0$export$b34ca9c02c5ea263), {
            onClose: handleClose,
            hasSuggestions: !!firstSuggestionId,
            onViewSuggestions: onViewSuggestions
        })));
}










var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $aro2m = parcelRequire("aro2m");

var $7ERUE = parcelRequire("7ERUE");

var $kDB94 = parcelRequire("kDB94");


var $e2ZTm = parcelRequire("e2ZTm");

const $808ebe84fb785452$var$AiSuggestionsButton = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const label = formatMessage((0, $95fcf8bb61fa82af$export$e4f30354a76c156b).suggestEditsButtonLabel);
    const handleClick = (0, $42omo.useCallback)(()=>{
        api?.aiSuggestions?.actions.startThinking();
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        onClick: handleClick,
        testId: "editor-toolbar__ai-suggestions-button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e2ZTm))), {
            label: label,
            size: "small"
        }),
        ignoreInteractionDisabled: true
    }, label);
};
const $808ebe84fb785452$export$e43f2f89cc843502 = ({ api: api })=>{
    return [
        // AI SUGGESTIONS GROUP — only registered in the pinned primary toolbar sections,
        // not in AI_SECTION (which is used by the floating toolbar).
        //
        // The group wraps its children in <Show above="lg"> so it hides below the breakpoint
        {
            type: (0, $cPCP8.AI_SUGGESTIONS_GROUP).type,
            key: (0, $cPCP8.AI_SUGGESTIONS_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.AI_SECTION).type,
                    key: (0, $cPCP8.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.AI_SUGGESTIONS_GROUP).key]
                },
                {
                    type: (0, $cPCP8.AI_SECTION).type,
                    key: (0, $cPCP8.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.AI_SUGGESTIONS_GROUP).key]
                },
                {
                    type: (0, $cPCP8.AI_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.AI_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.AI_SUGGESTIONS_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aro2m.Show), {
                    above: "lg"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children))
        },
        // AI SUGGESTIONS BUTTON — shown as a full labelled button when space is available
        // (via AI_SUGGESTIONS_GROUP above "lg"), or as an icon-only button with tooltip
        // inside ROVO_GROUP_DISPLAY_SMALL when space is tight (below "lg").
        {
            type: (0, $cPCP8.AI_SUGGESTIONS_BUTTON).type,
            key: (0, $cPCP8.AI_SUGGESTIONS_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.AI_SUGGESTIONS_GROUP).type,
                    key: (0, $cPCP8.AI_SUGGESTIONS_GROUP).key,
                    rank: (0, $4Chin.AI_SUGGESTIONS_GROUP_RANK)[(0, $cPCP8.AI_SUGGESTIONS_BUTTON).key]
                },
                {
                    type: (0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).type,
                    key: (0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).key,
                    rank: (0, $4Chin.ROVO_GROUP_DISPLAY_SMALL_RANK)[(0, $cPCP8.AI_SUGGESTIONS_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($808ebe84fb785452$var$AiSuggestionsButton, {
                    api: api
                })
        }
    ];
};


const $5d6abfec5f8b86f9$export$e4fa509a217898d8 = ({ api: api, config: config })=>{
    const { contentAri: contentAri, onShowSidebar: onShowSidebar, ConversationAssistant: ConversationAssistant } = config;
    if (api?.toolbar) api.toolbar.actions.registerComponents((0, $808ebe84fb785452$export$e43f2f89cc843502)({
        api: api
    }));
    return {
        name: 'aiSuggestions',
        actions: {
            acceptSuggestion: (0, $648150141ab98191$export$11f54cceda85c938)(api),
            discardSuggestion: (0, $264e001355aecef2$export$97ae1e6707b788ba)(api),
            // Deprecated - will remove in direct follow up - use SelectSuggestionAction instead
            showSuggestionDiff: (0, $49a3354e5fae2e0c$export$abeb109a09e4f140)(api),
            // Deprecated - will remove in direct follow up - use SelectSuggestionAction instead
            hideSuggestionDiff: (0, $73e02324b1e4dc9e$export$63a2edde6c848f66)(api),
            acceptAllSuggestions: (0, $246bd17543716cd3$export$21100d27fbd5548c)(api),
            discardAllSuggestions: (0, $6e04719468ffdcd4$export$7cd05c39d88c72e0)(api),
            refreshSuggestions: (0, $187fa16e9a98c2ed$export$8c023f02ab5dbd45)(api, contentAri),
            selectSuggestion: (0, $27af45f05a8358d3$export$85c07d6dab7fe6b1)(api),
            setUIVisibility: (0, $1741cc5ffd05c197$export$6525a287b5847561)(api),
            startThinking: (0, $c8607a1691626c1d$export$b9b07f03787433d)(api),
            completeThinking: (0, $4ccbb8acf041332a$export$d3355a5693c51fd3)(api),
            stopThinking: (0, $bc01aad1a76ed984$export$cf0309e29c0b89b8)(api)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $4eed6fc998ed6bbf$export$dbbefe45c19011aa).getState(editorState);
            if (!pluginState) return undefined;
            const thinkingState = (0, $25171e55829ce194$export$1acc4db37d317889).getState(editorState);
            return {
                isHidden: pluginState.isHidden,
                selectedSuggestion: pluginState.selectedSuggestion,
                suggestionById: pluginState.suggestionById,
                baseLocalIdBySuggestionId: pluginState.baseLocalIdBySuggestionId,
                suggestionIdsByBaseLocalId: pluginState.suggestionIdsByBaseLocalId,
                orderedSuggestionIds: pluginState.orderedSuggestionIds,
                thinkingStatus: thinkingState?.status ?? 'idle'
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'aiSuggestionsPlugin',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const intl = getIntl?.();
                        return (0, $4eed6fc998ed6bbf$export$ae829ec7b2625219)({
                            api: api,
                            intl: intl,
                            contentAri: contentAri,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        });
                    }
                },
                {
                    name: 'aiSuggestionsThinkingPlugin',
                    plugin: ({ dispatch: dispatch })=>{
                        return (0, $25171e55829ce194$export$145797582d57a3db)({
                            dispatch: dispatch
                        });
                    }
                }
            ];
        },
        contentComponent ({ editorView: editorView }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /**
         * ThinkingContentComponent requires the ConversationAssistant store to
         * invoke the skill, track thinking states, and abort requests.
         */ ConversationAssistant && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ConversationAssistant, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d546b01a98085447$export$58900a3f971bc8cc), {
                api: api
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b71ad3bab76820ab$export$b9f1c5d82af9ea41), {
                api: api,
                onShowSidebar: onShowSidebar,
                view: editorView
            }));
        }
    };
};
module.exports["aiSuggestionsPlugin"] = $5d6abfec5f8b86f9$export$e4fa509a217898d8;

});

parcelRegister("b7xX4", function(module, exports) {
function $03a647a335c52f20$export$13aeab2a71badd1e({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIDefinitionsConfig`.
    return options;
}
module.exports["aiDefinitionsPluginOptions"] = $03a647a335c52f20$export$13aeab2a71badd1e;

});

parcelRegister("bzbkd", function(module, exports) {
function $b10ae299850a21d7$export$a9185f12eb6f9427({ options: options }) {
    return options;
}
module.exports["aiImageGenerationPluginOptions"] = $b10ae299850a21d7$export$a9185f12eb6f9427;

});

parcelRegister("bpSEE", function(module, exports) {
function $0e54a671895f12da$export$a2b90416e38bfd44({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIOptions`.
    return options;
}
module.exports["aiPluginOptions"] = $0e54a671895f12da$export$a2b90416e38bfd44;

});

parcelRegister("70Ur3", function(module, exports) {
function $f116ad07960ba181$export$bc5ff52c1b8ecb7e({ options: options }) {
    return {
        streamFlowPacerEnabled: options?.streamFlowPacerEnabled,
        telemetryEventsEnabled: true
    };
}
module.exports["aiStreamingOrchestratorPluginOptions"] = $f116ad07960ba181$export$bc5ff52c1b8ecb7e;

});

parcelRegister("gG3sH", function(module, exports) {
function $c2363b970ec378f3$export$ac204ba03d7a4a41({ options: options }) {
    return options;
}
module.exports["aiSuggestionsOptions"] = $c2363b970ec378f3$export$ac204ba03d7a4a41;

});

parcelRegister("1eaC0", function(module, exports) {
function $b499f1aa43aeb0ae$export$bfd53895e8497571({}) {
    return {};
}
module.exports["analyticsPluginOptions"] = $b499f1aa43aeb0ae$export$bfd53895e8497571;

});

parcelRegister("b7e5N", function(module, exports) {
function $8ed9740f118d687b$export$b3e029fd31f94f55({ options: options, providers: providers }) {
    if (!providers.inlineCommentAnnotationProvider) return undefined;
    return {
        inlineComment: providers.inlineCommentAnnotationProvider,
        createCommentExperience: options.createCommentExperience,
        selectCommentExperience: {
            selectAnnotation: {
                complete: (annotationId)=>{
                    options.selectCommentExperience?.selectAnnotation.complete({
                        pageClass: 'editor',
                        annotationId: annotationId,
                        entryPoint: 'annotation-change'
                    });
                }
            }
        },
        viewInlineCommentTraceUFOPress: options.viewInlineCommentTraceUFOPress,
        annotationManager: options.annotationManager
    };
}
module.exports["annotationPluginOptions"] = $8ed9740f118d687b$export$b3e029fd31f94f55;

});

parcelRegister("6e0Xr", function(module, exports) {
function $ad7357a8ed7dfd42$export$eeaea850bc5c5797({ options: options }) {
    return {
        // Avatars are moved to Confluence codebase for Edit in Context
        // When Edit in Context is enabled primaryToolbarComponents is undefined
        // For more details please check
        // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
        collabEdit: options.collabEdit,
        // originally depends on !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        showAvatarGroup: false
    };
}
module.exports["avatarGroupPluginOptions"] = $ad7357a8ed7dfd42$export$eeaea850bc5c5797;

});

parcelRegister("8mYe0", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $78a1544f00d30a05$export$a23b3fa66082f163({ options: options }) {
    const removeScrollGutter = !(0, $dh538.fg)('confluence_frontend_content_wrapper') && options.__livePage;
    return {
        allowInlineCursorTarget: true,
        allowScrollGutter: removeScrollGutter ? undefined : {
            getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
        }
    };
}
module.exports["basePluginOptions"] = $78a1544f00d30a05$export$a23b3fa66082f163;

});

parcelRegister("i9XZB", function(module, exports) {
function $849252e5cfbe6f75$export$817c0e398e6ff750({}) {
    return {
        // rolling out under platform_editor_small_font_size experiment
        allowFontSize: true,
        includeBlockQuoteAsTextstyleOption: true,
        lastNodeMustBeParagraph: false,
        isUndoRedoButtonsEnabled: true,
        allowBlockType: undefined
    };
}
module.exports["blockTypePluginOptions"] = $849252e5cfbe6f75$export$817c0e398e6ff750;

});

parcelRegister("lSu7N", function(module, exports) {
function $18709874e4301e98$export$3be6b735d5cbc3e6({ options: options }) {
    return {
        allowBreakoutButton: options.editorAppearance === 'full-page',
        appearance: options.editorAppearance
    };
}
module.exports["breakoutPluginOptions"] = $18709874e4301e98$export$3be6b735d5cbc3e6;

});

parcelRegister("loJPN", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $aeAfU = parcelRequire("aeAfU");

// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $f8013e4ced731918$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $f8013e4ced731918$export$514131654bb897e2({ options: options, providers: providers }) {
    return {
        smartCardContext: options.smartCardContext,
        // From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `CARD_OPTIONS =`
        allowDatasource: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
        provider: providers.cardProvider,
        resolveBeforeMacros: $f8013e4ced731918$var$SMART_LINKS_BEFORE_MACROS,
        allowBlockCards: true,
        allowEmbeds: true,
        // END SECTION
        onClickCallback: options.onClickCallback,
        fullWidthMode: options.editorAppearance === 'full-width',
        linkPicker: options.linkPicker,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        editorAppearance: options.editorAppearance,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage,
        isPageSSRed: Boolean((0, $eTj7Y.isSSR)() || window.__SSR_RENDERED__),
        CompetitorPrompt: options.CompetitorPrompt,
        enablePasteDisplayAsMenu: [
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ].includes((0, $aeAfU.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control'))
    };
}
module.exports["cardPluginOptions"] = $f8013e4ced731918$export$514131654bb897e2;

});

parcelRegister("hCIES", function(module, exports) {
function $c70218b234c6d78f$export$3f0ff0bcf72f4d98({ options: options }) {
    return {
        appearance: options.editorAppearance
    };
}
module.exports["codeBidiWarningPluginOptions"] = $c70218b234c6d78f$export$3f0ff0bcf72f4d98;

});

parcelRegister("dSbzA", function(module, exports) {
function $de05ec98c0250c98$export$74cc43e84bb9c20({}) {
    return {
        allowCopyToClipboard: true,
        useLongPressSelection: false,
        allowCompositionInputOverride: false
    };
}
module.exports["codeBlockPluginOptions"] = $de05ec98c0250c98$export$74cc43e84bb9c20;

});

parcelRegister("eUaTu", function(module, exports) {

var $NPJKR = parcelRequire("NPJKR");


var $1oCLl = parcelRequire("1oCLl");

function $e2f5d02097d0844c$export$c1ebe19806bc53b1({ options: options, providers: providers }) {
    return {
        // Core options
        provider: providers.collabEditProvider,
        userId: options.collabEdit?.userId,
        useNativePlugin: options.collabEdit?.useNativePlugin,
        sanitizePrivateContent: true,
        hideTelecursorOnLoad: options.__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
        // Invite to edit related options
        inviteToEditHandler: options.collabEdit?.inviteToEditHandler,
        isInviteToEditButtonSelected: options.collabEdit?.isInviteToEditButtonSelected,
        inviteToEditComponent: options.collabEdit?.inviteToEditComponent,
        // Analytics options
        EXPERIMENTAL_allowInternalErrorAnalytics: options.collabEdit?.EXPERIMENTAL_allowInternalErrorAnalytics ?? (0, $NPJKR.shouldForceTracking)()
    };
}
module.exports["collabEditPluginOptions"] = $e2f5d02097d0844c$export$c1ebe19806bc53b1;

});

parcelRegister("411xE", function(module, exports) {
function $5d0ceab6af17632b$export$8a4106078b67336e({ options: options }) {
    return {
        initialContentMode: options?.initialContentMode ?? 'standard'
    };
}
module.exports["contentFormatPluginOptions"] = $5d0ceab6af17632b$export$8a4106078b67336e;

});

parcelRegister("7DQWQ", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $d7dae729776ab102$export$48a60d81b6bb28e3({ options: options }) {
    if (!options) return undefined;
    return(// SECTION: From confluence/next/packages/editor-presets/src/full-page/useFullPageEditorPreset.ts
    // If object-sidebar is not enabled, then we don't need to pass the contextPanelOptions
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('confluence_frontend_content_wrapper') && (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? {
        objectSideBar: options.objectSideBar
    } : undefined);
}
module.exports["contextPanelPluginOptions"] = $d7dae729776ab102$export$48a60d81b6bb28e3;

});

parcelRegister("l5VKX", function(module, exports) {
function $22bbbcb7ca748783$export$de47eee62065048e({ options: options }) {
    return {
        initialDisabledState: options?.disabled
    };
}
module.exports["editorDisabledPluginOptions"] = $22bbbcb7ca748783$export$de47eee62065048e;

});

parcelRegister("cvSKL", function(module, exports) {
function $f342e2c893778f00$export$36a79e2b5698697a({ options: options }) {
    return {
        mode: options.viewMode
    };
}
module.exports["editorViewModePluginOptions"] = $f342e2c893778f00$export$36a79e2b5698697a;

});

parcelRegister("bLqvq", function(module, exports) {
function $d63a2b43135c498f$export$128eafe7f843e327({ options: options }) {
    return {
        coordinationClient: options.coordinationClient
    };
}
module.exports["engagementPlatformPluginOptions"] = $d63a2b43135c498f$export$128eafe7f843e327;

});

parcelRegister("bMIN2", function(module, exports) {

var $iu6m9 = parcelRequire("iu6m9");

function $13d21f4408f33e88$export$3bff061e5229a7({}) {
    /**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */ return {
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        /**
		 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
		 * but cannot yet be cleaned up from editor component as pending rollout in other products first
		 */ lpLinkPicker: true,
        tableWithFixedColumnWidthsOption: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
        tableSelector: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true),
        macroInteractionUpdates: true,
        moreElementsInQuickInsertView: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/utils/createFeatureFlagsFromProps.ts
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}
module.exports["featureFlagsPluginOptions"] = $13d21f4408f33e88$export$3bff061e5229a7;

});

parcelRegister("ho6wy", function(module, exports) {
function $eab9055a4a41e7c7$export$2a67100cd9c61f05({ options: options }) {
    return options;
}
module.exports["helpDialogPluginOptions"] = $eab9055a4a41e7c7$export$2a67100cd9c61f05;

});

parcelRegister("atxxf", function(module, exports) {
function $ba2e03c1e9271b78$export$ab9ae3984d5aef33({ options: options }) {
    return {
        editorAppearance: options.editorAppearance,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        linkPicker: options.linkPicker,
        onClickCallback: options.onClickCallback,
        platform: 'web'
    };
}
module.exports["hyperlinkPluginOptions"] = $ba2e03c1e9271b78$export$ab9ae3984d5aef33;

});

parcelRegister("koReu", function(module, exports) {

var $iu6m9 = parcelRequire("iu6m9");

function $6e8873e0128315d2$export$1e11b615e9dc119e({ options: options }) {
    return {
        allowTables: true,
        allowExpand: true,
        horizontalRuleEnabled: true,
        tableSelectorSupported: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true),
        nativeStatusSupported: true,
        showElementBrowserLink: true,
        appearance: options.editorAppearance,
        itemFilter: options.itemFilter,
        toolbarButtons: options.toolbarButtons
    };
}
module.exports["insertBlockPluginOptions"] = $6e8873e0128315d2$export$1e11b615e9dc119e;

});

parcelRegister("fXtqB", function(module, exports) {
function $a233792833dda4ec$export$d384a797e800fdbe({ options: options }) {
    return {
        showFlag: options.showFlag,
        contentId: options.contentId,
        killSwitchEnabled: options.killSwitchEnabled
    };
}
module.exports["limitedModePluginOptions"] = $a233792833dda4ec$export$d384a797e800fdbe;

});

parcelRegister("2RHVA", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $5e5a949da08ce418$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    invalidAltText: {
        id: "editor-presets-confluence.media.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});


function $1412367cad2aa59d$export$484123ae56f6fbd9({ intl: intl, options: options, providers: providers }) {
    return {
        // SECTION: From confluence/next/packages/editor-features/src/utils/mediaOptions.ts
        provider: providers.mediaProvider,
        syncProvider: providers.syncMediaProvider,
        allowMediaSingle: true,
        allowResizing: options.allowResizing ?? true,
        allowResizingInTables: options.allowResizing ?? true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: options.allowCaptions ?? true,
        allowMediaInlineImages: true,
        allowPixelResizing: options.allowResizing ?? true,
        altTextValidator: (text)=>{
            // @ts-ignore - TS1501 Typescript 5.9.2 upgrade
            const storageSupports = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
            if (!storageSupports.test(text)) return [
                intl.formatMessage((0, $5e5a949da08ce418$export$a7357cdd1f0b0168).invalidAltText)
            ];
            return [];
        },
        // END SECTION
        // SECTION: From confluence/next/packages/fabric-media-support/src/mediaFeatureFlags.ts
        featureFlags: {
            mediaInline: true
        },
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts
        allowLazyLoading: true,
        allowBreakoutSnapPoints: true,
        allowAdvancedToolBarOptions: true,
        // originally value was Boolean(options.annotationProviders),
        allowCommentsOnMedia: true,
        allowDropzoneDropLine: true,
        allowMediaSingleEditable: true,
        allowRemoteDimensionsFetch: true,
        allowMarkingUploadsAsIncomplete: false,
        allowImagePreview: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        createCommentExperience: options.createCommentExperience,
        editorAppearance: options.editorAppearance,
        isCopyPasteEnabled: true,
        alignLeftOnInsert: false,
        allowImageEditing: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx
        waitForMediaUpload: true,
        // END SECTION
        mediaViewerExtensions: options.mediaViewerExtensions,
        fallbackMediaNameFetcher: options.fallbackMediaNameFetcher
    };
}
module.exports["mediaPluginOptions"] = $1412367cad2aa59d$export$484123ae56f6fbd9;

});

parcelRegister("iGGcn", function(module, exports) {
function $85c17a3a2c6c7b85$export$4677177d82484aef({ options: options }) {
    return options;
}
module.exports["metricsPluginOptions"] = $85c17a3a2c6c7b85$export$4677177d82484aef;

});

parcelRegister("jY8iu", function(module, exports) {
// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $49e9bc2589f6c0e6$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $49e9bc2589f6c0e6$export$6b1ad42d09c74964({ providers: providers }) {
    return {
        cardOptions: {
            provider: providers.cardProvider,
            // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
            allowBlockCards: true,
            allowDatasource: true,
            allowEmbeds: true,
            resolveBeforeMacros: $49e9bc2589f6c0e6$var$SMART_LINKS_BEFORE_MACROS
        },
        sanitizePrivateContent: true,
        isFullPage: true
    };
}
module.exports["pastePluginOptions"] = $49e9bc2589f6c0e6$export$6b1ad42d09c74964;

});

parcelRegister("fzjlm", function(module, exports) {

var $delmI = parcelRequire("delmI");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $aXWIB = parcelRequire("aXWIB");

const $3e5e5c18746b8d36$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    easyMentionsPlaceholder: {
        id: "editor-presets-confluence.placeholder.easy-mentions-placeholder",
        defaultMessage: "Type / for all elements or @ to mention someone."
    },
    aiPlaceholder: {
        id: "editor-presets-confluence.placeholder.ai-placeholder",
        defaultMessage: "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we'll let them know)."
    },
    defaultPlaceholder: {
        id: "editor-presets-confluence.placeholder.default-placeholder",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "editor-presets-confluence.placeholder.default-placeholder-ai",
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    },
    editorEmptyDocumentSpaceShortcutPlaceholder: {
        id: "editor-presets-confluence.placeholder.space-shortcut-placeholder",
        defaultMessage: "Press space to Ask Rovo or / to insert elements"
    },
    placeholderADF: {
        id: "editor-presets-confluence.placeholderADF",
        defaultMessage: "Press <code>space</code> to Ask Rovo or <code>/</code> to insert elements"
    }
});


function $01e23cb99d262862$export$c6841f879d4c8aef({ intl: intl, options: options }) {
    const shouldShowSpaceShortcut = options.isAIEnabled && (0, $dh538.fg)('platform_editor_ai_aifc_streaming');
    const placeholder = (()=>{
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `const placeholderText = `
        if (options.viewMode === 'view') return undefined;
        // END SECTION
        // We disable the placeholder here becuase we want to use the new ADF placeholder, see below.
        if (shouldShowSpaceShortcut) return undefined;
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `_getPlaceholderText()`
        if (!options.isAIEnabled) return intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholderAI);
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).defaultPlaceholder);
        return intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).easyMentionsPlaceholder);
    // END SECTION
    })();
    const placeholderADF = (()=>{
        if (options.viewMode === 'view') return undefined;
        if (shouldShowSpaceShortcut && (0, $dh538.fg)('platform_editor_ai_aifc_space_shortcut')) return (0, $delmI.createADFFromHTML)(intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).placeholderADF, {
            code: (parts)=>`<code>${parts}</code>`
        }));
        return undefined;
    })();
    return {
        placeholder: placeholder,
        placeholderADF: placeholderADF,
        isPlaceholderHidden: options.isPlaceholderHidden,
        withEmptyParagraph: (0, $dh538.fg)('platform_editor_ai_aifc_streaming'),
        isRovoLLMEnabled: options.isRovoLLMEnabled,
        enableLoadingSpinner: options.enableLoadingSpinner ?? (0, $1oCLl.expValEquals)('confluence_load_editor_title_on_transition', 'contentPlaceholder', true)
    };
}
module.exports["placeholderPluginOptions"] = $01e23cb99d262862$export$c6841f879d4c8aef;

});

parcelRegister("1TfUS", function(module, exports) {
function $66d5390e1d65d1af$export$44901d053a58e418({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}
module.exports["primaryToolbarPluginOptions"] = $66d5390e1d65d1af$export$44901d053a58e418;

});

parcelRegister("jmiBO", function(module, exports) {
function $9c8df38044d63cd4$export$26cff1f2fe9f781b({ options: options }) {
    return {
        enableElementBrowser: true,
        elementBrowserHelpUrl: '',
        disableDefaultItems: false,
        headless: false,
        emptyStateHandler: options?.emptyStateHandler,
        prioritySortingFn: typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
        onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined,
        // EDITOR-6558: forward consumer-supplied item filter (used by Markdown Mode
        // to allowlist GFM-compatible items in the `/` menu).
        itemFilter: typeof options.quickInsert === 'object' ? options.quickInsert.itemFilter : undefined
    };
}
module.exports["quickInsertPluginOptions"] = $9c8df38044d63cd4$export$26cff1f2fe9f781b;

});

parcelRegister("34JVP", function(module, exports) {
function $ed5f509dae6ecf5b$export$13a2743c2a93c688({ options: options }) {
    return {
        api: options.referentialityContext.api ?? undefined,
        // A spread operator of the options.referentialityContext.options was previously used here, now they're all explicitly listed out to make the code more readable.
        appearance: options.referentialityContext.options.appearance,
        extensionHandlers: options.referentialityContext.options.extensionHandlers,
        externalObservers: options.referentialityContext.options.externalObservers,
        nodeNameCallback: options.referentialityContext.options.nodeNameCallback,
        nodeFocusCallback: options.referentialityContext.options.nodeFocusCallback,
        editorAnalyticsAPI: options.referentialityContext.options.editorAnalyticsAPI,
        editorView: options.referentialityContext.options.editorView,
        featureFlags: options.referentialityContext.options.featureFlags,
        __livePage: options.referentialityContext.options.__livePage,
        __rendererExtensionOptions: options.referentialityContext.options.__rendererExtensionOptions,
        getExtensionHeight: options.referentialityContext.options.getExtensionHeight
    };
}
module.exports["referentialityPluginOptions"] = $ed5f509dae6ecf5b$export$13a2743c2a93c688;

});

parcelRegister("ddVvy", function(module, exports) {
function $70edb4b454693530$export$222c5aa4c9fb0805({ options: options }) {
    return options;
}
module.exports["selectionExtensionPluginOptions"] = $70edb4b454693530$export$222c5aa4c9fb0805;

});

parcelRegister("3QJIE", function(module, exports) {

var $1oCLl = parcelRequire("1oCLl");

function $45e8d9f61045475c$export$197b78e13e8987d2({ options: options }) {
    // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts `.add(['selectionMarkerPlugin', ...])`
    return {
        hideCursorOnInit: options.__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)
    };
// END SECTION
}
module.exports["selectionMarkerPluginOptions"] = $45e8d9f61045475c$export$197b78e13e8987d2;

});

parcelRegister("gWT9r", function(module, exports) {
function $d84bbda11ad6763d$export$ddc2936355c1da67({ options: options }) {
    return {
        useLongPressSelection: false,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage
    };
}
module.exports["selectionPluginOptions"] = $d84bbda11ad6763d$export$ddc2936355c1da67;

});

parcelRegister("a38jz", function(module, exports) {
function $9a57111cbcc407d6$export$bc6dcb3c2a6112e1({ options: options, providers: providers }) {
    return {
        preferenceToolbarAboveSelection: false,
        contextualFormattingEnabled: options.contextualFormattingEnabled,
        userPreferencesProvider: providers.userPreferencesProvider,
        disablePin: options.disablePin
    };
}
module.exports["selectionToolbarPluginOptions"] = $9a57111cbcc407d6$export$bc6dcb3c2a6112e1;

});

parcelRegister("bx6Sm", function(module, exports) {
function $f5ca45a4f682676c$export$5c1f265f89d46b24({ options: options }) {
    if (!options?.originalDoc || !options?.steps) return undefined;
    return {
        originalDoc: options.originalDoc,
        steps: options.steps,
        colorScheme: options.colorScheme
    };
}
module.exports["showDiffPluginOptions"] = $f5ca45a4f682676c$export$5c1f265f89d46b24;

});

parcelRegister("kqt6j", function(module, exports) {
function $8660f8880f9cea3b$export$3612ff8a6b94af71({}) {
    return undefined;
}
module.exports["submitEditorPluginOptions"] = $8660f8880f9cea3b$export$3612ff8a6b94af71;

});

parcelRegister("4H3SW", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");

function $2f3fcd3de4e4a210$export$9868b594778cf535({ options: options }) {
    return {
        // value from next/packages/editor-features/src/hooks/useTableOptions.ts
        tableOptions: {
            allowTableResizing: true,
            allowTableAlignment: true,
            allowBackgroundColor: true,
            allowColumnResizing: true,
            allowColumnSorting: true,
            allowDistributeColumns: true,
            allowHeaderColumn: true,
            allowHeaderRow: true,
            allowMergeCells: true,
            allowNumberColumn: true,
            allowNestedTables: true,
            allowControls: true,
            stickyHeaders: true,
            allowAddColumnWithCustomStep: false
        },
        isTableScalingEnabled: true,
        allowContextualMenu: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        maxWidthEnabled: options.editorAppearance === 'max',
        wasFullWidthEnabled: options.prevEditorAppearance && options.prevEditorAppearance === 'full-width',
        getEditorFeatureFlags: ()=>({
                // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
                tableWithFixedColumnWidthsOption: (0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? undefined : true,
                // END SECTION
                // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
                tableSelector: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true)
            }),
        isCommentEditor: false,
        isChromelessEditor: false,
        allowFixedColumnWidthOption: (0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? true : undefined
    };
}
module.exports["tablePluginOptions"] = $2f3fcd3de4e4a210$export$9868b594778cf535;

});

parcelRegister("aD3RD", function(module, exports) {
function $87c3c57462c09942$export$1d23e03c42bfc1ac({ options: options, providers: providers }) {
    return {
        allowNestedTasks: true,
        consumeTabs: true,
        useLongPressSelection: false,
        taskDecisionProvider: providers.taskDecisionProvider,
        hasEditPermission: options.hasEditPermission,
        requestToEditContent: options.requestToEditContent,
        hasRequestedEditPermission: options.hasRequestedEditPermission,
        allowBlockTaskItem: true
    };
}
module.exports["tasksAndDecisionsPluginOptions"] = $87c3c57462c09942$export$1d23e03c42bfc1ac;

});

parcelRegister("fsguo", function(module, exports) {
function $cd23e889f6860a3b$export$cb883a3a9320698e({}) {
    return {
        responsiveToolbarMenu: true
    };
}
module.exports["textFormattingPluginOptions"] = $cd23e889f6860a3b$export$cb883a3a9320698e;

});

parcelRegister("9Da5o", function(module, exports) {
function $969f212772f8d82f$export$2d206ce8fa0c3d37({ options: options }) {
    return {
        componentFilter: options.componentFilter,
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}
module.exports["toolbarPluginOptions"] = $969f212772f8d82f$export$2d206ce8fa0c3d37;

});

parcelRegister("7Dfbr", function(module, exports) {
function $663aa679fccecaaa$export$612ea2d32c3e4c96({}) {
    return {
        isMobile: false
    };
}
module.exports["typeAheadPluginOptions"] = $663aa679fccecaaa$export$612ea2d32c3e4c96;

});

parcelRegister("j5uEY", function(module, exports) {
function $e2c7c4acf3e187dc$export$abdb0d09187eec69({ providers: providers, options: options }) {
    return {
        userPreferencesProvider: providers.userPreferencesProviderNext,
        // If initialToolbarDockingPosition is set, use it to override any saved user preference
        initialUserPreferences: options.initialToolbarDockingPosition ? {
            toolbarDockingPosition: options.initialToolbarDockingPosition
        } : undefined
    };
}
module.exports["userPreferencesPluginOptions"] = $e2c7c4acf3e187dc$export$abdb0d09187eec69;

});

parcelRegister("eFJVr", function(module, exports) {
/**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ 
var $26Ync = parcelRequire("26Ync");


var $7v7jT = parcelRequire("7v7jT");


var $cpZDY = parcelRequire("cpZDY");


var $2JNc8 = parcelRequire("2JNc8");

const $e9dabcd9647ff028$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $e9dabcd9647ff028$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $e9dabcd9647ff028$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}



var $kxETH = parcelRequire("kxETH");


var $4b5zd = parcelRequire("4b5zd");


function $9971139f2babea38$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $e9dabcd9647ff028$export$c564cdbbe6da493)($9971139f2babea38$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $9971139f2babea38$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $4b5zd.asciiAlphanumeric)(value.charCodeAt(index + 1)) && (0, $4b5zd.asciiAlphanumeric)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


const $aae884e15f6b6350$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $aae884e15f6b6350$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $aae884e15f6b6350$var$protocolSource = /^https?$/i;
function $aae884e15f6b6350$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $cpZDY.combineHtmlExtensions)([
        defaultHandlers,
        ...settings.htmlExtensions || []
    ]);
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $7v7jT.push)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $7v7jT.push)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $7v7jT.push)(head, body);
        head = (0, $7v7jT.push)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($aae884e15f6b6350$var$hasOwnProperty.call(handles, kind) && handle) handle.call({
                sliceSerialize: result[index][2].sliceSerialize,
                ...context
            }, result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0; // Skip open.
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $e9dabcd9647ff028$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1; // Skip current.
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $kxETH.normalizeIdentifier)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $9971139f2babea38$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $aae884e15f6b6350$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $9971139f2babea38$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $aae884e15f6b6350$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $kxETH.normalizeIdentifier)(media.labelId);
        resume();
        if (!$aae884e15f6b6350$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const value = this.sliceSerialize(token);
        const decoded = getData('characterReferenceType') ? (0, $2JNc8.decodeNumericCharacterReference)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $26Ync.decodeNamedCharacterReference)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $9971139f2babea38$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $aae884e15f6b6350$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $9971139f2babea38$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}
module.exports["compile"] = $aae884e15f6b6350$export$ef7acd7185315e22;

});

parcelRegister("cJwEn", function(module, exports) {
/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
var $cpZDY = parcelRequire("cpZDY");

/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ 
var $2q899 = parcelRequire("2q899");


var $4b5zd = parcelRequire("4b5zd");

const $d7a7d96cba1acfe5$export$a7db06668cad9adb = {
    tokenize: $d7a7d96cba1acfe5$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $d7a7d96cba1acfe5$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $2q899.factorySpace)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 






var $7v7jT = parcelRequire("7v7jT");

const $a448cbaadd6df3ae$export$5a7bfc01df82fcd1 = {
    tokenize: $a448cbaadd6df3ae$var$initializeDocument
};
/** @type {Construct} */ const $a448cbaadd6df3ae$var$containerConstruct = {
    tokenize: $a448cbaadd6df3ae$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $a448cbaadd6df3ae$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $7v7jT.splice)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($a448cbaadd6df3ae$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($a448cbaadd6df3ae$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        const stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $7v7jT.splice)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $a448cbaadd6df3ae$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $2q899.factorySpace)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ /**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





const $802f00095852d9ca$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $802f00095852d9ca$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $802f00095852d9ca$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $4b5zd.markdownSpace)(code) ? (0, $2q899.factorySpace)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $4b5zd.markdownLineEnding)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 






var $95tvg = parcelRequire("95tvg");

const $6c064fe855347292$export$a7db06668cad9adb = {
    resolve: $6c064fe855347292$var$resolveContent,
    tokenize: $6c064fe855347292$var$tokenizeContent
};
/** @type {Construct} */ const $6c064fe855347292$var$continuationConstruct = {
    partial: true,
    tokenize: $6c064fe855347292$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $6c064fe855347292$var$resolveContent(events) {
    (0, $95tvg.subtokenize)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6c064fe855347292$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $4b5zd.markdownLineEnding)(code)) return effects.check($6c064fe855347292$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6c064fe855347292$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $2q899.factorySpace)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}






const $39f4ba804cade2d2$export$ccc7b0636abaffc3 = {
    tokenize: $39f4ba804cade2d2$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $39f4ba804cade2d2$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $802f00095852d9ca$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $2q899.factorySpace)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $6c064fe855347292$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ const $8868287e41c0f5d2$export$50397835cbfdbc24 = {
    resolveAll: $8868287e41c0f5d2$var$createResolver()
};
const $8868287e41c0f5d2$export$22b082955e083ec3 = $8868287e41c0f5d2$var$initializeFactory('string');
const $8868287e41c0f5d2$export$6f093cfa640b7166 = $8868287e41c0f5d2$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $8868287e41c0f5d2$var$initializeFactory(field) {
    return {
        resolveAll: $8868287e41c0f5d2$var$createResolver(field === 'text' ? $8868287e41c0f5d2$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $8868287e41c0f5d2$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $8868287e41c0f5d2$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        // Allow final trailing whitespace.
        if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: {
                    ...data.end
                }
            };
            data.end = {
                ...token.start
            };
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


var $37b3eddc2bd0243b$exports = {};
/**
 * @import {Extension} from 'micromark-util-types'
 */ /**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 



var $daFoX = parcelRequire("daFoX");


var $fQmC6 = parcelRequire("fQmC6");

const $d58920a3f9d2b824$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $d58920a3f9d2b824$var$resolveAllAttention,
    tokenize: $d58920a3f9d2b824$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $d58920a3f9d2b824$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = {
                ...events[open][1].end
            };
            const end = {
                ...events[index][1].start
            };
            $d58920a3f9d2b824$var$movePoint(start, -use);
            $d58920a3f9d2b824$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: {
                    ...events[open][1].end
                }
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: {
                    ...events[index][1].start
                },
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: {
                    ...events[open][1].end
                },
                end: {
                    ...events[index][1].start
                }
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: {
                    ...openingSequence.start
                },
                end: {
                    ...closingSequence.end
                }
            };
            events[open][1].end = {
                ...openingSequence.start
            };
            events[index][1].start = {
                ...closingSequence.end
            };
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $7v7jT.push)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $7v7jT.push)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $7v7jT.push)(nextEvents, (0, $fQmC6.resolveAll)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $7v7jT.push)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $7v7jT.push)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $7v7jT.splice)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d58920a3f9d2b824$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $daFoX.classifyCharacter)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $daFoX.classifyCharacter)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $d58920a3f9d2b824$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


const $036c29e598252c6b$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $036c29e598252c6b$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $036c29e598252c6b$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $4b5zd.asciiAlpha)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $4b5zd.asciiAlphanumeric)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $4b5zd.asciiAlphanumeric)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $4b5zd.asciiControl)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $4b5zd.asciiAtext)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $4b5zd.asciiAlphanumeric)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $4b5zd.asciiAlphanumeric)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





const $14dc2b8146688352$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $14dc2b8146688352$var$tokenizeBlockQuoteContinuation
    },
    exit: $14dc2b8146688352$var$exit,
    name: 'blockQuote',
    tokenize: $14dc2b8146688352$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $14dc2b8146688352$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $14dc2b8146688352$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $4b5zd.markdownSpace)(code)) // Always populated by defaults.
        return (0, $2q899.factorySpace)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($14dc2b8146688352$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $14dc2b8146688352$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


const $4f225bcad835fa1e$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $4f225bcad835fa1e$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $4f225bcad835fa1e$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $4b5zd.asciiPunctuation)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $26Ync = parcelRequire("26Ync");




const $94dc43a105236549$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $94dc43a105236549$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $94dc43a105236549$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $4b5zd.asciiAlphanumeric);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $4b5zd.asciiHexDigit);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $4b5zd.asciiDigit);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $4b5zd.asciiAlphanumeric) && !(0, $26Ync.decodeNamedCharacterReference)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





/** @type {Construct} */ const $eb6cc588f2e07fce$var$nonLazyContinuation = {
    partial: true,
    tokenize: $eb6cc588f2e07fce$var$tokenizeNonLazyContinuation
};
const $eb6cc588f2e07fce$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $eb6cc588f2e07fce$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $eb6cc588f2e07fce$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $4b5zd.markdownSpace)(code) ? (0, $2q899.factorySpace)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($eb6cc588f2e07fce$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $2q899.factorySpace)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $4b5zd.markdownSpace)(code) ? (0, $2q899.factorySpace)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) return effects.check($eb6cc588f2e07fce$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $4b5zd.markdownSpace)(code) ? (0, $2q899.factorySpace)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $4b5zd.markdownSpace)(code) ? (0, $2q899.factorySpace)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $eb6cc588f2e07fce$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





const $4b1887744c84879f$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $4b1887744c84879f$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $4b1887744c84879f$var$furtherStart = {
    partial: true,
    tokenize: $4b1887744c84879f$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $4b1887744c84879f$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $2q899.factorySpace)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $4b5zd.markdownLineEnding)(code)) return effects.attempt($4b1887744c84879f$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $4b1887744c84879f$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $2q899.factorySpace)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $4b5zd.markdownLineEnding)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 


const $3b53747cb83a158d$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $3b53747cb83a158d$var$previous,
    resolve: $3b53747cb83a158d$var$resolveCodeText,
    tokenize: $3b53747cb83a158d$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $3b53747cb83a158d$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $3b53747cb83a158d$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3b53747cb83a158d$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 


function $664dccd82593d722$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $4b5zd.asciiControl)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $4b5zd.markdownLineEnding)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $4b5zd.markdownLineEndingOrSpace)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $4b5zd.asciiControl)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 


function $06090232fa971fe9$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $4b5zd.markdownLineEnding)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $4b5zd.markdownSpace)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}





/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 





function $d71b96731b3a4170$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $2q899.factorySpace)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 





function $68ac31ade833557a$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $4b5zd.markdownSpace)(code)) return (0, $2q899.factorySpace)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}






var $kxETH = parcelRequire("kxETH");

const $21e71fb046bdbacc$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $21e71fb046bdbacc$var$tokenizeDefinition
};
/** @type {Construct} */ const $21e71fb046bdbacc$var$titleBefore = {
    partial: true,
    tokenize: $21e71fb046bdbacc$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $21e71fb046bdbacc$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $06090232fa971fe9$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $kxETH.normalizeIdentifier)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $4b5zd.markdownLineEndingOrSpace)(code) ? (0, $68ac31ade833557a$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $664dccd82593d722$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($21e71fb046bdbacc$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $4b5zd.markdownSpace)(code) ? (0, $2q899.factorySpace)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $21e71fb046bdbacc$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $4b5zd.markdownLineEndingOrSpace)(code) ? (0, $68ac31ade833557a$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $d71b96731b3a4170$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $4b5zd.markdownSpace)(code) ? (0, $2q899.factorySpace)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $4b5zd.markdownLineEnding)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


const $1460803d1689ba1e$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $1460803d1689ba1e$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1460803d1689ba1e$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 








const $65ea81cec58dde7b$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $65ea81cec58dde7b$var$resolveHeadingAtx,
    tokenize: $65ea81cec58dde7b$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $65ea81cec58dde7b$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $7v7jT.splice)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $65ea81cec58dde7b$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $4b5zd.markdownLineEndingOrSpace)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $4b5zd.markdownSpace)(code)) return (0, $2q899.factorySpace)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $4b5zd.markdownLineEndingOrSpace)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $c6f40f5ce8682188$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $c6f40f5ce8682188$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $fceeba08894c959a$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $fceeba08894c959a$var$resolveToHtmlFlow,
    tokenize: $fceeba08894c959a$var$tokenizeHtmlFlow
};
/** @type {Construct} */ const $fceeba08894c959a$var$blankLineBefore = {
    partial: true,
    tokenize: $fceeba08894c959a$var$tokenizeBlankLineBefore
};
const $fceeba08894c959a$var$nonLazyContinuationStart = {
    partial: true,
    tokenize: $fceeba08894c959a$var$tokenizeNonLazyContinuationStart
};
/** @type {Resolver} */ function $fceeba08894c959a$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $fceeba08894c959a$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $4b5zd.asciiAlpha)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $4b5zd.asciiAlpha)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $4b5zd.asciiAlpha)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $4b5zd.markdownLineEndingOrSpace)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $c6f40f5ce8682188$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $c6f40f5ce8682188$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $4b5zd.asciiAlphanumeric)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $4b5zd.asciiAlpha)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $4b5zd.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $4b5zd.markdownLineEndingOrSpace)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $4b5zd.markdownSpace)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $4b5zd.markdownLineEnding)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($fceeba08894c959a$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($fceeba08894c959a$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $c6f40f5ce8682188$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $4b5zd.asciiAlpha)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $fceeba08894c959a$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $fceeba08894c959a$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $802f00095852d9ca$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





const $59402d9bc15602f1$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $59402d9bc15602f1$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $59402d9bc15602f1$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $4b5zd.asciiAlpha)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $4b5zd.asciiAlpha)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $4b5zd.asciiAlpha)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $4b5zd.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $4b5zd.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $4b5zd.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $4b5zd.asciiAlpha)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $4b5zd.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $4b5zd.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $4b5zd.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $4b5zd.markdownSpace)(code) ? (0, $2q899.factorySpace)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 















const $9406dc07f9edb78a$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $9406dc07f9edb78a$var$resolveAllLabelEnd,
    resolveTo: $9406dc07f9edb78a$var$resolveToLabelEnd,
    tokenize: $9406dc07f9edb78a$var$tokenizeLabelEnd
};
/** @type {Construct} */ const $9406dc07f9edb78a$var$resourceConstruct = {
    tokenize: $9406dc07f9edb78a$var$tokenizeResource
};
/** @type {Construct} */ const $9406dc07f9edb78a$var$referenceFullConstruct = {
    tokenize: $9406dc07f9edb78a$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $9406dc07f9edb78a$var$referenceCollapsedConstruct = {
    tokenize: $9406dc07f9edb78a$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $9406dc07f9edb78a$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Array<Event>} */ const newEvents = [];
    while(++index < events.length){
        const token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            const offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $7v7jT.splice)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $9406dc07f9edb78a$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    const label = {
        type: "label",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[close][1].end
        }
    };
    const text = {
        type: "labelText",
        start: {
            ...events[open + offset + 2][1].end
        },
        end: {
            ...events[close - 2][1].start
        }
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $7v7jT.push)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $7v7jT.push)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $7v7jT.push)(media, (0, $fQmC6.resolveAll)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $7v7jT.push)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $7v7jT.push)(media, events.slice(close + 1));
    // Media close.
    media = (0, $7v7jT.push)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $7v7jT.splice)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9406dc07f9edb78a$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $kxETH.normalizeIdentifier)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($9406dc07f9edb78a$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($9406dc07f9edb78a$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($9406dc07f9edb78a$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9406dc07f9edb78a$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $4b5zd.markdownLineEndingOrSpace)(code) ? (0, $68ac31ade833557a$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $664dccd82593d722$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $4b5zd.markdownLineEndingOrSpace)(code) ? (0, $68ac31ade833557a$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $d71b96731b3a4170$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $4b5zd.markdownLineEndingOrSpace)(code) ? (0, $68ac31ade833557a$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9406dc07f9edb78a$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $06090232fa971fe9$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $kxETH.normalizeIdentifier)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9406dc07f9edb78a$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $5b3d4d40d1b8d6c5$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $9406dc07f9edb78a$export$470a5dafbbf62654).resolveAll,
    tokenize: $5b3d4d40d1b8d6c5$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5b3d4d40d1b8d6c5$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $3b62eb04ab13954c$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $9406dc07f9edb78a$export$470a5dafbbf62654).resolveAll,
    tokenize: $3b62eb04ab13954c$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3b62eb04ab13954c$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 



const $2eeeeb07d22a54e7$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $2eeeeb07d22a54e7$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2eeeeb07d22a54e7$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $2q899.factorySpace)(effects, ok, "linePrefix");
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 






/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





const $68f3544bf3af4126$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $68f3544bf3af4126$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $68f3544bf3af4126$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $4b5zd.markdownLineEnding)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $4b5zd.markdownSpace)(code) ? (0, $2q899.factorySpace)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $888a162e1a471a28$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $888a162e1a471a28$var$tokenizeListContinuation
    },
    exit: $888a162e1a471a28$var$tokenizeListEnd,
    name: 'list',
    tokenize: $888a162e1a471a28$var$tokenizeListStart
};
/** @type {Construct} */ const $888a162e1a471a28$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $888a162e1a471a28$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ const $888a162e1a471a28$var$indentConstruct = {
    partial: true,
    tokenize: $888a162e1a471a28$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $888a162e1a471a28$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $4b5zd.asciiDigit)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $68f3544bf3af4126$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $4b5zd.asciiDigit)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $802f00095852d9ca$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($888a162e1a471a28$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $888a162e1a471a28$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $802f00095852d9ca$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $2q899.factorySpace)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $4b5zd.markdownSpace)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($888a162e1a471a28$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $2q899.factorySpace)(effects, effects.attempt($888a162e1a471a28$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $888a162e1a471a28$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $2q899.factorySpace)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $888a162e1a471a28$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $888a162e1a471a28$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $2q899.factorySpace)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $4b5zd.markdownSpace)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 





const $17d639543a02e511$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $17d639543a02e511$var$resolveToSetextUnderline,
    tokenize: $17d639543a02e511$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $17d639543a02e511$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: {
            ...events[content][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = {
            ...events[definition][1].end
        };
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $17d639543a02e511$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $4b5zd.markdownSpace)(code) ? (0, $2q899.factorySpace)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $4b5zd.markdownLineEnding)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $37b3eddc2bd0243b$export$5a7bfc01df82fcd1 = {
    [42]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [43]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [45]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [48]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [49]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [50]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [51]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [52]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [53]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [54]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [55]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [56]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [57]: (0, $888a162e1a471a28$export$8837f4fc672e936d),
    [62]: (0, $14dc2b8146688352$export$200dcd0a5903c968)
};
const $37b3eddc2bd0243b$export$5a2181fb44b58173 = {
    [91]: (0, $21e71fb046bdbacc$export$69f215ed977cdb73)
};
const $37b3eddc2bd0243b$export$cf8bead395eff824 = {
    [-2]: (0, $4b1887744c84879f$export$47910b7ab28d1853),
    [-1]: (0, $4b1887744c84879f$export$47910b7ab28d1853),
    [32]: (0, $4b1887744c84879f$export$47910b7ab28d1853)
};
const $37b3eddc2bd0243b$export$ccc7b0636abaffc3 = {
    [35]: (0, $65ea81cec58dde7b$export$3871e9deb360695c),
    [42]: (0, $68f3544bf3af4126$export$ba7b13e047416c03),
    [45]: [
        (0, $17d639543a02e511$export$e104e2de391dfde9),
        (0, $68f3544bf3af4126$export$ba7b13e047416c03)
    ],
    [60]: (0, $fceeba08894c959a$export$476ac411cb7d0d8f),
    [61]: (0, $17d639543a02e511$export$e104e2de391dfde9),
    [95]: (0, $68f3544bf3af4126$export$ba7b13e047416c03),
    [96]: (0, $eb6cc588f2e07fce$export$c23e4921f8d87e7c),
    [126]: (0, $eb6cc588f2e07fce$export$c23e4921f8d87e7c)
};
const $37b3eddc2bd0243b$export$22b082955e083ec3 = {
    [38]: (0, $94dc43a105236549$export$e31905600aaf3d8e),
    [92]: (0, $4f225bcad835fa1e$export$2005478564e78d96)
};
const $37b3eddc2bd0243b$export$6f093cfa640b7166 = {
    [-5]: (0, $2eeeeb07d22a54e7$export$8e62e0ad51c97b2),
    [-4]: (0, $2eeeeb07d22a54e7$export$8e62e0ad51c97b2),
    [-3]: (0, $2eeeeb07d22a54e7$export$8e62e0ad51c97b2),
    [33]: (0, $5b3d4d40d1b8d6c5$export$3d754936e25aa5f5),
    [38]: (0, $94dc43a105236549$export$e31905600aaf3d8e),
    [42]: (0, $d58920a3f9d2b824$export$45b92471da762af7),
    [60]: [
        (0, $036c29e598252c6b$export$17ddf85e4c916ad6),
        (0, $59402d9bc15602f1$export$398af27f284914fe)
    ],
    [91]: (0, $3b62eb04ab13954c$export$5c0cee0701a3b584),
    [92]: [
        (0, $1460803d1689ba1e$export$86c573ab9e06f418),
        (0, $4f225bcad835fa1e$export$2005478564e78d96)
    ],
    [93]: (0, $9406dc07f9edb78a$export$470a5dafbbf62654),
    [95]: (0, $d58920a3f9d2b824$export$45b92471da762af7),
    [96]: (0, $3b53747cb83a158d$export$d24f93e715f9df88)
};
const $37b3eddc2bd0243b$export$d44f260a3f9b69f5 = {
    null: [
        (0, $d58920a3f9d2b824$export$45b92471da762af7),
        (0, $8868287e41c0f5d2$export$50397835cbfdbc24)
    ]
};
const $37b3eddc2bd0243b$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $37b3eddc2bd0243b$export$e20fbacbb41798b = {
    null: []
};
$37b3eddc2bd0243b$exports["document"] = $37b3eddc2bd0243b$export$5a7bfc01df82fcd1;
$37b3eddc2bd0243b$exports["contentInitial"] = $37b3eddc2bd0243b$export$5a2181fb44b58173;
$37b3eddc2bd0243b$exports["flowInitial"] = $37b3eddc2bd0243b$export$cf8bead395eff824;
$37b3eddc2bd0243b$exports["flow"] = $37b3eddc2bd0243b$export$ccc7b0636abaffc3;
$37b3eddc2bd0243b$exports["string"] = $37b3eddc2bd0243b$export$22b082955e083ec3;
$37b3eddc2bd0243b$exports["text"] = $37b3eddc2bd0243b$export$6f093cfa640b7166;
$37b3eddc2bd0243b$exports["insideSpan"] = $37b3eddc2bd0243b$export$d44f260a3f9b69f5;
$37b3eddc2bd0243b$exports["attentionMarkers"] = $37b3eddc2bd0243b$export$b9c0b60d74426aea;
$37b3eddc2bd0243b$exports["disable"] = $37b3eddc2bd0243b$export$e20fbacbb41798b;


/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 








function $753270413ccb7b1a$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $7v7jT.push)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $fQmC6.resolveAll)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $753270413ccb7b1a$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $753270413ccb7b1a$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { _bufferIndex: _bufferIndex, _index: _index, line: line, column: column, offset: offset } = point;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $4b5zd.markdownLineEnding)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const left = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(left) ? left : left ? [
                            left
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $7v7jT.splice)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $753270413ccb7b1a$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $753270413ccb7b1a$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


function $945303a81356ceb2$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $cpZDY.combineExtensions)([
        $37b3eddc2bd0243b$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        constructs: constructs,
        content: create((0, $d7a7d96cba1acfe5$export$a7db06668cad9adb)),
        defined: [],
        document: create((0, $a448cbaadd6df3ae$export$5a7bfc01df82fcd1)),
        flow: create((0, $39f4ba804cade2d2$export$ccc7b0636abaffc3)),
        lazy: {},
        string: create((0, $8868287e41c0f5d2$export$22b082955e083ec3)),
        text: create((0, $8868287e41c0f5d2$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $753270413ccb7b1a$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}
module.exports["parse"] = $945303a81356ceb2$export$98e6a39c04603d36;

});

parcelRegister("b0aSX", function(module, exports) {
/**
 * @import {Event} from 'micromark-util-types'
 */ 
var $95tvg = parcelRequire("95tvg");

function $8028236ba2b1fbde$export$bd0e6e1378a871d7(events) {
    while(!(0, $95tvg.subtokenize)(events));
    return events;
}
module.exports["postprocess"] = $8028236ba2b1fbde$export$bd0e6e1378a871d7;

});

parcelRegister("3qp16", function(module, exports) {
/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ const $27e7349c122b7c60$var$search = /[\0\t\n\r]/g;
function $27e7349c122b7c60$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $27e7349c122b7c60$var$search.lastIndex = startPosition;
            match = $27e7349c122b7c60$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}
module.exports["preprocess"] = $27e7349c122b7c60$export$fc37fe19dfda43ee;

});

parcelRegister("72j6x", function(module, exports) {
/**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<infer T>
 *   ? MatchesOne<Value, T>
 *   : Check extends Array<infer T>
 *   ? MatchesOne<Value, T>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 
var $eydDE = parcelRequire("eydDE");

/**
 * @param {string} d
 * @returns {string}
 */ function $63fe42700b7cdfdf$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $51f78a0f27f7ab0a$var$empty = [];
const $51f78a0f27f7ab0a$export$f4d8133c446fe484 = true;
const $51f78a0f27f7ab0a$export$7f100f842f565dc9 = false;
const $51f78a0f27f7ab0a$export$8773f85c2fb2c116 = 'skip';
function $51f78a0f27f7ab0a$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $eydDE.convert)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $63fe42700b7cdfdf$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $51f78a0f27f7ab0a$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $51f78a0f27f7ab0a$var$toResult(visitor(node, parents));
                if (result[0] === $51f78a0f27f7ab0a$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $51f78a0f27f7ab0a$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $51f78a0f27f7ab0a$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $51f78a0f27f7ab0a$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $51f78a0f27f7ab0a$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $51f78a0f27f7ab0a$var$empty : [
        value
    ];
}
module.exports["EXIT"] = $51f78a0f27f7ab0a$export$7f100f842f565dc9;
module.exports["visitParents"] = $51f78a0f27f7ab0a$export$70008a21eb6de899;

});

parcelRegister("eOoFF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calcSlices = module.exports.applyPatch = module.exports.calcPatch = module.exports.lcs = module.exports.diff = module.exports.diff_core = void 0;
function $ac88df560195f3b9$var$diff_internal(state, c) {
    const { b: b, eq: eq, stack_base: stack_base } = state;
    let { i: i, N: N, j: j, M: M, Z: Z, stack_top: stack_top } = state;
    for(;;)switch(c){
        case 0:
            Z_block: while(N > 0 && M > 0){
                b.fill(0, 0, 2 * Z);
                const W = N - M;
                const L = N + M;
                const parity = L & 1;
                const offsetx = i + N - 1;
                const offsety = j + M - 1;
                const hmax = (L + parity) / 2;
                let z;
                h_loop: for(let h = 0; h <= hmax; h++){
                    const kmin = 2 * Math.max(0, h - M) - h;
                    const kmax = h - 2 * Math.max(0, h - N);
                    for(let k = kmin; k <= kmax; k += 2){
                        const gkm = b[k - 1 - Z * Math.floor((k - 1) / Z)];
                        const gkp = b[k + 1 - Z * Math.floor((k + 1) / Z)];
                        const u = k === -h || k !== h && gkm < gkp ? gkp : gkm + 1;
                        const v = u - k;
                        let x = u;
                        let y = v;
                        while(x < N && y < M && eq(i + x, j + y))x++, y++;
                        b[k - Z * Math.floor(k / Z)] = x;
                        if (parity === 1 && (z = W - k) >= 1 - h && z < h && x + b[Z + z - Z * Math.floor(z / Z)] >= N) {
                            if (h > 1 || x !== u) {
                                stack_base[stack_top++] = i + x;
                                stack_base[stack_top++] = N - x;
                                stack_base[stack_top++] = j + y;
                                stack_base[stack_top++] = M - y;
                                N = u;
                                M = v;
                                Z = 2 * (Math.min(N, M) + 1);
                                continue Z_block;
                            } else break h_loop;
                        }
                    }
                    for(let k = kmin; k <= kmax; k += 2){
                        const pkm = b[Z + k - 1 - Z * Math.floor((k - 1) / Z)];
                        const pkp = b[Z + k + 1 - Z * Math.floor((k + 1) / Z)];
                        const u = k === -h || k !== h && pkm < pkp ? pkp : pkm + 1;
                        const v = u - k;
                        let x = u;
                        let y = v;
                        while(x < N && y < M && eq(offsetx - x, offsety - y))x++, y++;
                        b[Z + k - Z * Math.floor(k / Z)] = x;
                        if (parity === 0 && (z = W - k) >= -h && z <= h && x + b[z - Z * Math.floor(z / Z)] >= N) {
                            if (h > 0 || x !== u) {
                                stack_base[stack_top++] = i + N - u;
                                stack_base[stack_top++] = u;
                                stack_base[stack_top++] = j + M - v;
                                stack_base[stack_top++] = v;
                                N = N - x;
                                M = M - y;
                                Z = 2 * (Math.min(N, M) + 1);
                                continue Z_block;
                            } else break h_loop;
                        }
                    }
                }
                if (N === M) continue;
                if (M > N) {
                    i += N;
                    j += N;
                    M -= N;
                    N = 0;
                } else {
                    i += M;
                    j += M;
                    N -= M;
                    M = 0;
                }
                break;
            }
            if (N + M !== 0) {
                if (state.pxe === i || state.pye === j) {
                    state.pxe = i + N;
                    state.pye = j + M;
                } else {
                    const sx = state.pxs;
                    state.oxs = state.pxs;
                    state.oxe = state.pxe;
                    state.oys = state.pys;
                    state.oye = state.pye;
                    state.pxs = i;
                    state.pxe = i + N;
                    state.pys = j;
                    state.pye = j + M;
                    if (sx >= 0) {
                        state.i = i;
                        state.N = N;
                        state.j = j;
                        state.M = M;
                        state.Z = Z;
                        state.stack_top = stack_top;
                        return 1;
                    }
                }
            }
        case 1:
            if (stack_top === 0) return 2;
            M = stack_base[--stack_top];
            j = stack_base[--stack_top];
            N = stack_base[--stack_top];
            i = stack_base[--stack_top];
            Z = 2 * (Math.min(N, M) + 1);
            c = 0;
    }
}
class $ac88df560195f3b9$var$DiffGen {
    [Symbol.iterator]() {
        return this;
    }
    next() {
        const { state: state, result: result } = this;
        if (this.c > 1) {
            result.done = true;
            result.value = undefined;
            return result;
        }
        const c = $ac88df560195f3b9$var$diff_internal(state, this.c);
        this.c = c;
        if (c === 1) {
            result.value = [
                state.oxs,
                state.oxe,
                state.oys,
                state.oye
            ];
            return result;
        }
        if (state.pxs >= 0) {
            result.value = [
                state.pxs,
                state.pxe,
                state.pys,
                state.pye
            ];
            return result;
        }
        result.done = true;
        result.value = undefined;
        return result;
    }
    constructor(state){
        this.state = state;
        this.c = 0;
        this.result = {
            value: null,
            done: false
        };
    }
}
function $ac88df560195f3b9$var$diff_core(i, N, j, M, eq) {
    const Z = (Math.min(N, M) + 1) * 2;
    const L = N + M;
    const b = new (L < 256 ? Uint8Array : L < 65536 ? Uint16Array : Uint32Array)(2 * Z);
    return new $ac88df560195f3b9$var$DiffGen({
        i: i,
        N: N,
        j: j,
        M: M,
        Z: Z,
        b: b,
        eq: eq,
        pxs: -1,
        pxe: -1,
        pys: -1,
        pye: -1,
        oxs: -1,
        oxe: -1,
        oys: -1,
        oye: -1,
        stack_top: 0,
        stack_base: []
    });
}
module.exports.diff_core = $ac88df560195f3b9$var$diff_core;
function $ac88df560195f3b9$var$diff(xs, ys, eq) {
    let [i, N, M] = [
        0,
        xs.length,
        ys.length
    ];
    if (typeof eq === 'function') {
        while(i < N && i < M && eq(i, i))i++;
        if (i === N && i === M) return [][Symbol.iterator]();
        while(eq(--N, --M) && N > i && M > i);
    } else {
        while(i < N && i < M && xs[i] === ys[i])i++;
        if (i === N && i === M) return [][Symbol.iterator]();
        while(xs[--N] === ys[--M] && N > i && M > i);
        eq = (i, j)=>xs[i] === ys[j];
    }
    return $ac88df560195f3b9$var$diff_core(i, N + 1 - i, i, M + 1 - i, eq);
}
module.exports.diff = $ac88df560195f3b9$var$diff;
class $ac88df560195f3b9$var$LCSGen {
    [Symbol.iterator]() {
        return this;
    }
    next() {
        const rec = this.diff.next();
        if (rec.done) {
            const { i: i, j: j, N: N } = this;
            if (i < N) {
                rec.done = false;
                rec.value = [
                    i,
                    j,
                    N - i
                ];
                this.i = N;
            }
            return rec;
        }
        const v = rec.value;
        const sx = v[0];
        const ex = v[1];
        const ey = v[3];
        const { i: i, j: j } = this;
        if (i !== sx) {
            v.length--;
            v[0] = i;
            v[1] = j;
            v[2] = sx - i;
        }
        this.i = ex;
        this.j = ey;
        return rec;
    }
    constructor(diff, N){
        this.diff = diff;
        this.N = N;
        this.i = 0;
        this.j = 0;
    }
}
function $ac88df560195f3b9$var$lcs(xs, ys, eq) {
    return new $ac88df560195f3b9$var$LCSGen($ac88df560195f3b9$var$diff(xs, ys, eq), xs.length);
}
module.exports.lcs = $ac88df560195f3b9$var$lcs;
function* $ac88df560195f3b9$var$calcPatch(xs, ys, eq) {
    const slice = ArrayBuffer.isView(xs) ? Uint8Array.prototype.subarray : xs.slice;
    for (const v of $ac88df560195f3b9$var$diff(xs, ys, eq)){
        v[2] = slice.call(ys, v[2], v[3]);
        yield v;
    }
}
module.exports.calcPatch = $ac88df560195f3b9$var$calcPatch;
function* $ac88df560195f3b9$var$applyPatch(xs, patch) {
    let i = 0;
    const slice = ArrayBuffer.isView(xs) ? Uint8Array.prototype.subarray : xs.slice;
    for (const [dels, dele, ins] of patch){
        if (i < dels) yield slice.call(xs, i, dels);
        if (ins.length > 0) yield ins;
        i = dele;
    }
    if (i < xs.length) yield slice.call(xs, i);
}
module.exports.applyPatch = $ac88df560195f3b9$var$applyPatch;
function* $ac88df560195f3b9$var$calcSlices(xs, ys, eq) {
    let i = 0;
    const slice = ArrayBuffer.isView(xs) ? Uint8Array.prototype.subarray : xs.slice;
    for (const [dels, dele, inss, inse] of $ac88df560195f3b9$var$diff(xs, ys, eq)){
        if (i < dels) yield [
            0,
            slice.call(xs, i, dels)
        ];
        if (dels < dele) yield [
            -1,
            slice.call(xs, dels, dele)
        ];
        if (inss < inse) yield [
            1,
            slice.call(ys, inss, inse)
        ];
        i = dele;
    }
    if (i < xs.length) yield [
        0,
        xs.slice(i)
    ];
}
module.exports.calcSlices = $ac88df560195f3b9$var$calcSlices;

});

parcelRegister("1boHL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e781d3c70809e28cf62caa564f26c1f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0dc9fb606e9434ef$var$_react = $0dc9fb606e9434ef$var$_interopRequireDefault((parcelRequire("42omo")));

var $0dc9fb606e9434ef$var$_baseNew = $0dc9fb606e9434ef$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0dc9fb606e9434ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ViewSplit".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing a 2 column split view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0dc9fb606e9434ef$var$ViewSplitIcon = (props)=>/*#__PURE__*/ $0dc9fb606e9434ef$var$_react.default.createElement($0dc9fb606e9434ef$var$_baseNew.default, Object.assign({
        name: "ViewSplitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H8.75v11H14a.5.5 0 0 0 .5-.5zm-13 10a.5.5 0 0 0 .5.5h5.25v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$0dc9fb606e9434ef$var$ViewSplitIcon.displayName = 'ViewSplitIcon';
var $0dc9fb606e9434ef$var$_default = module.exports.default = $0dc9fb606e9434ef$var$ViewSplitIcon;

});

parcelRegister("7v7jT", function(module, exports) {
/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $57611b3f9293ce26$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $57611b3f9293ce26$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $57611b3f9293ce26$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}
module.exports["splice"] = $57611b3f9293ce26$export$869882364835d202;
module.exports["push"] = $57611b3f9293ce26$export$4cbf152802aa238;

});

parcelRegister("2JNc8", function(module, exports) {
/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $1fe5f1cfa01768ef$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}
module.exports["decodeNumericCharacterReference"] = $1fe5f1cfa01768ef$export$15a69557afac2c20;

});

parcelRegister("kxETH", function(module, exports) {
/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $ef469d19da38b7c5$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}
module.exports["normalizeIdentifier"] = $ef469d19da38b7c5$export$806d55e226cfcd08;

});

parcelRegister("4b5zd", function(module, exports) {
/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $30ac81fa385c76cc$export$d65d6b62c24d5436 = $30ac81fa385c76cc$var$regexCheck(/[A-Za-z]/);
const $30ac81fa385c76cc$export$75c76db11865a9f4 = $30ac81fa385c76cc$var$regexCheck(/[\dA-Za-z]/);
const $30ac81fa385c76cc$export$4397998b34fe597d = $30ac81fa385c76cc$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $30ac81fa385c76cc$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $30ac81fa385c76cc$export$ca8b5b1a6c320e6e = $30ac81fa385c76cc$var$regexCheck(/\d/);
const $30ac81fa385c76cc$export$eca2752363989806 = $30ac81fa385c76cc$var$regexCheck(/[\dA-Fa-f]/);
const $30ac81fa385c76cc$export$35794a7d1db99380 = $30ac81fa385c76cc$var$regexCheck(/[!-/:-@[-`{-~]/);
function $30ac81fa385c76cc$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $30ac81fa385c76cc$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $30ac81fa385c76cc$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $30ac81fa385c76cc$export$aa04114dd888a7a0 = $30ac81fa385c76cc$var$regexCheck(RegExp("\\p{P}|\\p{S}", "u"));
const $30ac81fa385c76cc$export$a0ff789c034ffdf4 = $30ac81fa385c76cc$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $30ac81fa385c76cc$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}
module.exports["asciiAlpha"] = $30ac81fa385c76cc$export$d65d6b62c24d5436;
module.exports["asciiAlphanumeric"] = $30ac81fa385c76cc$export$75c76db11865a9f4;
module.exports["asciiAtext"] = $30ac81fa385c76cc$export$4397998b34fe597d;
module.exports["asciiControl"] = $30ac81fa385c76cc$export$67dbf494fc8394df;
module.exports["asciiDigit"] = $30ac81fa385c76cc$export$ca8b5b1a6c320e6e;
module.exports["asciiHexDigit"] = $30ac81fa385c76cc$export$eca2752363989806;
module.exports["asciiPunctuation"] = $30ac81fa385c76cc$export$35794a7d1db99380;
module.exports["markdownLineEnding"] = $30ac81fa385c76cc$export$34a1dff1c0936953;
module.exports["markdownLineEndingOrSpace"] = $30ac81fa385c76cc$export$a30284361b3814b7;
module.exports["markdownSpace"] = $30ac81fa385c76cc$export$2c6cf65c1127992a;
module.exports["unicodePunctuation"] = $30ac81fa385c76cc$export$aa04114dd888a7a0;
module.exports["unicodeWhitespace"] = $30ac81fa385c76cc$export$a0ff789c034ffdf4;

});

parcelRegister("cpZDY", function(module, exports) {
/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
var $7v7jT = parcelRequire("7v7jT");

const $90a7a302b90b830b$var$hasOwnProperty = {}.hasOwnProperty;
function $90a7a302b90b830b$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$90a7a302b90b830b$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $90a7a302b90b830b$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $90a7a302b90b830b$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$90a7a302b90b830b$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $90a7a302b90b830b$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $90a7a302b90b830b$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $7v7jT.splice)(existing, 0, 0, before);
}
function $90a7a302b90b830b$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$90a7a302b90b830b$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $90a7a302b90b830b$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $90a7a302b90b830b$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}
module.exports["combineExtensions"] = $90a7a302b90b830b$export$86a865d89ef3c690;
module.exports["combineHtmlExtensions"] = $90a7a302b90b830b$export$eaf8c406dfb0a620;

});

parcelRegister("2q899", function(module, exports) {
/**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
var $4b5zd = parcelRequire("4b5zd");

function $1c34543eed43de94$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $4b5zd.markdownSpace)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $4b5zd.markdownSpace)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}
module.exports["factorySpace"] = $1c34543eed43de94$export$ae105c1eb063a0a2;

});

parcelRegister("hFOPD", function(module, exports) {
/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $cdddb224f4b6eed2$export$bd596157370df26e {
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $cdddb224f4b6eed2$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $cdddb224f4b6eed2$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $cdddb224f4b6eed2$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $cdddb224f4b6eed2$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $cdddb224f4b6eed2$var$chunkedPush(this.left, removed.reverse());
        }
    }
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $cdddb224f4b6eed2$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}
module.exports["SpliceBuffer"] = $cdddb224f4b6eed2$export$bd596157370df26e;

});

parcelRegister("daFoX", function(module, exports) {
/**
 * @import {Code} from 'micromark-util-types'
 */ 
var $4b5zd = parcelRequire("4b5zd");

function $996c53043df73a39$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $4b5zd.markdownLineEndingOrSpace)(code) || (0, $4b5zd.unicodeWhitespace)(code)) return 1;
    if ((0, $4b5zd.unicodePunctuation)(code)) return 2;
}
module.exports["classifyCharacter"] = $996c53043df73a39$export$e3902bc0d835cad0;

});

parcelRegister("fQmC6", function(module, exports) {
/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $b88d40f1a4db0ceb$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}
module.exports["resolveAll"] = $b88d40f1a4db0ceb$export$3ff61ec196ff408b;

});

parcelRegister("95tvg", function(module, exports) {
/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 
var $7v7jT = parcelRequire("7v7jT");


var $hFOPD = parcelRequire("hFOPD");

function $69db7766b805b148$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $hFOPD.SpliceBuffer)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $69db7766b805b148$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
                else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = {
                    ...events.get(lineIndex)[1].start
                };
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $7v7jT.splice)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $69db7766b805b148$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    let tokenizer = token._tokenizer;
    if (!tokenizer) {
        tokenizer = context.parser[token.contentType](token.start);
        if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
    }
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}
module.exports["subtokenize"] = $69db7766b805b148$export$12949d1dd00fddf4;

});

parcelRegister("eydDE", function(module, exports) {
/**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $a97ed2020f1dd362$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $a97ed2020f1dd362$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$a97ed2020f1dd362$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $a97ed2020f1dd362$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $a97ed2020f1dd362$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $a97ed2020f1dd362$var$ok;
    if (typeof test === 'function') return $a97ed2020f1dd362$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $a97ed2020f1dd362$var$anyFactory(test) : // narrows to `Array`.
    $a97ed2020f1dd362$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $a97ed2020f1dd362$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $a97ed2020f1dd362$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $a97ed2020f1dd362$export$9c68d69a4c5bbcf9(tests[index]);
    return $a97ed2020f1dd362$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $a97ed2020f1dd362$var$propertiesFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $a97ed2020f1dd362$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $a97ed2020f1dd362$var$typeFactory(check) {
    return $a97ed2020f1dd362$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $a97ed2020f1dd362$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($a97ed2020f1dd362$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $a97ed2020f1dd362$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $a97ed2020f1dd362$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}
module.exports["convert"] = $a97ed2020f1dd362$export$9c68d69a4c5bbcf9;

});


//# sourceMappingURL=FullPageEditorComponent.544fd600.js.map
